var __defProp = Object.defineProperty;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __glob = (map) => (path2) => {
  var fn = map[path2];
  if (fn) return fn();
  throw new Error("Module not found in bundle: " + path2);
};
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/core/interfaces/adminDB.ts
var init_adminDB = __esm({
  "src/core/interfaces/adminDB.ts"() {
    "use strict";
  }
});

// src/core/interfaces/classroomDB.ts
var init_classroomDB = __esm({
  "src/core/interfaces/classroomDB.ts"() {
    "use strict";
  }
});

// src/impl/common/SyncStrategy.ts
var init_SyncStrategy = __esm({
  "src/impl/common/SyncStrategy.ts"() {
    "use strict";
  }
});

// src/util/logger.ts
var isDevelopment, logger;
var init_logger = __esm({
  "src/util/logger.ts"() {
    "use strict";
    isDevelopment = typeof process !== "undefined" && process.env.NODE_ENV === "development";
    logger = {
      /**
       * Debug-level logging - only shown in development
       */
      debug: (message, ...args) => {
        if (isDevelopment) {
          console.debug(`[DB:DEBUG] ${message}`, ...args);
        }
      },
      /**
       * Info-level logging - general information
       */
      info: (message, ...args) => {
        console.info(`[DB:INFO] ${message}`, ...args);
      },
      /**
       * Warning-level logging - potential issues
       */
      warn: (message, ...args) => {
        console.warn(`[DB:WARN] ${message}`, ...args);
      },
      /**
       * Error-level logging - serious problems
       */
      error: (message, ...args) => {
        console.error(`[DB:ERROR] ${message}`, ...args);
      },
      /**
       * Log function for backward compatibility with existing log() usage
       */
      log: (message, ...args) => {
        if (isDevelopment) {
          console.log(`[DB:LOG] ${message}`, ...args);
        }
      }
    };
  }
});

// src/core/types/types-legacy.ts
var GuestUsername, log, DocType, DocTypePrefixes;
var init_types_legacy = __esm({
  "src/core/types/types-legacy.ts"() {
    "use strict";
    init_logger();
    GuestUsername = "sk-guest-";
    log = (message) => {
      logger.log(message);
    };
    DocType = /* @__PURE__ */ ((DocType3) => {
      DocType3["DISPLAYABLE_DATA"] = "DISPLAYABLE_DATA";
      DocType3["CARD"] = "CARD";
      DocType3["DATASHAPE"] = "DATASHAPE";
      DocType3["QUESTIONTYPE"] = "QUESTION";
      DocType3["VIEW"] = "VIEW";
      DocType3["PEDAGOGY"] = "PEDAGOGY";
      DocType3["CARDRECORD"] = "CARDRECORD";
      DocType3["SCHEDULED_CARD"] = "SCHEDULED_CARD";
      DocType3["TAG"] = "TAG";
      DocType3["NAVIGATION_STRATEGY"] = "NAVIGATION_STRATEGY";
      DocType3["STRATEGY_STATE"] = "STRATEGY_STATE";
      DocType3["USER_OUTCOME"] = "USER_OUTCOME";
      DocType3["STRATEGY_LEARNING_STATE"] = "STRATEGY_LEARNING_STATE";
      return DocType3;
    })(DocType || {});
    DocTypePrefixes = {
      ["CARD" /* CARD */]: "c",
      ["DISPLAYABLE_DATA" /* DISPLAYABLE_DATA */]: "dd",
      ["TAG" /* TAG */]: "TAG",
      ["CARDRECORD" /* CARDRECORD */]: "cardH",
      ["SCHEDULED_CARD" /* SCHEDULED_CARD */]: "card_review_",
      // Add other doctypes here as they get prefixed IDs
      ["DATASHAPE" /* DATASHAPE */]: "DATASHAPE",
      ["QUESTION" /* QUESTIONTYPE */]: "QUESTION",
      ["VIEW" /* VIEW */]: "VIEW",
      ["PEDAGOGY" /* PEDAGOGY */]: "PEDAGOGY",
      ["NAVIGATION_STRATEGY" /* NAVIGATION_STRATEGY */]: "NAVIGATION_STRATEGY",
      ["STRATEGY_STATE" /* STRATEGY_STATE */]: "STRATEGY_STATE",
      ["USER_OUTCOME" /* USER_OUTCOME */]: "USER_OUTCOME",
      ["STRATEGY_LEARNING_STATE" /* STRATEGY_LEARNING_STATE */]: "STRATEGY_LEARNING_STATE"
    };
  }
});

// src/core/util/index.ts
function areQuestionRecords(h) {
  return isQuestionRecord(h.records[0]);
}
function isQuestionRecord(c) {
  return c.userAnswer !== void 0;
}
function getCardHistoryID(courseID, cardID) {
  return `${DocTypePrefixes["CARDRECORD" /* CARDRECORD */]}-${courseID}-${cardID}`;
}
function parseCardHistoryID(id) {
  const split = id.split("-");
  let error = "";
  error += split.length === 3 ? "" : `
	given ID has incorrect number of '-' characters`;
  error += split[0] === DocTypePrefixes["CARDRECORD" /* CARDRECORD */] ? "" : `
	given ID does not start with ${DocTypePrefixes["CARDRECORD" /* CARDRECORD */]}`;
  if (split.length === 3 && split[0] === DocTypePrefixes["CARDRECORD" /* CARDRECORD */]) {
    return {
      courseID: split[1],
      cardID: split[2]
    };
  } else {
    throw new Error("parseCardHistory Error:" + error);
  }
}
function docIsDeleted(e) {
  return Boolean(e?.error === "not_found" && e?.reason === "deleted");
}
var init_util = __esm({
  "src/core/util/index.ts"() {
    "use strict";
    init_types_legacy();
  }
});

// src/impl/couch/pouchdb-setup.ts
import PouchDB from "pouchdb";
import PouchDBFind from "pouchdb-find";
import PouchDBAuth from "@nilock2/pouchdb-authentication";
var pouchdb_setup_default;
var init_pouchdb_setup = __esm({
  "src/impl/couch/pouchdb-setup.ts"() {
    "use strict";
    PouchDB.plugin(PouchDBFind);
    PouchDB.plugin(PouchDBAuth);
    if (typeof PouchDB.debug !== "undefined") {
      PouchDB.debug.disable();
    }
    PouchDB.defaults({
      // ajax: {
      //   timeout: 60000,
      // },
    });
    pouchdb_setup_default = PouchDB;
  }
});

// src/util/dataDirectory.ts
import * as fs from "fs";
import * as path from "path";
import * as os from "os";
function getAppDataDirectory() {
  if (ENV.LOCAL_STORAGE_PREFIX) {
    return path.join(os.homedir(), `.tuilder`, ENV.LOCAL_STORAGE_PREFIX);
  } else {
    return path.join(os.homedir(), ".tuilder");
  }
}
async function ensureAppDataDirectory() {
  const appDataDir = getAppDataDirectory();
  try {
    await fs.promises.mkdir(appDataDir, { recursive: true });
  } catch (err) {
    if (err.code !== "EEXIST") {
      throw new Error(`Failed to create app data directory ${appDataDir}: ${err.message}`);
    }
  }
  return appDataDir;
}
function getDbPath(dbName) {
  return path.join(getAppDataDirectory(), dbName);
}
async function initializeDataDirectory() {
  await ensureAppDataDirectory();
  logger.info(`PouchDB data directory initialized: ${getAppDataDirectory()}`);
}
var init_dataDirectory = __esm({
  "src/util/dataDirectory.ts"() {
    "use strict";
    init_logger();
    init_factory();
  }
});

// src/impl/common/userDBHelpers.ts
import moment from "moment";
function hexEncode(str) {
  let hex;
  let returnStr = "";
  for (let i = 0; i < str.length; i++) {
    hex = str.charCodeAt(i).toString(16);
    returnStr += ("000" + hex).slice(3);
  }
  return returnStr;
}
function filterAllDocsByPrefix(db, prefix, opts) {
  const options = {
    startkey: prefix,
    endkey: prefix + "\uFFF0",
    include_docs: true
  };
  if (opts) {
    Object.assign(options, opts);
  }
  return db.allDocs(options);
}
function getStartAndEndKeys(key) {
  return {
    startkey: key,
    endkey: key + "\uFFF0"
  };
}
function updateGuestAccountExpirationDate(guestDB) {
  const currentTime = moment.utc();
  const expirationDate = currentTime.add(2, "months").toISOString();
  const expiryDocID = "GuestAccountExpirationDate";
  void guestDB.get(expiryDocID).then((doc) => {
    return guestDB.put({
      _id: expiryDocID,
      _rev: doc._rev,
      date: expirationDate
    });
  }).catch(() => {
    return guestDB.put({
      _id: expiryDocID,
      date: expirationDate
    });
  });
}
function getLocalUserDB(username) {
  const dbName = `userdb-${username}`;
  if (typeof window === "undefined") {
    return new pouchdb_setup_default(getDbPath(dbName), {});
  } else {
    return new pouchdb_setup_default(dbName, {});
  }
}
function scheduleCardReviewLocal(userDB, review) {
  const now = moment.utc();
  logger.info(`Scheduling for review in: ${review.time.diff(now, "h") / 24} days`);
  void userDB.put({
    _id: DocTypePrefixes["SCHEDULED_CARD" /* SCHEDULED_CARD */] + review.time.format(REVIEW_TIME_FORMAT),
    cardId: review.card_id,
    reviewTime: review.time.toISOString(),
    courseId: review.course_id,
    scheduledAt: now.toISOString(),
    scheduledFor: review.scheduledFor,
    schedulingAgentId: review.schedulingAgentId
  });
}
async function removeScheduledCardReviewLocal(userDB, reviewDocID) {
  const reviewDoc = await userDB.get(reviewDocID);
  userDB.remove(reviewDoc).then((res) => {
    if (res.ok) {
      log2(`Removed Review Doc: ${reviewDocID}`);
    }
  }).catch((err) => {
    log2(`Failed to remove Review Doc: ${reviewDocID},
${JSON.stringify(err)}`);
  });
}
var REVIEW_TIME_FORMAT, log2;
var init_userDBHelpers = __esm({
  "src/impl/common/userDBHelpers.ts"() {
    "use strict";
    init_core();
    init_logger();
    init_pouchdb_setup();
    init_dataDirectory();
    REVIEW_TIME_FORMAT = "YYYY-MM-DD--kk:mm:ss-SSS";
    log2 = (s) => {
      logger.info(s);
    };
  }
});

// src/util/Loggable.ts
var Loggable;
var init_Loggable = __esm({
  "src/util/Loggable.ts"() {
    "use strict";
    Loggable = class {
      log(...args) {
        console.log(`LOG-${this._className}@${/* @__PURE__ */ new Date()}:`, ...args);
      }
      error(...args) {
        console.error(`ERROR-${this._className}@${/* @__PURE__ */ new Date()}:`, ...args);
      }
    };
  }
});

// src/impl/couch/updateQueue.ts
var UpdateQueue;
var init_updateQueue = __esm({
  "src/impl/couch/updateQueue.ts"() {
    "use strict";
    init_Loggable();
    init_logger();
    UpdateQueue = class extends Loggable {
      _className = "UpdateQueue";
      pendingUpdates = {};
      inprogressUpdates = {};
      readDB;
      // Database for read operations
      writeDB;
      // Database for write operations (local-first)
      /**
       * Queues an update for a document and applies it with conflict resolution.
       *
       * @param id - Document ID to update
       * @param update - Partial object or function that transforms the document
       * @returns Promise resolving to the updated document
       *
       * @throws {PouchError} with status 404 if document doesn't exist
       *
       * @remarks
       * **Error Handling Pattern:**
       * - This method does NOT create documents if they don't exist
       * - Callers are responsible for handling 404 errors and creating documents
       * - This design maintains separation of concerns (UpdateQueue handles conflicts, callers handle lifecycle)
       *
       * @example
       * ```typescript
       * try {
       *   await updateQueue.update(docId, (doc) => ({ ...doc, field: newValue }));
       * } catch (e) {
       *   if ((e as PouchError).status === 404) {
       *     // Create the document with initial values
       *     await db.put({ _id: docId, field: newValue, ...initialFields });
       *   }
       * }
       * ```
       */
      update(id, update) {
        logger.debug(`Update requested on doc: ${id}`);
        if (this.pendingUpdates[id]) {
          this.pendingUpdates[id].push(update);
        } else {
          this.pendingUpdates[id] = [update];
        }
        return this.applyUpdates(id);
      }
      constructor(readDB, writeDB) {
        super();
        this.readDB = readDB;
        this.writeDB = writeDB || readDB;
        logger.debug(`UpdateQ initialized...`);
        void this.readDB.info().then((i) => {
          logger.debug(`db info: ${JSON.stringify(i)}`);
        });
      }
      async applyUpdates(id) {
        logger.debug(`Applying updates on doc: ${id}`);
        if (this.inprogressUpdates[id]) {
          while (this.inprogressUpdates[id]) {
            await new Promise((resolve) => setTimeout(resolve, Math.random() * 50));
          }
          return this.applyUpdates(id);
        } else {
          if (this.pendingUpdates[id] && this.pendingUpdates[id].length > 0) {
            this.inprogressUpdates[id] = true;
            const MAX_RETRIES = 5;
            for (let i = 0; i < MAX_RETRIES; i++) {
              try {
                const doc = await this.readDB.get(id);
                let updatedDoc = { ...doc };
                const updatesToApply = [...this.pendingUpdates[id]];
                for (const update of updatesToApply) {
                  if (typeof update === "function") {
                    updatedDoc = { ...updatedDoc, ...update(updatedDoc) };
                  } else {
                    updatedDoc = {
                      ...updatedDoc,
                      ...update
                    };
                  }
                }
                await this.writeDB.put(updatedDoc);
                this.pendingUpdates[id].splice(0, updatesToApply.length);
                if (this.pendingUpdates[id].length === 0) {
                  this.inprogressUpdates[id] = false;
                  delete this.inprogressUpdates[id];
                } else {
                  return this.applyUpdates(id);
                }
                return updatedDoc;
              } catch (e) {
                if (e.name === "conflict" && i < MAX_RETRIES - 1) {
                  logger.warn(`Conflict on update for doc ${id}, retry #${i + 1}`);
                  await new Promise((res) => setTimeout(res, 50 * Math.random()));
                } else if (e.name === "not_found" && i === 0) {
                  logger.warn(`Update failed for ${id} - does not exist. Throwing to caller.`);
                  delete this.inprogressUpdates[id];
                  throw e;
                } else {
                  delete this.inprogressUpdates[id];
                  if (this.pendingUpdates[id]) {
                    delete this.pendingUpdates[id];
                  }
                  logger.error(`Error on attemped update (retry ${i}): ${JSON.stringify(e)}`);
                  throw e;
                }
              }
            }
            throw new Error(`UpdateQueue failed for doc ${id} after ${MAX_RETRIES} retries.`);
          } else {
            throw new Error(`Empty Updates Queue Triggered`);
          }
        }
      }
    };
  }
});

// src/impl/couch/user-course-relDB.ts
import moment2 from "moment";
var UsrCrsData;
var init_user_course_relDB = __esm({
  "src/impl/couch/user-course-relDB.ts"() {
    "use strict";
    init_logger();
    UsrCrsData = class {
      user;
      _courseId;
      constructor(user, courseId) {
        this.user = user;
        this._courseId = courseId;
      }
      async getReviewsForcast(daysCount) {
        const time = moment2.utc().add(daysCount, "days");
        return this.getReviewstoDate(time);
      }
      async getPendingReviews() {
        const now = moment2.utc();
        return this.getReviewstoDate(now);
      }
      async getScheduledReviewCount() {
        return (await this.getPendingReviews()).length;
      }
      async getCourseSettings() {
        const regDoc = await this.user.getCourseRegistrationsDoc();
        const crsDoc = regDoc.courses.find((c) => c.courseID === this._courseId);
        if (crsDoc && crsDoc.settings) {
          return crsDoc.settings;
        } else {
          logger.warn(`no settings found during lookup on course ${this._courseId}`);
          return {};
        }
      }
      updateCourseSettings(updates) {
        if ("updateCourseSettings" in this.user) {
          void this.user.updateCourseSettings(this._courseId, updates);
        }
      }
      async getStrategyState(strategyKey) {
        return this.user.getStrategyState(this._courseId, strategyKey);
      }
      async putStrategyState(strategyKey, data) {
        return this.user.putStrategyState(this._courseId, strategyKey, data);
      }
      async deleteStrategyState(strategyKey) {
        return this.user.deleteStrategyState(this._courseId, strategyKey);
      }
      async getReviewstoDate(targetDate) {
        const allReviews = await this.user.getPendingReviews(this._courseId);
        logger.debug(
          `Fetching ${this.user.getUsername()}'s scheduled reviews for course ${this._courseId}.`
        );
        return allReviews.filter((review) => {
          const reviewTime = moment2.utc(review.reviewTime);
          return targetDate.isAfter(reviewTime);
        });
      }
    };
  }
});

// src/impl/couch/clientCache.ts
async function GET_CACHED(k, f) {
  if (CLIENT_CACHE[k]) {
    return CLIENT_CACHE[k];
  }
  CLIENT_CACHE[k] = f ? await f(k) : await GET_ITEM(k);
  return GET_CACHED(k);
}
async function GET_ITEM(k) {
  throw new Error(`No implementation found for GET_CACHED(${k})`);
}
var CLIENT_CACHE;
var init_clientCache = __esm({
  "src/impl/couch/clientCache.ts"() {
    "use strict";
    CLIENT_CACHE = {};
  }
});

// src/impl/couch/courseAPI.ts
import { NameSpacer } from "@vue-skuilder/common";
import { blankCourseElo, toCourseElo } from "@vue-skuilder/common";
import { prepareNote55 } from "@vue-skuilder/common";
import { v4 as uuidv4 } from "uuid";
async function addNote55(courseID, codeCourse, shape, data, author, tags, uploads, elo = blankCourseElo()) {
  const db = getCourseDB(courseID);
  const payload = prepareNote55(courseID, codeCourse, shape, data, author, tags, uploads);
  const _id = `${DocTypePrefixes["DISPLAYABLE_DATA" /* DISPLAYABLE_DATA */]}-${uuidv4()}`;
  const result = await db.put({ ...payload, _id });
  const dataShapeId = NameSpacer.getDataShapeString({
    course: codeCourse,
    dataShape: shape.name
  });
  if (result.ok) {
    try {
      await createCards(courseID, dataShapeId, result.id, tags, elo, author);
    } catch (error) {
      let errorMessage = "Unknown error";
      if (error instanceof Error) {
        errorMessage = error.message;
      } else if (error && typeof error === "object" && "reason" in error) {
        errorMessage = error.reason;
      } else if (error && typeof error === "object" && "message" in error) {
        errorMessage = error.message;
      } else {
        errorMessage = String(error);
      }
      logger.error(`[addNote55] Failed to create cards for note ${result.id}: ${errorMessage}`);
      result.cardCreationFailed = true;
      result.cardCreationError = errorMessage;
    }
  } else {
    logger.error(`[addNote55] Error adding note. Result: ${JSON.stringify(result)}`);
  }
  return result;
}
async function createCards(courseID, datashapeID, noteID, tags, elo = blankCourseElo(), author) {
  const cfg = await getCredentialledCourseConfig(courseID);
  const dsDescriptor = NameSpacer.getDataShapeDescriptor(datashapeID);
  let questionViewTypes = [];
  for (const ds of cfg.dataShapes) {
    if (ds.name === datashapeID) {
      questionViewTypes = ds.questionTypes;
    }
  }
  if (questionViewTypes.length === 0) {
    const errorMsg = `No questionViewTypes found for datashapeID: ${datashapeID} in course config. Cards cannot be created.`;
    logger.error(errorMsg);
    throw new Error(errorMsg);
  }
  for (const questionView of questionViewTypes) {
    await createCard(questionView, courseID, dsDescriptor, noteID, tags, elo, author);
  }
}
async function createCard(questionViewName, courseID, dsDescriptor, noteID, tags, elo = blankCourseElo(), author) {
  const qDescriptor = NameSpacer.getQuestionDescriptor(questionViewName);
  const cfg = await getCredentialledCourseConfig(courseID);
  for (const rQ of cfg.questionTypes) {
    if (rQ.name === questionViewName) {
      for (const view of rQ.viewList) {
        await addCard(
          courseID,
          dsDescriptor.course,
          [noteID],
          NameSpacer.getViewString({
            course: qDescriptor.course,
            questionType: qDescriptor.questionType,
            view
          }),
          elo,
          tags,
          author
        );
      }
    }
  }
}
async function addCard(courseID, course, id_displayable_data, id_view, elo, tags, author) {
  const db = getCourseDB(courseID);
  const _id = `${DocTypePrefixes["CARD" /* CARD */]}-${uuidv4()}`;
  const card = await db.put({
    _id,
    course,
    id_displayable_data,
    id_view,
    docType: "CARD" /* CARD */,
    elo: elo || toCourseElo(990 + Math.round(20 * Math.random())),
    author
  });
  for (const tag of tags) {
    logger.info(`adding tag: ${tag} to card ${card.id}`);
    await addTagToCard(courseID, card.id, tag, author, false);
  }
  return card;
}
async function getCredentialledCourseConfig(courseID) {
  try {
    const db = getCourseDB(courseID);
    const ret = await db.get("CourseConfig");
    ret.courseID = courseID;
    logger.info(`Returning course config: ${JSON.stringify(ret)}`);
    return ret;
  } catch (e) {
    logger.error(`Error fetching config for ${courseID}:`, e);
    throw e;
  }
}
async function addTagToCard(courseID, cardID, tagID, author, updateELO = true) {
  const prefixedTagID = getTagID(tagID);
  const courseDB = getCourseDB(courseID);
  const courseApi = new CourseDB(courseID, async () => {
    const dummySyncStrategy = {
      setupRemoteDB: () => null,
      startSync: () => {
      },
      canCreateAccount: () => false,
      canAuthenticate: () => false,
      getCurrentUsername: async () => "DummyUser"
    };
    return BaseUser.Dummy(dummySyncStrategy);
  });
  try {
    logger.info(`Applying tag ${tagID} to card ${courseID + "-" + cardID}...`);
    const tag = await courseDB.get(prefixedTagID);
    if (!tag.taggedCards.includes(cardID)) {
      tag.taggedCards.push(cardID);
      if (updateELO) {
        try {
          const eloData = await courseApi.getCardEloData([cardID]);
          const elo = eloData[0];
          elo.tags[tagID] = {
            count: 0,
            score: elo.global.score
            // todo: or 1000?
          };
          await updateCardElo(courseID, cardID, elo);
        } catch (error) {
          logger.error("Failed to update ELO data for card:", cardID, error);
        }
      }
      return courseDB.put(tag);
    } else throw new AlreadyTaggedErr(`Card ${cardID} is already tagged with ${tagID}`);
  } catch (e) {
    if (e instanceof AlreadyTaggedErr) {
      throw e;
    }
    await createTag(courseID, tagID, author);
    return addTagToCard(courseID, cardID, tagID, author, updateELO);
  }
}
async function updateCardElo(courseID, cardID, elo) {
  if (elo) {
    const cDB = getCourseDB(courseID);
    const card = await cDB.get(cardID);
    logger.debug(`Replacing ${JSON.stringify(card.elo)} with ${JSON.stringify(elo)}`);
    card.elo = elo;
    return cDB.put(card);
  }
}
function getTagID(tagName) {
  const tagPrefix = "TAG" /* TAG */.valueOf() + "-";
  if (tagName.indexOf(tagPrefix) === 0) {
    return tagName;
  } else {
    return tagPrefix + tagName;
  }
}
function getCourseDB(courseID) {
  const dbName = `coursedb-${courseID}`;
  return new pouchdb_setup_default(
    ENV.COUCHDB_SERVER_PROTOCOL + "://" + ENV.COUCHDB_SERVER_URL + dbName,
    createPouchDBConfig()
  );
}
var AlreadyTaggedErr;
var init_courseAPI = __esm({
  "src/impl/couch/courseAPI.ts"() {
    "use strict";
    init_pouchdb_setup();
    init_couch();
    init_factory();
    init_courseDB();
    init_types_legacy();
    init_common();
    init_logger();
    AlreadyTaggedErr = class extends Error {
      constructor(message) {
        super(message);
        this.name = "AlreadyTaggedErr";
      }
    };
  }
});

// src/impl/couch/courseLookupDB.ts
var courseLookupDBTitle, CourseLookup;
var init_courseLookupDB = __esm({
  "src/impl/couch/courseLookupDB.ts"() {
    "use strict";
    init_pouchdb_setup();
    init_factory();
    init_logger();
    courseLookupDBTitle = "coursedb-lookup";
    logger.debug(`COURSELOOKUP FILE RUNNING`);
    CourseLookup = class _CourseLookup {
      // [ ] this db should be read only for public, admin-only for write
      // Cache for the PouchDB instance
      static _dbInstance = null;
      /**
       * Static getter for the PouchDB database instance.
       * Connects using ENV variables and caches the instance.
       * Throws an error if required ENV variables are not set.
       */
      static get _db() {
        if (this._dbInstance) {
          return this._dbInstance;
        }
        if (ENV.COUCHDB_SERVER_URL === "NOT_SET" || !ENV.COUCHDB_SERVER_URL) {
          throw new Error(
            "CourseLookup.db: COUCHDB_SERVER_URL is not set. Ensure initializeDataLayer has been called with valid configuration."
          );
        }
        if (ENV.COUCHDB_SERVER_PROTOCOL === "NOT_SET" || !ENV.COUCHDB_SERVER_PROTOCOL) {
          throw new Error(
            "CourseLookup.db: COUCHDB_SERVER_PROTOCOL is not set. Ensure initializeDataLayer has been called with valid configuration."
          );
        }
        const dbUrl = `${ENV.COUCHDB_SERVER_PROTOCOL}://${ENV.COUCHDB_SERVER_URL}/${courseLookupDBTitle}`;
        const options = {
          // fetch: (url, opts) => { // Optional: Add for debugging network requests
          //   console.log('PouchDB fetch:', url, opts);
          //   return pouch.fetch(url, opts);
          // }
        };
        if (ENV.COUCHDB_USERNAME && ENV.COUCHDB_PASSWORD) {
          options.auth = {
            username: ENV.COUCHDB_USERNAME,
            password: ENV.COUCHDB_PASSWORD
          };
          logger.info(`CourseLookup: Connecting to ${dbUrl} with authentication.`);
        } else {
          logger.info(`CourseLookup: Connecting to ${dbUrl} without authentication.`);
        }
        try {
          this._dbInstance = new pouchdb_setup_default(dbUrl, options);
          logger.info(`CourseLookup: Database instance created for ${courseLookupDBTitle}.`);
          return this._dbInstance;
        } catch (error) {
          logger.error(`CourseLookup: Failed to create PouchDB instance for ${dbUrl}`, error);
          this._dbInstance = null;
          throw new Error(
            `CourseLookup: Failed to initialize database connection: ${error instanceof Error ? error.message : String(error)}`
          );
        }
      }
      /**
       * Adds a new course to the lookup database, and returns the courseID
       * @param courseName
       * @returns
       */
      static async add(courseName) {
        const resp = await _CourseLookup._db.post({
          name: courseName
        });
        return resp.id;
      }
      /**
       * Adds a new course to the lookup database with a specific courseID
       * @param courseId The specific course ID to use
       * @param courseName The course name
       * @param disambiguator Optional disambiguator
       * @returns Promise<void>
       */
      static async addWithId(courseId, courseName, disambiguator) {
        const doc = {
          _id: courseId,
          name: courseName
        };
        if (disambiguator) {
          doc.disambiguator = disambiguator;
        }
        await _CourseLookup._db.put(doc);
      }
      /**
       * Removes a course from the index
       * @param courseID
       */
      static async delete(courseID) {
        const doc = await _CourseLookup._db.get(courseID);
        return await _CourseLookup._db.remove(doc);
      }
      // [ ] rename to allCourses()
      static async allCourseWare() {
        const resp = await _CourseLookup._db.allDocs({
          include_docs: true
        });
        return resp.rows.map((row) => row.doc);
      }
      static async updateDisambiguator(courseID, disambiguator) {
        const doc = await _CourseLookup._db.get(courseID);
        doc.disambiguator = disambiguator;
        return await _CourseLookup._db.put(doc);
      }
      static async isCourse(courseID) {
        try {
          await _CourseLookup._db.get(courseID);
          return true;
        } catch (error) {
          logger.info(`Courselookup failed:`, error);
          return false;
        }
      }
    };
  }
});

// src/core/navigators/diversityRerank.ts
var diversityRerank_exports = {};
__export(diversityRerank_exports, {
  DIVERSITY_FLOOR: () => DIVERSITY_FLOOR,
  DIVERSITY_STRENGTH: () => DIVERSITY_STRENGTH,
  diversityRerank: () => diversityRerank
});
function diversityRerank(cards, opts = {}) {
  const strength = opts.strength ?? DIVERSITY_STRENGTH;
  const floor = opts.floor ?? DIVERSITY_FLOOR;
  const n = cards.length;
  if (n <= 1) return cards;
  const df = /* @__PURE__ */ new Map();
  for (const card of cards) {
    for (const tag of card.tags ?? []) {
      df.set(tag, (df.get(tag) ?? 0) + 1);
    }
  }
  const idf = /* @__PURE__ */ new Map();
  for (const [tag, freq] of df) {
    idf.set(tag, Math.log(n / freq));
  }
  const remaining = [...cards];
  const emittedCount = /* @__PURE__ */ new Map();
  const out = [];
  const repetitionLoad = (card) => {
    let load = 0;
    for (const tag of card.tags ?? []) {
      const seen = emittedCount.get(tag);
      if (seen) load += (idf.get(tag) ?? 0) * seen;
    }
    return load;
  };
  while (remaining.length > 0) {
    let bestIdx = 0;
    let bestValue = -Infinity;
    let bestPenalty = 1;
    let bestLoad = 0;
    for (let i = 0; i < remaining.length; i++) {
      const card = remaining[i];
      const load = repetitionLoad(card);
      const penalty = load > 0 ? Math.max(floor, 1 / (1 + strength * load)) : 1;
      const value = card.score * penalty;
      if (value > bestValue) {
        bestValue = value;
        bestIdx = i;
        bestPenalty = penalty;
        bestLoad = load;
      }
    }
    const [picked] = remaining.splice(bestIdx, 1);
    if (Number.isFinite(picked.score) && bestPenalty < 1) {
      const newScore = picked.score * bestPenalty;
      out.push({
        ...picked,
        score: newScore,
        provenance: [
          ...picked.provenance,
          {
            strategy: STRATEGY,
            strategyId: STRATEGY_ID,
            strategyName: STRATEGY_NAME,
            action: "penalized",
            score: newScore,
            reason: `repeated tags (load ${bestLoad.toFixed(2)}) \u2192 \xD7${bestPenalty.toFixed(2)}`
          }
        ]
      });
    } else {
      out.push(picked);
    }
    for (const tag of picked.tags ?? []) {
      emittedCount.set(tag, (emittedCount.get(tag) ?? 0) + 1);
    }
  }
  return out;
}
var DIVERSITY_STRENGTH, DIVERSITY_FLOOR, STRATEGY, STRATEGY_ID, STRATEGY_NAME;
var init_diversityRerank = __esm({
  "src/core/navigators/diversityRerank.ts"() {
    "use strict";
    DIVERSITY_STRENGTH = 0.6;
    DIVERSITY_FLOOR = 0.3;
    STRATEGY = "diversityRerank";
    STRATEGY_ID = "DIVERSITY_RERANK";
    STRATEGY_NAME = "Diversity Re-rank";
  }
});

// src/core/navigators/PipelineDebugger.ts
var PipelineDebugger_exports = {};
__export(PipelineDebugger_exports, {
  buildRunReport: () => buildRunReport,
  captureRun: () => captureRun,
  clearRunHistory: () => clearRunHistory,
  getActivePipeline: () => getActivePipeline,
  mountPipelineDebugger: () => mountPipelineDebugger,
  pipelineDebugAPI: () => pipelineDebugAPI,
  registerPipelineForDebug: () => registerPipelineForDebug
});
function registerPipelineForDebug(pipeline) {
  _activePipeline = pipeline;
}
function getActivePipeline() {
  return _activePipeline;
}
function clearRunHistory() {
  runHistory.length = 0;
}
function getOrigin(card) {
  const firstEntry = card.provenance[0];
  if (!firstEntry) return "unknown";
  const reason = firstEntry.reason?.toLowerCase() || "";
  const strategy = firstEntry.strategy?.toLowerCase() || "";
  if (reason.includes("new card") || strategy.includes("elo")) return "new";
  if (reason.includes("review") || strategy.includes("srs")) return "review";
  return "unknown";
}
function captureRun(report) {
  const fullReport = {
    ...report,
    runId: `run-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    timestamp: /* @__PURE__ */ new Date()
  };
  runHistory.unshift(fullReport);
  if (runHistory.length > MAX_RUNS) {
    runHistory.pop();
  }
}
function parseCardElo(provenance) {
  const eloEntry = provenance.find((p) => p.strategy === "elo");
  if (!eloEntry?.reason) return void 0;
  const match = eloEntry.reason.match(/card:\s*(\d+)/);
  return match ? parseInt(match[1], 10) : void 0;
}
function buildRunReport(courseId, courseName, generatorName, generators, generatedCount, filters, allCards, selectedCards, userElo, hints) {
  const selectedIds = new Set(selectedCards.map((c) => c.cardId));
  const toReport = (card) => ({
    cardId: card.cardId,
    courseId: card.courseId,
    origin: getOrigin(card),
    generator: card.provenance[0]?.strategyName || card.provenance[0]?.strategy,
    finalScore: card.score,
    cardElo: parseCardElo(card.provenance),
    provenance: card.provenance,
    tags: card.tags,
    selected: selectedIds.has(card.cardId)
  });
  const selectedReported = [];
  const nearMissReported = [];
  const discardedTailCards = [];
  let nonSelectedSeen = 0;
  for (const card of allCards) {
    if (selectedIds.has(card.cardId)) {
      selectedReported.push(toReport(card));
    } else if (nonSelectedSeen < DISCARDED_KEEP_TOP) {
      nearMissReported.push(toReport(card));
      nonSelectedSeen++;
    } else {
      discardedTailCards.push(card);
    }
  }
  const cards = [...selectedReported, ...nearMissReported];
  let discardedTail;
  if (discardedTailCards.length > 0) {
    let scoreMin = Infinity;
    let scoreMax = -Infinity;
    let eloMin = Infinity;
    let eloMax = -Infinity;
    let eloSeen = false;
    for (const c of discardedTailCards) {
      if (c.score < scoreMin) scoreMin = c.score;
      if (c.score > scoreMax) scoreMax = c.score;
      const elo = parseCardElo(c.provenance);
      if (elo !== void 0) {
        eloSeen = true;
        if (elo < eloMin) eloMin = elo;
        if (elo > eloMax) eloMax = elo;
      }
    }
    const eloFragment = eloSeen ? `, ELO ${eloMin}\u2013${eloMax}` : "";
    discardedTail = {
      count: discardedTailCards.length,
      scoreRange: [scoreMin, scoreMax],
      eloRange: eloSeen ? [eloMin, eloMax] : void 0,
      note: `${discardedTailCards.length} additional candidate(s) scored below the top ${DISCARDED_KEEP_TOP} near-misses and were not retained (score ${scoreMin.toExponential(2)}\u2013${scoreMax.toExponential(2)}${eloFragment}). Likely ELO-window pull remnants filtered out by hierarchy/lesson/priority gates.`
    };
  }
  const reviewsSelected = selectedCards.filter((c) => getOrigin(c) === "review").length;
  const newSelected = selectedCards.filter((c) => getOrigin(c) === "new").length;
  return {
    courseId,
    courseName,
    userElo,
    generatorName,
    generators,
    generatedCount,
    filters,
    hints,
    finalCount: selectedCards.length,
    reviewsSelected,
    newSelected,
    cards,
    discardedTail
  };
}
function formatProvenance(provenance) {
  return provenance.map((p) => {
    const actionSymbol = p.action === "generated" ? "\u{1F3B2}" : p.action === "boosted" ? "\u2B06\uFE0F" : p.action === "penalized" ? "\u2B07\uFE0F" : "\u27A1\uFE0F";
    return `  ${actionSymbol} ${p.strategyName}: ${p.score.toFixed(3)} - ${p.reason}`;
  }).join("\n");
}
function printRunSummary(run) {
  console.group(`\u{1F50D} Pipeline Run: ${run.courseId} (${run.courseName || "unnamed"})`);
  logger.info(`Run ID: ${run.runId}`);
  logger.info(`Time: ${run.timestamp.toISOString()}`);
  logger.info(`User ELO: ${run.userElo ?? "unknown"}`);
  logger.info(`Generator: ${run.generatorName} \u2192 ${run.generatedCount} candidates`);
  if (run.generators && run.generators.length > 0) {
    console.group("Generator breakdown:");
    for (const g of run.generators) {
      logger.info(
        `  ${g.name}: ${g.cardCount} cards (${g.newCount} new, ${g.reviewCount} reviews, top: ${g.topScore.toFixed(2)})`
      );
    }
    console.groupEnd();
  }
  if (run.filters.length > 0) {
    console.group("Filter impact:");
    for (const f of run.filters) {
      logger.info(`  ${f.name}: \u2191${f.boosted} \u2193${f.penalized} =${f.passed} \u2715${f.removed}`);
    }
    console.groupEnd();
  }
  logger.info(
    `Result: ${run.finalCount} cards selected (${run.newSelected} new, ${run.reviewsSelected} reviews)`
  );
  console.groupEnd();
}
function escapeHtml(s) {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function escapeAttr(s) {
  return escapeHtml(s).replace(/"/g, "&quot;");
}
function copyTextToClipboard(text, btn) {
  const done = () => {
    if (!btn) return;
    const orig = btn.textContent ?? "Copy";
    btn.textContent = "Copied!";
    btn.classList.add("copied");
    setTimeout(() => {
      btn.textContent = orig;
      btn.classList.remove("copied");
    }, 1200);
  };
  const fallback = () => {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand("copy");
    } catch (e) {
      logger.warn(`[Pipeline Debug] Copy failed: ${e}`);
    }
    document.body.removeChild(ta);
    done();
  };
  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(text).then(done).catch(fallback);
  } else {
    fallback();
  }
}
function renderUI() {
  if (!_uiContainer) return;
  const runs = runHistory;
  const selectedRun = _selectedRunIndex !== null ? runs[_selectedRunIndex] : null;
  const styles = `
    #sk-pipeline-debugger {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: #f8f9fa;
      color: #212529;
      z-index: 999999;
      display: flex;
      flex-direction: column;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
      font-size: 14px;
    }
    #sk-pipeline-debugger header {
      padding: 1rem;
      background: #343a40;
      color: white;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    #sk-pipeline-debugger .container {
      display: flex;
      flex: 1;
      overflow: hidden;
    }
    #sk-pipeline-debugger .sidebar {
      width: 300px;
      border-right: 1px solid #dee2e6;
      overflow-y: auto;
      background: white;
    }
    #sk-pipeline-debugger .main-content {
      flex: 1;
      overflow-y: auto;
      padding: 1.5rem;
    }
    #sk-pipeline-debugger .run-item {
      padding: 0.75rem 1rem;
      border-bottom: 1px solid #eee;
      cursor: pointer;
    }
    #sk-pipeline-debugger .run-item:hover { background: #f1f3f5; }
    #sk-pipeline-debugger .run-item.active { background: #e9ecef; border-left: 4px solid #007bff; }
    #sk-pipeline-debugger h2, #sk-pipeline-debugger h3 { margin-top: 0; }
    #sk-pipeline-debugger table { width: 100%; border-collapse: collapse; margin-bottom: 1rem; background: white; }
    #sk-pipeline-debugger th, #sk-pipeline-debugger td { border: 1px solid #dee2e6; padding: 0.5rem; text-align: left; }
    #sk-pipeline-debugger th { background: #f1f3f5; }
    #sk-pipeline-debugger code { background: #f1f3f5; padding: 0.1rem 0.3rem; border-radius: 3px; font-family: monospace; }
    #sk-pipeline-debugger .close-btn { background: #dc3545; color: white; border: none; padding: 0.5rem 1rem; border-radius: 4px; cursor: pointer; }
    #sk-pipeline-debugger .search-box { margin-bottom: 1rem; width: 100%; padding: 0.5rem; border: 1px solid #ced4da; border-radius: 4px; }
    #sk-pipeline-debugger .provenance { font-size: 12px; color: #666; margin-top: 0.25rem; white-space: pre-wrap; font-family: monospace; background: #f8f9fa; padding: 0.5rem; border-radius: 4px; }
    #sk-pipeline-debugger .run-label { display: inline-block; margin-top: 0.25rem; padding: 0.1rem 0.4rem; background: #fff3cd; color: #664d03; border-radius: 3px; font-family: monospace; font-size: 11px; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; vertical-align: bottom; }
    #sk-pipeline-debugger .label-banner { display: inline-block; padding: 0.25rem 0.6rem; background: #fff3cd; color: #664d03; border-radius: 4px; font-family: monospace; font-size: 13px; margin: 0 0 0.75rem 0; }
    #sk-pipeline-debugger .copy-btn { background: #0d6efd; color: white; border: none; padding: 0.25rem 0.6rem; border-radius: 3px; cursor: pointer; font-size: 12px; margin-left: 0.5rem; }
    #sk-pipeline-debugger .copy-btn:hover { background: #0b5ed7; }
    #sk-pipeline-debugger .copy-btn.copied { background: #198754; }
    #sk-pipeline-debugger .section-head { display: flex; align-items: center; justify-content: space-between; margin-top: 1rem; }
    #sk-pipeline-debugger .section-head h3 { margin: 0; }
  `;
  const runListHtml = runs.length === 0 ? '<div style="padding: 1rem;">No runs captured yet.</div>' : runs.map(
    (r, i) => `
        <div class="run-item ${i === _selectedRunIndex ? "active" : ""}" onclick="window.skuilder.pipeline._selectRun(${i})">
          <strong>${r.timestamp.toLocaleTimeString()}</strong><br/>
          <small>${r.courseName || r.courseId.slice(0, 8)}</small><br/>
          <small>${r.finalCount} cards selected</small>
          ${r.hints?._label ? `<br/><span class="run-label" title="${escapeAttr(r.hints._label)}">${escapeHtml(r.hints._label)}</span>` : ""}
        </div>
      `
  ).join("");
  let detailsHtml = '<div style="color: #6c757d; text-align: center; margin-top: 5rem;">Select a run to see details</div>';
  if (selectedRun) {
    const filteredCards = selectedRun.cards.filter(
      (c) => !_cardSearchQuery || c.cardId.toLowerCase().includes(_cardSearchQuery.toLowerCase())
    );
    const labelText = selectedRun.hints?._label ?? "(no label)";
    detailsHtml = `
      <h2>Run: ${selectedRun.runId}</h2>
      <div class="label-banner" title="${escapeAttr(labelText)}">${escapeHtml(labelText)}</div>
      <p>
        <strong>Time:</strong> ${selectedRun.timestamp.toLocaleString()} |
        <strong>Course:</strong> ${selectedRun.courseName || selectedRun.courseId} |
        <strong>User ELO:</strong> ${selectedRun.userElo ?? "unknown"}
      </p>

      <h3>Pipeline Config</h3>
      <table>
        <tr><th>Generator</th><td>${selectedRun.generatorName} (${selectedRun.generatedCount} candidates)</td></tr>
        ${(selectedRun.generators || []).map(
      (g) => `
          <tr><td style="padding-left: 2rem;">\u21B3 ${g.name}</td><td>${g.cardCount} cards (${g.newCount} new, ${g.reviewCount} review, top: ${g.topScore.toFixed(2)})</td></tr>
        `
    ).join("")}
      </table>

      ${selectedRun.hints ? `
        <div class="section-head">
          <h3>Ephemeral Hints</h3>
          <button class="copy-btn" onclick="window.skuilder.pipeline._copyConfig('${selectedRun.runId}', this)">Copy config</button>
        </div>
        <table>
          ${selectedRun.hints._label ? `<tr><th>Label</th><td>${selectedRun.hints._label}</td></tr>` : ""}
          ${selectedRun.hints.boostTags ? `<tr><th>Boost Tags</th><td><pre style="margin:0">${JSON.stringify(selectedRun.hints.boostTags, null, 2)}</pre></td></tr>` : ""}
          ${selectedRun.hints.boostCards ? `<tr><th>Boost Cards</th><td><pre style="margin:0">${JSON.stringify(selectedRun.hints.boostCards, null, 2)}</pre></td></tr>` : ""}
          ${selectedRun.hints.requireTags ? `<tr><th>Require Tags</th><td>${selectedRun.hints.requireTags.join(", ")}</td></tr>` : ""}
          ${selectedRun.hints.requireCards ? `<tr><th>Require Cards</th><td>${selectedRun.hints.requireCards.join(", ")}</td></tr>` : ""}
          ${selectedRun.hints.excludeTags ? `<tr><th>Exclude Tags</th><td>${selectedRun.hints.excludeTags.join(", ")}</td></tr>` : ""}
          ${selectedRun.hints.excludeCards ? `<tr><th>Exclude Cards</th><td>${selectedRun.hints.excludeCards.join(", ")}</td></tr>` : ""}
        </table>
      ` : ""}

      <h3>Filter Impact</h3>
      <table>
        <thead><tr><th>Filter</th><th>Boosted</th><th>Penalized</th><th>Passed</th><th>Removed</th></tr></thead>
        <tbody>
          ${selectedRun.filters.map(
      (f) => `
            <tr><td>${f.name}</td><td>\u2191${f.boosted}</td><td>\u2193${f.penalized}</td><td>=${f.passed}</td><td>\u2715${f.removed}</td></tr>
          `
    ).join("")}
        </tbody>
      </table>

      <div class="section-head">
        <h3>Cards (${selectedRun.finalCount} selected / ${selectedRun.cards.length} total)</h3>
        <button class="copy-btn" onclick="window.skuilder.pipeline._copyResults('${selectedRun.runId}', this)">Copy results</button>
      </div>
      <input type="text" class="search-box" placeholder="Search Card ID..." value="${_cardSearchQuery}" oninput="window.skuilder.pipeline._setSearch(this.value)">
      
      <table>
        <thead><tr><th>ID</th><th>Generator</th><th>Origin</th><th>Score</th><th>Selected</th></tr></thead>
        <tbody>
          ${filteredCards.map(
      (c) => `
            <tr>
              <td><code>${c.cardId}</code></td>
              <td>${c.generator || "unknown"}</td>
              <td>${c.origin}</td>
              <td>${c.finalScore.toFixed(3)}</td>
              <td>${c.selected ? "\u2705" : "\u274C"}</td>
            </tr>
            ${c.selected || _cardSearchQuery ? `
              <tr>
                <td colspan="5">
                  <div class="provenance">${formatProvenance(c.provenance)}</div>
                </td>
              </tr>
            ` : ""}
          `
    ).join("")}
        </tbody>
      </table>
    `;
  }
  _uiContainer.innerHTML = `
    <style>${styles}</style>
    <header>
      <strong>Pipeline Debugger</strong>
      <button class="close-btn" onclick="window.skuilder.pipeline.ui()">Close</button>
    </header>
    <div class="container">
      <div class="sidebar">${runListHtml}</div>
      <div class="main-content">${detailsHtml}</div>
    </div>
  `;
}
function mountPipelineDebugger() {
  if (typeof window === "undefined") return;
  const win = window;
  win.skuilder = win.skuilder || {};
  win.skuilder.pipeline = pipelineDebugAPI;
}
var _activePipeline, MAX_RUNS, runHistory, DISCARDED_KEEP_TOP, _uiContainer, _selectedRunIndex, _cardSearchQuery, pipelineDebugAPI;
var init_PipelineDebugger = __esm({
  "src/core/navigators/PipelineDebugger.ts"() {
    "use strict";
    init_navigators();
    init_logger();
    _activePipeline = null;
    MAX_RUNS = 10;
    runHistory = [];
    DISCARDED_KEEP_TOP = 25;
    _uiContainer = null;
    _selectedRunIndex = null;
    _cardSearchQuery = "";
    pipelineDebugAPI = {
      /**
       * Get raw run history for programmatic access.
       */
      get runs() {
        return [...runHistory];
      },
      /**
       * Show summary of a specific pipeline run.
       */
      showRun(idOrIndex = 0) {
        if (runHistory.length === 0) {
          logger.info("[Pipeline Debug] No runs captured yet.");
          return;
        }
        let run;
        if (typeof idOrIndex === "number") {
          run = runHistory[idOrIndex];
          if (!run) {
            logger.info(
              `[Pipeline Debug] No run found at index ${idOrIndex}. History length: ${runHistory.length}`
            );
            return;
          }
        } else {
          run = runHistory.find((r) => r.runId.endsWith(idOrIndex));
          if (!run) {
            logger.info(`[Pipeline Debug] No run found matching ID '${idOrIndex}'.`);
            return;
          }
        }
        printRunSummary(run);
      },
      /**
       * Show summary of the last pipeline run.
       */
      showLastRun() {
        this.showRun(0);
      },
      /**
       * Show detailed provenance for a specific card.
       */
      showCard(cardId) {
        for (const run of runHistory) {
          const card = run.cards.find((c) => c.cardId === cardId);
          if (card) {
            console.group(`\u{1F3B4} Card: ${cardId}`);
            logger.info(`Course: ${card.courseId}`);
            logger.info(`Origin: ${card.origin}`);
            logger.info(`Card ELO: ${card.cardElo ?? "unknown"} | User ELO: ${run.userElo ?? "unknown"}`);
            logger.info(`Final score: ${card.finalScore.toFixed(3)}`);
            logger.info(`Selected: ${card.selected ? "Yes \u2705" : "No \u274C"}`);
            if (card.tags && card.tags.length > 0) {
              logger.info(`Tags (${card.tags.length}): ${card.tags.join(", ")}`);
            }
            logger.info("Provenance:");
            logger.info(formatProvenance(card.provenance));
            console.groupEnd();
            return;
          }
        }
        const runsWithTails = runHistory.filter((r) => r.discardedTail && r.discardedTail.count > 0);
        if (runsWithTails.length > 0) {
          logger.info(
            `[Pipeline Debug] Card '${cardId}' not found in retained cards. ${runsWithTails.length} run(s) have discarded tails that were not retained \u2014 the card may have been a low-score candidate. See run.discardedTail for ranges.`
          );
        } else {
          logger.info(`[Pipeline Debug] Card '${cardId}' not found in recent runs.`);
        }
      },
      /**
       * Explain why reviews may or may not have been selected.
       */
      explainReviews() {
        if (runHistory.length === 0) {
          logger.info("[Pipeline Debug] No runs captured yet.");
          return;
        }
        console.group("\u{1F4CB} Review Selection Analysis");
        for (const run of runHistory) {
          console.group(`Run: ${run.courseId} @ ${run.timestamp.toLocaleTimeString()}`);
          const allReviews = run.cards.filter((c) => c.origin === "review");
          const selectedReviews = allReviews.filter((c) => c.selected);
          if (allReviews.length === 0) {
            logger.info("\u274C No reviews were generated. Check SRS logs for why.");
          } else if (selectedReviews.length === 0) {
            logger.info(`\u26A0\uFE0F ${allReviews.length} reviews generated but none selected.`);
            logger.info("Possible reasons:");
            const topNewScore = Math.max(
              ...run.cards.filter((c) => c.origin === "new" && c.selected).map((c) => c.finalScore),
              0
            );
            const topReviewScore = Math.max(...allReviews.map((c) => c.finalScore), 0);
            if (topReviewScore < topNewScore) {
              logger.info(
                `  - New cards scored higher (top new: ${topNewScore.toFixed(2)}, top review: ${topReviewScore.toFixed(2)})`
              );
            }
            const topReview = allReviews.sort((a, b) => b.finalScore - a.finalScore)[0];
            if (topReview) {
              logger.info(`  - Top review score: ${topReview.finalScore.toFixed(3)}`);
              logger.info("  - Its provenance:");
              logger.info(formatProvenance(topReview.provenance));
            }
          } else {
            logger.info(`\u2705 ${selectedReviews.length}/${allReviews.length} reviews selected.`);
            logger.info("Top selected review:");
            const topSelected = selectedReviews.sort((a, b) => b.finalScore - a.finalScore)[0];
            logger.info(formatProvenance(topSelected.provenance));
          }
          console.groupEnd();
        }
        console.groupEnd();
      },
      /**
       * Show prescribed-related cards from the most recent run.
       *
       * Highlights:
       * - cards directly generated by the prescribed strategy
       * - blocked prescribed targets mentioned in provenance
       * - support tags resolved for blocked targets
       *
       * @param groupId - Optional prescribed group ID filter (e.g. 'intro-core')
       */
      showPrescribed(groupId) {
        if (runHistory.length === 0) {
          logger.info("[Pipeline Debug] No runs captured yet.");
          return;
        }
        const run = runHistory[0];
        const prescribedCards = run.cards.filter(
          (c) => c.provenance.some((p) => p.strategy === "prescribed")
        );
        console.group(`\u{1F9ED} Prescribed Debug (${run.courseId})`);
        if (prescribedCards.length === 0) {
          logger.info("No prescribed-generated cards were present in the most recent run.");
          console.groupEnd();
          return;
        }
        const rows = prescribedCards.map((card) => {
          const prescribedProv = card.provenance.find((p) => p.strategy === "prescribed");
          const reason = prescribedProv?.reason ?? "";
          const parsedGroup = reason.match(/group=([^;]+)/)?.[1] ?? "unknown";
          const mode = reason.match(/mode=([^;]+)/)?.[1] ?? "unknown";
          const blocked = reason.match(/blocked=([^;]+)/)?.[1] ?? "unknown";
          const blockedTargets = reason.match(/blockedTargets=([^;]+)/)?.[1] ?? "none";
          const supportCard = reason.match(/supportCard=([^;]+)/)?.[1] ?? "none";
          const supportTags = reason.match(/supportTags=([^;]+)/)?.[1] ?? "none";
          const multiplier = reason.match(/multiplier=([^;]+)/)?.[1] ?? "unknown";
          const supportSource = mode === "discovered-support" ? "discovered" : mode === "support" ? "authored" : "n/a";
          return {
            group: parsedGroup,
            mode,
            supportSource,
            cardId: card.cardId,
            selected: card.selected ? "yes" : "no",
            finalScore: card.finalScore.toFixed(3),
            blocked,
            blockedTargets,
            supportCard,
            supportTags,
            multiplier
          };
        }).filter((row) => !groupId || row.group === groupId).sort((a, b) => Number(b.finalScore) - Number(a.finalScore));
        if (rows.length === 0) {
          logger.info(
            `[Pipeline Debug] No prescribed cards matched group '${groupId}' in the most recent run.`
          );
          console.groupEnd();
          return;
        }
        console.table(rows);
        const selectedRows = rows.filter((r) => r.selected === "yes");
        const blockedTargetSet = /* @__PURE__ */ new Set();
        const supportTagSet = /* @__PURE__ */ new Set();
        const authoredSupportSet = /* @__PURE__ */ new Set();
        const discoveredSupportSet = /* @__PURE__ */ new Set();
        for (const row of rows) {
          if (row.blockedTargets && row.blockedTargets !== "none") {
            row.blockedTargets.split("|").filter(Boolean).forEach((t) => blockedTargetSet.add(t));
          }
          if (row.supportTags && row.supportTags !== "none") {
            row.supportTags.split("|").filter(Boolean).forEach((t) => supportTagSet.add(t));
          }
          if (row.supportCard && row.supportCard !== "none") {
            if (row.supportSource === "discovered") {
              discoveredSupportSet.add(row.supportCard);
            } else if (row.supportSource === "authored") {
              authoredSupportSet.add(row.supportCard);
            }
          }
        }
        logger.info(`Prescribed cards in run: ${rows.length}`);
        logger.info(`Selected prescribed cards: ${selectedRows.length}`);
        logger.info(
          `Blocked prescribed targets referenced: ${blockedTargetSet.size > 0 ? [...blockedTargetSet].join(", ") : "none"}`
        );
        logger.info(
          `Resolved support tags referenced: ${supportTagSet.size > 0 ? [...supportTagSet].join(", ") : "none"}`
        );
        logger.info(
          `Authored support cards emitted: ${authoredSupportSet.size > 0 ? [...authoredSupportSet].join(", ") : "none"}`
        );
        logger.info(
          `Discovered support cards emitted: ${discoveredSupportSet.size > 0 ? [...discoveredSupportSet].join(", ") : "none"}`
        );
        console.groupEnd();
      },
      /**
       * Show all runs in compact format.
       */
      listRuns() {
        if (runHistory.length === 0) {
          logger.info("[Pipeline Debug] No runs captured yet.");
          return;
        }
        console.table(
          runHistory.map((r) => ({
            id: r.runId.slice(-8),
            time: r.timestamp.toLocaleTimeString(),
            course: r.courseName || r.courseId.slice(0, 8),
            generated: r.generatedCount,
            selected: r.finalCount,
            new: r.newSelected,
            reviews: r.reviewsSelected
          }))
        );
      },
      /**
       * Export run history as JSON for bug reports.
       */
      export() {
        const json = JSON.stringify(runHistory, null, 2);
        logger.info("[Pipeline Debug] Run history exported. Copy the returned string or use:");
        logger.info("  copy(window.skuilder.pipeline.export())");
        return json;
      },
      /**
       * Clear run history.
       */
      clear() {
        runHistory.length = 0;
        logger.info("[Pipeline Debug] Run history cleared.");
      },
      /**
       * Show the navigator registry: all registered classes and their roles.
       *
       * Useful for verifying that consumer-defined navigators were registered
       * before pipeline assembly.
       */
      showRegistry() {
        const names = getRegisteredNavigatorNames();
        if (names.length === 0) {
          logger.info("[Pipeline Debug] Navigator registry is empty.");
          return;
        }
        console.group("\u{1F4E6} Navigator Registry");
        console.table(
          names.map((name) => {
            const registryRole = getRegisteredNavigatorRole(name);
            const builtinRole = NavigatorRoles[name];
            const effectiveRole = builtinRole || registryRole || "\u26A0\uFE0F NONE";
            const source = builtinRole ? "built-in" : registryRole ? "consumer" : "unclassified";
            return {
              name,
              role: effectiveRole,
              source,
              isGenerator: isGenerator(name),
              isFilter: isFilter(name)
            };
          })
        );
        console.groupEnd();
      },
      /**
       * Show strategy documents from the last pipeline run and how they mapped
       * to the registry.
       *
       * If no runs are captured yet, falls back to showing just the registry.
       */
      showStrategies() {
        this.showRegistry();
        if (runHistory.length === 0) {
          logger.info("[Pipeline Debug] No pipeline runs captured yet \u2014 cannot show strategy doc mapping.");
          return;
        }
        const run = runHistory[0];
        console.group("\u{1F50C} Pipeline Strategy Mapping (last run)");
        logger.info(`Generator: ${run.generatorName}`);
        if (run.generators && run.generators.length > 0) {
          for (const g of run.generators) {
            logger.info(`  \u{1F4E5} ${g.name}: ${g.cardCount} cards (${g.newCount} new, ${g.reviewCount} reviews)`);
          }
        }
        if (run.filters.length > 0) {
          logger.info("Filters:");
          for (const f of run.filters) {
            logger.info(`  \u{1F538} ${f.name}: \u2191${f.boosted} \u2193${f.penalized} =${f.passed} \u2715${f.removed}`);
          }
        } else {
          logger.info("Filters: (none)");
        }
        console.groupEnd();
      },
      /**
       * Scan the full card space through the filter chain for the current user.
       *
       * Reports how many cards are well-indicated and how many are new.
       * Use this to understand how the search space grows during onboarding.
       *
       * @param threshold - Score threshold for "well indicated" (default 0.10)
       */
      async diagnoseCardSpace(threshold) {
        if (!_activePipeline) {
          logger.info("[Pipeline Debug] No active pipeline. Run a session first.");
          return null;
        }
        return _activePipeline.diagnoseCardSpace({ threshold });
      },
      /**
       * Show user's per-tag ELO data. Useful for diagnosing hierarchy gate status.
       *
       * @param tagFilter - Optional glob pattern(s) to filter tags.
       *   Examples: 'gpc:expose:*', 'gpc:intro:t-T', ['gpc:expose:t-*', 'gpc:intro:t-*']
       */
      async showTagElo(tagFilter) {
        if (!_activePipeline) {
          logger.info("[Pipeline Debug] No active pipeline. Run a session first.");
          return;
        }
        const status = await _activePipeline.getTagEloStatus(tagFilter);
        const entries = Object.entries(status).sort(([a], [b]) => a.localeCompare(b));
        if (entries.length === 0) {
          logger.info(`[Pipeline Debug] No tag ELO data found${tagFilter ? ` for pattern: ${tagFilter}` : ""}.`);
          return;
        }
        console.table(
          Object.fromEntries(entries.map(([tag, data]) => [tag, { score: Math.round(data.score), count: data.count }]))
        );
      },
      /**
       * Toggle the full-screen UI debugger.
       */
      ui() {
        if (_uiContainer) {
          document.body.removeChild(_uiContainer);
          _uiContainer = null;
          return;
        }
        _uiContainer = document.createElement("div");
        _uiContainer.id = "sk-pipeline-debugger";
        document.body.appendChild(_uiContainer);
        if (_selectedRunIndex === null && runHistory.length > 0) {
          _selectedRunIndex = 0;
        }
        renderUI();
      },
      /**
       * Internal UI helpers
       * @internal
       */
      _selectRun(index) {
        _selectedRunIndex = index;
        renderUI();
      },
      /**
       * Internal UI helpers
       * @internal
       */
      _setSearch(query) {
        _cardSearchQuery = query;
        renderUI();
      },
      /**
       * Internal UI helpers
       * @internal
       */
      _copyConfig(runId, btn) {
        const run = runHistory.find((r) => r.runId === runId);
        if (!run) return;
        const payload = {
          runId: run.runId,
          timestamp: run.timestamp.toISOString(),
          courseId: run.courseId,
          courseName: run.courseName,
          hints: run.hints ?? null
        };
        copyTextToClipboard(JSON.stringify(payload, null, 2), btn);
      },
      /**
       * Internal UI helpers
       * @internal
       *
       * Copies an "abridged" view of results: just the selected cards with their
       * generator, origin, final score, and the top provenance reason. Designed
       * for pasting into bug reports without flooding with full provenance.
       */
      _copyResults(runId, btn) {
        const run = runHistory.find((r) => r.runId === runId);
        if (!run) return;
        const selected = run.cards.filter((c) => c.selected).sort((a, b) => b.finalScore - a.finalScore).map((c) => ({
          cardId: c.cardId,
          generator: c.generator,
          origin: c.origin,
          score: Number(c.finalScore.toFixed(3)),
          topReason: c.provenance[0]?.reason ?? ""
        }));
        const payload = {
          runId: run.runId,
          label: run.hints?._label ?? null,
          finalCount: run.finalCount,
          newSelected: run.newSelected,
          reviewsSelected: run.reviewsSelected,
          selected
        };
        copyTextToClipboard(JSON.stringify(payload, null, 2), btn);
      },
      /**
       * Show help.
       */
      help() {
        logger.info(`
\u{1F527} Pipeline Debug API

Commands:
  .ui()                  Toggle full-screen UI debugger
  .showLastRun()         Show summary of most recent pipeline run
  .showRun(id|index)     Show summary of a specific run (by index or ID suffix)
  .showCard(cardId)      Show provenance trail for a specific card
  .showTagElo(pattern)   Show user's tag ELO data (async). E.g. 'gpc:expose:*'
  .explainReviews()      Analyze why reviews were/weren't selected
  .diagnoseCardSpace()   Scan full card space through filters (async)
  .showRegistry()        Show navigator registry (classes + roles)
  .showStrategies()      Show registry + strategy mapping from last run
  .showPrescribed(id?)   Show prescribed-generated cards and blocked/support details from last run
  .listRuns()            List all captured runs in table format
  .export()              Export run history as JSON for bug reports
  .clear()               Clear run history
  .runs                  Access raw run history array
  .help()                Show this help message

Example:
  window.skuilder.pipeline.ui()
  window.skuilder.pipeline.showLastRun()
  window.skuilder.pipeline.showRun(1)
  await window.skuilder.pipeline.diagnoseCardSpace()
`);
      }
    };
    mountPipelineDebugger();
  }
});

// src/core/navigators/SrsDebugger.ts
var SrsDebugger_exports = {};
__export(SrsDebugger_exports, {
  captureSrsBacklog: () => captureSrsBacklog,
  clearSrsBacklogDebug: () => clearSrsBacklogDebug,
  getSrsBacklogDebug: () => getSrsBacklogDebug
});
function captureSrsBacklog(snapshot) {
  snapshots.set(snapshot.courseId, snapshot);
}
function getSrsBacklogDebug() {
  return [...snapshots.values()].sort((a, b) => b.timestamp - a.timestamp);
}
function clearSrsBacklogDebug() {
  snapshots.clear();
}
var snapshots;
var init_SrsDebugger = __esm({
  "src/core/navigators/SrsDebugger.ts"() {
    "use strict";
    snapshots = /* @__PURE__ */ new Map();
  }
});

// src/core/navigators/generators/CompositeGenerator.ts
var CompositeGenerator_exports = {};
__export(CompositeGenerator_exports, {
  AggregationMode: () => AggregationMode,
  default: () => CompositeGenerator
});
function mergeHints(allHints) {
  const defined = allHints.filter((h) => h !== void 0);
  if (defined.length === 0) return void 0;
  const merged = {};
  const boostTags = {};
  for (const hints of defined) {
    for (const [pattern, factor] of Object.entries(hints.boostTags ?? {})) {
      boostTags[pattern] = (boostTags[pattern] ?? 1) * factor;
    }
  }
  if (Object.keys(boostTags).length > 0) {
    merged.boostTags = boostTags;
  }
  const boostCards = {};
  for (const hints of defined) {
    for (const [pattern, factor] of Object.entries(hints.boostCards ?? {})) {
      boostCards[pattern] = (boostCards[pattern] ?? 1) * factor;
    }
  }
  if (Object.keys(boostCards).length > 0) {
    merged.boostCards = boostCards;
  }
  const concatUnique = (field) => {
    const values = defined.flatMap((h) => h[field] ?? []);
    if (values.length > 0) {
      merged[field] = [...new Set(values)];
    }
  };
  concatUnique("requireTags");
  concatUnique("requireCards");
  concatUnique("excludeTags");
  concatUnique("excludeCards");
  const labels = defined.map((h) => h._label).filter(Boolean);
  if (labels.length > 0) {
    merged._label = labels.join("; ");
  }
  return Object.keys(merged).length > 0 ? merged : void 0;
}
var AggregationMode, DEFAULT_AGGREGATION_MODE, FREQUENCY_BOOST_FACTOR, CompositeGenerator;
var init_CompositeGenerator = __esm({
  "src/core/navigators/generators/CompositeGenerator.ts"() {
    "use strict";
    init_navigators();
    init_logger();
    AggregationMode = /* @__PURE__ */ ((AggregationMode2) => {
      AggregationMode2["MAX"] = "max";
      AggregationMode2["AVERAGE"] = "average";
      AggregationMode2["FREQUENCY_BOOST"] = "frequencyBoost";
      return AggregationMode2;
    })(AggregationMode || {});
    DEFAULT_AGGREGATION_MODE = "frequencyBoost" /* FREQUENCY_BOOST */;
    FREQUENCY_BOOST_FACTOR = 0.1;
    CompositeGenerator = class _CompositeGenerator extends ContentNavigator {
      /** Human-readable name for CardGenerator interface */
      name = "Composite Generator";
      generators;
      aggregationMode;
      constructor(generators, aggregationMode = DEFAULT_AGGREGATION_MODE) {
        super();
        this.generators = generators;
        this.aggregationMode = aggregationMode;
        if (generators.length === 0) {
          throw new Error("CompositeGenerator requires at least one generator");
        }
        logger.debug(
          `[CompositeGenerator] Created with ${generators.length} generators, mode: ${aggregationMode}`
        );
      }
      /**
       * Creates a CompositeGenerator from strategy data.
       *
       * This is a convenience factory for use by PipelineAssembler.
       */
      static async fromStrategies(user, course, strategies, aggregationMode = DEFAULT_AGGREGATION_MODE) {
        const generators = await Promise.all(
          strategies.map((s) => ContentNavigator.create(user, course, s))
        );
        return new _CompositeGenerator(generators, aggregationMode);
      }
      /**
       * Get weighted cards from all generators, merge and deduplicate.
       *
       * Cards appearing in multiple generators receive a score boost.
       * Provenance tracks which generators produced each card and how scores were aggregated.
       *
       * This method supports both the legacy signature (limit only) and the
       * CardGenerator interface signature (limit, context).
       *
       * @param limit - Maximum number of cards to return
       * @param context - GeneratorContext passed to child generators (required when called via Pipeline)
       */
      async getWeightedCards(limit, context) {
        if (!context) {
          throw new Error(
            "CompositeGenerator.getWeightedCards requires a GeneratorContext. It should be called via Pipeline, not directly."
          );
        }
        const results = await Promise.all(
          this.generators.map((g) => g.getWeightedCards(limit, context))
        );
        const generatorSummaries = [];
        results.forEach((result, index) => {
          const cards2 = result.cards;
          const gen = this.generators[index];
          const genName = gen.name || `Generator ${index}`;
          const newCards = cards2.filter((c) => c.provenance[0]?.reason?.includes("new card"));
          const reviewCards = cards2.filter((c) => c.provenance[0]?.reason?.includes("review"));
          if (cards2.length > 0) {
            const topScore = Math.max(...cards2.map((c) => c.score)).toFixed(2);
            const parts = [];
            if (newCards.length > 0) parts.push(`${newCards.length} new`);
            if (reviewCards.length > 0) parts.push(`${reviewCards.length} reviews`);
            const breakdown = parts.length > 0 ? parts.join(", ") : `${cards2.length} cards`;
            generatorSummaries.push(`${genName}: ${breakdown} (top: ${topScore})`);
          } else {
            generatorSummaries.push(`${genName}: 0 cards`);
          }
        });
        logger.info(`[Composite] Generator breakdown: ${generatorSummaries.join(" | ")}`);
        const byCardId = /* @__PURE__ */ new Map();
        results.forEach((result, index) => {
          const cards2 = result.cards;
          const gen = this.generators[index];
          let weight = gen.learnable?.weight ?? 1;
          let deviation;
          if (gen.learnable && !gen.staticWeight && context.orchestration) {
            const strategyId = gen.strategyId;
            if (strategyId) {
              weight = context.orchestration.getEffectiveWeight(strategyId, gen.learnable);
              deviation = context.orchestration.getDeviation(strategyId);
            }
          }
          for (const card of cards2) {
            if (card.provenance.length > 0) {
              card.provenance[0].effectiveWeight = weight;
              card.provenance[0].deviation = deviation;
            }
            const existing = byCardId.get(card.cardId) || [];
            existing.push({ card, weight });
            byCardId.set(card.cardId, existing);
          }
        });
        const merged = [];
        for (const [, items] of byCardId) {
          const cards2 = items.map((i) => i.card);
          const aggregatedScore = this.aggregateScores(items);
          const finalScore = Math.max(0, aggregatedScore);
          const mergedProvenance = cards2.flatMap((c) => c.provenance);
          const initialScore = cards2[0].score;
          const action = finalScore > initialScore ? "boosted" : finalScore < initialScore ? "penalized" : "passed";
          const reason = this.buildAggregationReason(items, finalScore);
          merged.push({
            ...cards2[0],
            score: finalScore,
            provenance: [
              ...mergedProvenance,
              {
                strategy: "composite",
                strategyName: "Composite Generator",
                strategyId: "COMPOSITE_GENERATOR",
                action,
                score: finalScore,
                reason
              }
            ]
          });
        }
        const cards = merged.sort((a, b) => b.score - a.score).slice(0, limit);
        const hints = mergeHints(results.map((result) => result.hints));
        return { cards, hints };
      }
      /**
       * Build human-readable reason for score aggregation.
       */
      buildAggregationReason(items, finalScore) {
        const cards = items.map((i) => i.card);
        const count = cards.length;
        const scores = cards.map((c) => c.score.toFixed(2)).join(", ");
        if (count === 1) {
          const weightMsg = Math.abs(items[0].weight - 1) > 1e-3 ? ` (w=${items[0].weight.toFixed(2)})` : "";
          return `Single generator, score ${finalScore.toFixed(2)}${weightMsg}`;
        }
        const strategies = cards.map((c) => c.provenance[0]?.strategy || "unknown").join(", ");
        switch (this.aggregationMode) {
          case "max" /* MAX */:
            return `Max of ${count} generators (${strategies}): scores [${scores}] \u2192 ${finalScore.toFixed(2)}`;
          case "average" /* AVERAGE */:
            return `Weighted Avg of ${count} generators (${strategies}): scores [${scores}] \u2192 ${finalScore.toFixed(2)}`;
          case "frequencyBoost" /* FREQUENCY_BOOST */: {
            const totalWeight = items.reduce((sum, i) => sum + i.weight, 0);
            const weightedSum = items.reduce((sum, i) => sum + i.card.score * i.weight, 0);
            const avg = totalWeight > 0 ? weightedSum / totalWeight : 0;
            const boost = 1 + FREQUENCY_BOOST_FACTOR * (count - 1);
            return `Frequency boost from ${count} generators (${strategies}): w-avg ${avg.toFixed(2)} \xD7 ${boost.toFixed(2)} \u2192 ${finalScore.toFixed(2)}`;
          }
          default:
            return `Aggregated from ${count} generators: ${finalScore.toFixed(2)}`;
        }
      }
      /**
       * Aggregate scores from multiple generators for the same card.
       */
      aggregateScores(items) {
        const scores = items.map((i) => i.card.score);
        switch (this.aggregationMode) {
          case "max" /* MAX */:
            return Math.max(...scores);
          case "average" /* AVERAGE */: {
            const totalWeight = items.reduce((sum, i) => sum + i.weight, 0);
            if (totalWeight === 0) return 0;
            const weightedSum = items.reduce((sum, i) => sum + i.card.score * i.weight, 0);
            return weightedSum / totalWeight;
          }
          case "frequencyBoost" /* FREQUENCY_BOOST */: {
            const totalWeight = items.reduce((sum, i) => sum + i.weight, 0);
            const weightedSum = items.reduce((sum, i) => sum + i.card.score * i.weight, 0);
            const avg = totalWeight > 0 ? weightedSum / totalWeight : 0;
            const frequencyBoost = 1 + FREQUENCY_BOOST_FACTOR * (items.length - 1);
            return avg * frequencyBoost;
          }
          default:
            return scores[0];
        }
      }
    };
  }
});

// src/core/navigators/generators/elo.ts
var elo_exports = {};
__export(elo_exports, {
  default: () => ELONavigator
});
import { toCourseElo as toCourseElo2 } from "@vue-skuilder/common";
var ELO_RELEVANCE_SIGMA, ELONavigator;
var init_elo = __esm({
  "src/core/navigators/generators/elo.ts"() {
    "use strict";
    init_navigators();
    init_logger();
    ELO_RELEVANCE_SIGMA = 300;
    ELONavigator = class extends ContentNavigator {
      /** Human-readable name for CardGenerator interface */
      name;
      constructor(user, course, strategyData) {
        super(user, course, strategyData);
        this.name = strategyData?.name || "ELO";
      }
      /**
       * Get new cards with suitability scores based on ELO distance.
       *
       * Cards closer to user's ELO get higher scores.
       * Score formula: max(0, 1 - distance / 500)
       *
       * NOTE: This generator only handles NEW cards. Reviews are handled by
       * SRSNavigator. Use CompositeGenerator to combine both.
       *
       * This method supports both the legacy signature (limit only) and the
       * CardGenerator interface signature (limit, context).
       *
       * @param limit - Maximum number of cards to return
       * @param context - Optional GeneratorContext (used when called via Pipeline)
       */
      async getWeightedCards(limit, context) {
        let userGlobalElo;
        if (context?.userElo !== void 0) {
          userGlobalElo = context.userElo;
        } else {
          const courseReg = await this.user.getCourseRegDoc(this.course.getCourseID());
          const userElo = toCourseElo2(courseReg.elo);
          userGlobalElo = userElo.global.score;
        }
        const activeCards = await this.user.getActiveCards();
        const newCards = (await this.course.getCardsCenteredAtELO(
          { limit, elo: "user" },
          (c) => !activeCards.some((ac) => c.cardID === ac.cardID)
        )).map((c) => ({ ...c, status: "new" }));
        const scored = newCards.map((c) => {
          const cardElo = c.elo ?? 1e3;
          const distance = Math.abs(cardElo - userGlobalElo);
          const relevance = Math.exp(-((distance / ELO_RELEVANCE_SIGMA) ** 2));
          const samplingKey = relevance * (0.5 + 0.5 * Math.random());
          return {
            cardId: c.cardID,
            courseId: c.courseID,
            score: samplingKey,
            provenance: [
              {
                strategy: "elo",
                strategyName: this.strategyName || this.name,
                strategyId: this.strategyId || "NAVIGATION_STRATEGY-ELO-default",
                action: "generated",
                score: samplingKey,
                reason: `ELO distance ${Math.round(distance)} (card: ${Math.round(cardElo)}, user: ${Math.round(userGlobalElo)}), relevance ${relevance.toFixed(3)}, key ${samplingKey.toFixed(3)}`
              }
            ]
          };
        });
        scored.sort((a, b) => b.score - a.score);
        const cards = scored.slice(0, limit);
        if (cards.length > 0) {
          const topScores = cards.slice(0, 3).map((c) => c.score.toFixed(2)).join(", ");
          logger.info(
            `[ELO] Course ${this.course.getCourseID()}: ${cards.length} new cards (top scores: ${topScores})`
          );
        } else {
          logger.info(`[ELO] Course ${this.course.getCourseID()}: No new cards available`);
        }
        return { cards };
      }
    };
  }
});

// src/core/navigators/generators/index.ts
var generators_exports = {};
var init_generators = __esm({
  "src/core/navigators/generators/index.ts"() {
    "use strict";
  }
});

// src/core/navigators/generators/prescribed.ts
var prescribed_exports = {};
__export(prescribed_exports, {
  default: () => PrescribedCardsGenerator
});
function dedupe(arr) {
  return [...new Set(arr)];
}
function isoNow() {
  return (/* @__PURE__ */ new Date()).toISOString();
}
function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}
function matchesTagPattern(tag, pattern) {
  if (pattern === "*") return true;
  const escaped = pattern.replace(/[.+^${}()|[\]\\]/g, "\\$&").replace(/\*/g, ".*");
  const re = new RegExp(`^${escaped}$`);
  return re.test(tag);
}
function extractWordStem(cardId) {
  for (const prefix of ["c-ml-", "c-ws-", "c-spelling-"]) {
    if (cardId.startsWith(prefix)) {
      const rest = cardId.slice(prefix.length);
      const lastDash = rest.lastIndexOf("-");
      return lastDash > 0 ? rest.slice(0, lastDash) : rest;
    }
  }
  return cardId;
}
function shuffleInPlace(arr) {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
}
function pickTopByScore(cards, limit) {
  return [...cards].sort((a, b) => b.score - a.score || a.cardId.localeCompare(b.cardId)).slice(0, limit);
}
var DEFAULT_FRESHNESS_WINDOW, DEFAULT_MAX_DIRECT_PER_RUN, DEFAULT_MAX_SUPPORT_PER_RUN, DEFAULT_HIERARCHY_DEPTH, DEFAULT_MIN_COUNT, DEFAULT_PRACTICE_MIN_COUNT, DEFAULT_MAX_PRACTICE_PER_RUN, BASE_TARGET_SCORE, BASE_SUPPORT_SCORE, DISCOVERED_SUPPORT_SCORE, BASE_PRACTICE_SCORE, PRACTICE_BASE_MULT, MAX_PRACTICE_MULTIPLIER, PRACTICE_STALENESS_BUMP_PER_DAY, MAX_TARGET_MULTIPLIER, MAX_SUPPORT_MULTIPLIER, PRESCRIBED_DEBUG_VERSION, PrescribedCardsGenerator;
var init_prescribed = __esm({
  "src/core/navigators/generators/prescribed.ts"() {
    "use strict";
    init_navigators();
    init_logger();
    DEFAULT_FRESHNESS_WINDOW = 3;
    DEFAULT_MAX_DIRECT_PER_RUN = 3;
    DEFAULT_MAX_SUPPORT_PER_RUN = 3;
    DEFAULT_HIERARCHY_DEPTH = 2;
    DEFAULT_MIN_COUNT = 3;
    DEFAULT_PRACTICE_MIN_COUNT = 3;
    DEFAULT_MAX_PRACTICE_PER_RUN = 4;
    BASE_TARGET_SCORE = 1;
    BASE_SUPPORT_SCORE = 0.8;
    DISCOVERED_SUPPORT_SCORE = 12;
    BASE_PRACTICE_SCORE = 1;
    PRACTICE_BASE_MULT = 2;
    MAX_PRACTICE_MULTIPLIER = 4;
    PRACTICE_STALENESS_BUMP_PER_DAY = 0.5;
    MAX_TARGET_MULTIPLIER = 8;
    MAX_SUPPORT_MULTIPLIER = 4;
    PRESCRIBED_DEBUG_VERSION = "testversion-prescribed-v3";
    PrescribedCardsGenerator = class extends ContentNavigator {
      name;
      config;
      constructor(user, course, strategyData) {
        super(user, course, strategyData);
        this.name = strategyData.name || "Prescribed Cards";
        this.config = this.parseConfig(strategyData.serializedData);
        logger.debug(
          `[Prescribed] Initialized with ${this.config.groups.length} groups and ${this.config.groups.reduce((n, g) => n + g.targetCardIds.length, 0)} targets`
        );
      }
      get strategyKey() {
        return "PrescribedProgress";
      }
      async getWeightedCards(limit, context) {
        if (this.config.groups.length === 0 || limit <= 0) {
          return { cards: [] };
        }
        const courseId = this.course.getCourseID();
        const activeCards = await this.user.getActiveCards();
        const activeIds = new Set(activeCards.map((ac) => ac.cardID));
        const seenCards = await this.user.getSeenCards(courseId).catch(() => []);
        const seenIds = new Set(seenCards);
        const progress = await this.getStrategyState() ?? {
          updatedAt: isoNow(),
          groups: {}
        };
        const hierarchyConfigs = await this.loadHierarchyConfigs();
        const courseReg = await this.user.getCourseRegDoc(courseId).catch(() => null);
        const userGlobalElo = typeof courseReg?.elo === "number" ? courseReg.elo : courseReg?.elo?.global?.score ?? context?.userElo ?? 1e3;
        const userTagElo = typeof courseReg?.elo === "number" ? {} : courseReg?.elo?.tags ?? {};
        const allTargetIds = dedupe(this.config.groups.flatMap((g) => g.targetCardIds));
        const allSupportIds = dedupe(this.config.groups.flatMap((g) => g.supportCardIds ?? []));
        const allRelevantIds = dedupe([...allTargetIds, ...allSupportIds]);
        const tagsByCard = allRelevantIds.length > 0 ? await this.course.getAppliedTagsBatch(allRelevantIds) : /* @__PURE__ */ new Map();
        const courseTagDocs = await this.course.getCourseTagStubs().catch(
          () => ({
            rows: [],
            offset: 0,
            total_rows: 0
          })
        );
        const cardsByTag = /* @__PURE__ */ new Map();
        for (const row of courseTagDocs.rows ?? []) {
          const tagDoc = row.doc;
          if (tagDoc?.name && Array.isArray(tagDoc.taggedCards)) {
            cardsByTag.set(tagDoc.name, [...tagDoc.taggedCards]);
          }
        }
        const nextState = {
          updatedAt: isoNow(),
          groups: {}
        };
        const emitted = [];
        const emittedIds = /* @__PURE__ */ new Set();
        const groupRuntimes = [];
        const priorPracticeDebt = progress.practiceDebt ?? {};
        const nextPracticeDebt = {};
        for (const group of this.config.groups) {
          const runtime = this.buildGroupRuntimeState({
            group,
            priorState: progress.groups[group.id],
            activeIds,
            seenIds,
            tagsByCard,
            cardsByTag,
            hierarchyConfigs,
            userTagElo,
            userGlobalElo
          });
          groupRuntimes.push(runtime);
          logger.info(
            `[Prescribed] Group '${group.id}': ${group.targetCardIds.length} targets total, ${runtime.encounteredTargets.size} encountered, ${runtime.pendingTargets.length} pending (${runtime.surfaceableTargets.length} surfaceable, ${runtime.blockedTargets.length} blocked), ${runtime.supportCandidates.length} authored support candidates, ${runtime.discoveredSupportCandidates.length} discovered support candidates, pressure=${runtime.pressureMultiplier.toFixed(2)}`
          );
          if (runtime.blockedTargets.length > 0) {
            logger.info(
              `[Prescribed] Group '${group.id}' blocked targets: ${runtime.blockedTargets.join(", ")}`
            );
            logger.info(
              `[Prescribed] Group '${group.id}' support tags needed: ${runtime.supportTags.join(", ") || "(none)"}`
            );
            logger.info(
              `[Prescribed] Group '${group.id}' escalation mode: ` + (runtime.supportCandidates.length > 0 ? "direct-support" : runtime.discoveredSupportCandidates.length > 0 ? "inserted-support-candidates" : "boost-only")
            );
            if (runtime.discoveredSupportCandidates.length > 0) {
              logger.info(
                `[Prescribed] Group '${group.id}' discovered support candidates: ${runtime.discoveredSupportCandidates.join(", ")}`
              );
            }
          }
          nextState.groups[group.id] = this.buildNextGroupState(runtime, progress.groups[group.id]);
          const directCards = this.buildDirectTargetCards(
            runtime,
            courseId,
            emittedIds
          );
          const supportCards = this.buildSupportCards(
            runtime,
            courseId,
            emittedIds
          );
          const discoveredSupportCards = this.buildDiscoveredSupportCards(
            runtime,
            courseId,
            emittedIds
          );
          const practiceCards = this.buildPracticeCards({
            group,
            courseId,
            emittedIds,
            cardsByTag,
            hierarchyConfigs,
            userTagElo,
            userGlobalElo,
            activeIds,
            seenIds,
            priorPracticeDebt,
            nextPracticeDebt
          });
          emitted.push(...directCards, ...supportCards, ...discoveredSupportCards, ...practiceCards);
        }
        nextState.practiceDebt = nextPracticeDebt;
        const hintSummary = this.buildSupportHintSummary(groupRuntimes);
        const hints = Object.keys(hintSummary.boostTags).length > 0 ? {
          boostTags: hintSummary.boostTags,
          _label: `prescribed-support (${hintSummary.supportTags.length} tags; blocked=${hintSummary.blockedTargetIds.length}; testversion=${PRESCRIBED_DEBUG_VERSION})`
        } : void 0;
        if (hints) {
          const tagEntries = Object.entries(hints.boostTags ?? {});
          logger.info(
            `[Prescribed] Emitting ${tagEntries.length} boost hint(s): ` + tagEntries.map(([tag, mult]) => `${tag}\xD7${mult.toFixed(1)}`).join(", ")
          );
        } else {
          logger.info("[Prescribed] No hints to emit (no blocked targets or no support tags)");
        }
        if (emitted.length === 0) {
          logger.info(
            "[Prescribed] 0 cards emitted (all targets blocked, authored/discovered support candidates exhausted)" + (hints ? " \u2014 boost hints emitted but may not survive filters" : "")
          );
          await this.putStrategyState(nextState).catch((e) => {
            logger.debug(`[Prescribed] Failed to persist empty-state update: ${e}`);
          });
          return hints ? { cards: [], hints } : { cards: [] };
        }
        const finalCards = pickTopByScore(emitted, limit);
        const surfacedByGroup = /* @__PURE__ */ new Map();
        for (const card of finalCards) {
          const prov = card.provenance[0];
          if (prov?.reason.includes("mode=practice")) continue;
          const groupId = prov?.reason.match(/group=([^;]+)/)?.[1];
          const mode = prov?.reason.includes("mode=support") ? "supportIds" : "targetIds";
          if (!groupId) continue;
          if (!surfacedByGroup.has(groupId)) {
            surfacedByGroup.set(groupId, { targetIds: [], supportIds: [] });
          }
          surfacedByGroup.get(groupId)[mode].push(card.cardId);
        }
        for (const group of this.config.groups) {
          const groupState = nextState.groups[group.id];
          const surfaced = surfacedByGroup.get(group.id);
          if (surfaced && (surfaced.targetIds.length > 0 || surfaced.supportIds.length > 0)) {
            groupState.lastSurfacedAt = isoNow();
            groupState.sessionsSinceSurfaced = 0;
            if (surfaced.supportIds.length > 0) {
              groupState.lastSupportAt = isoNow();
            }
          }
        }
        await this.putStrategyState(nextState).catch((e) => {
          logger.debug(`[Prescribed] Failed to persist prescribed progress: ${e}`);
        });
        logger.info(
          `[Prescribed] Emitting ${finalCards.length} cards (${finalCards.filter((c) => c.provenance[0]?.reason.includes("mode=target")).length} target, ${finalCards.filter((c) => c.provenance[0]?.reason.includes("mode=support")).length} support, ${finalCards.filter((c) => c.provenance[0]?.reason.includes("mode=discovered-support")).length} discovered support)`
        );
        return hints ? { cards: finalCards, hints } : { cards: finalCards };
      }
      buildSupportHintSummary(groupRuntimes) {
        const boostTags = {};
        const blockedTargetIds = /* @__PURE__ */ new Set();
        const supportTags = /* @__PURE__ */ new Set();
        for (const runtime of groupRuntimes) {
          if (runtime.blockedTargets.length === 0 || runtime.supportTags.length === 0) {
            continue;
          }
          runtime.blockedTargets.forEach((cardId) => blockedTargetIds.add(cardId));
          for (const tag of runtime.supportTags) {
            supportTags.add(tag);
            boostTags[tag] = (boostTags[tag] ?? 1) * runtime.supportMultiplier;
          }
        }
        return {
          boostTags,
          blockedTargetIds: [...blockedTargetIds].sort(),
          supportTags: [...supportTags].sort()
        };
      }
      parseConfig(serializedData) {
        try {
          const parsed = JSON.parse(serializedData);
          const groupsRaw = Array.isArray(parsed.groups) ? parsed.groups : [];
          const groups = groupsRaw.map((raw, i) => ({
            id: typeof raw.id === "string" && raw.id.trim().length > 0 ? raw.id : `group-${i + 1}`,
            targetCardIds: dedupe(
              Array.isArray(raw.targetCardIds) ? raw.targetCardIds.filter((v) => typeof v === "string") : []
            ),
            supportCardIds: dedupe(
              Array.isArray(raw.supportCardIds) ? raw.supportCardIds.filter((v) => typeof v === "string") : []
            ),
            supportTagPatterns: dedupe(
              Array.isArray(raw.supportTagPatterns) ? raw.supportTagPatterns.filter((v) => typeof v === "string") : []
            ),
            freshnessWindowSessions: typeof raw.freshnessWindowSessions === "number" ? raw.freshnessWindowSessions : DEFAULT_FRESHNESS_WINDOW,
            maxDirectTargetsPerRun: typeof raw.maxDirectTargetsPerRun === "number" ? raw.maxDirectTargetsPerRun : DEFAULT_MAX_DIRECT_PER_RUN,
            maxSupportCardsPerRun: typeof raw.maxSupportCardsPerRun === "number" ? raw.maxSupportCardsPerRun : DEFAULT_MAX_SUPPORT_PER_RUN,
            hierarchyWalk: {
              enabled: raw.hierarchyWalk?.enabled !== false,
              maxDepth: typeof raw.hierarchyWalk?.maxDepth === "number" ? raw.hierarchyWalk.maxDepth : DEFAULT_HIERARCHY_DEPTH
            },
            retireOnEncounter: raw.retireOnEncounter !== false,
            practiceTagPatterns: dedupe(
              Array.isArray(raw.practiceTagPatterns) ? raw.practiceTagPatterns.filter((v) => typeof v === "string") : []
            ),
            practiceMinCount: typeof raw.practiceMinCount === "number" ? raw.practiceMinCount : DEFAULT_PRACTICE_MIN_COUNT,
            maxPracticeCardsPerRun: typeof raw.maxPracticeCardsPerRun === "number" ? raw.maxPracticeCardsPerRun : DEFAULT_MAX_PRACTICE_PER_RUN
          })).filter((g) => g.targetCardIds.length > 0);
          return { groups };
        } catch {
          return { groups: [] };
        }
      }
      async loadHierarchyConfigs() {
        try {
          const strategies = await this.course.getAllNavigationStrategies();
          return strategies.filter((s) => s.implementingClass === "hierarchyDefinition").map((s) => {
            try {
              const parsed = JSON.parse(s.serializedData);
              return {
                prerequisites: parsed.prerequisites || {}
              };
            } catch {
              return { prerequisites: {} };
            }
          });
        } catch (e) {
          logger.debug(`[Prescribed] Failed to load hierarchy configs: ${e}`);
          return [];
        }
      }
      buildGroupRuntimeState(args) {
        const {
          group,
          priorState,
          activeIds,
          seenIds,
          tagsByCard,
          cardsByTag,
          hierarchyConfigs,
          userTagElo,
          userGlobalElo
        } = args;
        const encounteredTargets = /* @__PURE__ */ new Set();
        for (const cardId of group.targetCardIds) {
          if (activeIds.has(cardId) || seenIds.has(cardId)) {
            encounteredTargets.add(cardId);
          }
        }
        if (priorState?.encounteredCardIds?.length) {
          for (const cardId of priorState.encounteredCardIds) {
            encounteredTargets.add(cardId);
          }
        }
        const pendingTargets = group.targetCardIds.filter((id) => !encounteredTargets.has(id));
        const targetTags = /* @__PURE__ */ new Map();
        for (const cardId of pendingTargets) {
          targetTags.set(cardId, tagsByCard.get(cardId) ?? []);
        }
        const blockedTargets = [];
        const surfaceableTargets = [];
        const supportTags = /* @__PURE__ */ new Set();
        for (const cardId of pendingTargets) {
          const tags = targetTags.get(cardId) ?? [];
          const resolution = this.resolveBlockedSupportTags(
            tags,
            hierarchyConfigs,
            userTagElo,
            userGlobalElo,
            group.hierarchyWalk?.enabled !== false,
            group.hierarchyWalk?.maxDepth ?? DEFAULT_HIERARCHY_DEPTH
          );
          const introTags = tags.filter((tag) => tag.startsWith("gpc:intro:"));
          const exposeTags = new Set(tags.filter((tag) => tag.startsWith("gpc:expose:")));
          for (const introTag of introTags) {
            const suffix = introTag.slice("gpc:intro:".length);
            if (suffix) {
              exposeTags.add(`gpc:expose:${suffix}`);
            }
          }
          const unmetExposeTags = [...exposeTags].filter((tag) => {
            const tagElo = userTagElo[tag];
            return !tagElo || tagElo.count < DEFAULT_MIN_COUNT;
          });
          if (unmetExposeTags.length > 0) {
            unmetExposeTags.forEach((tag) => supportTags.add(tag));
          }
          if (resolution.blocked || unmetExposeTags.length > 0) {
            blockedTargets.push(cardId);
            resolution.supportTags.forEach((t) => supportTags.add(t));
          } else {
            surfaceableTargets.push(cardId);
          }
        }
        const supportCandidates = dedupe([
          ...group.supportCardIds ?? [],
          ...this.findSupportCardsByTags(
            group,
            tagsByCard,
            [...supportTags]
          )
        ]).filter((id) => !activeIds.has(id) && !seenIds.has(id));
        const discoveredSupportCandidates = blockedTargets.length > 0 && supportTags.size > 0 && supportCandidates.length === 0 ? this.findDiscoveredSupportCards({
          supportTags: [...supportTags],
          cardsByTag,
          activeIds,
          seenIds,
          excludedIds: /* @__PURE__ */ new Set([
            ...group.targetCardIds,
            ...group.supportCardIds ?? []
          ]),
          limit: group.maxSupportCardsPerRun ?? DEFAULT_MAX_SUPPORT_PER_RUN
        }) : [];
        if (blockedTargets.length > 0 && supportTags.size > 0 && discoveredSupportCandidates.length === 0) {
          logger.info(
            `[Prescribed] Group '${group.id}' discovered 0 broader support candidates (blocked=${blockedTargets.length}; authoredSupport=${supportCandidates.length})`
          );
        }
        const sessionsSinceSurfaced = priorState?.sessionsSinceSurfaced ?? 0;
        const freshnessWindow = group.freshnessWindowSessions ?? DEFAULT_FRESHNESS_WINDOW;
        const staleSessions = Math.max(0, sessionsSinceSurfaced - freshnessWindow);
        const pressureMultiplier = pendingTargets.length === 0 ? 1 : clamp(1 + staleSessions * 0.75 + Math.min(2, pendingTargets.length * 0.1), 1, MAX_TARGET_MULTIPLIER);
        const supportMultiplier = blockedTargets.length === 0 ? 1 : clamp(1 + staleSessions * 0.5 + Math.min(1.5, blockedTargets.length * 0.15), 1, MAX_SUPPORT_MULTIPLIER);
        return {
          group,
          encounteredTargets,
          pendingTargets,
          blockedTargets,
          surfaceableTargets,
          targetTags,
          supportCandidates,
          discoveredSupportCandidates,
          supportTags: [...supportTags],
          pressureMultiplier,
          supportMultiplier,
          debugVersion: PRESCRIBED_DEBUG_VERSION
        };
      }
      buildNextGroupState(runtime, prior) {
        const carriedSessions = prior?.sessionsSinceSurfaced ?? 0;
        const surfacedThisRun = false;
        return {
          encounteredCardIds: [...runtime.encounteredTargets].sort(),
          pendingTargetIds: [...runtime.pendingTargets].sort(),
          lastSurfacedAt: prior?.lastSurfacedAt ?? null,
          sessionsSinceSurfaced: surfacedThisRun ? 0 : carriedSessions + 1,
          lastSupportAt: prior?.lastSupportAt ?? null,
          blockedTargetIds: [...runtime.blockedTargets].sort(),
          lastResolvedSupportTags: [...runtime.supportTags].sort()
        };
      }
      buildDirectTargetCards(runtime, courseId, emittedIds) {
        const maxDirect = runtime.group.maxDirectTargetsPerRun ?? DEFAULT_MAX_DIRECT_PER_RUN;
        const directIds = runtime.surfaceableTargets.filter((id) => !emittedIds.has(id)).slice(0, maxDirect);
        const cards = [];
        for (const cardId of directIds) {
          emittedIds.add(cardId);
          cards.push({
            cardId,
            courseId,
            score: BASE_TARGET_SCORE * runtime.pressureMultiplier,
            provenance: [
              {
                strategy: "prescribed",
                strategyName: this.strategyName || this.name,
                strategyId: this.strategyId || "NAVIGATION_STRATEGY-prescribed",
                action: "generated",
                score: BASE_TARGET_SCORE * runtime.pressureMultiplier,
                reason: `mode=target;group=${runtime.group.id};pending=${runtime.pendingTargets.length};surfaceable=${runtime.surfaceableTargets.length};blocked=${runtime.blockedTargets.length};blockedTargets=${runtime.blockedTargets.join("|") || "none"};supportTags=${runtime.supportTags.join("|") || "none"};multiplier=${runtime.pressureMultiplier.toFixed(2)};testversion=${runtime.debugVersion}`
              }
            ]
          });
        }
        return cards;
      }
      buildSupportCards(runtime, courseId, emittedIds) {
        if (runtime.blockedTargets.length === 0 || runtime.supportCandidates.length === 0) {
          return [];
        }
        const maxSupport = runtime.group.maxSupportCardsPerRun ?? DEFAULT_MAX_SUPPORT_PER_RUN;
        const supportIds = runtime.supportCandidates.filter((id) => !emittedIds.has(id)).slice(0, maxSupport);
        const cards = [];
        for (const cardId of supportIds) {
          emittedIds.add(cardId);
          cards.push({
            cardId,
            courseId,
            score: BASE_SUPPORT_SCORE * runtime.supportMultiplier,
            provenance: [
              {
                strategy: "prescribed",
                strategyName: this.strategyName || this.name,
                strategyId: this.strategyId || "NAVIGATION_STRATEGY-prescribed",
                action: "generated",
                score: BASE_SUPPORT_SCORE * runtime.supportMultiplier,
                reason: `mode=support;group=${runtime.group.id};pending=${runtime.pendingTargets.length};blocked=${runtime.blockedTargets.length};blockedTargets=${runtime.blockedTargets.join("|") || "none"};supportCard=${cardId};supportTags=${runtime.supportTags.join("|") || "none"};multiplier=${runtime.supportMultiplier.toFixed(2)};testversion=${runtime.debugVersion}`
              }
            ]
          });
        }
        return cards;
      }
      buildDiscoveredSupportCards(runtime, courseId, emittedIds) {
        if (runtime.blockedTargets.length === 0 || runtime.discoveredSupportCandidates.length === 0) {
          return [];
        }
        const maxSupport = runtime.group.maxSupportCardsPerRun ?? DEFAULT_MAX_SUPPORT_PER_RUN;
        const supportIds = runtime.discoveredSupportCandidates.filter((id) => !emittedIds.has(id)).slice(0, maxSupport);
        const cards = [];
        for (const cardId of supportIds) {
          emittedIds.add(cardId);
          cards.push({
            cardId,
            courseId,
            score: DISCOVERED_SUPPORT_SCORE * runtime.supportMultiplier,
            provenance: [
              {
                strategy: "prescribed",
                strategyName: this.strategyName || this.name,
                strategyId: this.strategyId || "NAVIGATION_STRATEGY-prescribed",
                action: "generated",
                score: DISCOVERED_SUPPORT_SCORE * runtime.supportMultiplier,
                reason: `mode=discovered-support;group=${runtime.group.id};pending=${runtime.pendingTargets.length};blocked=${runtime.blockedTargets.length};blockedTargets=${runtime.blockedTargets.join("|") || "none"};supportCard=${cardId};supportTags=${runtime.supportTags.join("|") || "none"};multiplier=${runtime.supportMultiplier.toFixed(2)};testversion=${runtime.debugVersion}`
              }
            ]
          });
        }
        return cards;
      }
      /**
       * Emit drill cards for *unlocked-but-under-practiced* skills.
       *
       * For each course tag matching the group's `practiceTagPatterns` that is both
       * unlocked (all hierarchy prerequisites met — i.e. the learner has been
       * introduced to it) and under-practiced (per-tag attempt count below
       * `practiceMinCount`), this resolves cards carrying that tag and emits them
       * into the candidate pool. It exists because global-ELO retrieval
       * systematically fails to fetch the (low-ELO) drill cards for a
       * freshly-introduced skill — putting them in the pool here guarantees presence.
       *
       * Emphasis is a **practice-debt pressure** (parallel to SRS backlog pressure):
       * cards score `base × multiplier`, where the multiplier starts at
       * PRACTICE_BASE_MULT (so a few reps land promptly post-intro, competing with
       * pressured reviews) and escalates by how long the debt has stayed open
       * (per-tag, time-based via `priorPracticeDebt`/`nextPracticeDebt`), clamped at
       * MAX_PRACTICE_MULTIPLIER. The debt is durable and self-discharges the instant
       * the skill reaches `practiceMinCount` — so this no longer relies on the
       * session-scoped intro boost to actually surface.
       *
       * Fully data-driven: the unlock relation comes from the hierarchy config and
       * practice-status from per-tag ELO. No card-id or tag-namespace hard-coding.
       */
      buildPracticeCards(args) {
        const {
          group,
          courseId,
          emittedIds,
          cardsByTag,
          hierarchyConfigs,
          userTagElo,
          userGlobalElo,
          activeIds,
          seenIds,
          priorPracticeDebt,
          nextPracticeDebt
        } = args;
        const patterns = group.practiceTagPatterns ?? [];
        if (patterns.length === 0) return [];
        const practiceMinCount = group.practiceMinCount ?? DEFAULT_PRACTICE_MIN_COUNT;
        const maxPractice = group.maxPracticeCardsPerRun ?? DEFAULT_MAX_PRACTICE_PER_RUN;
        const practiceTags = [...cardsByTag.keys()].filter(
          (tag) => patterns.some((p) => matchesTagPattern(tag, p)) && this.isUnlockedGatedSkill(tag, hierarchyConfigs, userTagElo, userGlobalElo) && (userTagElo[tag]?.count ?? 0) < practiceMinCount
        );
        if (practiceTags.length === 0) return [];
        const now = Date.now();
        const DAY_MS = 24 * 60 * 60 * 1e3;
        const tagMultiplier = /* @__PURE__ */ new Map();
        for (const tag of practiceTags) {
          const firstOwedAt = priorPracticeDebt[tag] ?? isoNow();
          nextPracticeDebt[tag] = firstOwedAt;
          const staleDays = Math.max(0, (now - new Date(firstOwedAt).getTime()) / DAY_MS);
          const mult = clamp(
            PRACTICE_BASE_MULT + staleDays * PRACTICE_STALENESS_BUMP_PER_DAY,
            PRACTICE_BASE_MULT,
            MAX_PRACTICE_MULTIPLIER
          );
          tagMultiplier.set(tag, mult);
        }
        const practiceCardIds = this.findDiscoveredSupportCards({
          supportTags: practiceTags,
          cardsByTag,
          activeIds,
          seenIds,
          excludedIds: emittedIds,
          limit: maxPractice
        });
        if (practiceCardIds.length === 0) return [];
        logger.info(
          `[Prescribed] Group '${group.id}' practice: ${practiceTags.length} unlocked under-practiced skill(s), emitting ${practiceCardIds.length} drill card(s)`
        );
        const cards = [];
        for (const cardId of practiceCardIds) {
          emittedIds.add(cardId);
          let mult = PRACTICE_BASE_MULT;
          for (const tag of practiceTags) {
            if (cardsByTag.get(tag)?.includes(cardId) ?? false) {
              mult = Math.max(mult, tagMultiplier.get(tag) ?? PRACTICE_BASE_MULT);
            }
          }
          const score = BASE_PRACTICE_SCORE * mult;
          cards.push({
            cardId,
            courseId,
            score,
            provenance: [
              {
                strategy: "prescribed",
                strategyName: this.strategyName || this.name,
                strategyId: this.strategyId || "NAVIGATION_STRATEGY-prescribed",
                action: "generated",
                score,
                reason: `mode=practice;group=${group.id};debtMult=\xD7${mult.toFixed(2)};underPracticedSkills=${practiceTags.length};practiceTags=${practiceTags.slice(0, 8).join("|")}${practiceTags.length > 8 ? "|\u2026" : ""};testversion=${PRESCRIBED_DEBUG_VERSION}`
              }
            ]
          });
        }
        return cards;
      }
      /**
       * True for a skill that was *gated and is now reached*: it has at least one
       * declared hierarchy prerequisite set, and every set is fully satisfied by the
       * learner's per-tag ELO. This deliberately EXCLUDES tags with no prerequisites
       * — an ungated tag was never "introduced" in the curricular sense, so it isn't
       * a post-intro drill target (e.g. whole-word spelling tags that share the
       * `gpc:exercise:*` prefix but have no intro gate). Those are left to normal
       * ELO retrieval. This is the precise population the retrieval gap strands:
       * just-unlocked, low-ELO skills.
       */
      isUnlockedGatedSkill(tag, hierarchyConfigs, userTagElo, userGlobalElo) {
        const prereqSets = hierarchyConfigs.map((hierarchy) => hierarchy.prerequisites[tag]).filter((prereqs) => Array.isArray(prereqs) && prereqs.length > 0);
        if (prereqSets.length === 0) return false;
        return prereqSets.every(
          (prereqs) => prereqs.every((pr) => this.isPrerequisiteMet(pr, userTagElo[pr.tag], userGlobalElo))
        );
      }
      findSupportCardsByTags(group, tagsByCard, supportTags) {
        if (supportTags.length === 0) {
          return [];
        }
        const explicitSupportIds = group.supportCardIds ?? [];
        const explicitPatterns = group.supportTagPatterns ?? [];
        if (explicitSupportIds.length === 0 && explicitPatterns.length === 0) {
          return [];
        }
        const candidates = /* @__PURE__ */ new Set();
        for (const cardId of explicitSupportIds) {
          const cardTags = tagsByCard.get(cardId) ?? [];
          const matchesResolved = supportTags.some((supportTag) => cardTags.includes(supportTag));
          const matchesPattern = explicitPatterns.some(
            (pattern) => cardTags.some((tag) => matchesTagPattern(tag, pattern))
          );
          if (matchesResolved || matchesPattern) {
            candidates.add(cardId);
          }
        }
        return [...candidates];
      }
      findDiscoveredSupportCards(args) {
        const { supportTags, cardsByTag, activeIds, seenIds, excludedIds, limit } = args;
        const byCardId = /* @__PURE__ */ new Map();
        for (const supportTag of supportTags) {
          const taggedCards = cardsByTag.get(supportTag) ?? [];
          for (const cardId of taggedCards) {
            if (activeIds.has(cardId) || seenIds.has(cardId) || excludedIds.has(cardId)) {
              continue;
            }
            const existing = byCardId.get(cardId);
            if (existing) {
              existing.matches += 1;
            } else {
              byCardId.set(cardId, { cardId, matches: 1 });
            }
          }
        }
        const candidates = [...byCardId.values()].sort((a, b) => b.matches - a.matches || a.cardId.localeCompare(b.cardId));
        const usedStems = /* @__PURE__ */ new Set();
        const diverse = [];
        const deferred = [];
        for (const entry of candidates) {
          const stem = extractWordStem(entry.cardId);
          if (!usedStems.has(stem)) {
            usedStems.add(stem);
            diverse.push(entry);
          } else {
            deferred.push(entry);
          }
        }
        shuffleInPlace(diverse);
        shuffleInPlace(deferred);
        return [...diverse, ...deferred].slice(0, limit).map((entry) => entry.cardId);
      }
      resolveBlockedSupportTags(targetTags, hierarchyConfigs, userTagElo, userGlobalElo, hierarchyWalkEnabled, maxDepth) {
        const supportTags = /* @__PURE__ */ new Set();
        let blocked = false;
        for (const targetTag of targetTags) {
          const prereqSets = hierarchyConfigs.map((hierarchy) => hierarchy.prerequisites[targetTag]).filter((prereqs) => Array.isArray(prereqs) && prereqs.length > 0);
          if (prereqSets.length === 0) {
            continue;
          }
          const tagBlocked = prereqSets.some(
            (prereqs) => prereqs.some((pr) => !this.isPrerequisiteMet(pr, userTagElo[pr.tag], userGlobalElo))
          );
          if (!tagBlocked) {
            continue;
          }
          blocked = true;
          if (!hierarchyWalkEnabled) {
            for (const prereqs of prereqSets) {
              for (const prereq of prereqs) {
                if (!this.isPrerequisiteMet(prereq, userTagElo[prereq.tag], userGlobalElo)) {
                  supportTags.add(prereq.tag);
                }
              }
            }
            continue;
          }
          for (const prereqs of prereqSets) {
            for (const prereq of prereqs) {
              if (!this.isPrerequisiteMet(prereq, userTagElo[prereq.tag], userGlobalElo)) {
                this.collectSupportTagsRecursive(
                  prereq.tag,
                  hierarchyConfigs,
                  userTagElo,
                  userGlobalElo,
                  maxDepth,
                  /* @__PURE__ */ new Set(),
                  supportTags
                );
              }
            }
          }
        }
        return { blocked, supportTags: [...supportTags] };
      }
      collectSupportTagsRecursive(tag, hierarchyConfigs, userTagElo, userGlobalElo, depth, visited, out) {
        if (depth < 0 || visited.has(tag)) return;
        visited.add(tag);
        let walkedFurther = false;
        for (const hierarchy of hierarchyConfigs) {
          const prereqs = hierarchy.prerequisites[tag];
          if (!prereqs || prereqs.length === 0) continue;
          const unmet = prereqs.filter(
            (pr) => !this.isPrerequisiteMet(pr, userTagElo[pr.tag], userGlobalElo)
          );
          if (unmet.length > 0 && depth > 0) {
            walkedFurther = true;
            for (const prereq of unmet) {
              this.collectSupportTagsRecursive(
                prereq.tag,
                hierarchyConfigs,
                userTagElo,
                userGlobalElo,
                depth - 1,
                visited,
                out
              );
            }
          }
        }
        if (!walkedFurther) {
          out.add(tag);
        }
      }
      isPrerequisiteMet(prereq, userTagElo, userGlobalElo) {
        if (!userTagElo) return false;
        const minCount = prereq.masteryThreshold?.minCount ?? DEFAULT_MIN_COUNT;
        if (userTagElo.count < minCount) return false;
        if (prereq.masteryThreshold?.minElo !== void 0) {
          return userTagElo.score >= prereq.masteryThreshold.minElo;
        }
        if (prereq.masteryThreshold?.minCount !== void 0) {
          return true;
        }
        return userTagElo.score >= userGlobalElo;
      }
    };
  }
});

// src/core/navigators/generators/srs.ts
var srs_exports = {};
__export(srs_exports, {
  default: () => SRSNavigator
});
import moment3 from "moment";
var DEFAULT_HEALTHY_BACKLOG, MAX_BACKLOG_MULTIPLIER, SRSNavigator;
var init_srs = __esm({
  "src/core/navigators/generators/srs.ts"() {
    "use strict";
    init_navigators();
    init_SrsDebugger();
    init_logger();
    DEFAULT_HEALTHY_BACKLOG = 20;
    MAX_BACKLOG_MULTIPLIER = 2;
    SRSNavigator = class extends ContentNavigator {
      /** Human-readable name for CardGenerator interface */
      name;
      /** Healthy backlog threshold - when exceeded, backlog pressure kicks in */
      healthyBacklog;
      constructor(user, course, strategyData) {
        super(user, course, strategyData);
        this.name = strategyData?.name || "SRS";
        const config = this.parseConfig(strategyData?.serializedData);
        this.healthyBacklog = config.healthyBacklog ?? DEFAULT_HEALTHY_BACKLOG;
      }
      /**
       * Parse configuration from serialized JSON.
       */
      parseConfig(serializedData) {
        if (!serializedData) return {};
        try {
          return JSON.parse(serializedData);
        } catch {
          logger.warn("[SRS] Failed to parse strategy config, using defaults");
          return {};
        }
      }
      /**
       * Get review cards scored by urgency.
       *
       * Score formula combines:
       * - Relative overdueness: hoursOverdue / intervalHours
       * - Interval recency: exponential decay favoring shorter intervals
       * - Backlog pressure: boost when due reviews exceed healthy threshold
       *
       * Cards not yet due are excluded (not scored as 0).
       *
       * This method supports both the legacy signature (limit only) and the
       * CardGenerator interface signature (limit, context).
       *
       * @param limit - Maximum number of cards to return
       * @param _context - Optional GeneratorContext (currently unused, but required for interface)
       */
      async getWeightedCards(limit, _context) {
        if (!this.user || !this.course) {
          throw new Error("SRSNavigator requires user and course to be set");
        }
        const courseId = this.course.getCourseID();
        const reviews = await this.user.getPendingReviews(courseId);
        const now = moment3.utc();
        let dueReviews = reviews.filter((r) => now.isAfter(moment3.utc(r.reviewTime)));
        if (dueReviews.length > 0) {
          const dueCardIds = [...new Set(dueReviews.map((r) => r.cardId))];
          const tagsByCard = await this.course.getAppliedTagsBatch(dueCardIds);
          const skippedReviewIds = [];
          dueReviews = dueReviews.filter((r) => {
            const tags = tagsByCard.get(r.cardId) ?? [];
            if (tags.includes("srs:skip")) {
              skippedReviewIds.push(r._id);
              return false;
            }
            return true;
          });
          if (skippedReviewIds.length > 0) {
            logger.info(`[SRS] Removing ${skippedReviewIds.length} scheduled reviews for srs:skip cards`);
            for (const id of skippedReviewIds) {
              void this.user.removeScheduledCardReview(id);
            }
          }
        }
        const backlogMultiplier = this.computeBacklogMultiplier(dueReviews.length);
        const notDue = reviews.filter((r) => !now.isAfter(moment3.utc(r.reviewTime)));
        let nextDueIn = null;
        if (notDue.length > 0) {
          const next = notDue.reduce(
            (a, b) => moment3.utc(a.reviewTime).isBefore(moment3.utc(b.reviewTime)) ? a : b
          );
          const until = moment3.duration(moment3.utc(next.reviewTime).diff(now));
          nextDueIn = until.asHours() < 1 ? `${Math.round(until.asMinutes())}m` : until.asHours() < 24 ? `${Math.round(until.asHours())}h` : `${Math.round(until.asDays())}d`;
        }
        if (dueReviews.length > 0) {
          const pressureNote = backlogMultiplier > 1 ? ` [backlog pressure: \xD7${backlogMultiplier.toFixed(2)}]` : ` [healthy backlog]`;
          logger.info(
            `[SRS] Course ${courseId}: ${dueReviews.length} reviews due now (of ${reviews.length} scheduled)${pressureNote}`
          );
        } else if (reviews.length > 0) {
          const sortedByDue = [...reviews].sort(
            (a, b) => moment3.utc(a.reviewTime).diff(moment3.utc(b.reviewTime))
          );
          const nextDue = sortedByDue[0];
          const nextDueTime = moment3.utc(nextDue.reviewTime);
          const untilDue = moment3.duration(nextDueTime.diff(now));
          const untilDueStr = untilDue.asHours() < 1 ? `${Math.round(untilDue.asMinutes())}m` : untilDue.asHours() < 24 ? `${Math.round(untilDue.asHours())}h` : `${Math.round(untilDue.asDays())}d`;
          logger.info(
            `[SRS] Course ${courseId}: 0 reviews due now (${reviews.length} scheduled, next in ${untilDueStr})`
          );
        } else {
          logger.info(`[SRS] Course ${courseId}: No reviews scheduled`);
        }
        const scored = dueReviews.map((review) => {
          const { score, reason } = this.computeUrgencyScore(review, now, backlogMultiplier);
          return {
            cardId: review.cardId,
            courseId: review.courseId,
            score,
            reviewID: review._id,
            provenance: [
              {
                strategy: "srs",
                strategyName: this.strategyName || this.name,
                strategyId: this.strategyId || "NAVIGATION_STRATEGY-SRS-default",
                action: "generated",
                score,
                reason
              }
            ]
          };
        });
        const sorted = scored.sort((a, b) => b.score - a.score);
        captureSrsBacklog({
          courseId,
          scheduledTotal: reviews.length,
          dueNow: dueReviews.length,
          healthyBacklog: this.healthyBacklog,
          backlogMultiplier,
          maxBacklogMultiplier: MAX_BACKLOG_MULTIPLIER,
          topReviewScore: sorted.length > 0 ? sorted[0].score : null,
          nextDueIn,
          timestamp: Date.now()
        });
        return { cards: sorted.slice(0, limit) };
      }
      /**
       * Compute the multiplicative backlog pressure based on number of due reviews.
       *
       * ×1.0 at or below the healthy threshold (no boost), increasing linearly above
       * it and maxing out at MAX_BACKLOG_MULTIPLIER at 3× the healthy backlog.
       *
       * Examples (with default healthyBacklog=20, MAX_BACKLOG_MULTIPLIER=2.0):
       * - 10 due reviews → ×1.00 (healthy)
       * - 20 due reviews → ×1.00 (at threshold)
       * - 40 due reviews → ×1.50 (2x threshold)
       * - 60 due reviews → ×2.00 (3x threshold, maxed)
       *
       * @param dueCount - Number of reviews currently due
       * @returns Multiplier applied to review urgency (1.0 to MAX_BACKLOG_MULTIPLIER)
       */
      computeBacklogMultiplier(dueCount) {
        if (dueCount <= this.healthyBacklog) {
          return 1;
        }
        const excess = dueCount - this.healthyBacklog;
        const multiplier = 1 + excess / this.healthyBacklog * ((MAX_BACKLOG_MULTIPLIER - 1) / 2);
        return Math.min(MAX_BACKLOG_MULTIPLIER, multiplier);
      }
      /**
       * Compute urgency score for a review card.
       *
       * Three factors:
       * 1. Relative overdueness = hoursOverdue / intervalHours
       *    - 2 days overdue on 3-day interval = 0.67 (urgent)
       *    - 2 days overdue on 180-day interval = 0.01 (not urgent)
       *
       * 2. Interval recency factor = 0.3 + 0.7 * exp(-intervalHours / 720)
       *    - 24h interval → ~1.0 (very recent learning)
       *    - 30 days (720h) → ~0.56
       *    - 180 days → ~0.30
       *
       * 3. Backlog pressure = global *multiplier* when review backlog exceeds the
       *    healthy threshold (×1.0 healthy → up to MAX_BACKLOG_MULTIPLIER at 3×).
       *
       * Combined: (base 0.5 + urgency factors * 0.45) × backlog multiplier.
       * Per-card range before pressure: ~0.57–0.95. NOT clamped to 1.0 — under a
       * heavy backlog reviews scale onto the open scale to compete with (and exceed)
       * new cards; what keeps them from running away is the bounded multiplier, not
       * a hard ceiling.
       *
       * @param review - The scheduled card to score
       * @param now - Current time
       * @param backlogMultiplier - Pre-computed backlog multiplier (1.0 to MAX_BACKLOG_MULTIPLIER)
       */
      computeUrgencyScore(review, now, backlogMultiplier) {
        const scheduledAt = moment3.utc(review.scheduledAt);
        const due = moment3.utc(review.reviewTime);
        const intervalHours = Math.max(1, due.diff(scheduledAt, "hours"));
        const hoursOverdue = now.diff(due, "hours");
        const relativeOverdue = hoursOverdue / intervalHours;
        const recencyFactor = 0.3 + 0.7 * Math.exp(-intervalHours / 720);
        const overdueContribution = Math.min(1, Math.max(0, relativeOverdue));
        const urgency = overdueContribution * 0.5 + recencyFactor * 0.5;
        const baseScore = 0.5 + urgency * 0.45;
        const score = baseScore * backlogMultiplier;
        const reasonParts = [
          `${Math.round(hoursOverdue)}h overdue`,
          `interval: ${Math.round(intervalHours)}h`,
          `relative: ${relativeOverdue.toFixed(2)}`,
          `recency: ${recencyFactor.toFixed(2)}`
        ];
        if (backlogMultiplier > 1) {
          reasonParts.push(`backlog: \xD7${backlogMultiplier.toFixed(2)}`);
        }
        reasonParts.push("review");
        const reason = reasonParts.join(", ");
        return { score, reason };
      }
    };
  }
});

// src/core/navigators/generators/types.ts
var types_exports = {};
var init_types = __esm({
  "src/core/navigators/generators/types.ts"() {
    "use strict";
  }
});

// import("./generators/**/*") in src/core/navigators/index.ts
var globImport_generators;
var init_ = __esm({
  'import("./generators/**/*") in src/core/navigators/index.ts'() {
    globImport_generators = __glob({
      "./generators/CompositeGenerator.ts": () => Promise.resolve().then(() => (init_CompositeGenerator(), CompositeGenerator_exports)),
      "./generators/elo.ts": () => Promise.resolve().then(() => (init_elo(), elo_exports)),
      "./generators/index.ts": () => Promise.resolve().then(() => (init_generators(), generators_exports)),
      "./generators/prescribed.ts": () => Promise.resolve().then(() => (init_prescribed(), prescribed_exports)),
      "./generators/srs.ts": () => Promise.resolve().then(() => (init_srs(), srs_exports)),
      "./generators/types.ts": () => Promise.resolve().then(() => (init_types(), types_exports))
    });
  }
});

// src/core/types/contentNavigationStrategy.ts
var DEFAULT_LEARNABLE_WEIGHT;
var init_contentNavigationStrategy = __esm({
  "src/core/types/contentNavigationStrategy.ts"() {
    "use strict";
    DEFAULT_LEARNABLE_WEIGHT = {
      weight: 1,
      confidence: 0.1,
      // Low confidence initially = wide exploration
      sampleSize: 0
    };
  }
});

// src/core/navigators/filters/WeightedFilter.ts
var WeightedFilter_exports = {};
__export(WeightedFilter_exports, {
  WeightedFilter: () => WeightedFilter
});
var WeightedFilter;
var init_WeightedFilter = __esm({
  "src/core/navigators/filters/WeightedFilter.ts"() {
    "use strict";
    init_contentNavigationStrategy();
    WeightedFilter = class {
      name;
      inner;
      learnable;
      staticWeight;
      strategyId;
      constructor(inner, learnable = DEFAULT_LEARNABLE_WEIGHT, staticWeight = false, strategyId) {
        this.inner = inner;
        this.name = inner.name;
        this.learnable = learnable;
        this.staticWeight = staticWeight;
        this.strategyId = strategyId;
      }
      /**
       * Apply the inner filter, then scale its effect by the configured weight.
       */
      async transform(cards, context) {
        let effectiveWeight = this.learnable.weight;
        let deviation;
        if (!this.staticWeight && context.orchestration) {
          const strategyId = this.strategyId || this.inner.strategyId || this.name;
          effectiveWeight = context.orchestration.getEffectiveWeight(strategyId, this.learnable);
          deviation = context.orchestration.getDeviation(strategyId);
        }
        if (Math.abs(effectiveWeight - 1) < 1e-3) {
          return this.inner.transform(cards, context);
        }
        const originalScores = /* @__PURE__ */ new Map();
        for (const card of cards) {
          originalScores.set(card.cardId, card.score);
        }
        const transformedCards = await this.inner.transform(cards, context);
        return transformedCards.map((card) => {
          const originalScore = originalScores.get(card.cardId);
          if (originalScore === void 0 || originalScore === 0 || card.score === 0) {
            return card;
          }
          const rawEffect = card.score / originalScore;
          if (Math.abs(rawEffect - 1) < 1e-4) {
            return card;
          }
          const weightedEffect = Math.pow(rawEffect, effectiveWeight);
          const newScore = originalScore * weightedEffect;
          const lastProvIndex = card.provenance.length - 1;
          const lastProv = card.provenance[lastProvIndex];
          if (lastProv) {
            const updatedProvenance = [...card.provenance];
            updatedProvenance[lastProvIndex] = {
              ...lastProv,
              score: newScore,
              effectiveWeight,
              deviation
              // We can optionally append to the reason, but the structured field is key
            };
            return {
              ...card,
              score: newScore,
              provenance: updatedProvenance
            };
          }
          return {
            ...card,
            score: newScore
          };
        });
      }
    };
  }
});

// src/core/navigators/filters/eloDistance.ts
var eloDistance_exports = {};
__export(eloDistance_exports, {
  DEFAULT_HALF_LIFE: () => DEFAULT_HALF_LIFE,
  DEFAULT_MAX_MULTIPLIER: () => DEFAULT_MAX_MULTIPLIER,
  DEFAULT_MIN_MULTIPLIER: () => DEFAULT_MIN_MULTIPLIER,
  createEloDistanceFilter: () => createEloDistanceFilter
});
function computeMultiplier(distance, halfLife, minMultiplier, maxMultiplier) {
  const normalizedDistance = distance / halfLife;
  const decay = Math.exp(-(normalizedDistance * normalizedDistance));
  return minMultiplier + (maxMultiplier - minMultiplier) * decay;
}
function createEloDistanceFilter(config) {
  const halfLife = config?.halfLife ?? DEFAULT_HALF_LIFE;
  const minMultiplier = config?.minMultiplier ?? DEFAULT_MIN_MULTIPLIER;
  const maxMultiplier = config?.maxMultiplier ?? DEFAULT_MAX_MULTIPLIER;
  return {
    name: "ELO Distance Filter",
    async transform(cards, context) {
      const { course, userElo } = context;
      const cardIds = cards.map((c) => c.cardId);
      const cardElos = await course.getCardEloData(cardIds);
      return cards.map((card, i) => {
        const cardElo = cardElos[i]?.global?.score ?? 1e3;
        const distance = Math.abs(cardElo - userElo);
        const multiplier = computeMultiplier(distance, halfLife, minMultiplier, maxMultiplier);
        const newScore = card.score * multiplier;
        const action = multiplier < maxMultiplier - 0.01 ? "penalized" : "passed";
        return {
          ...card,
          score: newScore,
          provenance: [
            ...card.provenance,
            {
              strategy: "eloDistance",
              strategyName: "ELO Distance Filter",
              strategyId: "ELO_DISTANCE_FILTER",
              action,
              score: newScore,
              reason: `ELO distance ${Math.round(distance)} (card: ${Math.round(cardElo)}, user: ${Math.round(userElo)}) \u2192 ${multiplier.toFixed(2)}x`
            }
          ]
        };
      });
    }
  };
}
var DEFAULT_HALF_LIFE, DEFAULT_MIN_MULTIPLIER, DEFAULT_MAX_MULTIPLIER;
var init_eloDistance = __esm({
  "src/core/navigators/filters/eloDistance.ts"() {
    "use strict";
    DEFAULT_HALF_LIFE = 200;
    DEFAULT_MIN_MULTIPLIER = 0.3;
    DEFAULT_MAX_MULTIPLIER = 1;
  }
});

// src/core/navigators/filters/hierarchyDefinition.ts
var hierarchyDefinition_exports = {};
__export(hierarchyDefinition_exports, {
  default: () => HierarchyDefinitionNavigator
});
import { toCourseElo as toCourseElo3 } from "@vue-skuilder/common";
var DEFAULT_MIN_COUNT2, HierarchyDefinitionNavigator;
var init_hierarchyDefinition = __esm({
  "src/core/navigators/filters/hierarchyDefinition.ts"() {
    "use strict";
    init_navigators();
    init_logger();
    DEFAULT_MIN_COUNT2 = 3;
    HierarchyDefinitionNavigator = class extends ContentNavigator {
      config;
      /** Human-readable name for CardFilter interface */
      name;
      constructor(user, course, strategyData) {
        super(user, course, strategyData);
        this.config = this.parseConfig(strategyData.serializedData);
        this.name = strategyData.name || "Hierarchy Definition";
      }
      parseConfig(serializedData) {
        try {
          const parsed = JSON.parse(serializedData);
          return {
            prerequisites: parsed.prerequisites || {}
          };
        } catch {
          return {
            prerequisites: {}
          };
        }
      }
      /**
       * Check if a specific prerequisite is satisfied
       */
      isPrerequisiteMet(prereq, userTagElo, userGlobalElo) {
        if (!userTagElo) return false;
        const minCount = prereq.masteryThreshold?.minCount ?? DEFAULT_MIN_COUNT2;
        if (userTagElo.count < minCount) return false;
        if (prereq.masteryThreshold?.minElo !== void 0) {
          return userTagElo.score >= prereq.masteryThreshold.minElo;
        } else if (prereq.masteryThreshold?.minCount !== void 0) {
          return true;
        } else {
          return userTagElo.score >= userGlobalElo;
        }
      }
      /**
       * Get the set of tags the user has mastered.
       * A tag is "mastered" if it appears as a prerequisite somewhere and meets its threshold.
       */
      async getMasteredTags(context) {
        const mastered = /* @__PURE__ */ new Set();
        try {
          const courseReg = await context.user.getCourseRegDoc(context.course.getCourseID());
          const userElo = toCourseElo3(courseReg.elo);
          for (const prereqs of Object.values(this.config.prerequisites)) {
            for (const prereq of prereqs) {
              const tagElo = userElo.tags[prereq.tag];
              if (this.isPrerequisiteMet(prereq, tagElo, userElo.global.score)) {
                mastered.add(prereq.tag);
              }
            }
          }
        } catch {
        }
        return mastered;
      }
      /**
       * Get the set of tags that are unlocked (prerequisites met)
       */
      getUnlockedTags(masteredTags) {
        const unlocked = /* @__PURE__ */ new Set();
        for (const [tagId, prereqs] of Object.entries(this.config.prerequisites)) {
          const allPrereqsMet = prereqs.every((prereq) => masteredTags.has(prereq.tag));
          if (allPrereqsMet) {
            unlocked.add(tagId);
          }
        }
        return unlocked;
      }
      /**
       * Check if a tag has prerequisites defined in config
       */
      hasPrerequisites(tagId) {
        return tagId in this.config.prerequisites;
      }
      /**
       * Check if a card is unlocked and generate reason.
       */
      async checkCardUnlock(card, _course, unlockedTags, masteredTags) {
        try {
          const cardTags = card.tags ?? [];
          const lockedTags = cardTags.filter(
            (tag) => this.hasPrerequisites(tag) && !unlockedTags.has(tag)
          );
          if (lockedTags.length === 0) {
            const tagList = cardTags.length > 0 ? cardTags.join(", ") : "none";
            return {
              isUnlocked: true,
              reason: `Prerequisites met, tags: ${tagList}`
            };
          }
          const missingPrereqs = lockedTags.flatMap((tag) => {
            const prereqs = this.config.prerequisites[tag] || [];
            return prereqs.filter((p) => !masteredTags.has(p.tag)).map((p) => p.tag);
          });
          return {
            isUnlocked: false,
            reason: `Blocked: missing prerequisites ${missingPrereqs.join(", ")} for tags ${lockedTags.join(", ")}`
          };
        } catch {
          return {
            isUnlocked: true,
            reason: "Prerequisites check skipped (tag lookup failed)"
          };
        }
      }
      /**
       * Build a map of prereq tag → max configured boost for all *closed* gates.
       *
       * When a gate is closed (prereqs unmet), cards carrying that gate's prereq
       * tags get boosted — steering the pipeline toward content that helps unlock
       * the gated material. Once the gate opens, the boost disappears.
       */
      getPreReqBoosts(unlockedTags, masteredTags) {
        const boosts = /* @__PURE__ */ new Map();
        for (const [tagId, prereqs] of Object.entries(this.config.prerequisites)) {
          if (unlockedTags.has(tagId)) continue;
          for (const prereq of prereqs) {
            if (!prereq.preReqBoost || prereq.preReqBoost <= 1) continue;
            if (masteredTags.has(prereq.tag)) continue;
            const existing = boosts.get(prereq.tag) ?? 1;
            boosts.set(prereq.tag, Math.max(existing, prereq.preReqBoost));
          }
        }
        return boosts;
      }
      /**
       * Build a map of gated tag → max configured targetBoost for all *open* gates.
       *
       * When a gate opens (prereqs met), cards carrying the gated tag get boosted —
       * ensuring newly-unlocked content surfaces promptly. The boost is a static
       * multiplier; natural ELO/SRS deprioritization after interaction handles decay.
       */
      getTargetBoosts(unlockedTags) {
        const boosts = /* @__PURE__ */ new Map();
        const configKeys = Object.keys(this.config.prerequisites);
        const unlockedArr = [...unlockedTags];
        logger.info(
          `[HierarchyDefinition:targetBoost:trace] ${this.name} | configKeys=${configKeys.length}, unlocked=${unlockedArr.length} (${unlockedArr.slice(0, 5).join(", ")}${unlockedArr.length > 5 ? "..." : ""})`
        );
        for (const [tagId, prereqs] of Object.entries(this.config.prerequisites)) {
          if (!unlockedTags.has(tagId)) continue;
          logger.info(
            `[HierarchyDefinition:targetBoost:trace] UNLOCKED ${tagId}: ${prereqs.length} prereqs, raw=${JSON.stringify(prereqs.map((p) => ({ tag: p.tag, tb: p.targetBoost })))}`
          );
          for (const prereq of prereqs) {
            if (!prereq.targetBoost || prereq.targetBoost <= 1) continue;
            const existing = boosts.get(tagId) ?? 1;
            boosts.set(tagId, Math.max(existing, prereq.targetBoost));
          }
        }
        if (boosts.size > 0) {
          logger.info(
            `[HierarchyDefinition] targetBoosts active: ${[...boosts.entries()].map(([t, b]) => `${t}=\xD7${b}`).join(", ")}`
          );
        } else {
          logger.info(
            `[HierarchyDefinition:targetBoost:trace] no targetBoosts found despite ${unlockedArr.length} unlocked tags`
          );
        }
        return boosts;
      }
      /**
       * CardFilter.transform implementation.
       *
       * Three effects:
       * 1. Cards with locked tags receive score * 0.02 (gating penalty)
       * 2. Cards carrying prereq tags of closed gates receive preReqBoost
       * 3. Cards carrying gated tags of open gates receive targetBoost
       */
      async transform(cards, context) {
        const masteredTags = await this.getMasteredTags(context);
        const unlockedTags = this.getUnlockedTags(masteredTags);
        const preReqBoosts = this.getPreReqBoosts(unlockedTags, masteredTags);
        const targetBoosts = this.getTargetBoosts(unlockedTags);
        const gated = [];
        for (const card of cards) {
          const { isUnlocked, reason } = await this.checkCardUnlock(
            card,
            context.course,
            unlockedTags,
            masteredTags
          );
          const LOCKED_PENALTY = 0.02;
          let finalScore = isUnlocked ? card.score : card.score * LOCKED_PENALTY;
          let action = isUnlocked ? "passed" : "penalized";
          let finalReason = reason;
          if (isUnlocked && preReqBoosts.size > 0) {
            const cardTags = card.tags ?? [];
            let maxBoost = 1;
            const boostedPrereqs = [];
            for (const tag of cardTags) {
              const boost = preReqBoosts.get(tag);
              if (boost && boost > maxBoost) {
                maxBoost = boost;
                boostedPrereqs.push(tag);
              }
            }
            if (maxBoost > 1) {
              finalScore *= maxBoost;
              action = "boosted";
              finalReason = `${reason} | preReqBoost \xD7${maxBoost.toFixed(2)} for ${boostedPrereqs.join(", ")}`;
              logger.info(
                `[HierarchyDefinition] preReqBoost \xD7${maxBoost.toFixed(2)} applied to card ${card.cardId} via tags [${boostedPrereqs.join(", ")}] (score: ${card.score.toFixed(3)} \u2192 ${finalScore.toFixed(3)})`
              );
            }
          }
          if (isUnlocked && targetBoosts.size > 0) {
            const cardTags = card.tags ?? [];
            let maxTargetBoost = 1;
            const boostedTargets = [];
            for (const tag of cardTags) {
              const boost = targetBoosts.get(tag);
              if (boost && boost > maxTargetBoost) {
                maxTargetBoost = boost;
                boostedTargets.push(tag);
              }
            }
            if (maxTargetBoost > 1) {
              finalScore *= maxTargetBoost;
              action = "boosted";
              finalReason = `${finalReason} | targetBoost \xD7${maxTargetBoost.toFixed(2)} for ${boostedTargets.join(", ")}`;
              logger.info(
                `[HierarchyDefinition] targetBoost \xD7${maxTargetBoost.toFixed(2)} applied to card ${card.cardId} via tags [${boostedTargets.join(", ")}] (score: ${card.score.toFixed(3)} \u2192 ${finalScore.toFixed(3)})`
              );
            }
          }
          gated.push({
            ...card,
            score: finalScore,
            provenance: [
              ...card.provenance,
              {
                strategy: "hierarchyDefinition",
                strategyName: this.strategyName || this.name,
                strategyId: this.strategyId || "NAVIGATION_STRATEGY-hierarchy",
                action,
                score: finalScore,
                reason: finalReason
              }
            ]
          });
        }
        return gated;
      }
      /**
       * Legacy getWeightedCards - now throws as filters should not be used as generators.
       *
       * Use transform() via Pipeline instead.
       */
      async getWeightedCards(_limit) {
        throw new Error(
          "HierarchyDefinitionNavigator is a filter and should not be used as a generator. Use Pipeline with a generator and this filter via transform()."
        );
      }
    };
  }
});

// src/core/navigators/filters/userTagPreference.ts
var userTagPreference_exports = {};
__export(userTagPreference_exports, {
  default: () => UserTagPreferenceFilter
});
var UserTagPreferenceFilter;
var init_userTagPreference = __esm({
  "src/core/navigators/filters/userTagPreference.ts"() {
    "use strict";
    init_navigators();
    UserTagPreferenceFilter = class extends ContentNavigator {
      _strategyData;
      /** Human-readable name for CardFilter interface */
      name;
      constructor(user, course, strategyData) {
        super(user, course, strategyData);
        this._strategyData = strategyData;
        this.name = strategyData.name || "User Tag Preferences";
      }
      /**
       * Compute multiplier for a card based on its tags and user preferences.
       * Returns the maximum multiplier among all matching tags, or 1.0 if no matches.
       */
      computeMultiplier(cardTags, boostMap) {
        const multipliers = cardTags.map((tag) => boostMap[tag]).filter((val) => val !== void 0);
        if (multipliers.length === 0) {
          return 1;
        }
        return Math.max(...multipliers);
      }
      /**
       * Build human-readable reason for the filter's decision.
       */
      buildReason(cardTags, boostMap, multiplier) {
        const matchingTags = cardTags.filter((tag) => boostMap[tag] === multiplier);
        if (multiplier === 0) {
          return `Excluded by user preference: ${matchingTags.join(", ")} (${multiplier}x)`;
        }
        if (multiplier < 1) {
          return `Penalized by user preference: ${matchingTags.join(", ")} (${multiplier.toFixed(2)}x)`;
        }
        if (multiplier > 1) {
          return `Boosted by user preference: ${matchingTags.join(", ")} (${multiplier.toFixed(2)}x)`;
        }
        return "No matching user preferences";
      }
      /**
       * CardFilter.transform implementation.
       *
       * Apply user tag preferences:
       * 1. Read preferences from strategy state
       * 2. If no preferences, pass through unchanged
       * 3. For each card:
       *    - Look up tag in boost record
       *    - If tag found: apply multiplier (0 = exclude, 1 = neutral, >1 = boost)
       *    - If multiple tags match: use max multiplier
       *    - Append provenance with clear reason
       */
      async transform(cards, _context) {
        const prefs = await this.getStrategyState();
        if (!prefs || Object.keys(prefs.boost).length === 0) {
          return cards.map((card) => ({
            ...card,
            provenance: [
              ...card.provenance,
              {
                strategy: "userTagPreference",
                strategyName: this.strategyName || this.name,
                strategyId: this.strategyId || this._strategyData._id,
                action: "passed",
                score: card.score,
                reason: "No user tag preferences configured"
              }
            ]
          }));
        }
        const adjusted = await Promise.all(
          cards.map(async (card) => {
            const cardTags = card.tags ?? [];
            const multiplier = this.computeMultiplier(cardTags, prefs.boost);
            const finalScore = Math.min(1, card.score * multiplier);
            let action;
            if (multiplier === 0 || multiplier < 1) {
              action = "penalized";
            } else if (multiplier > 1) {
              action = "boosted";
            } else {
              action = "passed";
            }
            return {
              ...card,
              score: finalScore,
              provenance: [
                ...card.provenance,
                {
                  strategy: "userTagPreference",
                  strategyName: this.strategyName || this.name,
                  strategyId: this.strategyId || this._strategyData._id,
                  action,
                  score: finalScore,
                  reason: this.buildReason(cardTags, prefs.boost, multiplier)
                }
              ]
            };
          })
        );
        return adjusted;
      }
      /**
       * Legacy getWeightedCards - throws as filters should not be used as generators.
       */
      async getWeightedCards(_limit) {
        throw new Error(
          "UserTagPreferenceFilter is a filter and should not be used as a generator. Use Pipeline with a generator and this filter via transform()."
        );
      }
    };
  }
});

// src/core/navigators/filters/index.ts
var filters_exports = {};
__export(filters_exports, {
  UserTagPreferenceFilter: () => UserTagPreferenceFilter,
  createEloDistanceFilter: () => createEloDistanceFilter
});
var init_filters = __esm({
  "src/core/navigators/filters/index.ts"() {
    "use strict";
    init_eloDistance();
    init_userTagPreference();
  }
});

// src/core/navigators/filters/inferredPreferenceStub.ts
var inferredPreferenceStub_exports = {};
__export(inferredPreferenceStub_exports, {
  INFERRED_PREFERENCE_NAVIGATOR_STUB: () => INFERRED_PREFERENCE_NAVIGATOR_STUB
});
var INFERRED_PREFERENCE_NAVIGATOR_STUB;
var init_inferredPreferenceStub = __esm({
  "src/core/navigators/filters/inferredPreferenceStub.ts"() {
    "use strict";
    INFERRED_PREFERENCE_NAVIGATOR_STUB = true;
  }
});

// src/core/navigators/filters/interferenceMitigator.ts
var interferenceMitigator_exports = {};
__export(interferenceMitigator_exports, {
  default: () => InterferenceMitigatorNavigator
});
import { toCourseElo as toCourseElo4 } from "@vue-skuilder/common";
var DEFAULT_MIN_COUNT3, DEFAULT_MIN_ELAPSED_DAYS, DEFAULT_INTERFERENCE_DECAY, InterferenceMitigatorNavigator;
var init_interferenceMitigator = __esm({
  "src/core/navigators/filters/interferenceMitigator.ts"() {
    "use strict";
    init_navigators();
    DEFAULT_MIN_COUNT3 = 10;
    DEFAULT_MIN_ELAPSED_DAYS = 3;
    DEFAULT_INTERFERENCE_DECAY = 0.8;
    InterferenceMitigatorNavigator = class extends ContentNavigator {
      config;
      /** Human-readable name for CardFilter interface */
      name;
      /** Precomputed map: tag -> set of { partner, decay } it interferes with */
      interferenceMap;
      constructor(user, course, strategyData) {
        super(user, course, strategyData);
        this.config = this.parseConfig(strategyData.serializedData);
        this.interferenceMap = this.buildInterferenceMap();
        this.name = strategyData.name || "Interference Mitigator";
      }
      parseConfig(serializedData) {
        try {
          const parsed = JSON.parse(serializedData);
          let sets = parsed.interferenceSets || [];
          if (sets.length > 0 && Array.isArray(sets[0])) {
            sets = sets.map((tags) => ({ tags }));
          }
          return {
            interferenceSets: sets,
            maturityThreshold: {
              minCount: parsed.maturityThreshold?.minCount ?? DEFAULT_MIN_COUNT3,
              minElo: parsed.maturityThreshold?.minElo,
              minElapsedDays: parsed.maturityThreshold?.minElapsedDays ?? DEFAULT_MIN_ELAPSED_DAYS
            },
            defaultDecay: parsed.defaultDecay ?? DEFAULT_INTERFERENCE_DECAY
          };
        } catch {
          return {
            interferenceSets: [],
            maturityThreshold: {
              minCount: DEFAULT_MIN_COUNT3,
              minElapsedDays: DEFAULT_MIN_ELAPSED_DAYS
            },
            defaultDecay: DEFAULT_INTERFERENCE_DECAY
          };
        }
      }
      /**
       * Build a map from each tag to its interference partners with decay coefficients.
       * If tags A, B, C are in an interference group with decay 0.8, then:
       * - A interferes with B (decay 0.8) and C (decay 0.8)
       * - B interferes with A (decay 0.8) and C (decay 0.8)
       * - etc.
       */
      buildInterferenceMap() {
        const map = /* @__PURE__ */ new Map();
        for (const group of this.config.interferenceSets) {
          const decay = group.decay ?? this.config.defaultDecay ?? DEFAULT_INTERFERENCE_DECAY;
          for (const tag of group.tags) {
            if (!map.has(tag)) {
              map.set(tag, []);
            }
            const partners = map.get(tag);
            for (const other of group.tags) {
              if (other !== tag) {
                const existing = partners.find((p) => p.partner === other);
                if (existing) {
                  existing.decay = Math.max(existing.decay, decay);
                } else {
                  partners.push({ partner: other, decay });
                }
              }
            }
          }
        }
        return map;
      }
      /**
       * Get the set of tags that are currently immature for this user.
       * A tag is immature if the user has interacted with it but hasn't
       * reached the maturity threshold.
       */
      async getImmatureTags(context) {
        const immature = /* @__PURE__ */ new Set();
        try {
          const courseReg = await context.user.getCourseRegDoc(context.course.getCourseID());
          const userElo = toCourseElo4(courseReg.elo);
          const minCount = this.config.maturityThreshold?.minCount ?? DEFAULT_MIN_COUNT3;
          const minElo = this.config.maturityThreshold?.minElo;
          const minElapsedDays = this.config.maturityThreshold?.minElapsedDays ?? DEFAULT_MIN_ELAPSED_DAYS;
          const minCountForElapsed = minElapsedDays * 2;
          for (const [tagId, tagElo] of Object.entries(userElo.tags)) {
            if (tagElo.count === 0) continue;
            const belowCount = tagElo.count < minCount;
            const belowElo = minElo !== void 0 && tagElo.score < minElo;
            const belowElapsed = tagElo.count < minCountForElapsed;
            if (belowCount || belowElo || belowElapsed) {
              immature.add(tagId);
            }
          }
        } catch {
        }
        return immature;
      }
      /**
       * Get all tags that interfere with any immature tag, along with their decay coefficients.
       * These are the tags we want to avoid introducing.
       */
      getTagsToAvoid(immatureTags) {
        const avoid = /* @__PURE__ */ new Map();
        for (const immatureTag of immatureTags) {
          const partners = this.interferenceMap.get(immatureTag);
          if (partners) {
            for (const { partner, decay } of partners) {
              if (!immatureTags.has(partner)) {
                const existing = avoid.get(partner) ?? 0;
                avoid.set(partner, Math.max(existing, decay));
              }
            }
          }
        }
        return avoid;
      }
      /**
       * Compute interference score reduction for a card.
       * Returns: { multiplier, interfering tags, reason }
       */
      computeInterferenceEffect(cardTags, tagsToAvoid, immatureTags) {
        if (tagsToAvoid.size === 0) {
          return {
            multiplier: 1,
            interferingTags: [],
            reason: "No interference detected"
          };
        }
        let multiplier = 1;
        const interferingTags = [];
        for (const tag of cardTags) {
          const decay = tagsToAvoid.get(tag);
          if (decay !== void 0) {
            interferingTags.push(tag);
            multiplier *= 1 - decay;
          }
        }
        if (interferingTags.length === 0) {
          return {
            multiplier: 1,
            interferingTags: [],
            reason: "No interference detected"
          };
        }
        const causingTags = /* @__PURE__ */ new Set();
        for (const tag of interferingTags) {
          for (const immatureTag of immatureTags) {
            const partners = this.interferenceMap.get(immatureTag);
            if (partners?.some((p) => p.partner === tag)) {
              causingTags.add(immatureTag);
            }
          }
        }
        const reason = `Interferes with immature tags ${Array.from(causingTags).join(", ")} (tags: ${interferingTags.join(", ")}, multiplier: ${multiplier.toFixed(2)})`;
        return { multiplier, interferingTags, reason };
      }
      /**
       * CardFilter.transform implementation.
       *
       * Apply interference-aware scoring. Cards with tags that interfere with
       * immature learnings get reduced scores.
       */
      async transform(cards, context) {
        const immatureTags = await this.getImmatureTags(context);
        const tagsToAvoid = this.getTagsToAvoid(immatureTags);
        const adjusted = [];
        for (const card of cards) {
          const cardTags = card.tags ?? [];
          const { multiplier, reason } = this.computeInterferenceEffect(
            cardTags,
            tagsToAvoid,
            immatureTags
          );
          const finalScore = card.score * multiplier;
          const action = multiplier < 1 ? "penalized" : multiplier > 1 ? "boosted" : "passed";
          adjusted.push({
            ...card,
            score: finalScore,
            provenance: [
              ...card.provenance,
              {
                strategy: "interferenceMitigator",
                strategyName: this.strategyName || this.name,
                strategyId: this.strategyId || "NAVIGATION_STRATEGY-interference",
                action,
                score: finalScore,
                reason
              }
            ]
          });
        }
        return adjusted;
      }
      /**
       * Legacy getWeightedCards - now throws as filters should not be used as generators.
       *
       * Use transform() via Pipeline instead.
       */
      async getWeightedCards(_limit) {
        throw new Error(
          "InterferenceMitigatorNavigator is a filter and should not be used as a generator. Use Pipeline with a generator and this filter via transform()."
        );
      }
    };
  }
});

// src/core/navigators/filters/relativePriority.ts
var relativePriority_exports = {};
__export(relativePriority_exports, {
  default: () => RelativePriorityNavigator
});
var DEFAULT_PRIORITY, DEFAULT_PRIORITY_INFLUENCE, DEFAULT_COMBINE_MODE, RelativePriorityNavigator;
var init_relativePriority = __esm({
  "src/core/navigators/filters/relativePriority.ts"() {
    "use strict";
    init_navigators();
    DEFAULT_PRIORITY = 0.5;
    DEFAULT_PRIORITY_INFLUENCE = 0.5;
    DEFAULT_COMBINE_MODE = "max";
    RelativePriorityNavigator = class extends ContentNavigator {
      config;
      /** Human-readable name for CardFilter interface */
      name;
      constructor(user, course, strategyData) {
        super(user, course, strategyData);
        this.config = this.parseConfig(strategyData.serializedData);
        this.name = strategyData.name || "Relative Priority";
      }
      parseConfig(serializedData) {
        try {
          const parsed = JSON.parse(serializedData);
          return {
            tagPriorities: parsed.tagPriorities || {},
            defaultPriority: parsed.defaultPriority ?? DEFAULT_PRIORITY,
            combineMode: parsed.combineMode ?? DEFAULT_COMBINE_MODE,
            priorityInfluence: parsed.priorityInfluence ?? DEFAULT_PRIORITY_INFLUENCE
          };
        } catch {
          return {
            tagPriorities: {},
            defaultPriority: DEFAULT_PRIORITY,
            combineMode: DEFAULT_COMBINE_MODE,
            priorityInfluence: DEFAULT_PRIORITY_INFLUENCE
          };
        }
      }
      /**
       * Look up the priority for a tag.
       */
      getTagPriority(tagId) {
        return this.config.tagPriorities[tagId] ?? this.config.defaultPriority ?? DEFAULT_PRIORITY;
      }
      /**
       * Compute combined priority for a card based on its tags.
       */
      computeCardPriority(cardTags) {
        if (cardTags.length === 0) {
          return this.config.defaultPriority ?? DEFAULT_PRIORITY;
        }
        const priorities = cardTags.map((tag) => this.getTagPriority(tag));
        switch (this.config.combineMode) {
          case "max":
            return Math.max(...priorities);
          case "min":
            return Math.min(...priorities);
          case "average":
            return priorities.reduce((sum, p) => sum + p, 0) / priorities.length;
          default:
            return Math.max(...priorities);
        }
      }
      /**
       * Compute boost factor based on priority.
       *
       * The formula: 1 + (priority - 0.5) * priorityInfluence
       *
       * This creates a multiplier centered around 1.0:
       * - Priority 1.0 with influence 0.5 → 1.25 (25% boost)
       * - Priority 0.5 with any influence → 1.00 (neutral)
       * - Priority 0.0 with influence 0.5 → 0.75 (25% reduction)
       */
      computeBoostFactor(priority) {
        const influence = this.config.priorityInfluence ?? DEFAULT_PRIORITY_INFLUENCE;
        return 1 + (priority - 0.5) * influence;
      }
      /**
       * Build human-readable reason for priority adjustment.
       */
      buildPriorityReason(cardTags, priority, boostFactor, finalScore) {
        if (cardTags.length === 0) {
          return `No tags, neutral priority (${priority.toFixed(2)})`;
        }
        const tagList = cardTags.slice(0, 3).join(", ");
        const more = cardTags.length > 3 ? ` (+${cardTags.length - 3} more)` : "";
        if (boostFactor === 1) {
          return `Neutral priority (${priority.toFixed(2)}) for tags: ${tagList}${more}`;
        } else if (boostFactor > 1) {
          return `High-priority tags: ${tagList}${more} (priority ${priority.toFixed(2)} \u2192 boost ${boostFactor.toFixed(2)}x \u2192 ${finalScore.toFixed(2)})`;
        } else {
          return `Low-priority tags: ${tagList}${more} (priority ${priority.toFixed(2)} \u2192 reduce ${boostFactor.toFixed(2)}x \u2192 ${finalScore.toFixed(2)})`;
        }
      }
      /**
       * CardFilter.transform implementation.
       *
       * Apply priority-adjusted scoring. Cards with high-priority tags get boosted,
       * cards with low-priority tags get reduced scores.
       */
      async transform(cards, _context) {
        const adjusted = await Promise.all(
          cards.map(async (card) => {
            const cardTags = card.tags ?? [];
            const priority = this.computeCardPriority(cardTags);
            const boostFactor = this.computeBoostFactor(priority);
            const finalScore = Math.max(0, card.score * boostFactor);
            const action = boostFactor > 1 ? "boosted" : boostFactor < 1 ? "penalized" : "passed";
            const reason = this.buildPriorityReason(cardTags, priority, boostFactor, finalScore);
            return {
              ...card,
              score: finalScore,
              provenance: [
                ...card.provenance,
                {
                  strategy: "relativePriority",
                  strategyName: this.strategyName || this.name,
                  strategyId: this.strategyId || "NAVIGATION_STRATEGY-priority",
                  action,
                  score: finalScore,
                  reason
                }
              ]
            };
          })
        );
        return adjusted;
      }
      /**
       * Legacy getWeightedCards - now throws as filters should not be used as generators.
       *
       * Use transform() via Pipeline instead.
       */
      async getWeightedCards(_limit) {
        throw new Error(
          "RelativePriorityNavigator is a filter and should not be used as a generator. Use Pipeline with a generator and this filter via transform()."
        );
      }
    };
  }
});

// src/core/navigators/filters/types.ts
var types_exports2 = {};
var init_types2 = __esm({
  "src/core/navigators/filters/types.ts"() {
    "use strict";
  }
});

// src/core/navigators/filters/userGoalStub.ts
var userGoalStub_exports = {};
__export(userGoalStub_exports, {
  USER_GOAL_NAVIGATOR_STUB: () => USER_GOAL_NAVIGATOR_STUB
});
var USER_GOAL_NAVIGATOR_STUB;
var init_userGoalStub = __esm({
  "src/core/navigators/filters/userGoalStub.ts"() {
    "use strict";
    USER_GOAL_NAVIGATOR_STUB = true;
  }
});

// import("./filters/**/*") in src/core/navigators/index.ts
var globImport_filters;
var init_2 = __esm({
  'import("./filters/**/*") in src/core/navigators/index.ts'() {
    globImport_filters = __glob({
      "./filters/WeightedFilter.ts": () => Promise.resolve().then(() => (init_WeightedFilter(), WeightedFilter_exports)),
      "./filters/eloDistance.ts": () => Promise.resolve().then(() => (init_eloDistance(), eloDistance_exports)),
      "./filters/hierarchyDefinition.ts": () => Promise.resolve().then(() => (init_hierarchyDefinition(), hierarchyDefinition_exports)),
      "./filters/index.ts": () => Promise.resolve().then(() => (init_filters(), filters_exports)),
      "./filters/inferredPreferenceStub.ts": () => Promise.resolve().then(() => (init_inferredPreferenceStub(), inferredPreferenceStub_exports)),
      "./filters/interferenceMitigator.ts": () => Promise.resolve().then(() => (init_interferenceMitigator(), interferenceMitigator_exports)),
      "./filters/relativePriority.ts": () => Promise.resolve().then(() => (init_relativePriority(), relativePriority_exports)),
      "./filters/types.ts": () => Promise.resolve().then(() => (init_types2(), types_exports2)),
      "./filters/userGoalStub.ts": () => Promise.resolve().then(() => (init_userGoalStub(), userGoalStub_exports)),
      "./filters/userTagPreference.ts": () => Promise.resolve().then(() => (init_userTagPreference(), userTagPreference_exports))
    });
  }
});

// src/core/orchestration/gradient.ts
function aggregateOutcomesForGradient(outcomes, strategyId) {
  const observations = [];
  for (const outcome of outcomes) {
    const deviation = outcome.deviations[strategyId];
    if (deviation === void 0) {
      continue;
    }
    observations.push({
      deviation,
      outcomeValue: outcome.outcomeValue,
      weight: 1
    });
  }
  logger.debug(
    `[Orchestration] Aggregated ${observations.length} observations for strategy ${strategyId}`
  );
  return observations;
}
function computeStrategyGradient(observations) {
  const n = observations.length;
  if (n < 3) {
    logger.debug(`[Orchestration] Insufficient observations for gradient (${n} < 3)`);
    return null;
  }
  let sumX = 0;
  let sumY = 0;
  let sumW = 0;
  for (const obs of observations) {
    const w = obs.weight ?? 1;
    sumX += obs.deviation * w;
    sumY += obs.outcomeValue * w;
    sumW += w;
  }
  const meanX = sumX / sumW;
  const meanY = sumY / sumW;
  let numerator = 0;
  let denominator = 0;
  let ssTotal = 0;
  for (const obs of observations) {
    const w = obs.weight ?? 1;
    const dx = obs.deviation - meanX;
    const dy = obs.outcomeValue - meanY;
    numerator += w * dx * dy;
    denominator += w * dx * dx;
    ssTotal += w * dy * dy;
  }
  if (denominator < 1e-10) {
    logger.debug(`[Orchestration] No variance in deviations, cannot compute gradient`);
    return {
      gradient: 0,
      intercept: meanY,
      rSquared: 0,
      sampleSize: n
    };
  }
  const gradient = numerator / denominator;
  const intercept = meanY - gradient * meanX;
  let ssResidual = 0;
  for (const obs of observations) {
    const w = obs.weight ?? 1;
    const predicted = gradient * obs.deviation + intercept;
    const residual = obs.outcomeValue - predicted;
    ssResidual += w * residual * residual;
  }
  const rSquared = ssTotal > 1e-10 ? 1 - ssResidual / ssTotal : 0;
  logger.debug(
    `[Orchestration] Computed gradient: ${gradient.toFixed(4)}, intercept: ${intercept.toFixed(4)}, R\xB2: ${rSquared.toFixed(4)}, n=${n}`
  );
  return {
    gradient,
    intercept,
    rSquared: Math.max(0, Math.min(1, rSquared)),
    // Clamp to [0,1]
    sampleSize: n
  };
}
var init_gradient = __esm({
  "src/core/orchestration/gradient.ts"() {
    "use strict";
    init_logger();
  }
});

// src/core/orchestration/learning.ts
function updateStrategyWeight(current, gradient) {
  if (gradient.sampleSize < MIN_OBSERVATIONS_FOR_UPDATE) {
    logger.debug(
      `[Orchestration] Insufficient samples (${gradient.sampleSize} < ${MIN_OBSERVATIONS_FOR_UPDATE}), keeping current weight`
    );
    return {
      ...current,
      sampleSize: current.sampleSize + gradient.sampleSize
    };
  }
  const isReliable = gradient.rSquared >= MIN_R_SQUARED_FOR_GRADIENT;
  const isFlat = Math.abs(gradient.gradient) < FLAT_GRADIENT_THRESHOLD;
  let newWeight = current.weight;
  let newConfidence = current.confidence;
  if (!isReliable || isFlat) {
    const confidenceGain = 0.05 * (1 - current.confidence);
    newConfidence = Math.min(1, current.confidence + confidenceGain);
    logger.debug(
      `[Orchestration] Flat/unreliable gradient (|g|=${Math.abs(gradient.gradient).toFixed(4)}, R\xB2=${gradient.rSquared.toFixed(4)}). Increasing confidence: ${current.confidence.toFixed(3)} \u2192 ${newConfidence.toFixed(3)}`
    );
  } else {
    let delta = gradient.gradient * LEARNING_RATE;
    delta = Math.max(-MAX_WEIGHT_DELTA, Math.min(MAX_WEIGHT_DELTA, delta));
    newWeight = current.weight + delta;
    newWeight = Math.max(0.1, Math.min(3, newWeight));
    const confidenceGain = 0.02 * (1 - current.confidence);
    newConfidence = Math.min(1, current.confidence + confidenceGain);
    logger.debug(
      `[Orchestration] Adjusting weight: ${current.weight.toFixed(3)} \u2192 ${newWeight.toFixed(3)} (gradient=${gradient.gradient.toFixed(4)}, delta=${delta.toFixed(4)})`
    );
  }
  return {
    weight: newWeight,
    confidence: newConfidence,
    sampleSize: current.sampleSize + gradient.sampleSize
  };
}
function updateLearningState(courseId, strategyId, currentWeight, gradient, existing) {
  const now = (/* @__PURE__ */ new Date()).toISOString();
  const id = `STRATEGY_LEARNING_STATE::${courseId}::${strategyId}`;
  const historyEntry = {
    timestamp: now,
    weight: currentWeight.weight,
    confidence: currentWeight.confidence,
    gradient: gradient.gradient
  };
  let history = existing?.history ?? [];
  history = [...history, historyEntry];
  if (history.length > MAX_HISTORY_LENGTH) {
    history = history.slice(history.length - MAX_HISTORY_LENGTH);
  }
  const state = {
    _id: id,
    _rev: existing?._rev,
    docType: "STRATEGY_LEARNING_STATE" /* STRATEGY_LEARNING_STATE */,
    courseId,
    strategyId,
    currentWeight,
    regression: {
      gradient: gradient.gradient,
      intercept: gradient.intercept,
      rSquared: gradient.rSquared,
      sampleSize: gradient.sampleSize,
      computedAt: now
    },
    history,
    updatedAt: now
  };
  return state;
}
function runPeriodUpdate(input) {
  const { courseId, strategyId, currentWeight, gradient, existingState } = input;
  logger.info(
    `[Orchestration] Running period update for strategy ${strategyId} (${gradient.sampleSize} observations)`
  );
  const newWeight = updateStrategyWeight(currentWeight, gradient);
  const updated = newWeight.weight !== currentWeight.weight;
  const learningState = updateLearningState(
    courseId,
    strategyId,
    newWeight,
    gradient,
    existingState
  );
  logger.info(
    `[Orchestration] Period update complete for ${strategyId}: weight ${currentWeight.weight.toFixed(3)} \u2192 ${newWeight.weight.toFixed(3)}, confidence ${currentWeight.confidence.toFixed(3)} \u2192 ${newWeight.confidence.toFixed(3)}`
  );
  return {
    strategyId,
    previousWeight: currentWeight,
    newWeight,
    gradient,
    learningState,
    updated
  };
}
function getDefaultLearnableWeight() {
  return { ...DEFAULT_LEARNABLE_WEIGHT };
}
var MIN_OBSERVATIONS_FOR_UPDATE, LEARNING_RATE, MAX_WEIGHT_DELTA, MIN_R_SQUARED_FOR_GRADIENT, FLAT_GRADIENT_THRESHOLD, MAX_HISTORY_LENGTH;
var init_learning = __esm({
  "src/core/orchestration/learning.ts"() {
    "use strict";
    init_contentNavigationStrategy();
    init_types_legacy();
    init_logger();
    MIN_OBSERVATIONS_FOR_UPDATE = 10;
    LEARNING_RATE = 0.1;
    MAX_WEIGHT_DELTA = 0.3;
    MIN_R_SQUARED_FOR_GRADIENT = 0.05;
    FLAT_GRADIENT_THRESHOLD = 0.02;
    MAX_HISTORY_LENGTH = 100;
  }
});

// src/core/orchestration/signal.ts
function computeOutcomeSignal(records, config = {}) {
  if (!records || records.length === 0) {
    return null;
  }
  const target = config.targetAccuracy ?? 0.85;
  const tolerance = config.tolerance ?? 0.05;
  let correct = 0;
  for (const r of records) {
    if (r.isCorrect) correct++;
  }
  const accuracy = correct / records.length;
  return scoreAccuracyInZone(accuracy, target, tolerance);
}
function scoreAccuracyInZone(accuracy, target, tolerance) {
  const dist = Math.abs(accuracy - target);
  if (dist <= tolerance) {
    return 1;
  }
  const excess = dist - tolerance;
  const slope = 2.5;
  return Math.max(0, 1 - excess * slope);
}
var init_signal = __esm({
  "src/core/orchestration/signal.ts"() {
    "use strict";
  }
});

// src/core/orchestration/recording.ts
async function recordUserOutcome(context, periodStart, periodEnd, records, activeStrategyIds, eloStart = 0, eloEnd = 0, config) {
  const { user, course, userId } = context;
  const courseId = course.getCourseID();
  const outcomeValue = computeOutcomeSignal(records, config);
  if (outcomeValue === null) {
    logger.debug(
      `[Orchestration] No outcome signal computed for ${userId} (insufficient data). Skipping record.`
    );
    return;
  }
  const deviations = {};
  for (const strategyId of activeStrategyIds) {
    deviations[strategyId] = context.getDeviation(strategyId);
  }
  const id = `USER_OUTCOME::${courseId}::${userId}::${periodEnd}`;
  const record = {
    _id: id,
    docType: "USER_OUTCOME" /* USER_OUTCOME */,
    courseId,
    userId,
    periodStart,
    periodEnd,
    outcomeValue,
    deviations,
    metadata: {
      sessionsCount: 1,
      // Assumes recording is triggered per-session currently
      cardsSeen: records.length,
      eloStart,
      eloEnd,
      signalType: "accuracy_in_zone"
    }
  };
  try {
    await user.putUserOutcome(record);
    logger.debug(
      `[Orchestration] Recorded outcome ${outcomeValue.toFixed(3)} for ${userId} (doc: ${id})`
    );
  } catch (e) {
    logger.error(`[Orchestration] Failed to record outcome: ${e}`);
  }
}
var init_recording = __esm({
  "src/core/orchestration/recording.ts"() {
    "use strict";
    init_signal();
    init_types_legacy();
    init_logger();
  }
});

// src/core/orchestration/index.ts
function fnv1a(str) {
  let hash = 2166136261;
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}
function computeDeviation(userId, strategyId, salt) {
  const input = `${userId}:${strategyId}:${salt}`;
  const hash = fnv1a(input);
  const normalized = hash / 4294967296;
  return normalized * 2 - 1;
}
function computeSpread(confidence) {
  const clampedConfidence = Math.max(0, Math.min(1, confidence));
  return MAX_SPREAD - clampedConfidence * (MAX_SPREAD - MIN_SPREAD);
}
function computeEffectiveWeight(learnable, userId, strategyId, salt) {
  const deviation = computeDeviation(userId, strategyId, salt);
  const spread = computeSpread(learnable.confidence);
  const adjustment = deviation * spread * learnable.weight;
  const effective = learnable.weight + adjustment;
  return Math.max(MIN_WEIGHT, Math.min(MAX_WEIGHT, effective));
}
async function createOrchestrationContext(user, course) {
  let courseConfig;
  try {
    courseConfig = await course.getCourseConfig();
  } catch (e) {
    logger.error(`[Orchestration] Failed to load course config: ${e}`);
    courseConfig = {
      name: "Unknown",
      description: "",
      public: false,
      deleted: false,
      creator: "",
      admins: [],
      moderators: [],
      dataShapes: [],
      questionTypes: [],
      orchestration: { salt: "default" }
    };
  }
  const userId = user.getUsername();
  const salt = courseConfig.orchestration?.salt || "default_salt";
  return {
    user,
    course,
    userId,
    courseConfig,
    getEffectiveWeight(strategyId, learnable) {
      return computeEffectiveWeight(learnable, userId, strategyId, salt);
    },
    getDeviation(strategyId) {
      return computeDeviation(userId, strategyId, salt);
    }
  };
}
var MIN_SPREAD, MAX_SPREAD, MIN_WEIGHT, MAX_WEIGHT;
var init_orchestration = __esm({
  "src/core/orchestration/index.ts"() {
    "use strict";
    init_logger();
    init_gradient();
    init_learning();
    init_signal();
    init_recording();
    MIN_SPREAD = 0.1;
    MAX_SPREAD = 0.5;
    MIN_WEIGHT = 0.1;
    MAX_WEIGHT = 3;
  }
});

// src/core/navigators/Pipeline.ts
var Pipeline_exports = {};
__export(Pipeline_exports, {
  Pipeline: () => Pipeline,
  mergeHints: () => mergeHints2
});
import { toCourseElo as toCourseElo5 } from "@vue-skuilder/common";
function globToRegex(pattern) {
  const escaped = pattern.replace(/[.+?^${}()|[\]\\]/g, "\\$&");
  const withWildcards = escaped.replace(/\*/g, ".*");
  return new RegExp(`^${withWildcards}$`);
}
function globMatch(value, pattern) {
  if (!pattern.includes("*")) return value === pattern;
  return globToRegex(pattern).test(value);
}
function cardMatchesTagPattern(card, pattern) {
  return (card.tags ?? []).some((tag) => globMatch(tag, pattern));
}
function mergeHints2(allHints) {
  const defined = allHints.filter((h) => h !== null && h !== void 0);
  if (defined.length === 0) return void 0;
  const merged = {};
  const boostTags = {};
  for (const hints of defined) {
    for (const [pattern, factor] of Object.entries(hints.boostTags ?? {})) {
      boostTags[pattern] = (boostTags[pattern] ?? 1) * factor;
    }
  }
  if (Object.keys(boostTags).length > 0) {
    merged.boostTags = boostTags;
  }
  const boostCards = {};
  for (const hints of defined) {
    for (const [pattern, factor] of Object.entries(hints.boostCards ?? {})) {
      boostCards[pattern] = (boostCards[pattern] ?? 1) * factor;
    }
  }
  if (Object.keys(boostCards).length > 0) {
    merged.boostCards = boostCards;
  }
  const concatUnique = (field) => {
    const values = defined.flatMap((h) => h[field] ?? []);
    if (values.length > 0) {
      merged[field] = [...new Set(values)];
    }
  };
  concatUnique("requireTags");
  concatUnique("requireCards");
  concatUnique("excludeTags");
  concatUnique("excludeCards");
  const labels = defined.map((h) => h._label).filter(Boolean);
  if (labels.length > 0) {
    merged._label = labels.join("; ");
  }
  return Object.keys(merged).length > 0 ? merged : void 0;
}
function logPipelineConfig(generator, filters) {
  const filterList = filters.length > 0 ? "\n    - " + filters.map((f) => f.name).join("\n    - ") : " none";
  logger.info(
    `[Pipeline] Configuration:
  Generator: ${generator.name}
  Filters:${filterList}`
  );
}
function logTagHydration(cards, tagsByCard) {
  const totalTags = Array.from(tagsByCard.values()).reduce((sum, tags) => sum + tags.length, 0);
  const cardsWithTags = Array.from(tagsByCard.values()).filter((tags) => tags.length > 0).length;
  logger.debug(
    `[Pipeline] Tag hydration: ${cards.length} cards, ${cardsWithTags} have tags (${totalTags} total tags) - single batch query`
  );
}
function logExecutionSummary(generatorName, generatedCount, filterCount, finalCount, topScores, filterImpacts) {
  const scoreDisplay = topScores.length > 0 ? topScores.map((s) => s.toFixed(2)).join(", ") : "none";
  let filterSummary = "";
  if (filterImpacts.length > 0) {
    const impacts = filterImpacts.map((f) => {
      const parts = [];
      if (f.boosted > 0) parts.push(`+${f.boosted}`);
      if (f.penalized > 0) parts.push(`-${f.penalized}`);
      if (f.passed > 0) parts.push(`=${f.passed}`);
      return `${f.name}: ${parts.join("/")}`;
    });
    filterSummary = `
  Filter impact: ${impacts.join(", ")}`;
  }
  logger.info(
    `[Pipeline] Execution: ${generatorName} produced ${generatedCount} \u2192 ${filterCount} filters \u2192 ${finalCount} results (top scores: ${scoreDisplay})` + filterSummary + `
  \u{1F4A1} Inspect: window.skuilder.pipeline`
  );
}
function logResultCards(cards) {
  if (!VERBOSE_RESULTS || cards.length === 0) return;
  logger.info(`[Pipeline] Results (${cards.length} cards):`);
  for (let i = 0; i < cards.length; i++) {
    const c = cards[i];
    const tags = c.tags?.slice(0, 3).join(", ") || "";
    const filters = c.provenance.filter((p) => p.strategy === "hierarchyDefinition" || p.strategy === "priorityDefinition" || p.strategy === "interferenceFilter" || p.strategy === "letterGating" || p.strategy === "ephemeralHint" || p.strategy === "diversityRerank").map((p) => {
      const arrow = p.action === "boosted" ? "\u2191" : p.action === "penalized" ? "\u2193" : "=";
      return `${p.strategyName}${arrow}${p.score.toFixed(2)}`;
    }).join(" | ");
    logger.info(
      `[Pipeline]   ${String(i + 1).padStart(2)}. ${c.score.toFixed(4)}  ${c.cardId}  [${tags}]${filters ? `  {${filters}}` : ""}`
    );
  }
}
function logCardProvenance(cards, maxCards = 3) {
  const cardsToLog = cards.slice(0, maxCards);
  logger.debug(`[Pipeline] Provenance for top ${cardsToLog.length} cards:`);
  for (const card of cardsToLog) {
    logger.debug(`[Pipeline]   ${card.cardId} (final score: ${card.score.toFixed(3)}):`);
    for (const entry of card.provenance) {
      const scoreChange = entry.score.toFixed(3);
      const action = entry.action.padEnd(9);
      logger.debug(
        `[Pipeline]     ${action} ${scoreChange} - ${entry.strategyName}: ${entry.reason}`
      );
    }
  }
}
var VERBOSE_RESULTS, Pipeline;
var init_Pipeline = __esm({
  "src/core/navigators/Pipeline.ts"() {
    "use strict";
    init_navigators();
    init_logger();
    init_orchestration();
    init_PipelineDebugger();
    init_diversityRerank();
    VERBOSE_RESULTS = true;
    Pipeline = class extends ContentNavigator {
      generator;
      filters;
      /**
       * Cached orchestration context. Course config and salt don't change within
       * a page load, so we build the orchestration context once and reuse it on
       * subsequent getWeightedCards() calls (e.g. mid-session replans).
       *
       * This eliminates a remote getCourseConfig() round trip per pipeline run.
       */
      _cachedOrchestration = null;
      /**
       * Persistent tag cache. Maps cardId → tag names.
       *
       * Tags are static within a session (they're set at card generation time),
       * so we cache them across pipeline runs. On replans, many of the same cards
       * reappear — cache hits avoid redundant remote getAppliedTagsBatch() queries.
       */
      _tagCache = /* @__PURE__ */ new Map();
      /**
       * One-shot replan hints. Applied after the filter chain on the next
       * getWeightedCards() call, then cleared.
       */
      _ephemeralHints = null;
      /**
       * Create a new pipeline.
       *
       * @param generator - The generator (or CompositeGenerator) that produces candidates
       * @param filters - Filters to apply sequentially (order doesn't matter for multipliers)
       * @param user - User database interface
       * @param course - Course database interface
       */
      constructor(generator, filters, user, course) {
        super();
        this.generator = generator;
        this.filters = filters;
        this.user = user;
        this.course = course;
        course.getCourseConfig().then((cfg) => {
          logger.debug(`[pipeline] Crated pipeline for ${cfg.name}`);
        }).catch((e) => {
          logger.error(`[pipeline] Failed to lookup courseCfg: ${e}`);
        });
        logPipelineConfig(generator, filters);
        registerPipelineForDebug(this);
      }
      /**
       * Set one-shot hints for the next pipeline run.
       * Consumed after one getWeightedCards() call, then cleared.
       *
       * Overrides ContentNavigator.setEphemeralHints() no-op.
       */
      setEphemeralHints(hints) {
        this._ephemeralHints = hints;
        logger.info(`[Pipeline] Ephemeral hints set: ${JSON.stringify(hints)}`);
      }
      /**
       * Get weighted cards by running generator and applying filters.
       *
       * 1. Build shared context (user ELO, etc.)
       * 2. Get candidates from generator (passing context)
       * 3. Batch hydrate tags for all candidates
       * 4. Apply each filter sequentially
       * 5. Remove zero-score cards
       * 6. Sort by score descending
       * 7. Return top N
       *
       * @param limit - Maximum number of cards to return
       * @returns Cards sorted by score descending
       */
      async getWeightedCards(limit) {
        const t0 = performance.now();
        const context = await this.buildContext();
        const tContext = performance.now();
        const fetchLimit = 500;
        logger.debug(
          `[Pipeline] Fetching ${fetchLimit} candidates from generator '${this.generator.name}'`
        );
        const generatorResult = await this.generator.getWeightedCards(fetchLimit, context);
        let cards = generatorResult.cards;
        const tGenerate = performance.now();
        const generatedCount = cards.length;
        const mergedHints = mergeHints2([this._ephemeralHints, generatorResult.hints]);
        this._ephemeralHints = mergedHints ?? null;
        let generatorSummaries;
        if (this.generator.generators) {
          const genMap = /* @__PURE__ */ new Map();
          for (const card of cards) {
            const firstProv = card.provenance[0];
            if (firstProv) {
              const genName = firstProv.strategyName;
              if (!genMap.has(genName)) {
                genMap.set(genName, { cards: [] });
              }
              genMap.get(genName).cards.push(card);
            }
          }
          generatorSummaries = Array.from(genMap.entries()).map(([name, data]) => {
            const newCards = data.cards.filter((c) => c.provenance[0]?.reason?.includes("new card"));
            const reviewCards = data.cards.filter((c) => c.provenance[0]?.reason?.includes("review"));
            return {
              name,
              cardCount: data.cards.length,
              newCount: newCards.length,
              reviewCount: reviewCards.length,
              topScore: Math.max(...data.cards.map((c) => c.score), 0)
            };
          });
        }
        logger.debug(`[Pipeline] Generator returned ${generatedCount} candidates`);
        cards = await this.hydrateTags(cards);
        const tHydrate = performance.now();
        const allCardsBeforeFiltering = [...cards];
        const pendingHints = this._ephemeralHints;
        if (pendingHints?.requireCards?.length) {
          const poolIds = new Set(allCardsBeforeFiltering.map((c) => c.cardId));
          const missingIds = pendingHints.requireCards.filter(
            (p) => !p.includes("*") && !poolIds.has(p)
          );
          if (missingIds.length > 0) {
            const fetchedTags = await this.course.getAppliedTagsBatch(missingIds);
            const courseId = this.course.getCourseID();
            for (const cardId of missingIds) {
              allCardsBeforeFiltering.push({
                cardId,
                courseId,
                score: 1,
                tags: fetchedTags.get(cardId) ?? [],
                provenance: []
              });
            }
            logger.info(
              `[Pipeline] Pre-fetched ${missingIds.length} required card(s) into pool: ${missingIds.join(", ")}`
            );
          }
        }
        const prescribedIds = new Set(
          cards.filter((c) => c.provenance.some((p) => p.strategy === "prescribed")).map((c) => c.cardId)
        );
        const filterImpacts = [];
        for (const filter of this.filters) {
          const beforeCount = cards.length;
          const beforeScores = new Map(cards.map((c) => [c.cardId, c.score]));
          cards = await filter.transform(cards, context);
          let boosted = 0, penalized = 0, passed = 0;
          const removed = beforeCount - cards.length;
          for (const card of cards) {
            const before = beforeScores.get(card.cardId) ?? 0;
            if (card.score > before) boosted++;
            else if (card.score < before) penalized++;
            else passed++;
          }
          filterImpacts.push({ name: filter.name, boosted, penalized, passed, removed });
          if (prescribedIds.size > 0) {
            const survivingIds = new Set(cards.map((c) => c.cardId));
            const killedPrescribed = [...prescribedIds].filter((id) => !survivingIds.has(id));
            const zeroedPrescribed = cards.filter((c) => prescribedIds.has(c.cardId) && c.score === 0).map((c) => c.cardId);
            if (killedPrescribed.length > 0 || zeroedPrescribed.length > 0) {
              logger.info(
                `[Pipeline] Filter '${filter.name}' impact on prescribed cards: ` + (killedPrescribed.length > 0 ? `removed=[${killedPrescribed.join(", ")}] ` : "") + (zeroedPrescribed.length > 0 ? `zeroed=[${zeroedPrescribed.join(", ")}]` : "")
              );
              killedPrescribed.forEach((id) => prescribedIds.delete(id));
            }
          }
          logger.debug(`[Pipeline] Filter '${filter.name}': ${beforeScores.size} \u2192 ${cards.length} cards (\u2191${boosted} \u2193${penalized} =${passed})`);
        }
        cards = cards.filter((c) => c.score > 0);
        const hints = this._ephemeralHints;
        if (hints) {
          this._ephemeralHints = null;
          cards = this.applyHints(cards, hints, allCardsBeforeFiltering);
        }
        cards = diversityRerank(cards);
        cards.sort((a, b) => b.score - a.score);
        const tFilter = performance.now();
        const result = cards.slice(0, limit);
        logger.info(
          `[Pipeline:timing] total=${(tFilter - t0).toFixed(0)}ms (context=${(tContext - t0).toFixed(0)} generate=${(tGenerate - tContext).toFixed(0)} hydrate=${(tHydrate - tGenerate).toFixed(0)} filter=${(tFilter - tHydrate).toFixed(0)})`
        );
        const topScores = result.slice(0, 3).map((c) => c.score);
        logExecutionSummary(
          this.generator.name,
          generatedCount,
          this.filters.length,
          result.length,
          topScores,
          filterImpacts
        );
        logResultCards(result);
        logCardProvenance(result, 3);
        try {
          const courseName = await this.course?.getCourseConfig().then((c) => c.name).catch(() => void 0);
          const report = buildRunReport(
            this.course?.getCourseID() || "unknown",
            courseName,
            this.generator.name,
            generatorSummaries,
            generatedCount,
            filterImpacts,
            cards,
            result,
            context.userElo,
            hints ?? void 0
          );
          captureRun(report);
        } catch (e) {
          logger.debug(`[Pipeline] Failed to capture debug run: ${e}`);
        }
        return { cards: result };
      }
      /**
       * Batch hydrate tags for all cards.
       *
       * Fetches tags for all cards in a single database query and attaches them
       * to the WeightedCard objects. Filters can then use card.tags instead of
       * making individual getAppliedTags() calls.
       *
       * Uses a persistent tag cache across pipeline runs — tags are static within
       * a session, so cards seen in a prior run (e.g. before a replan) don't
       * require a second DB query.
       *
       * @param cards - Cards to hydrate
       * @returns Cards with tags populated
       */
      async hydrateTags(cards) {
        if (cards.length === 0) {
          return cards;
        }
        const uncachedIds = [];
        for (const card of cards) {
          if (!this._tagCache.has(card.cardId)) {
            uncachedIds.push(card.cardId);
          }
        }
        if (uncachedIds.length > 0) {
          const freshTags = await this.course.getAppliedTagsBatch(uncachedIds);
          for (const [cardId, tags] of freshTags) {
            this._tagCache.set(cardId, tags);
          }
        }
        const tagsByCard = /* @__PURE__ */ new Map();
        for (const card of cards) {
          tagsByCard.set(card.cardId, this._tagCache.get(card.cardId) ?? []);
        }
        logTagHydration(cards, tagsByCard);
        return cards.map((card) => ({
          ...card,
          tags: this._tagCache.get(card.cardId) ?? []
        }));
      }
      // ---------------------------------------------------------------------------
      // Ephemeral hints application
      // ---------------------------------------------------------------------------
      /**
       * Apply one-shot replan hints to the post-filter card set.
       *
       * Order of operations:
       *   1. Exclude (remove unwanted cards)
       *   2. Boost (multiply scores)
       *   3. Require (inject must-have cards from the full pre-filter pool)
       *
       * @param cards - Post-filter cards (score > 0)
       * @param hints - The ephemeral hints to apply
       * @param allCards - Full pre-filter card pool (for require injection)
       */
      applyHints(cards, hints, allCards) {
        const beforeCount = cards.length;
        if (hints.excludeCards?.length) {
          cards = cards.filter(
            (c) => !hints.excludeCards.some((pat) => globMatch(c.cardId, pat))
          );
        }
        if (hints.excludeTags?.length) {
          cards = cards.filter(
            (c) => !hints.excludeTags.some((pat) => cardMatchesTagPattern(c, pat))
          );
        }
        if (hints.boostTags) {
          for (const [pattern, factor] of Object.entries(hints.boostTags)) {
            for (const card of cards) {
              if (cardMatchesTagPattern(card, pattern)) {
                card.score *= factor;
                card.provenance.push({
                  strategy: "ephemeralHint",
                  strategyId: "ephemeral-hint",
                  strategyName: hints._label ? `Replan Hint (${hints._label})` : "Replan Hint",
                  action: "boosted",
                  score: card.score,
                  reason: `boostTag ${pattern} \xD7${factor}`
                });
              }
            }
          }
        }
        if (hints.boostCards) {
          for (const [pattern, factor] of Object.entries(hints.boostCards)) {
            for (const card of cards) {
              if (globMatch(card.cardId, pattern)) {
                card.score *= factor;
                card.provenance.push({
                  strategy: "ephemeralHint",
                  strategyId: "ephemeral-hint",
                  strategyName: hints._label ? `Replan Hint (${hints._label})` : "Replan Hint",
                  action: "boosted",
                  score: card.score,
                  reason: `boostCard ${pattern} \xD7${factor}`
                });
              }
            }
          }
        }
        const cardIds = new Set(cards.map((c) => c.cardId));
        const cardMap = new Map(cards.map((c) => [c.cardId, c]));
        const hintLabel = hints._label ? `Replan Hint (${hints._label})` : "Replan Hint";
        const applyRequirement = (card, reason) => {
          const mandatoryScore = Number.POSITIVE_INFINITY;
          const existing = cardMap.get(card.cardId);
          if (existing) {
            if (existing.score < mandatoryScore) {
              existing.score = mandatoryScore;
              existing.provenance.push({
                strategy: "ephemeralHint",
                strategyId: "ephemeral-hint",
                strategyName: hintLabel,
                action: "boosted",
                score: mandatoryScore,
                reason: `${reason} (upgrade to mandatory score)`
              });
            }
          } else {
            cards.push({
              ...card,
              score: mandatoryScore,
              provenance: [
                ...card.provenance,
                {
                  strategy: "ephemeralHint",
                  strategyId: "ephemeral-hint",
                  strategyName: hintLabel,
                  action: "boosted",
                  score: mandatoryScore,
                  reason
                }
              ]
            });
            cardIds.add(card.cardId);
            cardMap.set(card.cardId, cards[cards.length - 1]);
          }
        };
        if (hints.requireCards?.length) {
          for (const pattern of hints.requireCards) {
            for (const cardId of cardIds) {
              if (globMatch(cardId, pattern)) {
                applyRequirement(cardMap.get(cardId), `requireCard ${pattern}`);
              }
            }
            for (const card of allCards) {
              if (globMatch(card.cardId, pattern)) {
                applyRequirement(card, `requireCard ${pattern}`);
              }
            }
          }
        }
        if (hints.requireTags?.length) {
          for (const pattern of hints.requireTags) {
            for (const cardId of cardIds) {
              const card = cardMap.get(cardId);
              if (cardMatchesTagPattern(card, pattern)) {
                applyRequirement(card, `requireTag ${pattern}`);
              }
            }
            for (const card of allCards) {
              if (cardMatchesTagPattern(card, pattern)) {
                applyRequirement(card, `requireTag ${pattern}`);
              }
            }
          }
        }
        logger.info(`[Pipeline] Hints applied: ${beforeCount} \u2192 ${cards.length} cards`);
        return cards;
      }
      /**
       * Build shared context for generator and filters.
       *
       * Called once per getWeightedCards() invocation.
       * Contains data that the generator and multiple filters might need.
       *
       * The context satisfies both GeneratorContext and FilterContext interfaces.
       */
      async buildContext() {
        let userElo = 1e3;
        try {
          const courseReg = await this.user.getCourseRegDoc(this.course.getCourseID());
          const courseElo = toCourseElo5(courseReg.elo);
          userElo = courseElo.global.score;
        } catch (e) {
          logger.debug(`[Pipeline] Could not get user ELO, using default: ${e}`);
        }
        if (!this._cachedOrchestration) {
          this._cachedOrchestration = await createOrchestrationContext(this.user, this.course);
        }
        const orchestration = this._cachedOrchestration;
        return {
          user: this.user,
          course: this.course,
          userElo,
          orchestration
        };
      }
      /**
       * Get the course ID for this pipeline.
       */
      getCourseID() {
        return this.course.getCourseID();
      }
      /**
       * Get orchestration context for outcome recording.
       */
      async getOrchestrationContext() {
        return createOrchestrationContext(this.user, this.course);
      }
      /**
       * Get IDs of all strategies in this pipeline.
       * Used to record which strategies contributed to an outcome.
       */
      getStrategyIds() {
        const ids = [];
        const extractId = (obj) => {
          if (obj.strategyId) return obj.strategyId;
          return null;
        };
        const genId = extractId(this.generator);
        if (genId) ids.push(genId);
        if (this.generator.generators && Array.isArray(this.generator.generators)) {
          this.generator.generators.forEach((g) => {
            const subId = extractId(g);
            if (subId) ids.push(subId);
          });
        }
        for (const filter of this.filters) {
          const fId = extractId(filter);
          if (fId) ids.push(fId);
        }
        return [...new Set(ids)];
      }
      // ---------------------------------------------------------------------------
      // Tag ELO diagnostic
      // ---------------------------------------------------------------------------
      /**
       * Get the user's per-tag ELO data for specified tags (or all tags).
       * Useful for diagnosing why hierarchy gates are open/closed.
       */
      async getTagEloStatus(tagFilter) {
        const courseReg = await this.user.getCourseRegDoc(this.course.getCourseID());
        const courseElo = toCourseElo5(courseReg.elo);
        const result = {};
        if (!tagFilter) {
          for (const [tag, data] of Object.entries(courseElo.tags)) {
            result[tag] = { score: data.score, count: data.count };
          }
        } else {
          const patterns = Array.isArray(tagFilter) ? tagFilter : [tagFilter];
          for (const pattern of patterns) {
            const regex = globToRegex(pattern);
            for (const [tag, data] of Object.entries(courseElo.tags)) {
              if (regex.test(tag)) {
                result[tag] = { score: data.score, count: data.count };
              }
            }
          }
        }
        return result;
      }
      // ---------------------------------------------------------------------------
      // Card-space diagnostic
      // ---------------------------------------------------------------------------
      /**
       * Commit-free forecast: score the user's full card space through the filter
       * chain and return the cards that are currently *reachable* (score >=
       * threshold), optionally nudged by caller-supplied hints and/or restricted
       * to cards the user hasn't seen yet.
       *
       * This is a GENERIC primitive — it returns scored, tag-hydrated cards and
       * stops there. It has no knowledge of any particular tag convention; callers
       * decide what the surviving cards mean (e.g. filter to their own "intro"
       * tag family). Nothing is written and no session is started.
       *
       * The optional `hints` are the "out-of-band kick": they run through the same
       * {@link applyHints} path a live replan uses, so the two semantics carry over —
       *   - `boostTags`/`boostCards` reweight *within* gating (a gated score-0 card
       *     stays out), and
       *   - `requireTags`/`requireCards` inject from the full pre-filter pool,
       *     *bypassing* gating (use when you want a card regardless of reachability).
       * Note `unseenOnly` is applied LAST, so it can drop a `require`d card that the
       * user has already seen — pass `unseenOnly: false` if that matters.
       *
       * Cost note: like {@link diagnoseCardSpace}, this scans every card through the
       * filters, so it's heavier than a normal replan. Intended for one-shot
       * out-of-band use (e.g. a session-end "what's next" snapshot), not the hot path.
       *
       * @param opts.hints       Optional ephemeral hints to apply after the filter chain.
       * @param opts.unseenOnly  Only return cards the user hasn't encountered (default true).
       * @param opts.threshold   Min score to count as reachable (default 0.10).
       * @param opts.limit       Optional cap on results (already sorted desc).
       */
      async forecast(opts) {
        const threshold = opts?.threshold ?? 0.1;
        const unseenOnly = opts?.unseenOnly ?? true;
        const courseId = this.course.getCourseID();
        const allCardIds = await this.course.getAllCardIds();
        let cards = allCardIds.map((cardId) => ({
          cardId,
          courseId,
          score: 1,
          provenance: []
        }));
        cards = await this.hydrateTags(cards);
        const fullPool = cards.slice();
        const context = await this.buildContext();
        for (const filter of this.filters) {
          cards = await filter.transform(cards, context);
        }
        if (opts?.hints) {
          cards = this.applyHints(cards, opts.hints, fullPool);
        }
        cards = cards.filter((c) => c.score >= threshold);
        if (unseenOnly) {
          let encountered;
          try {
            encountered = new Set(await this.user.getSeenCards(courseId));
          } catch {
            encountered = /* @__PURE__ */ new Set();
          }
          cards = cards.filter((c) => !encountered.has(c.cardId));
        }
        cards.sort((a, b) => b.score - a.score);
        return opts?.limit ? cards.slice(0, opts.limit) : cards;
      }
      /**
       * Scan every card in the course through the filter chain and report
       * how many are "well indicated" (score >= threshold) for the current user.
       *
       * Also reports how many well-indicated cards the user has NOT yet encountered.
       *
       * Exposed via `window.skuilder.pipeline.diagnoseCardSpace()`.
       */
      async diagnoseCardSpace(opts) {
        const THRESHOLD = opts?.threshold ?? 0.1;
        const t0 = performance.now();
        const allCardIds = await this.course.getAllCardIds();
        let cards = allCardIds.map((cardId) => ({
          cardId,
          courseId: this.course.getCourseID(),
          score: 1,
          provenance: []
        }));
        cards = await this.hydrateTags(cards);
        const context = await this.buildContext();
        const filterBreakdown = [];
        for (const filter of this.filters) {
          cards = await filter.transform(cards, context);
          const wi = cards.filter((c) => c.score >= THRESHOLD).length;
          filterBreakdown.push({ name: filter.name, wellIndicated: wi });
        }
        const wellIndicated = cards.filter((c) => c.score >= THRESHOLD);
        const wellIndicatedIds = new Set(wellIndicated.map((c) => c.cardId));
        let encounteredIds;
        try {
          const courseId = this.course.getCourseID();
          const seenCards = await this.user.getSeenCards(courseId);
          encounteredIds = new Set(seenCards);
        } catch {
          encounteredIds = /* @__PURE__ */ new Set();
        }
        const wellIndicatedNew = wellIndicated.filter((c) => !encounteredIds.has(c.cardId));
        const byType = /* @__PURE__ */ new Map();
        for (const card of cards) {
          const type = card.cardId.split("-")[1] || "unknown";
          if (!byType.has(type)) {
            byType.set(type, { total: 0, wellIndicated: 0, new: 0 });
          }
          const entry = byType.get(type);
          entry.total++;
          if (card.score >= THRESHOLD) {
            entry.wellIndicated++;
            if (!encounteredIds.has(card.cardId)) entry.new++;
          }
        }
        const elapsed = performance.now() - t0;
        const result = {
          totalCards: allCardIds.length,
          threshold: THRESHOLD,
          wellIndicated: wellIndicatedIds.size,
          encountered: encounteredIds.size,
          wellIndicatedNew: wellIndicatedNew.length,
          byType: Object.fromEntries(byType),
          filterBreakdown,
          elapsedMs: Math.round(elapsed)
        };
        logger.info(`[Pipeline:diagnose] Card space scan (${result.elapsedMs}ms):`);
        logger.info(`[Pipeline:diagnose]   Total cards: ${result.totalCards}`);
        logger.info(`[Pipeline:diagnose]   Well-indicated (score >= ${THRESHOLD}): ${result.wellIndicated}`);
        logger.info(`[Pipeline:diagnose]   Encountered: ${result.encountered}`);
        logger.info(`[Pipeline:diagnose]   Well-indicated & new: ${result.wellIndicatedNew}`);
        logger.info(`[Pipeline:diagnose]   By type:`);
        for (const [type, counts] of byType) {
          logger.info(
            `[Pipeline:diagnose]     ${type}: ${counts.wellIndicated}/${counts.total} well-indicated, ${counts.new} new`
          );
        }
        logger.info(`[Pipeline:diagnose]   After each filter:`);
        for (const fb of filterBreakdown) {
          logger.info(`[Pipeline:diagnose]     ${fb.name}: ${fb.wellIndicated} well-indicated`);
        }
        return result;
      }
    };
  }
});

// src/core/navigators/defaults.ts
var defaults_exports = {};
__export(defaults_exports, {
  createDefaultEloStrategy: () => createDefaultEloStrategy,
  createDefaultPipeline: () => createDefaultPipeline,
  createDefaultSrsStrategy: () => createDefaultSrsStrategy
});
function createDefaultEloStrategy(courseId) {
  return {
    _id: "NAVIGATION_STRATEGY-ELO-default",
    docType: "NAVIGATION_STRATEGY" /* NAVIGATION_STRATEGY */,
    name: "ELO (default)",
    description: "Default ELO-based navigation strategy for new cards",
    implementingClass: "elo" /* ELO */,
    course: courseId,
    serializedData: ""
  };
}
function createDefaultSrsStrategy(courseId) {
  return {
    _id: "NAVIGATION_STRATEGY-SRS-default",
    docType: "NAVIGATION_STRATEGY" /* NAVIGATION_STRATEGY */,
    name: "SRS (default)",
    description: "Default SRS-based navigation strategy for reviews",
    implementingClass: "srs" /* SRS */,
    course: courseId,
    serializedData: ""
  };
}
function createDefaultPipeline(user, course) {
  const courseId = course.getCourseID();
  const eloNavigator = new ELONavigator(user, course, createDefaultEloStrategy(courseId));
  const srsNavigator = new SRSNavigator(user, course, createDefaultSrsStrategy(courseId));
  const compositeGenerator = new CompositeGenerator([eloNavigator, srsNavigator]);
  const eloDistanceFilter = createEloDistanceFilter();
  return new Pipeline(compositeGenerator, [eloDistanceFilter], user, course);
}
var init_defaults = __esm({
  "src/core/navigators/defaults.ts"() {
    "use strict";
    init_navigators();
    init_Pipeline();
    init_CompositeGenerator();
    init_elo();
    init_srs();
    init_eloDistance();
    init_types_legacy();
  }
});

// src/core/navigators/PipelineAssembler.ts
var PipelineAssembler_exports = {};
__export(PipelineAssembler_exports, {
  PipelineAssembler: () => PipelineAssembler
});
var PipelineAssembler;
var init_PipelineAssembler = __esm({
  "src/core/navigators/PipelineAssembler.ts"() {
    "use strict";
    init_navigators();
    init_WeightedFilter();
    init_Pipeline();
    init_logger();
    init_CompositeGenerator();
    init_defaults();
    PipelineAssembler = class {
      /**
       * Assembles a navigation pipeline from strategy documents.
       *
       * 1. Separates into generators and filters by role
       * 2. Validates at least one generator exists (or creates default ELO)
       * 3. Instantiates generators - wraps multiple in CompositeGenerator
       * 4. Instantiates filters
       * 5. Returns Pipeline(generator, filters)
       *
       * @param input - Strategy documents plus user/course interfaces
       * @returns Assembled pipeline and any warnings
       */
      async assemble(input) {
        const { strategies, user, course } = input;
        const warnings = [];
        if (strategies.length === 0) {
          return {
            pipeline: null,
            generatorStrategies: [],
            filterStrategies: [],
            warnings
          };
        }
        const generatorStrategies = [];
        const filterStrategies = [];
        for (const s of strategies) {
          if (isGenerator(s.implementingClass)) {
            generatorStrategies.push(s);
          } else if (isFilter(s.implementingClass)) {
            filterStrategies.push(s);
          } else {
            warnings.push(`Unknown strategy type '${s.implementingClass}', skipping: ${s.name}`);
          }
        }
        const courseId = course.getCourseID();
        const hasElo = generatorStrategies.some((s) => s.implementingClass === "elo" /* ELO */);
        const hasSrs = generatorStrategies.some((s) => s.implementingClass === "srs" /* SRS */);
        if (!hasElo) {
          logger.debug("[PipelineAssembler] No ELO generator configured, adding default");
          generatorStrategies.push(createDefaultEloStrategy(courseId));
        }
        if (!hasSrs) {
          logger.debug("[PipelineAssembler] No SRS generator configured, adding default");
          generatorStrategies.push(createDefaultSrsStrategy(courseId));
        }
        if (generatorStrategies.length === 0) {
          warnings.push("No generator strategy found");
          return {
            pipeline: null,
            generatorStrategies: [],
            filterStrategies: [],
            warnings
          };
        }
        let generator;
        if (generatorStrategies.length === 1) {
          const nav = await ContentNavigator.create(user, course, generatorStrategies[0]);
          generator = nav;
          logger.debug(`[PipelineAssembler] Using single generator: ${generatorStrategies[0].name}`);
        } else {
          logger.debug(
            `[PipelineAssembler] Using CompositeGenerator for ${generatorStrategies.length} generators: ${generatorStrategies.map((g) => g.name).join(", ")}`
          );
          generator = await CompositeGenerator.fromStrategies(user, course, generatorStrategies);
        }
        const filters = [];
        const sortedFilterStrategies = [...filterStrategies].sort(
          (a, b) => a.name.localeCompare(b.name)
        );
        for (const filterStrategy of sortedFilterStrategies) {
          try {
            const nav = await ContentNavigator.create(user, course, filterStrategy);
            if ("transform" in nav && typeof nav.transform === "function") {
              let filter = nav;
              if (filterStrategy.learnable) {
                filter = new WeightedFilter(
                  filter,
                  filterStrategy.learnable,
                  filterStrategy.staticWeight,
                  filterStrategy._id
                );
              }
              filters.push(filter);
              logger.debug(`[PipelineAssembler] Added filter: ${filterStrategy.name}`);
            } else {
              warnings.push(
                `Filter '${filterStrategy.name}' does not implement CardFilter.transform(), skipping`
              );
            }
          } catch (e) {
            warnings.push(`Failed to instantiate filter '${filterStrategy.name}': ${e}`);
          }
        }
        const pipeline = new Pipeline(generator, filters, user, course);
        logger.debug(
          `[PipelineAssembler] Assembled pipeline with ${generatorStrategies.length} generator(s) and ${filters.length} filter(s)`
        );
        return {
          pipeline,
          generatorStrategies,
          filterStrategies: sortedFilterStrategies,
          warnings
        };
      }
    };
  }
});

// import("./**/*") in src/core/navigators/index.ts
var globImport;
var init_3 = __esm({
  'import("./**/*") in src/core/navigators/index.ts'() {
    globImport = __glob({
      "./Pipeline.ts": () => Promise.resolve().then(() => (init_Pipeline(), Pipeline_exports)),
      "./PipelineAssembler.ts": () => Promise.resolve().then(() => (init_PipelineAssembler(), PipelineAssembler_exports)),
      "./PipelineDebugger.ts": () => Promise.resolve().then(() => (init_PipelineDebugger(), PipelineDebugger_exports)),
      "./SrsDebugger.ts": () => Promise.resolve().then(() => (init_SrsDebugger(), SrsDebugger_exports)),
      "./defaults.ts": () => Promise.resolve().then(() => (init_defaults(), defaults_exports)),
      "./diversityRerank.ts": () => Promise.resolve().then(() => (init_diversityRerank(), diversityRerank_exports)),
      "./filters/WeightedFilter.ts": () => Promise.resolve().then(() => (init_WeightedFilter(), WeightedFilter_exports)),
      "./filters/eloDistance.ts": () => Promise.resolve().then(() => (init_eloDistance(), eloDistance_exports)),
      "./filters/hierarchyDefinition.ts": () => Promise.resolve().then(() => (init_hierarchyDefinition(), hierarchyDefinition_exports)),
      "./filters/index.ts": () => Promise.resolve().then(() => (init_filters(), filters_exports)),
      "./filters/inferredPreferenceStub.ts": () => Promise.resolve().then(() => (init_inferredPreferenceStub(), inferredPreferenceStub_exports)),
      "./filters/interferenceMitigator.ts": () => Promise.resolve().then(() => (init_interferenceMitigator(), interferenceMitigator_exports)),
      "./filters/relativePriority.ts": () => Promise.resolve().then(() => (init_relativePriority(), relativePriority_exports)),
      "./filters/types.ts": () => Promise.resolve().then(() => (init_types2(), types_exports2)),
      "./filters/userGoalStub.ts": () => Promise.resolve().then(() => (init_userGoalStub(), userGoalStub_exports)),
      "./filters/userTagPreference.ts": () => Promise.resolve().then(() => (init_userTagPreference(), userTagPreference_exports)),
      "./generators/CompositeGenerator.ts": () => Promise.resolve().then(() => (init_CompositeGenerator(), CompositeGenerator_exports)),
      "./generators/elo.ts": () => Promise.resolve().then(() => (init_elo(), elo_exports)),
      "./generators/index.ts": () => Promise.resolve().then(() => (init_generators(), generators_exports)),
      "./generators/prescribed.ts": () => Promise.resolve().then(() => (init_prescribed(), prescribed_exports)),
      "./generators/srs.ts": () => Promise.resolve().then(() => (init_srs(), srs_exports)),
      "./generators/types.ts": () => Promise.resolve().then(() => (init_types(), types_exports)),
      "./index.ts": () => Promise.resolve().then(() => (init_navigators(), navigators_exports))
    });
  }
});

// src/core/navigators/index.ts
var navigators_exports = {};
__export(navigators_exports, {
  ContentNavigator: () => ContentNavigator,
  DIVERSITY_FLOOR: () => DIVERSITY_FLOOR,
  DIVERSITY_STRENGTH: () => DIVERSITY_STRENGTH,
  NavigatorRole: () => NavigatorRole,
  NavigatorRoles: () => NavigatorRoles,
  Navigators: () => Navigators,
  clearSrsBacklogDebug: () => clearSrsBacklogDebug,
  diversityRerank: () => diversityRerank,
  getActivePipeline: () => getActivePipeline,
  getCardOrigin: () => getCardOrigin,
  getRegisteredNavigator: () => getRegisteredNavigator,
  getRegisteredNavigatorNames: () => getRegisteredNavigatorNames,
  getRegisteredNavigatorRole: () => getRegisteredNavigatorRole,
  getSrsBacklogDebug: () => getSrsBacklogDebug,
  hasRegisteredNavigator: () => hasRegisteredNavigator,
  initializeNavigatorRegistry: () => initializeNavigatorRegistry,
  isFilter: () => isFilter,
  isGenerator: () => isGenerator,
  mountPipelineDebugger: () => mountPipelineDebugger,
  pipelineDebugAPI: () => pipelineDebugAPI,
  registerNavigator: () => registerNavigator
});
function registerNavigator(implementingClass, constructor, role) {
  navigatorRegistry.set(implementingClass, { constructor, role });
  logger.debug(`[NavigatorRegistry] Registered: ${implementingClass}${role ? ` (${role})` : ""}`);
}
function getRegisteredNavigator(implementingClass) {
  return navigatorRegistry.get(implementingClass)?.constructor;
}
function hasRegisteredNavigator(implementingClass) {
  return navigatorRegistry.has(implementingClass);
}
function getRegisteredNavigatorRole(implementingClass) {
  return navigatorRegistry.get(implementingClass)?.role;
}
function getRegisteredNavigatorNames() {
  return Array.from(navigatorRegistry.keys());
}
async function initializeNavigatorRegistry() {
  logger.debug("[NavigatorRegistry] Initializing built-in navigators...");
  const [eloModule, srsModule] = await Promise.all([
    Promise.resolve().then(() => (init_elo(), elo_exports)),
    Promise.resolve().then(() => (init_srs(), srs_exports))
  ]);
  const prescribedModule = await Promise.resolve().then(() => (init_prescribed(), prescribed_exports));
  registerNavigator("elo", eloModule.default);
  registerNavigator("srs", srsModule.default);
  registerNavigator("prescribed", prescribedModule.default);
  const [
    hierarchyModule,
    interferenceModule,
    relativePriorityModule,
    userTagPreferenceModule
  ] = await Promise.all([
    Promise.resolve().then(() => (init_hierarchyDefinition(), hierarchyDefinition_exports)),
    Promise.resolve().then(() => (init_interferenceMitigator(), interferenceMitigator_exports)),
    Promise.resolve().then(() => (init_relativePriority(), relativePriority_exports)),
    Promise.resolve().then(() => (init_userTagPreference(), userTagPreference_exports))
  ]);
  registerNavigator("hierarchyDefinition", hierarchyModule.default);
  registerNavigator("interferenceMitigator", interferenceModule.default);
  registerNavigator("relativePriority", relativePriorityModule.default);
  registerNavigator("userTagPreference", userTagPreferenceModule.default);
  logger.debug(
    `[NavigatorRegistry] Initialized ${navigatorRegistry.size} navigators: ${getRegisteredNavigatorNames().join(", ")}`
  );
}
function getCardOrigin(card) {
  if (card.provenance.length === 0) {
    throw new Error("Card has no provenance - cannot determine origin");
  }
  const firstEntry = card.provenance[0];
  const reason = firstEntry.reason.toLowerCase();
  if (reason.includes("failed")) {
    return "failed";
  }
  if (reason.includes("review")) {
    return "review";
  }
  return "new";
}
function isGenerator(impl) {
  if (NavigatorRoles[impl] === "generator" /* GENERATOR */) return true;
  return getRegisteredNavigatorRole(impl) === "generator" /* GENERATOR */;
}
function isFilter(impl) {
  if (NavigatorRoles[impl] === "filter" /* FILTER */) return true;
  return getRegisteredNavigatorRole(impl) === "filter" /* FILTER */;
}
var navigatorRegistry, Navigators, NavigatorRole, NavigatorRoles, ContentNavigator;
var init_navigators = __esm({
  "src/core/navigators/index.ts"() {
    "use strict";
    init_diversityRerank();
    init_PipelineDebugger();
    init_SrsDebugger();
    init_logger();
    init_();
    init_2();
    init_3();
    navigatorRegistry = /* @__PURE__ */ new Map();
    Navigators = /* @__PURE__ */ ((Navigators2) => {
      Navigators2["ELO"] = "elo";
      Navigators2["SRS"] = "srs";
      Navigators2["PRESCRIBED"] = "prescribed";
      Navigators2["HIERARCHY"] = "hierarchyDefinition";
      Navigators2["INTERFERENCE"] = "interferenceMitigator";
      Navigators2["RELATIVE_PRIORITY"] = "relativePriority";
      Navigators2["USER_TAG_PREFERENCE"] = "userTagPreference";
      return Navigators2;
    })(Navigators || {});
    NavigatorRole = /* @__PURE__ */ ((NavigatorRole2) => {
      NavigatorRole2["GENERATOR"] = "generator";
      NavigatorRole2["FILTER"] = "filter";
      return NavigatorRole2;
    })(NavigatorRole || {});
    NavigatorRoles = {
      ["elo" /* ELO */]: "generator" /* GENERATOR */,
      ["srs" /* SRS */]: "generator" /* GENERATOR */,
      ["prescribed" /* PRESCRIBED */]: "generator" /* GENERATOR */,
      ["hierarchyDefinition" /* HIERARCHY */]: "filter" /* FILTER */,
      ["interferenceMitigator" /* INTERFERENCE */]: "filter" /* FILTER */,
      ["relativePriority" /* RELATIVE_PRIORITY */]: "filter" /* FILTER */,
      ["userTagPreference" /* USER_TAG_PREFERENCE */]: "filter" /* FILTER */
    };
    ContentNavigator = class {
      /** User interface for this navigation session */
      user;
      /** Course interface for this navigation session */
      course;
      /** Human-readable name for this strategy instance (from ContentNavigationStrategyData.name) */
      strategyName;
      /** Unique document ID for this strategy instance (from ContentNavigationStrategyData._id) */
      strategyId;
      /** Evolutionary weighting configuration */
      learnable;
      /** Whether to bypass deviation (manual/static weighting) */
      staticWeight;
      /**
       * Constructor for standard navigators.
       * Call this from subclass constructors to initialize common fields.
       *
       * Note: CompositeGenerator and Pipeline call super() without args, then set
       * user/course fields directly if needed.
       */
      constructor(user, course, strategyData) {
        this.user = user;
        this.course = course;
        if (strategyData) {
          this.strategyName = strategyData.name;
          this.strategyId = strategyData._id;
          this.learnable = strategyData.learnable;
          this.staticWeight = strategyData.staticWeight;
        }
      }
      // ============================================================================
      // STRATEGY STATE HELPERS
      // ============================================================================
      //
      // These methods allow strategies to persist their own state (user preferences,
      // learned patterns, temporal tracking) in the user database.
      //
      // ============================================================================
      /**
       * Unique key identifying this strategy for state storage.
       *
       * Defaults to the constructor name (e.g., "UserTagPreferenceFilter").
       * Override in subclasses if multiple instances of the same strategy type
       * need separate state storage.
       */
      get strategyKey() {
        return this.constructor.name;
      }
      /**
       * Get this strategy's persisted state for the current course.
       *
       * @returns The strategy's data payload, or null if no state exists
       * @throws Error if user or course is not initialized
       */
      async getStrategyState() {
        if (!this.user || !this.course) {
          throw new Error(
            `Cannot get strategy state: navigator not properly initialized. Ensure user and course are provided to constructor.`
          );
        }
        return this.user.getStrategyState(this.course.getCourseID(), this.strategyKey);
      }
      /**
       * Persist this strategy's state for the current course.
       *
       * @param data - The strategy's data payload to store
       * @throws Error if user or course is not initialized
       */
      async putStrategyState(data) {
        if (!this.user || !this.course) {
          throw new Error(
            `Cannot put strategy state: navigator not properly initialized. Ensure user and course are provided to constructor.`
          );
        }
        return this.user.putStrategyState(this.course.getCourseID(), this.strategyKey, data);
      }
      /**
       * Factory method to create navigator instances.
       *
       * First checks the navigator registry for a pre-registered constructor.
       * If not found, falls back to dynamic import (for custom navigators).
       *
       * For reliable operation in test environments, call initializeNavigatorRegistry()
       * before using this method.
       *
       * @param user - User interface
       * @param course - Course interface
       * @param strategyData - Strategy configuration document
       * @returns the runtime object used to steer a study session.
       */
      static async create(user, course, strategyData) {
        const implementingClass = strategyData.implementingClass;
        const RegisteredImpl = getRegisteredNavigator(implementingClass);
        if (RegisteredImpl) {
          logger.debug(`[ContentNavigator.create] Using registered navigator: ${implementingClass}`);
          return new RegisteredImpl(user, course, strategyData);
        }
        logger.debug(
          `[ContentNavigator.create] Navigator not in registry, attempting dynamic import: ${implementingClass}`
        );
        let NavigatorImpl;
        const variations = [".ts", ".js", ""];
        for (const ext of variations) {
          try {
            const module = await globImport_generators(`./generators/${implementingClass}${ext}`);
            NavigatorImpl = module.default;
            if (NavigatorImpl) break;
          } catch (e) {
            logger.debug(`Failed to load generator ${implementingClass}${ext}:`, e);
          }
          try {
            const module = await globImport_filters(`./filters/${implementingClass}${ext}`);
            NavigatorImpl = module.default;
            if (NavigatorImpl) break;
          } catch (e) {
            logger.debug(`Failed to load filter ${implementingClass}${ext}:`, e);
          }
          try {
            const module = await globImport(`./${implementingClass}${ext}`);
            NavigatorImpl = module.default;
            if (NavigatorImpl) break;
          } catch (e) {
            logger.debug(`Failed to load legacy ${implementingClass}${ext}:`, e);
          }
          if (NavigatorImpl) break;
        }
        if (!NavigatorImpl) {
          throw new Error(`Could not load navigator implementation for: ${implementingClass}`);
        }
        return new NavigatorImpl(user, course, strategyData);
      }
      /**
       * Get cards with suitability scores and provenance trails.
       *
       * **This is the PRIMARY API for navigation strategies.**
       *
       * Returns cards ranked by suitability score (0-1). Higher scores indicate
       * better candidates for presentation. Each card includes a provenance trail
       * documenting how strategies contributed to the final score.
       *
       * ## Implementation Required
       * All navigation strategies MUST override this method. The base class does
       * not provide a default implementation.
       *
       * ## For Generators
       * Override this method to generate candidates and compute scores based on
       * your strategy's logic (e.g., ELO proximity, review urgency). Create the
       * initial provenance entry with action='generated'.
       *
       * ## For Filters
       * Filters should implement the CardFilter interface instead and be composed
       * via Pipeline. Filters do not directly implement getWeightedCards().
       *
       * @param limit - Maximum cards to return
       * @returns Cards sorted by score descending, with provenance trails
       */
      async getWeightedCards(_limit) {
        throw new Error(`${this.constructor.name} must implement getWeightedCards(). `);
      }
      /**
       * Set ephemeral hints for the next pipeline run.
       * No-op for non-Pipeline navigators. Pipeline overrides this.
       */
      setEphemeralHints(_hints) {
      }
    };
  }
});

// src/impl/couch/courseDB.ts
import {
  EloToNumber,
  Status,
  blankCourseElo as blankCourseElo2,
  toCourseElo as toCourseElo6
} from "@vue-skuilder/common";
function randIntWeightedTowardZero(n) {
  return Math.floor(Math.random() * Math.random() * Math.random() * n);
}
async function getCourseTagStubs(courseID) {
  logger.debug(`Getting tag stubs for course: ${courseID}`);
  const stubs = await filterAllDocsByPrefix2(
    getCourseDB2(courseID),
    "TAG" /* TAG */.valueOf() + "-"
  );
  stubs.rows.forEach((row) => {
    logger.debug(`	Tag stub for doc: ${row.id}`);
  });
  return stubs;
}
async function createTag(courseID, tagName, author) {
  logger.debug(`Creating tag: ${tagName}...`);
  const tagID = getTagID(tagName);
  const courseDB = getCourseDB2(courseID);
  const resp = await courseDB.put({
    course: courseID,
    docType: "TAG" /* TAG */,
    name: tagName,
    snippet: "",
    taggedCards: [],
    wiki: "",
    author,
    _id: tagID
  });
  return resp;
}
async function updateTag(tag) {
  const prior = await getTag(tag.course, tag.name);
  return await getCourseDB2(tag.course).put({
    ...tag,
    _rev: prior._rev
  });
}
async function getTag(courseID, tagName) {
  const tagID = getTagID(tagName);
  const courseDB = getCourseDB2(courseID);
  return courseDB.get(tagID);
}
async function removeTagFromCard(courseID, cardID, tagID) {
  tagID = getTagID(tagID);
  const courseDB = getCourseDB2(courseID);
  const tag = await courseDB.get(tagID);
  tag.taggedCards = tag.taggedCards.filter((taggedID) => {
    return cardID !== taggedID;
  });
  return courseDB.put(tag);
}
async function getAppliedTags(id_course, id_card) {
  const db = getCourseDB2(id_course);
  const result = await db.query("getTags", {
    startkey: id_card,
    endkey: id_card
    // include_docs: true
  });
  return result;
}
async function updateCredentialledCourseConfig(courseID, config) {
  logger.debug(`Updating course config:

${JSON.stringify(config)}
`);
  const db = getCourseDB2(courseID);
  const old = await getCredentialledCourseConfig(courseID);
  return await db.put({
    ...config,
    _rev: old._rev
  });
}
function isSuccessRow(row) {
  return "doc" in row && row.doc !== null && row.doc !== void 0;
}
var CoursesDB, CourseDB;
var init_courseDB = __esm({
  "src/impl/couch/courseDB.ts"() {
    "use strict";
    init_couch();
    init_updateQueue();
    init_types_legacy();
    init_logger();
    init_clientCache();
    init_courseAPI();
    init_courseLookupDB();
    init_navigators();
    init_PipelineAssembler();
    init_defaults();
    CoursesDB = class {
      _courseIDs;
      constructor(courseIDs) {
        if (courseIDs && courseIDs.length > 0) {
          this._courseIDs = courseIDs;
        } else {
          this._courseIDs = void 0;
        }
      }
      async getCourseList() {
        let crsList = await CourseLookup.allCourseWare();
        logger.debug(`AllCourses: ${crsList.map((c) => c.name + ", " + c._id + "\n	")}`);
        if (this._courseIDs) {
          crsList = crsList.filter((c) => this._courseIDs.includes(c._id));
        }
        logger.debug(`AllCourses.filtered: ${crsList.map((c) => c.name + ", " + c._id + "\n	")}`);
        const cfgs = await Promise.all(
          crsList.map(async (c) => {
            try {
              const cfg = await getCredentialledCourseConfig(c._id);
              logger.debug(`Found cfg: ${JSON.stringify(cfg)}`);
              return cfg;
            } catch (e) {
              logger.warn(`Error fetching cfg for course ${c.name}, ${c._id}: ${e}`);
              return void 0;
            }
          })
        );
        return cfgs.filter((c) => !!c);
      }
      async getCourseConfig(courseId) {
        if (this._courseIDs && this._courseIDs.length && !this._courseIDs.includes(courseId)) {
          throw new Error(`Course ${courseId} not in course list`);
        }
        const cfg = await getCredentialledCourseConfig(courseId);
        if (cfg === void 0) {
          throw new Error(`Error fetching cfg for course ${courseId}`);
        } else {
          return cfg;
        }
      }
      async disambiguateCourse(courseId, disambiguator) {
        await CourseLookup.updateDisambiguator(courseId, disambiguator);
      }
    };
    CourseDB = class {
      // private log(msg: string): void {
      //   log(`CourseLog: ${this.id}\n  ${msg}`);
      // }
      /**
       * Primary database handle used for all **read** operations (queries, gets).
       *
       * When local sync is active, this points to the local PouchDB replica for
       * fast, network-free reads. Otherwise it points to the remote CouchDB.
       */
      db;
      /**
       * Remote database handle used for all **write** operations.
       *
       * Always points to the remote CouchDB so that writes (ELO updates, tag
       * mutations, admin operations) aggregate on the server. The local replica
       * is a read-only snapshot that refreshes on the next page load.
       *
       * When local sync is NOT active, this is the same instance as `this.db`.
       */
      remoteDB;
      id;
      _getCurrentUser;
      updateQueue;
      /**
       * @param id - Course ID
       * @param userLookup - Async function returning the current user DB
       * @param localDB - Optional local PouchDB replica for reads. When provided,
       *   `this.db` uses the local replica and `this.remoteDB` stays remote.
       *   The UpdateQueue reads from remote and writes to remote (local `_rev`
       *   values may be stale, so read-modify-write cycles must go through
       *   the remote DB to avoid conflicts).
       */
      constructor(id, userLookup, localDB) {
        this.id = id;
        const remote = getCourseDB2(this.id);
        this.remoteDB = remote;
        this.db = localDB ?? remote;
        this._getCurrentUser = userLookup;
        this.updateQueue = new UpdateQueue(this.remoteDB, this.remoteDB);
      }
      getCourseID() {
        return this.id;
      }
      async getCourseInfo() {
        const cardCount = (await this.db.find({
          selector: {
            docType: "CARD" /* CARD */
          },
          limit: 1e3
        })).docs.length;
        return {
          cardCount,
          registeredUsers: 0
        };
      }
      async getInexperiencedCards(limit = 2) {
        return (await this.db.query("cardsByInexperience", {
          limit
        })).rows.map((r) => {
          const ret = {
            courseId: this.id,
            cardId: r.id,
            count: r.key,
            elo: r.value
          };
          return ret;
        });
      }
      async getCardsByEloLimits(options = {
        low: 0,
        high: Number.MIN_SAFE_INTEGER,
        limit: 25,
        page: 0
      }) {
        return (await this.db.query("elo", {
          startkey: options.low,
          endkey: options.high,
          limit: options.limit,
          skip: options.limit * options.page
        })).rows.map((r) => {
          return `${this.id}-${r.id}-${r.key}`;
        });
      }
      async getCardEloData(id) {
        const docs = await this.db.allDocs({
          keys: id,
          include_docs: true
        });
        const ret = [];
        docs.rows.forEach((r) => {
          if (isSuccessRow(r)) {
            if (r.doc && r.doc.elo) {
              ret.push(toCourseElo6(r.doc.elo));
            } else {
              logger.warn("no elo data for card: " + r.id);
              ret.push(blankCourseElo2());
            }
          } else {
            logger.warn("no elo data for card: " + JSON.stringify(r));
            ret.push(blankCourseElo2());
          }
        });
        return ret;
      }
      /**
       * Returns the lowest and highest `global` ELO ratings in the course
       */
      async getELOBounds() {
        const [low, high] = await Promise.all([
          (await this.db.query("elo", {
            startkey: 0,
            limit: 1,
            include_docs: false
          })).rows[0].key,
          (await this.db.query("elo", {
            limit: 1,
            descending: true,
            startkey: 1e5
          })).rows[0].key
        ]);
        return {
          low,
          high
        };
      }
      async removeCard(id) {
        const doc = await this.remoteDB.get(id);
        if (!doc.docType || !(doc.docType === "CARD" /* CARD */)) {
          throw new Error(`failed to remove ${id} from course ${this.id}. id does not point to a card`);
        }
        try {
          const appliedTags = await this.getAppliedTags(id);
          const results = await Promise.allSettled(
            appliedTags.rows.map(async (tagRow) => {
              const tagId = tagRow.id;
              await this.removeTagFromCard(id, tagId);
            })
          );
          results.forEach((result, index) => {
            if (result.status === "rejected") {
              const tagId = appliedTags.rows[index].id;
              logger.error(`Failed to remove card ${id} from tag ${tagId}: ${result.reason}`);
            }
          });
        } catch (error) {
          logger.error(`Error removing card ${id} from tags: ${error}`);
        }
        return this.remoteDB.remove(doc);
      }
      async getCardDisplayableDataIDs(id) {
        logger.debug(id.join(", "));
        const cards = await this.db.allDocs({
          keys: id,
          include_docs: true
        });
        const ret = {};
        cards.rows.forEach((r) => {
          if (isSuccessRow(r)) {
            ret[r.id] = r.doc.id_displayable_data;
          }
        });
        return ret;
      }
      async getCardsByELO(elo, cardLimit) {
        elo = parseInt(elo);
        const limit = cardLimit ? cardLimit : 25;
        const below = await this.db.query("elo", {
          limit: Math.ceil(limit / 2),
          startkey: elo,
          descending: true
        });
        const aboveLimit = limit - below.rows.length;
        const above = await this.db.query("elo", {
          limit: aboveLimit,
          startkey: elo + 1
        });
        let cards = below.rows;
        cards = cards.concat(above.rows);
        const ret = cards.sort((a, b) => {
          const s = Math.abs(a.key - elo) - Math.abs(b.key - elo);
          if (s === 0) {
            return Math.random() - 0.5;
          } else {
            return s;
          }
        }).map((c) => {
          return {
            courseID: this.id,
            cardID: c.id,
            elo: c.key
          };
        });
        const str = `below:
${below.rows.map((r) => `	${r.id}-${r.key}
`)}

above:
${above.rows.map((r) => `	${r.id}-${r.key}
`)}`;
        logger.debug(`Getting ${limit} cards centered around elo: ${elo}:

` + str);
        return ret;
      }
      async getCourseConfig() {
        const ret = await getCredentialledCourseConfig(this.id);
        if (ret) {
          return ret;
        } else {
          throw new Error(`Course config not found for course ID: ${this.id}`);
        }
      }
      async updateCourseConfig(cfg) {
        logger.debug(`Updating: ${JSON.stringify(cfg)}`);
        try {
          return await updateCredentialledCourseConfig(this.id, cfg);
        } catch (error) {
          logger.error(`Error updating course config in course DB: ${error}`);
          throw error;
        }
      }
      async updateCardElo(cardId, elo) {
        if (!elo) {
          throw new Error(`Cannot update card elo with null or undefined value for card ID: ${cardId}`);
        }
        try {
          const result = await this.updateQueue.update(cardId, (card) => {
            logger.debug(`Replacing ${JSON.stringify(card.elo)} with ${JSON.stringify(elo)}`);
            card.elo = elo;
            return card;
          });
          return { ok: true, id: cardId, rev: result._rev };
        } catch (error) {
          logger.error(`Failed to update card elo for card ID: ${cardId}`, error);
          throw new Error(`Failed to update card elo for card ID: ${cardId}`);
        }
      }
      async getAppliedTags(cardId) {
        const ret = await getAppliedTags(this.id, cardId);
        if (ret) {
          return ret;
        } else {
          throw new Error(`Failed to find tags for card ${this.id}-${cardId}`);
        }
      }
      async getAppliedTagsBatch(cardIds) {
        if (cardIds.length === 0) {
          return /* @__PURE__ */ new Map();
        }
        const result = await this.db.query("getTags", {
          keys: cardIds,
          include_docs: false
        });
        const tagsByCard = /* @__PURE__ */ new Map();
        for (const cardId of cardIds) {
          tagsByCard.set(cardId, []);
        }
        for (const row of result.rows) {
          const cardId = row.key;
          const tagName = row.value?.name;
          if (tagName && tagsByCard.has(cardId)) {
            tagsByCard.get(cardId).push(tagName);
          }
        }
        return tagsByCard;
      }
      async getAllCardIds() {
        const prefix = `${DocTypePrefixes["CARD" /* CARD */]}-`;
        const result = await this.db.allDocs({
          startkey: prefix,
          endkey: `${prefix}\uFFF0`,
          include_docs: false
        });
        return result.rows.map((row) => row.id);
      }
      async addTagToCard(cardId, tagId, updateELO) {
        return await addTagToCard(
          this.id,
          cardId,
          tagId,
          (await this._getCurrentUser()).getUsername(),
          updateELO
        );
      }
      async removeTagFromCard(cardId, tagId) {
        return await removeTagFromCard(this.id, cardId, tagId);
      }
      async createTag(name, author) {
        return await createTag(this.id, name, author);
      }
      async getTag(tagId) {
        return await getTag(this.id, tagId);
      }
      async updateTag(tag) {
        if (tag.course !== this.id) {
          throw new Error(`Tag ${JSON.stringify(tag)} does not belong to course ${this.id}`);
        }
        return await updateTag(tag);
      }
      async getCourseTagStubs() {
        return getCourseTagStubs(this.id);
      }
      async addNote(codeCourse, shape, data, author, tags, uploads, elo = blankCourseElo2()) {
        try {
          const resp = await addNote55(this.id, codeCourse, shape, data, author, tags, uploads, elo);
          if (resp.ok) {
            if (resp.cardCreationFailed) {
              logger.warn(
                `[courseDB.addNote] Note added but card creation failed: ${resp.cardCreationError}`
              );
              return {
                status: Status.error,
                message: `Note was added but no cards were created: ${resp.cardCreationError}`,
                id: resp.id
              };
            }
            return {
              status: Status.ok,
              message: "",
              id: resp.id
            };
          } else {
            return {
              status: Status.error,
              message: "Unexpected error adding note"
            };
          }
        } catch (e) {
          const err = e;
          logger.error(
            `[addNote] error ${err.name}
	reason: ${err.reason}
	message: ${err.message}`
          );
          return {
            status: Status.error,
            message: `Error adding note to course. ${e.reason || err.message}`
          };
        }
      }
      async getCourseDoc(id, options) {
        return await this.db.get(id, options ?? {});
      }
      async getCourseDocs(ids, options = {}) {
        return await this.db.allDocs({
          ...options,
          keys: ids
        });
      }
      ////////////////////////////////////
      // NavigationStrategyManager implementation
      ////////////////////////////////////
      getNavigationStrategy(id) {
        logger.debug(`[courseDB] Getting navigation strategy: ${id}`);
        if (id == "") {
          const strategy = {
            _id: "NAVIGATION_STRATEGY-ELO",
            docType: "NAVIGATION_STRATEGY" /* NAVIGATION_STRATEGY */,
            name: "ELO",
            description: "ELO-based navigation strategy for ordering content by difficulty",
            implementingClass: "elo" /* ELO */,
            course: this.id,
            serializedData: ""
            // serde is a noop for ELO navigator.
          };
          return Promise.resolve(strategy);
        } else {
          return this.db.get(id);
        }
      }
      async getAllNavigationStrategies() {
        const prefix = DocTypePrefixes["NAVIGATION_STRATEGY" /* NAVIGATION_STRATEGY */];
        const result = await this.db.allDocs({
          startkey: prefix,
          endkey: `${prefix}\uFFF0`,
          include_docs: true
        });
        return result.rows.map((row) => row.doc);
      }
      async addNavigationStrategy(data) {
        logger.debug(`[courseDB] Adding navigation strategy: ${data._id}`);
        this.invalidateNavigatorCache();
        return this.remoteDB.put(data).then(() => {
        });
      }
      updateNavigationStrategy(id, data) {
        logger.debug(`[courseDB] Updating navigation strategy: ${id}`);
        logger.debug(JSON.stringify(data));
        return Promise.resolve();
      }
      /**
       * Creates an instantiated navigator for this course.
       *
       * Handles multiple generators by wrapping them in CompositeGenerator.
       * This is the preferred method for getting a ready-to-use navigator.
       *
       * @param user - User database interface
       * @returns Instantiated ContentNavigator ready for use
       */
      async createNavigator(user) {
        try {
          const allStrategies = await this.getAllNavigationStrategies();
          if (allStrategies.length === 0) {
            logger.debug(
              "[courseDB] No strategy documents found, using default Pipeline(Composite(ELO, SRS), [eloDistanceFilter])"
            );
            return createDefaultPipeline(user, this);
          }
          const assembler = new PipelineAssembler();
          const { pipeline, generatorStrategies, filterStrategies, warnings } = await assembler.assemble({
            strategies: allStrategies,
            user,
            course: this
          });
          for (const warning of warnings) {
            logger.warn(`[PipelineAssembler] ${warning}`);
          }
          if (!pipeline) {
            logger.debug("[courseDB] Pipeline assembly failed, using default pipeline");
            return createDefaultPipeline(user, this);
          }
          logger.debug(
            `[courseDB] Using assembled pipeline with ${generatorStrategies.length} generator(s) and ${filterStrategies.length} filter(s)`
          );
          return pipeline;
        } catch (e) {
          const msg = e instanceof Error ? `${e.message}
${e.stack}` : JSON.stringify(e);
          logger.error(`[courseDB] Error creating navigator: ${msg}`);
          throw e;
        }
      }
      ////////////////////////////////////
      // END NavigationStrategyManager implementation
      ////////////////////////////////////
      ////////////////////////////////////
      // StudyContentSource implementation
      ////////////////////////////////////
      /**
       * Get cards with suitability scores for presentation.
       *
       * This is the PRIMARY API for content sources going forward. Delegates to the
       * course's configured NavigationStrategy to get scored candidates.
       *
       * @param limit - Maximum number of cards to return
       * @returns Cards sorted by score descending
       */
      _pendingHints = null;
      /**
       * Session-scoped cache of the broad ELO-neighbor pool used by
       * getCardsCenteredAtELO. The `elo` view query re-indexes on first touch per
       * call (PouchDB 9 ignores `stale`), so without this each plan/replan pays
       * ~1.5-2s. The pool is fetched once and re-ranked against the live (roaming)
       * ELO in memory on subsequent calls.
       */
      _eloPoolCache = null;
      _eloPoolTtlMs = 5 * 60 * 1e3;
      /**
       * Cached assembled navigator (Pipeline). createNavigator() reads strategy
       * docs and builds a fresh Pipeline every call — whose internal `_tagCache`
       * and `_cachedOrchestration` are designed to make replans cheap but never
       * survive, because the instance is discarded each run. Caching it lets those
       * caches persist across plan/replan within a session (SessionController holds
       * one CourseDB instance for the session's lifetime). Rebuilt on user change,
       * TTL expiry, or explicit invalidation after a strategy-doc write.
       */
      _cachedNavigator = null;
      _navigatorTtlMs = 5 * 60 * 1e3;
      setEphemeralHints(hints) {
        this._pendingHints = hints;
      }
      async getWeightedCards(limit) {
        const u = await this._getCurrentUser();
        try {
          const { navigator: navigator2 } = await this._getCachedNavigator(u);
          if (this._pendingHints) {
            navigator2.setEphemeralHints(this._pendingHints);
            this._pendingHints = null;
          }
          const result = await navigator2.getWeightedCards(limit);
          return result;
        } catch (e) {
          logger.error(`[courseDB] Error getting weighted cards: ${e}`);
          throw e;
        }
      }
      /**
       * Return the assembled navigator, reusing the cached instance when possible.
       * Reuse preserves the Pipeline's per-session caches (tags, orchestration
       * context) across replans, which is the dominant per-replan cost once the
       * ELO-pool cost is removed. Rebuilds on user change or TTL expiry.
       */
      async _getCachedNavigator(user) {
        const userId = user.getUsername();
        const now = Date.now();
        if (this._cachedNavigator && this._cachedNavigator.userId === userId && now - this._cachedNavigator.builtAt < this._navigatorTtlMs) {
          return { navigator: this._cachedNavigator.navigator, cacheStatus: "hit" };
        }
        const navigator2 = await this.createNavigator(user);
        this._cachedNavigator = { navigator: navigator2, userId, builtAt: now };
        return { navigator: navigator2, cacheStatus: "miss" };
      }
      /**
       * Drop the cached navigator so the next getWeightedCards() rebuilds it.
       * Call after mutating this course's navigation strategy documents.
       */
      invalidateNavigatorCache() {
        this._cachedNavigator = null;
      }
      async getCardsCenteredAtELO(options = {
        limit: 99,
        elo: "user"
      }, filter) {
        let targetElo;
        if (options.elo === "user") {
          const u = await this._getCurrentUser();
          targetElo = -1;
          try {
            const courseDoc = (await u.getCourseRegistrationsDoc()).courses.find((c) => {
              return c.courseID === this.id;
            });
            targetElo = EloToNumber(courseDoc.elo);
          } catch {
            targetElo = 1e3;
          }
        } else if (options.elo === "random") {
          const bounds = await GET_CACHED(`elo-bounds-${this.id}`, () => this.getELOBounds());
          targetElo = Math.round(bounds.low + Math.random() * (bounds.high - bounds.low));
        } else {
          targetElo = options.elo;
        }
        const POOL_SIZE = Math.max(2e3, options.limit * 4);
        const nowMs = Date.now();
        let cacheStatus = "hit";
        if (!this._eloPoolCache || nowMs - this._eloPoolCache.fetchedAt > this._eloPoolTtlMs) {
          const fetched = await this.getCardsByELO(targetElo, POOL_SIZE);
          if (fetched.length > 0) {
            this._eloPoolCache = { rows: fetched, fetchedAt: nowMs };
          }
          cacheStatus = "miss";
        }
        const rankAgainstCurrentElo = () => {
          const raw = this._eloPoolCache?.rows ?? [];
          const survivors = filter ? raw.filter((c) => filter(c)) : raw;
          return survivors.map((c) => ({ ...c })).sort(
            (a, b) => Math.abs((a.elo ?? targetElo) - targetElo) - Math.abs((b.elo ?? targetElo) - targetElo)
          );
        };
        let cards = rankAgainstCurrentElo();
        if (cards.length < options.limit && (cacheStatus === "hit" || !this._eloPoolCache)) {
          const fetched = await this.getCardsByELO(targetElo, POOL_SIZE);
          if (fetched.length > 0) {
            this._eloPoolCache = { rows: fetched, fetchedAt: nowMs };
          }
          cards = rankAgainstCurrentElo();
          cacheStatus = "refresh";
        }
        const selectedCards = [];
        while (selectedCards.length < options.limit && cards.length > 0) {
          const index = randIntWeightedTowardZero(cards.length);
          const card = cards.splice(index, 1)[0];
          selectedCards.push(card);
        }
        return selectedCards.map((c) => {
          return {
            courseID: this.id,
            cardID: c.cardID,
            contentSourceType: "course",
            contentSourceID: this.id,
            elo: c.elo,
            status: "new"
          };
        });
      }
      // Admin search methods
      async searchCards(query) {
        logger.log(`[CourseDB ${this.id}] Searching for: "${query}"`);
        let displayableData;
        try {
          displayableData = await this.db.find({
            selector: {
              docType: "DISPLAYABLE_DATA",
              "data.0.data": { $regex: `.*${query}.*` }
            }
          });
          logger.log(`[CourseDB ${this.id}] Regex search on data[0].data successful`);
        } catch (regexError) {
          logger.log(
            `[CourseDB ${this.id}] Regex search failed, falling back to manual search:`,
            regexError
          );
          const allDisplayable = await this.db.find({
            selector: {
              docType: "DISPLAYABLE_DATA"
            }
          });
          logger.log(
            `[CourseDB ${this.id}] Retrieved ${allDisplayable.docs.length} documents for manual filtering`
          );
          displayableData = {
            docs: allDisplayable.docs.filter((doc) => {
              const docString = JSON.stringify(doc).toLowerCase();
              const match = docString.includes(query.toLowerCase());
              if (match) {
                logger.log(`[CourseDB ${this.id}] Manual match found in document: ${doc._id}`);
              }
              return match;
            })
          };
        }
        logger.log(
          `[CourseDB ${this.id}] Found ${displayableData.docs.length} displayable data documents`
        );
        if (displayableData.docs.length === 0) {
          const allDisplayableData = await this.db.find({
            selector: {
              docType: "DISPLAYABLE_DATA"
            },
            limit: 5
            // Just sample a few
          });
          logger.log(
            `[CourseDB ${this.id}] Sample displayable data:`,
            allDisplayableData.docs.map((d) => ({
              id: d._id,
              docType: d.docType,
              dataStructure: d.data ? Object.keys(d.data) : "no data field",
              dataContent: d.data,
              fullDoc: d
            }))
          );
        }
        const allResults = [];
        for (const dd of displayableData.docs) {
          const cards = await this.db.find({
            selector: {
              docType: "CARD",
              id_displayable_data: { $in: [dd._id] }
            }
          });
          logger.log(
            `[CourseDB ${this.id}] Displayable data ${dd._id} linked to ${cards.docs.length} cards`
          );
          allResults.push(...cards.docs);
        }
        logger.log(`[CourseDB ${this.id}] Total cards found: ${allResults.length}`);
        return allResults;
      }
      async find(request) {
        return this.db.find(request);
      }
    };
  }
});

// src/impl/couch/classroomDB.ts
import moment4 from "moment";
var classroomLookupDBTitle, CLASSROOM_CONFIG, ClassroomDBBase, StudentClassroomDB, TeacherClassroomDB, ClassroomLookupDB;
var init_classroomDB2 = __esm({
  "src/impl/couch/classroomDB.ts"() {
    "use strict";
    init_factory();
    init_logger();
    init_pouchdb_setup();
    init_couch();
    init_courseDB();
    classroomLookupDBTitle = "classdb-lookup";
    CLASSROOM_CONFIG = "ClassroomConfig";
    ClassroomDBBase = class {
      _id;
      _db;
      _cfg;
      _initComplete = false;
      _content_prefix = "content";
      get _content_searchkeys() {
        return getStartAndEndKeys2(this._content_prefix);
      }
      async getAssignedContent() {
        logger.info(`Getting assigned content...`);
        const docRows = await this._db.allDocs({
          startkey: this._content_prefix,
          endkey: this._content_prefix + `\uFFF0`,
          include_docs: true
        });
        const ret = docRows.rows.map((row) => {
          return row.doc;
        });
        return ret;
      }
      getContentId(content) {
        if (content.type === "tag") {
          return `${this._content_prefix}-${content.courseID}-${content.tagID}`;
        } else {
          return `${this._content_prefix}-${content.courseID}`;
        }
      }
      get ready() {
        return this._initComplete;
      }
      getConfig() {
        return this._cfg;
      }
    };
    StudentClassroomDB = class _StudentClassroomDB extends ClassroomDBBase {
      // private readonly _prefix: string = 'content';
      userMessages;
      _user;
      constructor(classID, user) {
        super();
        this._id = classID;
        this._user = user;
      }
      async init() {
        const dbName = `classdb-student-${this._id}`;
        this._db = new pouchdb_setup_default(
          ENV.COUCHDB_SERVER_PROTOCOL + "://" + ENV.COUCHDB_SERVER_URL + dbName,
          createPouchDBConfig()
        );
        try {
          const cfg = await this._db.get(CLASSROOM_CONFIG);
          this._cfg = cfg;
          this.userMessages = this._db.changes({
            since: "now",
            live: true,
            include_docs: true
          });
          this._initComplete = true;
          return;
        } catch (e) {
          throw new Error(`Error in StudentClassroomDB constructor: ${JSON.stringify(e)}`);
        }
      }
      static async factory(classID, user) {
        const ret = new _StudentClassroomDB(classID, user);
        await ret.init();
        return ret;
      }
      setChangeFcn(f) {
        void this.userMessages.on("change", f);
      }
      /**
       * Get cards with suitability scores for presentation.
       *
       * Gathers new cards from assigned content (courses, tags, cards) and
       * pending reviews scheduled for this classroom. Assigns score=1.0 to all.
       *
       * @param limit - Maximum number of cards to return
       * @returns Cards sorted by score descending (all scores = 1.0)
       */
      async getWeightedCards(limit) {
        const weighted = [];
        const allUserReviews = await this._user.getPendingReviews();
        const classroomReviews = allUserReviews.filter(
          (r) => r.scheduledFor === "classroom" && r.schedulingAgentId === this._id
        );
        for (const r of classroomReviews) {
          weighted.push({
            cardId: r.cardId,
            courseId: r.courseId,
            score: 1,
            reviewID: r._id,
            provenance: [
              {
                strategy: "classroom",
                strategyName: "Classroom",
                strategyId: "CLASSROOM",
                action: "generated",
                score: 1,
                reason: "Classroom scheduled review"
              }
            ]
          });
        }
        const activeCards = await this._user.getActiveCards();
        const activeCardIds = new Set(activeCards.map((ac) => ac.cardID));
        const now = moment4.utc();
        const assigned = await this.getAssignedContent();
        const due = assigned.filter((c) => now.isAfter(moment4.utc(c.activeOn, REVIEW_TIME_FORMAT2)));
        logger.info(`[StudentClassroomDB] Due content: ${JSON.stringify(due)}`);
        for (const content of due) {
          if (content.type === "course") {
            const db = new CourseDB(content.courseID, async () => this._user);
            const { cards: courseCards } = await db.getWeightedCards(limit);
            for (const card of courseCards) {
              if (!activeCardIds.has(card.cardId)) {
                weighted.push({
                  ...card,
                  provenance: [
                    ...card.provenance,
                    {
                      strategy: "classroom",
                      strategyName: "Classroom",
                      strategyId: "CLASSROOM",
                      action: "passed",
                      score: card.score,
                      reason: `Assigned via classroom from course ${content.courseID}`
                    }
                  ]
                });
              }
            }
          } else if (content.type === "tag") {
            const tagDoc = await getTag(content.courseID, content.tagID);
            for (const cardId of tagDoc.taggedCards) {
              if (!activeCardIds.has(cardId)) {
                weighted.push({
                  cardId,
                  courseId: content.courseID,
                  score: 1,
                  provenance: [
                    {
                      strategy: "classroom",
                      strategyName: "Classroom",
                      strategyId: "CLASSROOM",
                      action: "generated",
                      score: 1,
                      reason: `Classroom assigned tag: ${content.tagID}, new card`
                    }
                  ]
                });
              }
            }
          } else if (content.type === "card") {
            if (!activeCardIds.has(content.cardID)) {
              weighted.push({
                cardId: content.cardID,
                courseId: content.courseID,
                score: 1,
                provenance: [
                  {
                    strategy: "classroom",
                    strategyName: "Classroom",
                    strategyId: "CLASSROOM",
                    action: "generated",
                    score: 1,
                    reason: "Classroom assigned card, new card"
                  }
                ]
              });
            }
          }
        }
        logger.info(
          `[StudentClassroomDB] New cards from classroom ${this._cfg.name}: ${weighted.length} total (reviews + new)`
        );
        return { cards: weighted.sort((a, b) => b.score - a.score).slice(0, limit) };
      }
    };
    TeacherClassroomDB = class _TeacherClassroomDB extends ClassroomDBBase {
      _stuDb;
      constructor(classID) {
        super();
        this._id = classID;
      }
      async init() {
        const dbName = `classdb-teacher-${this._id}`;
        const stuDbName = `classdb-student-${this._id}`;
        this._db = new pouchdb_setup_default(
          ENV.COUCHDB_SERVER_PROTOCOL + "://" + ENV.COUCHDB_SERVER_URL + dbName,
          createPouchDBConfig()
        );
        this._stuDb = new pouchdb_setup_default(
          ENV.COUCHDB_SERVER_PROTOCOL + "://" + ENV.COUCHDB_SERVER_URL + stuDbName,
          createPouchDBConfig()
        );
        try {
          return this._db.get(CLASSROOM_CONFIG).then((cfg) => {
            this._cfg = cfg;
            this._initComplete = true;
          }).then(() => {
            return;
          });
        } catch (e) {
          throw new Error(`Error in TeacherClassroomDB constructor: ${JSON.stringify(e)}`);
        }
      }
      static async factory(classID) {
        const ret = new _TeacherClassroomDB(classID);
        await ret.init();
        return ret;
      }
      async removeContent(content) {
        const contentID = this.getContentId(content);
        try {
          const doc = await this._db.get(contentID);
          await this._db.remove(doc);
          void this._db.replicate.to(this._stuDb, {
            doc_ids: [contentID]
          });
        } catch (error) {
          logger.error("Failed to remove content:", contentID, error);
        }
      }
      async assignContent(content) {
        let put;
        const id = this.getContentId(content);
        if (content.type === "tag") {
          put = await this._db.put({
            courseID: content.courseID,
            tagID: content.tagID,
            type: "tag",
            _id: id,
            assignedBy: content.assignedBy,
            assignedOn: moment4.utc(),
            activeOn: content.activeOn || moment4.utc()
          });
        } else {
          put = await this._db.put({
            courseID: content.courseID,
            type: "course",
            _id: id,
            assignedBy: content.assignedBy,
            assignedOn: moment4.utc(),
            activeOn: content.activeOn || moment4.utc()
          });
        }
        if (put.ok) {
          void this._db.replicate.to(this._stuDb, {
            doc_ids: [id]
          });
          return true;
        } else {
          return false;
        }
      }
    };
    ClassroomLookupDB = () => new pouchdb_setup_default(ENV.COUCHDB_SERVER_PROTOCOL + "://" + ENV.COUCHDB_SERVER_URL + classroomLookupDBTitle, {
      skip_setup: true
    });
  }
});

// src/impl/couch/adminDB.ts
var AdminDB;
var init_adminDB2 = __esm({
  "src/impl/couch/adminDB.ts"() {
    "use strict";
    init_pouchdb_setup();
    init_factory();
    init_couch();
    init_classroomDB2();
    init_courseLookupDB();
    init_logger();
    AdminDB = class {
      usersDB;
      constructor() {
        this.usersDB = new pouchdb_setup_default(
          ENV.COUCHDB_SERVER_PROTOCOL + "://" + ENV.COUCHDB_SERVER_URL + "_users",
          createPouchDBConfig()
        );
      }
      async getUsers() {
        return (await this.usersDB.allDocs({
          include_docs: true,
          ...getStartAndEndKeys2("org.couchdb.user:")
        })).rows.map((r) => r.doc);
      }
      async getCourses() {
        const list = await CourseLookup.allCourseWare();
        return await Promise.all(
          list.map((c) => {
            return getCredentialledCourseConfig(c._id);
          })
        );
      }
      async removeCourse(id) {
        const delResp = await CourseLookup.delete(id);
        const cfg = await getCredentialledCourseConfig(id);
        cfg.deleted = true;
        const isDeletedResp = await updateCredentialledCourseConfig(id, cfg);
        return {
          ok: delResp.ok && isDeletedResp.ok,
          id: delResp.id,
          rev: delResp.rev
        };
      }
      async getClassrooms() {
        const uuids = (await ClassroomLookupDB().allDocs({
          include_docs: true
        })).rows.map((r) => r.doc.uuid);
        logger.debug(uuids.join(", "));
        const promisedCRDbs = [];
        for (let i = 0; i < uuids.length; i++) {
          try {
            const db = await TeacherClassroomDB.factory(uuids[i]);
            promisedCRDbs.push(db);
          } catch (e) {
            const err = e;
            if (err.error && err.error === "not_found") {
              logger.warn(`db ${uuids[i]} not found`);
            }
          }
        }
        return promisedCRDbs.map((db) => {
          return {
            ...db.getConfig(),
            _id: db._id
          };
        });
      }
    };
  }
});

// src/impl/couch/CourseSyncService.ts
var CourseSyncService_exports = {};
__export(CourseSyncService_exports, {
  CourseSyncService: () => CourseSyncService
});
var DEFAULT_REPLICATION, CourseSyncService;
var init_CourseSyncService = __esm({
  "src/impl/couch/CourseSyncService.ts"() {
    "use strict";
    init_pouchdb_setup();
    init_couch();
    init_logger();
    DEFAULT_REPLICATION = {
      batchSize: 1e3,
      batchesLimit: 5
    };
    CourseSyncService = class _CourseSyncService {
      static instance = null;
      entries = /* @__PURE__ */ new Map();
      replicationOptions = DEFAULT_REPLICATION;
      constructor() {
      }
      static getInstance() {
        if (!_CourseSyncService.instance) {
          _CourseSyncService.instance = new _CourseSyncService();
        }
        return _CourseSyncService.instance;
      }
      /**
       * Apply replication tuning. Typically called once from `initializeDataLayer`.
       * Partial overrides merge with defaults.
       */
      configure(opts) {
        if (opts.replication) {
          this.replicationOptions = {
            ...DEFAULT_REPLICATION,
            ...opts.replication
          };
          logger.info(
            `[CourseSyncService] Replication configured: batch_size=${this.replicationOptions.batchSize}, batches_limit=${this.replicationOptions.batchesLimit}`
          );
        }
      }
      /**
       * Reset the singleton (for testing).
       */
      static resetInstance() {
        if (_CourseSyncService.instance) {
          for (const [, entry] of _CourseSyncService.instance.entries) {
            if (entry.localDB) {
              entry.localDB.close().catch(() => {
              });
            }
          }
          _CourseSyncService.instance.entries.clear();
        }
        _CourseSyncService.instance = null;
      }
      // --------------------------------------------------------------------------
      // Public API
      // --------------------------------------------------------------------------
      /**
       * Ensure a course's local replica is synced.
       *
       * On first call for a course:
       *   1. Fetches CourseConfig from remote to check localSync.enabled
       *   2. If enabled, performs one-shot replication remote → local
       *   3. Pre-warms PouchDB view indices (elo, getTags)
       *
       * On subsequent calls: returns immediately if already synced, or awaits
       * the in-flight sync if one is in progress.
       *
       * Safe to call multiple times — concurrent calls coalesce to one sync.
       *
       * @param courseId - The course to sync
       * @param forceEnabled - Skip the CourseConfig check and sync regardless.
       *   Useful when the caller already knows local sync is desired (e.g.,
       *   LettersPractice hardcodes this).
       */
      async ensureSynced(courseId, forceEnabled) {
        const existing = this.entries.get(courseId);
        if (existing?.status.state === "ready" && existing.localDB) {
          const stale = await this.isLocalEpochStale(courseId, existing.localDB);
          if (!stale) {
            return;
          }
          logger.info(
            `[CourseSyncService] Remote DB epoch changed for course ${courseId} \u2014 destroying stale local replica`
          );
          try {
            await existing.localDB.destroy();
          } catch {
          }
          existing.localDB = null;
          existing.readyPromise = null;
        }
        if (existing?.status.state === "disabled") {
          return;
        }
        if (existing?.readyPromise) {
          return existing.readyPromise;
        }
        const entry = {
          localDB: null,
          status: { state: "not-started" },
          readyPromise: null
        };
        this.entries.set(courseId, entry);
        entry.readyPromise = this.performSync(courseId, entry, forceEnabled);
        return entry.readyPromise;
      }
      /**
       * Get the local PouchDB for a course, or null if not available.
       *
       * Returns null when:
       *   - Local sync is not enabled for this course
       *   - Sync has not been triggered yet
       *   - Sync is still in progress
       *   - Sync failed
       */
      getLocalDB(courseId) {
        const entry = this.entries.get(courseId);
        if (entry?.status.state === "ready" && entry.localDB) {
          return entry.localDB;
        }
        return null;
      }
      /**
       * Check whether a course has a ready local replica.
       */
      isReady(courseId) {
        return this.entries.get(courseId)?.status.state === "ready";
      }
      /**
       * Get detailed sync status for a course.
       */
      getStatus(courseId) {
        return this.entries.get(courseId)?.status ?? { state: "not-started" };
      }
      // --------------------------------------------------------------------------
      // Internal
      // --------------------------------------------------------------------------
      async performSync(courseId, entry, forceEnabled) {
        try {
          if (!forceEnabled) {
            entry.status = { state: "checking-config" };
            const enabled = await this.checkLocalSyncEnabled(courseId);
            if (!enabled) {
              entry.status = { state: "disabled" };
              entry.readyPromise = null;
              logger.debug(
                `[CourseSyncService] Local sync disabled for course ${courseId}`
              );
              return;
            }
          }
          entry.status = { state: "syncing" };
          const localDBName = this.localDBName(courseId);
          let localDB = new pouchdb_setup_default(localDBName);
          const stale = await this.isLocalEpochStale(courseId, localDB);
          if (stale) {
            logger.info(
              `[CourseSyncService] Stale local DB detected for course ${courseId} \u2014 destroying before sync`
            );
            await localDB.destroy();
            localDB = new pouchdb_setup_default(localDBName);
          }
          entry.localDB = localDB;
          const remoteDB = this.getRemoteDB(courseId);
          const syncStart = Date.now();
          logger.info(
            `[CourseSyncService] Starting one-shot replication for course ${courseId} (batch_size=${this.replicationOptions.batchSize}, batches_limit=${this.replicationOptions.batchesLimit})`
          );
          const result = await this.replicate(remoteDB, localDB);
          const syncTimeMs = Date.now() - syncStart;
          logger.info(
            `[CourseSyncService] Replication complete for course ${courseId}: ${result.docs_written} docs in ${syncTimeMs}ms`
          );
          entry.status = { state: "warming-views" };
          const warmStart = Date.now();
          await this.warmViewIndices(localDB);
          const viewWarmTimeMs = Date.now() - warmStart;
          logger.info(
            `[CourseSyncService] View indices warmed for course ${courseId} in ${viewWarmTimeMs}ms`
          );
          entry.status = {
            state: "ready",
            docsReplicated: result.docs_written,
            syncTimeMs,
            viewWarmTimeMs
          };
        } catch (e) {
          const errorMsg = e instanceof Error ? e.message : String(e);
          logger.error(
            `[CourseSyncService] Sync failed for course ${courseId}: ${errorMsg}`
          );
          entry.status = { state: "error", error: errorMsg };
          entry.readyPromise = null;
          if (entry.localDB) {
            try {
              await entry.localDB.destroy();
            } catch {
            }
            entry.localDB = null;
          }
        }
      }
      /**
       * Check CourseConfig.localSync.enabled on the remote DB.
       */
      async checkLocalSyncEnabled(courseId) {
        try {
          const remoteDB = this.getRemoteDB(courseId);
          const config = await remoteDB.get("CourseConfig");
          return config.localSync?.enabled === true;
        } catch (e) {
          logger.warn(
            `[CourseSyncService] Could not read CourseConfig for ${courseId}, assuming local sync disabled: ${e}`
          );
          return false;
        }
      }
      /**
       * One-shot replication from remote to local.
       */
      replicate(source, target) {
        return new Promise((resolve, reject) => {
          void pouchdb_setup_default.replicate(source, target, {
            // One-shot, not live. Local is a read-only snapshot.
            batch_size: this.replicationOptions.batchSize,
            batches_limit: this.replicationOptions.batchesLimit
          }).on("complete", (info) => {
            resolve(info);
          }).on("error", (err) => {
            reject(err);
          });
        });
      }
      /**
       * Pre-warm PouchDB view indices by running a minimal query against each
       * design doc. This forces PouchDB to build the MapReduce index now
       * (during a loading phase) rather than on first pipeline query.
       */
      async warmViewIndices(localDB) {
        const viewsToWarm = ["elo", "getTags"];
        for (const viewName of viewsToWarm) {
          try {
            await localDB.query(viewName, { limit: 1 });
            logger.debug(
              `[CourseSyncService] Warmed view index: ${viewName}`
            );
          } catch (e) {
            logger.debug(
              `[CourseSyncService] Could not warm view ${viewName}: ${e}`
            );
          }
        }
      }
      /**
       * Check whether the local replica's `db-epoch` doc matches the remote.
       *
       * The seed script (and optionally upload-cards) writes a `db-epoch`
       * document with a numeric timestamp. If the remote epoch differs from
       * the local copy, the remote DB was recreated (e.g., `yarn db:seed`)
       * and the local PouchDB is stale.
       *
       * Returns `true` if stale (epoch mismatch or remote has epoch but local
       * doesn't). Returns `false` (not stale) if epochs match, or if the
       * remote doesn't have an epoch doc at all (backwards compat).
       */
      async isLocalEpochStale(courseId, localDB) {
        try {
          const remoteDB = this.getRemoteDB(courseId);
          const remoteEpoch = await remoteDB.get("db-epoch");
          let localEpoch = null;
          try {
            localEpoch = await localDB.get("db-epoch");
          } catch {
            return true;
          }
          return remoteEpoch.epoch !== localEpoch.epoch;
        } catch {
          return false;
        }
      }
      /**
       * Get a remote PouchDB handle for a course.
       */
      getRemoteDB(courseId) {
        return getCourseDB2(courseId);
      }
      /**
       * Local DB naming convention.
       */
      localDBName(courseId) {
        return `coursedb-local-${courseId}`;
      }
    };
  }
});

// src/impl/couch/auth.ts
import fetch2 from "cross-fetch";
async function getCurrentSession() {
  try {
    if (ENV.COUCHDB_SERVER_URL === NOT_SET || ENV.COUCHDB_SERVER_PROTOCOL === NOT_SET) {
      throw new Error(`CouchDB server configuration not properly initialized. Protocol: "${ENV.COUCHDB_SERVER_PROTOCOL}", URL: "${ENV.COUCHDB_SERVER_URL}"`);
    }
    const baseUrl = ENV.COUCHDB_SERVER_URL.endsWith("/") ? ENV.COUCHDB_SERVER_URL.slice(0, -1) : ENV.COUCHDB_SERVER_URL;
    const url = `${ENV.COUCHDB_SERVER_PROTOCOL}://${baseUrl}/_session`;
    logger.debug(`Attempting session check at: ${url}`);
    const response = await fetch2(url, {
      method: "GET",
      credentials: "include"
    });
    if (!response.ok) {
      throw new Error(`Session check failed: ${response.status}`);
    }
    const resp = await response.json();
    return resp;
  } catch (error) {
    const baseUrl = ENV.COUCHDB_SERVER_URL.endsWith("/") ? ENV.COUCHDB_SERVER_URL.slice(0, -1) : ENV.COUCHDB_SERVER_URL;
    const url = `${ENV.COUCHDB_SERVER_PROTOCOL}://${baseUrl}/_session`;
    logger.error(`Session check error attempting to connect to: ${url} - ${error}`);
    throw new Error(`Session check failed connecting to ${url}: ${error}`);
  }
}
async function getLoggedInUsername() {
  const session = await getCurrentSession();
  if (session.userCtx.name && session.userCtx.name !== "") {
    return session.userCtx.name;
  }
  throw new Error("No logged in user");
}
var init_auth = __esm({
  "src/impl/couch/auth.ts"() {
    "use strict";
    init_factory();
    init_logger();
  }
});

// src/impl/couch/CouchDBSyncStrategy.ts
var CouchDBSyncStrategy_exports = {};
__export(CouchDBSyncStrategy_exports, {
  CouchDBSyncStrategy: () => CouchDBSyncStrategy
});
import { Status as Status2 } from "@vue-skuilder/common";
var log3, CouchDBSyncStrategy;
var init_CouchDBSyncStrategy = __esm({
  "src/impl/couch/CouchDBSyncStrategy.ts"() {
    "use strict";
    init_factory();
    init_types_legacy();
    init_logger();
    init_common();
    init_pouchdb_setup();
    init_couch();
    init_auth();
    log3 = (s) => {
      logger.info(s);
    };
    CouchDBSyncStrategy = class {
      syncHandle;
      // Handle to cancel sync if needed
      setupRemoteDB(username) {
        if (username === GuestUsername || username.startsWith(GuestUsername)) {
          return getLocalUserDB(username);
        } else {
          return this.getUserDB(username);
        }
      }
      getWriteDB(username) {
        if (username === GuestUsername || username.startsWith(GuestUsername)) {
          return getLocalUserDB(username);
        } else {
          return this.getUserDB(username);
        }
      }
      startSync(localDB, remoteDB) {
        if (localDB !== remoteDB) {
          this.syncHandle = pouchdb_setup_default.sync(localDB, remoteDB, {
            live: true,
            retry: true
          });
        }
      }
      stopSync() {
        if (this.syncHandle) {
          this.syncHandle.cancel();
          this.syncHandle = void 0;
        }
      }
      canCreateAccount() {
        return true;
      }
      canAuthenticate() {
        return true;
      }
      async createAccount(username, password) {
        const funnelUsername = await this.getCurrentUsername();
        const isFunnelAccount = funnelUsername.startsWith(GuestUsername);
        if (isFunnelAccount) {
          logger.info(`Creating account for funnel user ${funnelUsername} -> ${username}`);
        }
        try {
          const signupRequest = await this.getRemoteCouchRootDB().signUp(username, password);
          if (signupRequest.ok) {
            log3(`CREATEACCOUNT: Successfully created account for ${username}`);
            try {
              const logoutResult = await this.getRemoteCouchRootDB().logOut();
              log3(`CREATEACCOUNT: logged out: ${logoutResult.ok}`);
            } catch {
            }
            const loginResult = await this.getRemoteCouchRootDB().logIn(username, password);
            log3(`CREATEACCOUNT: logged in as new user: ${loginResult.ok}`);
            if (loginResult.ok) {
              if (isFunnelAccount) {
                logger.info(`Migrating data from funnel account ${funnelUsername} to ${username}`);
                const migrationResult = await this.migrateFunnelData(funnelUsername, username);
                if (!migrationResult.success) {
                  logger.warn(`Migration failed: ${migrationResult.error}`);
                }
              }
              return {
                status: Status2.ok,
                error: void 0
              };
            } else {
              return {
                status: Status2.error,
                error: "Failed to log in after account creation"
              };
            }
          } else {
            logger.warn(`Signup not OK: ${JSON.stringify(signupRequest)}`);
            return {
              status: Status2.error,
              error: "Account creation failed"
            };
          }
        } catch (e) {
          if (e.reason === "Document update conflict.") {
            return {
              status: Status2.error,
              error: "This username is taken!"
            };
          }
          logger.error(`Error on signup: ${JSON.stringify(e)}`);
          return {
            status: Status2.error,
            error: e.message || "Unknown error during account creation"
          };
        }
      }
      async authenticate(username, password) {
        try {
          const loginResult = await this.getRemoteCouchRootDB().logIn(username, password);
          if (loginResult.ok) {
            log3(`Successfully logged in as ${username}`);
            return {
              ok: true
            };
          } else {
            log3(`Login failed for ${username}`);
            return {
              ok: false,
              error: "Invalid username or password"
            };
          }
        } catch (error) {
          logger.error(`Authentication error for ${username}:`, error);
          return {
            ok: false,
            error: error.message || "Authentication failed"
          };
        }
      }
      async logout() {
        try {
          const result = await this.getRemoteCouchRootDB().logOut();
          return {
            ok: result.ok,
            error: result.ok ? void 0 : "Logout failed"
          };
        } catch (error) {
          logger.error("Logout error:", error);
          return {
            ok: false,
            error: error.message || "Logout failed"
          };
        }
      }
      async getCurrentUsername() {
        logger.log("[funnel] CouchDBSyncStrategy.getCurrentUsername() called");
        try {
          const loggedInUsername = await getLoggedInUsername();
          logger.log("[funnel] getLoggedInUsername() returned:", loggedInUsername);
          return loggedInUsername;
        } catch (e) {
          logger.log("[funnel] getLoggedInUsername() failed, calling accomodateGuest()");
          logger.log("[funnel] Error was:", e);
          const guestInfo = accomodateGuest();
          logger.log("[funnel] accomodateGuest() returned:", guestInfo);
          return guestInfo.username;
        }
      }
      /**
       * Migrate data from funnel account to real account
       */
      async migrateFunnelData(oldUsername, newUsername) {
        try {
          logger.info(`Starting data migration from ${oldUsername} to ${newUsername}`);
          const oldLocalDB = getLocalUserDB(oldUsername);
          const newLocalDB = getLocalUserDB(newUsername);
          const allDocs = await oldLocalDB.allDocs({ include_docs: true });
          logger.info(`Found ${allDocs.rows.length} documents in funnel account`);
          const docsToMigrate = allDocs.rows.filter((row) => !row.id.startsWith("_design/")).map((row) => ({
            ...row.doc,
            _rev: void 0
            // Remove rev to insert as new
          }));
          if (docsToMigrate.length > 0) {
            await newLocalDB.bulkDocs(docsToMigrate);
            logger.info(`Successfully migrated ${docsToMigrate.length} documents from ${oldUsername} to ${newUsername}`);
          } else {
            logger.info("No documents to migrate from funnel account");
          }
          return { success: true };
        } catch (error) {
          logger.error("Migration failed:", error);
          return {
            success: false,
            error: error instanceof Error ? error.message : "Unknown error"
          };
        }
      }
      /**
       * Get remote CouchDB root database for authentication operations
       */
      getRemoteCouchRootDB() {
        const remoteStr = ENV.COUCHDB_SERVER_PROTOCOL + "://" + ENV.COUCHDB_SERVER_URL + "skuilder";
        try {
          return new pouchdb_setup_default(remoteStr, {
            skip_setup: true
          });
        } catch (error) {
          logger.error("Failed to initialize remote CouchDB connection:", error);
          throw new Error(`Failed to initialize CouchDB: ${JSON.stringify(error)}`);
        }
      }
      /**
       * Get remote user database for a specific user
       */
      getUserDB(username) {
        const guestAccount = false;
        const hexName = hexEncode(username);
        const dbName = `userdb-${hexName}`;
        log3(`Fetching user database: ${dbName} (${username})`);
        const ret = new pouchdb_setup_default(
          ENV.COUCHDB_SERVER_PROTOCOL + "://" + ENV.COUCHDB_SERVER_URL + dbName,
          createPouchDBConfig()
        );
        if (guestAccount) {
          updateGuestAccountExpirationDate(ret);
        }
        return ret;
      }
    };
  }
});

// src/impl/couch/index.ts
import fetch3 from "cross-fetch";
import moment5 from "moment";
import process2 from "process";
function createPouchDBConfig() {
  const hasExplicitCredentials = ENV.COUCHDB_USERNAME && ENV.COUCHDB_PASSWORD;
  const isNodeEnvironment = typeof window === "undefined";
  if (hasExplicitCredentials && isNodeEnvironment) {
    return {
      fetch(url, opts = {}) {
        const basicAuth = btoa(`${ENV.COUCHDB_USERNAME}:${ENV.COUCHDB_PASSWORD}`);
        const headers = new Headers(opts.headers || {});
        headers.set("Authorization", `Basic ${basicAuth}`);
        const newOpts = {
          ...opts,
          headers
        };
        return pouchdb_setup_default.fetch(url, newOpts);
      }
    };
  }
  return pouchDBincludeCredentialsConfig;
}
function getCourseDB2(courseID) {
  return new pouchdb_setup_default(
    ENV.COUCHDB_SERVER_PROTOCOL + "://" + ENV.COUCHDB_SERVER_URL + "coursedb-" + courseID,
    createPouchDBConfig()
  );
}
function filterAllDocsByPrefix2(db, prefix, opts) {
  const options = {
    startkey: prefix,
    endkey: prefix + "\uFFF0",
    include_docs: true
  };
  if (opts) {
    Object.assign(options, opts);
  }
  return db.allDocs(options);
}
function getStartAndEndKeys2(key) {
  return {
    startkey: key,
    endkey: key + "\uFFF0"
  };
}
var isBrowser, GUEST_LOCAL_DB, localUserDB, pouchDBincludeCredentialsConfig, REVIEW_TIME_FORMAT2;
var init_couch = __esm({
  "src/impl/couch/index.ts"() {
    "use strict";
    init_factory();
    init_types_legacy();
    init_logger();
    init_pouchdb_setup();
    init_contentSource();
    init_adminDB2();
    init_classroomDB2();
    init_courseAPI();
    init_courseDB();
    init_CourseSyncService();
    init_CouchDBSyncStrategy();
    isBrowser = typeof window !== "undefined";
    if (isBrowser) {
      window.process = process2;
    }
    GUEST_LOCAL_DB = `userdb-${GuestUsername}`;
    localUserDB = new pouchdb_setup_default(GUEST_LOCAL_DB);
    pouchDBincludeCredentialsConfig = {
      fetch(url, opts) {
        opts.credentials = "include";
        return pouchdb_setup_default.fetch(url, opts);
      }
    };
    REVIEW_TIME_FORMAT2 = "YYYY-MM-DD--kk:mm:ss-SSS";
  }
});

// src/impl/common/BaseUserDB.ts
import { Status as Status3 } from "@vue-skuilder/common";
import moment6 from "moment";
function accomodateGuest() {
  logger.log("[funnel] accomodateGuest() called");
  if (typeof localStorage === "undefined") {
    logger.log(
      "[funnel] localStorage not available (Node.js environment), returning default guest"
    );
    return {
      username: GuestUsername + "nodejs-test",
      firstVisit: true
    };
  }
  const dbUUID = "sk-guest-uuid";
  let firstVisit;
  const existingUUID = localStorage.getItem(dbUUID);
  logger.log("[funnel] Checking localStorage for key:", dbUUID);
  logger.log("[funnel] Existing UUID value:", existingUUID);
  logger.log("[funnel] existingUUID !== null:", existingUUID !== null);
  if (existingUUID !== null) {
    firstVisit = false;
    logger.log(`[funnel] Returning guest ${existingUUID} "logging in".`);
  } else {
    firstVisit = true;
    logger.log("[funnel] No existing UUID, generating new one...");
    const uuid = generateUUID();
    logger.log("[funnel] Generated UUID:", uuid);
    logger.log("[funnel] UUID length:", uuid.length);
    try {
      localStorage.setItem(dbUUID, uuid);
      logger.log("[funnel] Successfully stored UUID in localStorage");
      const verification = localStorage.getItem(dbUUID);
      logger.log("[funnel] Verification read from localStorage:", verification);
    } catch (e) {
      logger.error("[funnel] ERROR storing UUID:", e);
    }
    logger.log(`[funnel] Accommodating a new guest with account: ${uuid}`);
  }
  const finalUUID = localStorage.getItem(dbUUID);
  const finalUsername = GuestUsername + finalUUID;
  logger.log("[funnel] Final UUID from localStorage:", finalUUID);
  logger.log("[funnel] GuestUsername constant:", GuestUsername);
  logger.log("[funnel] Final username to return:", finalUsername);
  return {
    username: finalUsername,
    firstVisit
  };
  function generateUUID() {
    logger.log("[funnel] Inside generateUUID()");
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
      const uuid2 = crypto.randomUUID();
      logger.log("[funnel] Generated UUID using crypto.randomUUID():", uuid2);
      return uuid2;
    }
    if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
      const bytes = new Uint8Array(16);
      crypto.getRandomValues(bytes);
      bytes[6] = bytes[6] & 15 | 64;
      bytes[8] = bytes[8] & 63 | 128;
      const uuid2 = [
        Array.from(bytes.slice(0, 4)).map((b) => b.toString(16).padStart(2, "0")).join(""),
        Array.from(bytes.slice(4, 6)).map((b) => b.toString(16).padStart(2, "0")).join(""),
        Array.from(bytes.slice(6, 8)).map((b) => b.toString(16).padStart(2, "0")).join(""),
        Array.from(bytes.slice(8, 10)).map((b) => b.toString(16).padStart(2, "0")).join(""),
        Array.from(bytes.slice(10, 16)).map((b) => b.toString(16).padStart(2, "0")).join("")
      ].join("-");
      logger.log("[funnel] Generated UUID using crypto.getRandomValues():", uuid2);
      return uuid2;
    }
    logger.warn("[funnel] crypto API not available, using timestamp-based UUID (NOT SECURE)");
    let d = (/* @__PURE__ */ new Date()).getTime();
    if (typeof performance !== "undefined" && typeof performance.now === "function") {
      d += performance.now();
    }
    const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      const r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === "x" ? r : r & 3 | 8).toString(16);
    });
    logger.log("[funnel] Generated UUID (fallback):", uuid);
    return uuid;
  }
}
async function getOrCreateClassroomRegistrationsDoc(user) {
  let ret;
  try {
    ret = await getLocalUserDB(user).get(userClassroomsDoc);
  } catch (e) {
    const err = e;
    if (err.status === 404) {
      await getLocalUserDB(user).put({
        _id: userClassroomsDoc,
        registrations: []
      });
      ret = await getOrCreateClassroomRegistrationsDoc(user);
    } else {
      const errorDetails = {
        name: err.name,
        status: err.status,
        message: err.message,
        reason: err.reason,
        error: err.error
      };
      logger.error(
        "Database error in getOrCreateClassroomRegistrationsDoc (standalone function):",
        errorDetails
      );
      throw new Error(
        `Database error accessing classroom registrations: ${err.message || err.name || "Unknown error"} (status: ${err.status})`
      );
    }
  }
  return ret;
}
async function getOrCreateCourseRegistrationsDoc(user) {
  let ret;
  try {
    ret = await getLocalUserDB(user).get(userCoursesDoc);
  } catch (e) {
    const err = e;
    if (err.status === 404) {
      await getLocalUserDB(user).put({
        _id: userCoursesDoc,
        courses: [],
        studyWeight: {}
      });
      ret = await getOrCreateCourseRegistrationsDoc(user);
    } else {
      throw new Error(
        `Unexpected error ${JSON.stringify(e)} in getOrCreateCourseRegistrationDoc...`
      );
    }
  }
  return ret;
}
async function updateUserElo(user, course_id, elo) {
  const regDoc = await getOrCreateCourseRegistrationsDoc(user);
  const course = regDoc.courses.find((c) => c.courseID === course_id);
  course.elo = elo;
  return getLocalUserDB(user).put(regDoc);
}
async function registerUserForClassroom(user, classID, registerAs) {
  log4(`Registering user: ${user} in course: ${classID}`);
  return getOrCreateClassroomRegistrationsDoc(user).then((doc) => {
    const regItem = {
      classID,
      registeredAs: registerAs
    };
    if (doc.registrations.filter((reg) => {
      return reg.classID === regItem.classID && reg.registeredAs === regItem.registeredAs;
    }).length === 0) {
      doc.registrations.push(regItem);
    } else {
      log4(`User ${user} is already registered for class ${classID}`);
    }
    return getLocalUserDB(user).put(doc);
  });
}
async function dropUserFromClassroom(user, classID) {
  return getOrCreateClassroomRegistrationsDoc(user).then((doc) => {
    let index = -1;
    for (let i = 0; i < doc.registrations.length; i++) {
      if (doc.registrations[i].classID === classID) {
        index = i;
      }
    }
    if (index !== -1) {
      doc.registrations.splice(index, 1);
    }
    return getLocalUserDB(user).put(doc);
  });
}
async function getUserClassrooms(user) {
  return getOrCreateClassroomRegistrationsDoc(user);
}
var log4, BaseUser, userCoursesDoc, userClassroomsDoc;
var init_BaseUserDB = __esm({
  "src/impl/common/BaseUserDB.ts"() {
    "use strict";
    init_core();
    init_util();
    init_types_legacy();
    init_logger();
    init_userDBHelpers();
    init_updateQueue();
    init_user_course_relDB();
    init_couch();
    log4 = (s) => {
      logger.info(s);
    };
    BaseUser = class _BaseUser {
      static _instance;
      static _initialized = false;
      static Dummy(syncStrategy) {
        return new _BaseUser("Me", syncStrategy);
      }
      static DOC_IDS = {
        CONFIG: "CONFIG",
        COURSE_REGISTRATIONS: "CourseRegistrations",
        CLASSROOM_REGISTRATIONS: "ClassroomRegistrations"
      };
      // private email: string;
      _username;
      syncStrategy;
      getUsername() {
        return this._username;
      }
      isLoggedIn() {
        return !this._username.startsWith(GuestUsername);
      }
      remote() {
        return this.remoteDB;
      }
      localDB;
      remoteDB;
      writeDB;
      // Database to use for write operations (local-first approach)
      updateQueue;
      async createAccount(username, password) {
        if (!this.syncStrategy.canCreateAccount()) {
          throw new Error("Account creation not supported by current sync strategy");
        }
        if (!this._username.startsWith(GuestUsername)) {
          throw new Error(
            `Cannot create a new account while logged in:
Currently logged-in as ${this._username}.`
          );
        }
        const result = await this.syncStrategy.createAccount(username, password);
        if (result.status === Status3.ok) {
          log4(`Account created successfully, updating username to ${username}`);
          this._username = username;
          try {
            localStorage.removeItem("sk-guest-uuid");
          } catch (e) {
            logger.warn("localStorage not available (Node.js environment):", e);
          }
          await this.init();
        }
        return {
          status: result.status,
          error: result.error || ""
        };
      }
      async login(username, password) {
        if (!this.syncStrategy.canAuthenticate()) {
          throw new Error("Authentication not supported by current sync strategy");
        }
        if (!this._username.startsWith(GuestUsername) && this._username != username) {
          if (this._username != username) {
            throw new Error(`Cannot change accounts while logged in.
        Log out of account ${this.getUsername()} before logging in as ${username}.`);
          }
          logger.warn(`User ${this._username} is already logged in, but executing login again.`);
        }
        const loginResult = await this.syncStrategy.authenticate(username, password);
        if (loginResult.ok) {
          log4(`Logged in as ${username}`);
          this._username = username;
          try {
            localStorage.removeItem("sk-guest-uuid");
          } catch (e) {
            logger.warn("localStorage not available (Node.js environment):", e);
          }
          await this.init();
        }
        return loginResult;
      }
      async resetUserData() {
        if (this.syncStrategy.canAuthenticate()) {
          return {
            status: Status3.error,
            error: "Reset user data is only available for local-only mode. Use logout instead for remote sync."
          };
        }
        try {
          const localDB = getLocalUserDB(this._username);
          const allDocs = await localDB.allDocs({ include_docs: false });
          const docsToDelete = allDocs.rows.filter((row) => {
            const id = row.id;
            return id.startsWith(DocTypePrefixes["CARDRECORD" /* CARDRECORD */]) || // Card interaction history
            id.startsWith(DocTypePrefixes["SCHEDULED_CARD" /* SCHEDULED_CARD */]) || // Scheduled reviews
            id.startsWith(DocTypePrefixes["STRATEGY_STATE" /* STRATEGY_STATE */]) || // Strategy state (user prefs, progression)
            id.startsWith(DocTypePrefixes["USER_OUTCOME" /* USER_OUTCOME */]) || // Evolutionary orchestration outcomes
            id.startsWith(DocTypePrefixes["STRATEGY_LEARNING_STATE" /* STRATEGY_LEARNING_STATE */]) || // Strategy learning state
            id === _BaseUser.DOC_IDS.COURSE_REGISTRATIONS || // Course registrations
            id === _BaseUser.DOC_IDS.CLASSROOM_REGISTRATIONS || // Classroom registrations
            id === _BaseUser.DOC_IDS.CONFIG;
          }).map((row) => ({ _id: row.id, _rev: row.value.rev, _deleted: true }));
          if (docsToDelete.length > 0) {
            await localDB.bulkDocs(docsToDelete);
          }
          await this.init();
          return { status: Status3.ok };
        } catch (error) {
          logger.error("Failed to reset user data:", error);
          return {
            status: Status3.error,
            error: error instanceof Error ? error.message : "Unknown error during reset"
          };
        }
      }
      async logout() {
        if (!this.syncStrategy.canAuthenticate()) {
          this._username = await this.syncStrategy.getCurrentUsername();
          await this.init();
          return { ok: true };
        }
        const ret = await this.syncStrategy.logout();
        this._username = await this.syncStrategy.getCurrentUsername();
        await this.init();
        return ret;
      }
      async get(id) {
        return this.localDB.get(id);
      }
      update(id, update) {
        return this.updateQueue.update(id, update);
      }
      async getCourseRegistrationsDoc() {
        logger.debug(`Fetching courseRegistrations for ${this.getUsername()}`);
        let ret;
        try {
          const regDoc = await this.localDB.get(
            _BaseUser.DOC_IDS.COURSE_REGISTRATIONS
          );
          return regDoc;
        } catch (e) {
          const err = e;
          if (err.status === 404) {
            await this.localDB.put({
              _id: _BaseUser.DOC_IDS.COURSE_REGISTRATIONS,
              courses: [],
              studyWeight: {}
            });
            ret = await this.getCourseRegistrationsDoc();
          } else {
            throw new Error(
              `Unexpected error ${JSON.stringify(e)} in getOrCreateCourseRegistrationDoc...`
            );
          }
        }
        return ret;
      }
      async getActiveCourses() {
        const reg = await this.getCourseRegistrationsDoc();
        return reg.courses.filter((c) => {
          return c.status === void 0 || c.status === "active";
        });
      }
      /**
       * Returns a promise of the card IDs that the user has
       * a scheduled review for.
       *
       */
      async getActiveCards() {
        const keys = getStartAndEndKeys(DocTypePrefixes["SCHEDULED_CARD" /* SCHEDULED_CARD */]);
        const reviews = await this.remoteDB.allDocs({
          startkey: keys.startkey,
          endkey: keys.endkey,
          include_docs: true
        });
        return reviews.rows.map((r) => {
          return {
            courseID: r.doc.courseId,
            cardID: r.doc.cardId
          };
        });
      }
      async getActivityRecords() {
        try {
          const hist = await this.getHistory();
          const allRecords = [];
          if (!Array.isArray(hist)) {
            logger.error("getHistory did not return an array:", hist);
            return allRecords;
          }
          let sampleCount = 0;
          for (let i = 0; i < hist.length; i++) {
            try {
              if (hist[i] && Array.isArray(hist[i].records)) {
                hist[i].records.forEach((record) => {
                  try {
                    if (!record.timeStamp) {
                      return;
                    }
                    let timeStamp;
                    if (typeof record.timeStamp === "object") {
                      if (typeof record.timeStamp.toDate === "function") {
                        timeStamp = record.timeStamp.toISOString();
                      } else if (record.timeStamp instanceof Date) {
                        timeStamp = record.timeStamp.toISOString();
                      } else {
                        if (sampleCount < 3) {
                          logger.warn("Unknown timestamp object type:", record.timeStamp);
                          sampleCount++;
                        }
                        return;
                      }
                    } else if (typeof record.timeStamp === "string") {
                      const date = new Date(record.timeStamp);
                      if (isNaN(date.getTime())) {
                        return;
                      }
                      timeStamp = record.timeStamp;
                    } else if (typeof record.timeStamp === "number") {
                      timeStamp = new Date(record.timeStamp).toISOString();
                    } else {
                      return;
                    }
                    allRecords.push({
                      timeStamp,
                      courseID: record.courseID || "unknown",
                      cardID: record.cardID || "unknown",
                      timeSpent: record.timeSpent || 0,
                      type: "card_view"
                    });
                  } catch (err) {
                  }
                });
              }
            } catch (err) {
              logger.error("Error processing history item:", err);
            }
          }
          logger.debug(`Found ${allRecords.length} activity records`);
          return allRecords;
        } catch (err) {
          logger.error("Error in getActivityRecords:", err);
          return [];
        }
      }
      async getReviewstoDate(targetDate, course_id) {
        const keys = getStartAndEndKeys(DocTypePrefixes["SCHEDULED_CARD" /* SCHEDULED_CARD */]);
        const reviews = await this.remoteDB.allDocs({
          startkey: keys.startkey,
          endkey: keys.endkey,
          include_docs: true
        });
        log4(
          `Fetching ${this._username}'s scheduled reviews${course_id ? ` for course ${course_id}` : ""}.`
        );
        return reviews.rows.filter((r) => {
          if (r.id.startsWith(DocTypePrefixes["SCHEDULED_CARD" /* SCHEDULED_CARD */])) {
            const date = moment6.utc(
              r.id.substr(DocTypePrefixes["SCHEDULED_CARD" /* SCHEDULED_CARD */].length),
              REVIEW_TIME_FORMAT
            );
            if (targetDate.isAfter(date)) {
              if (course_id === void 0 || r.doc.courseId === course_id) {
                return true;
              }
            }
          }
        }).map((r) => r.doc);
      }
      async getReviewsForcast(daysCount) {
        const time = moment6.utc().add(daysCount, "days");
        return this.getReviewstoDate(time);
      }
      async getPendingReviews(course_id) {
        const now = moment6.utc();
        return this.getReviewstoDate(now, course_id);
      }
      async getScheduledReviewCount(course_id) {
        return (await this.getPendingReviews(course_id)).length;
      }
      async getRegisteredCourses() {
        const regDoc = await this.getCourseRegistrationsDoc();
        return regDoc.courses.filter((c) => {
          return !c.status || c.status === "active" || c.status === "maintenance-mode";
        });
      }
      async getCourseRegDoc(courseID) {
        const regDocs = await this.getCourseRegistrationsDoc();
        const ret = regDocs.courses.find((c) => c.courseID === courseID);
        if (ret) {
          return ret;
        } else {
          throw new Error(`Course registration not found for course ID: ${courseID}`);
        }
      }
      async registerForCourse(course_id, previewMode = false) {
        return this.getCourseRegistrationsDoc().then((doc) => {
          const status = previewMode ? "preview" : "active";
          logger.debug(`Registering for ${course_id} with status: ${status}`);
          const regItem = {
            status,
            courseID: course_id,
            user: true,
            admin: false,
            moderator: false,
            elo: {
              global: {
                score: 1e3,
                count: 0
              },
              tags: {},
              misc: {}
            }
          };
          if (doc.courses.filter((course) => {
            return course.courseID === regItem.courseID;
          }).length === 0) {
            log4(`It's a new course registration!`);
            doc.courses.push(regItem);
            doc.studyWeight[course_id] = 1;
          } else {
            doc.courses.forEach((c) => {
              log4(`Found the previously registered course!`);
              if (c.courseID === course_id) {
                c.status = status;
              }
            });
          }
          return this.localDB.put(doc);
        }).catch((e) => {
          log4(`Registration failed because of: ${JSON.stringify(e)}`);
          throw e;
        });
      }
      async dropCourse(course_id, dropStatus = "dropped") {
        return this.getCourseRegistrationsDoc().then((doc) => {
          let index = -1;
          for (let i = 0; i < doc.courses.length; i++) {
            if (doc.courses[i].courseID === course_id) {
              index = i;
            }
          }
          if (index !== -1) {
            delete doc.studyWeight[course_id];
            doc.courses[index].status = dropStatus;
          } else {
            throw new Error(
              `User ${this.getUsername()} is not currently registered for course ${course_id}`
            );
          }
          return this.localDB.put(doc);
        });
      }
      async getCourseInterface(courseId) {
        return new UsrCrsData(this, courseId);
      }
      async getUserEditableCourses() {
        let courseIDs = [];
        const registeredCourses = await this.getCourseRegistrationsDoc();
        courseIDs = courseIDs.concat(
          registeredCourses.courses.map((course) => {
            return course.courseID;
          })
        );
        const cfgs = await Promise.all(
          courseIDs.map(async (id) => {
            return await getCredentialledCourseConfig(id);
          })
        );
        return cfgs;
      }
      async getConfig() {
        const defaultConfig = {
          _id: _BaseUser.DOC_IDS.CONFIG,
          darkMode: false,
          likesConfetti: false,
          sessionTimeLimit: 5
        };
        try {
          const cfg = await this.localDB.get(_BaseUser.DOC_IDS.CONFIG);
          logger.debug("Raw config from DB:", cfg);
          return cfg;
        } catch (e) {
          const err = e;
          if (err.name && err.name === "not_found") {
            await this.localDB.put(defaultConfig);
            return this.getConfig();
          } else {
            logger.error(`Error setting user default config:`, e);
            throw new Error(`Error returning the user's configuration: ${JSON.stringify(e)}`);
          }
        }
      }
      async setConfig(items) {
        logger.debug(`Setting Config items ${JSON.stringify(items)}`);
        const c = await this.getConfig();
        const put = await this.localDB.put({
          ...c,
          ...items
        });
        if (put.ok) {
          logger.debug(`Config items set: ${JSON.stringify(items)}`);
        } else {
          logger.error(`Error setting config items: ${JSON.stringify(put)}`);
        }
      }
      /**
       *
       * This function should be called *only* by the pouchdb datalayer provider
       * auth store.
       *
       *
       * Anyone else seeking the current user should use the auth store's
       * exported `getCurrentUser` method.
       *
       */
      static async instance(syncStrategy, username) {
        if (username) {
          _BaseUser._instance = new _BaseUser(username, syncStrategy);
          await _BaseUser._instance.init();
          return _BaseUser._instance;
        } else if (_BaseUser._instance && _BaseUser._initialized) {
          return _BaseUser._instance;
        } else if (_BaseUser._instance) {
          return new Promise((resolve) => {
            (function waitForUser() {
              if (_BaseUser._initialized) {
                return resolve(_BaseUser._instance);
              } else {
                setTimeout(waitForUser, 50);
              }
            })();
          });
        } else {
          const guestUsername = await syncStrategy.getCurrentUsername();
          _BaseUser._instance = new _BaseUser(guestUsername, syncStrategy);
          await _BaseUser._instance.init();
          return _BaseUser._instance;
        }
      }
      constructor(username, syncStrategy) {
        _BaseUser._initialized = false;
        this._username = username;
        this.syncStrategy = syncStrategy;
        this.setDBandQ();
      }
      setDBandQ() {
        this.localDB = getLocalUserDB(this._username);
        this.remoteDB = this.syncStrategy.setupRemoteDB(this._username);
        this.writeDB = this.syncStrategy.getWriteDB ? this.syncStrategy.getWriteDB(this._username) : this.localDB;
        this.updateQueue = new UpdateQueue(this.localDB, this.writeDB);
      }
      async init() {
        _BaseUser._initialized = false;
        if (this._username === "admin") {
          _BaseUser._initialized = true;
          return;
        }
        this.setDBandQ();
        this.syncStrategy.startSync(this.localDB, this.remoteDB);
        this.applyDesignDocs().catch((error) => {
          log4(`Error in applyDesignDocs background task: ${error}`);
          if (error && typeof error === "object") {
            log4(`Full error details in applyDesignDocs: ${JSON.stringify(error)}`);
          }
        });
        this.deduplicateReviews().catch((error) => {
          log4(`Error in deduplicateReviews background task: ${error}`);
          if (error && typeof error === "object") {
            log4(`Full error details in background task: ${JSON.stringify(error)}`);
          }
        });
        _BaseUser._initialized = true;
      }
      static designDocs = [
        {
          _id: "_design/reviewCards",
          views: {
            reviewCards: {
              map: `function (doc) {
            if (doc._id && doc._id.indexOf('card_review') === 0 && doc.courseId && doc.cardId) {
              emit(doc._id, doc.courseId + '-' + doc.cardId);
            }
          }`
            }
          }
        }
      ];
      async applyDesignDocs() {
        log4(`Starting applyDesignDocs for user: ${this._username}`);
        log4(`Remote DB name: ${this.remoteDB.name || "unknown"}`);
        if (this._username === "admin") {
          log4("Skipping design docs for admin user");
          return;
        }
        log4(`Applying ${_BaseUser.designDocs.length} design docs`);
        for (const doc of _BaseUser.designDocs) {
          log4(`Applying design doc: ${doc._id}`);
          try {
            try {
              const existingDoc = await this.remoteDB.get(doc._id);
              await this.remoteDB.put({
                ...doc,
                _rev: existingDoc._rev
              });
            } catch (e) {
              if (e?.name === "not_found") {
                await this.remoteDB.put(doc);
              } else {
                throw e;
              }
            }
          } catch (error) {
            if (error.name && error.name === "conflict") {
              logger.warn(`Design doc ${doc._id} update conflict - will retry`);
              await new Promise((resolve) => setTimeout(resolve, 1e3));
              await this.applyDesignDoc(doc);
            } else {
              logger.error(`Failed to apply design doc ${doc._id}:`, error);
              throw error;
            }
          }
        }
      }
      // Helper method for single doc update with retry
      async applyDesignDoc(doc, retries = 3) {
        try {
          const existingDoc = await this.remoteDB.get(doc._id);
          await this.remoteDB.put({
            ...doc,
            _rev: existingDoc._rev
          });
        } catch (e) {
          if (e?.name === "conflict" && retries > 0) {
            await new Promise((resolve) => setTimeout(resolve, 1e3));
            return this.applyDesignDoc(doc, retries - 1);
          }
          throw e;
        }
      }
      /**
       * Logs a record of the user's interaction with the card and returns the card's
       * up-to-date history.
       *
       * **Automatic Initialization:**
       * If this is the user's first interaction with the card (CardHistory doesn't exist),
       * this method automatically creates the CardHistory document with initial values
       * (lapses: 0, streak: 0, bestInterval: 0).
       *
       * **Error Handling:**
       * - Handles 404 errors by creating initial CardHistory document
       * - Re-throws all other errors from UpdateQueue
       *
       * // [ ] #db-refactor extract to a smaller scope - eg, UserStudySession
       *
       * @param record - The recent recorded interaction between user and card
       * @returns The updated state of the card's CardHistory data
       * @throws Error if document creation fails or non-404 database error occurs
       */
      async putCardRecord(record) {
        const cardHistoryID = getCardHistoryID(record.courseID, record.cardID);
        record.timeStamp = moment6.utc(record.timeStamp).toString();
        try {
          const cardHistory = await this.update(
            cardHistoryID,
            function(h) {
              h.records.push(record);
              h.bestInterval = h.bestInterval || 0;
              h.lapses = h.lapses || 0;
              h.streak = h.streak || 0;
              return h;
            }
          );
          cardHistory.records = cardHistory.records.map((record2) => {
            const ret = {
              ...record2
            };
            ret.timeStamp = moment6.utc(record2.timeStamp);
            return ret;
          });
          return cardHistory;
        } catch (e) {
          const reason = e;
          if (reason.status === 404) {
            try {
              const initCardHistory = {
                _id: cardHistoryID,
                cardID: record.cardID,
                courseID: record.courseID,
                records: [record],
                lapses: 0,
                streak: 0,
                bestInterval: 0
              };
              const putResult = await this.writeDB.put(initCardHistory);
              return { ...initCardHistory, _rev: putResult.rev };
            } catch (creationError) {
              throw new Error(
                `Failed to create CardHistory for ${cardHistoryID}. Reason: ${creationError}`
              );
            }
          } else {
            throw new Error(`putCardRecord failed because of:
  name:${reason.name}
  error: ${reason.error}
  message: ${reason.message}`);
          }
        }
      }
      async deduplicateReviews() {
        try {
          log4("Starting deduplication of scheduled reviews...");
          log4(`Remote DB name: ${this.remoteDB.name || "unknown"}`);
          log4(`Write DB name: ${this.writeDB.name || "unknown"}`);
          const reviewsMap = {};
          const duplicateDocIds = [];
          log4(
            `Attempting to query remoteDB for reviewCards/reviewCards. Database: ${this.remoteDB.name || "unknown"}`
          );
          const scheduledReviews = await this.remoteDB.query("reviewCards/reviewCards");
          log4(`Found ${scheduledReviews.rows.length} scheduled reviews to process`);
          scheduledReviews.rows.forEach((r) => {
            const qualifiedCardId = r.value;
            const docId = r.key;
            if (reviewsMap[qualifiedCardId]) {
              log4(`Found duplicate scheduled review for card: ${qualifiedCardId}`);
              log4(
                `Marking earlier review ${reviewsMap[qualifiedCardId]} for deletion, keeping ${docId}`
              );
              duplicateDocIds.push(reviewsMap[qualifiedCardId]);
              reviewsMap[qualifiedCardId] = docId;
            } else {
              reviewsMap[qualifiedCardId] = docId;
            }
          });
          if (duplicateDocIds.length > 0) {
            log4(`Removing ${duplicateDocIds.length} duplicate reviews...`);
            const deletePromises = duplicateDocIds.map(async (docId) => {
              try {
                const doc = await this.remoteDB.get(docId);
                await this.writeDB.remove(doc);
                log4(`Successfully removed duplicate review: ${docId}`);
              } catch (error) {
                log4(`Failed to remove duplicate review ${docId}: ${error}`);
              }
            });
            await Promise.all(deletePromises);
            log4(`Deduplication complete. Processed ${duplicateDocIds.length} duplicates`);
          } else {
            log4("No duplicate reviews found");
          }
        } catch (error) {
          log4(`Error during review deduplication: ${error}`);
          if (error && typeof error === "object" && "status" in error && error.status === 404) {
            log4(
              `Database not found (404) during review deduplication. Database: ${this.remoteDB.name || "unknown"}`
            );
            log4(
              `This might indicate the user database doesn't exist or the reviewCards view isn't available`
            );
          }
          if (error && typeof error === "object") {
            log4(`Full error details: ${JSON.stringify(error)}`);
          }
        }
      }
      /**
       * Returns a promise of the card IDs that the user has
       * encountered in the past.
       *
       * @param course_id optional specification of individual course
       */
      async getSeenCards(course_id) {
        const basePrefix = DocTypePrefixes["CARDRECORD" /* CARDRECORD */];
        let filterPrefix = basePrefix;
        if (course_id) {
          filterPrefix += `-${course_id}-`;
        }
        const docs = await filterAllDocsByPrefix(this.localDB, filterPrefix, {
          include_docs: false
        });
        const ret = [];
        docs.rows.forEach((row) => {
          if (row.id.startsWith(filterPrefix)) {
            ret.push(row.id.substr(filterPrefix.length));
          }
        });
        return ret;
      }
      /**
       *
       * @returns A promise of the cards that the user has seen in the past.
       */
      async getHistory() {
        const cards = await filterAllDocsByPrefix(
          this.remoteDB,
          DocTypePrefixes["CARDRECORD" /* CARDRECORD */],
          {
            include_docs: true,
            attachments: false
          }
        );
        return cards.rows.map((r) => r.doc);
      }
      async updateCourseSettings(course_id, settings) {
        void this.getCourseRegistrationsDoc().then((doc) => {
          const crs = doc.courses.find((c) => c.courseID === course_id);
          if (crs) {
            if (crs.settings === null || crs.settings === void 0) {
              crs.settings = {};
            }
            settings.forEach((setting) => {
              crs.settings[setting.key] = setting.value;
            });
          }
          return this.localDB.put(doc);
        });
      }
      async getCourseSettings(course_id) {
        const regDoc = await this.getCourseRegistrationsDoc();
        const crsDoc = regDoc.courses.find((c) => c.courseID === course_id);
        if (crsDoc) {
          return crsDoc.settings;
        } else {
          throw new Error(`getCourseSettings Failed:
      User is not registered for course ${course_id}`);
        }
      }
      async getOrCreateClassroomRegistrationsDoc() {
        let ret;
        try {
          ret = await this.remoteDB.get(
            _BaseUser.DOC_IDS.CLASSROOM_REGISTRATIONS
          );
        } catch (e) {
          const err = e;
          if (err.status === 404) {
            await this.writeDB.put({
              _id: _BaseUser.DOC_IDS.CLASSROOM_REGISTRATIONS,
              registrations: []
            });
            ret = await this.getOrCreateClassroomRegistrationsDoc();
          } else {
            const errorDetails = {
              name: err.name,
              status: err.status,
              message: err.message,
              reason: err.reason,
              error: err.error
            };
            logger.error(
              "Database error in getOrCreateClassroomRegistrationsDoc (private method):",
              errorDetails
            );
            throw new Error(
              `Database error accessing classroom registrations: ${err.message || err.name || "Unknown error"} (status: ${err.status})`
            );
          }
        }
        logger.debug(`Returning classroom registrations doc: ${JSON.stringify(ret)}`);
        return ret;
      }
      /**
       * Retrieves the list of active classroom IDs where the user is registered as a student.
       *
       * @returns Promise<string[]> - Array of classroom IDs, or empty array if classroom
       *                              registration document is unavailable due to database errors
       *
       * @description This method gracefully handles database connectivity issues by returning
       *              an empty array when the classroom registrations document cannot be accessed.
       *              This ensures that users can still access other application features even
       *              when classroom functionality is temporarily unavailable.
       */
      async getActiveClasses() {
        try {
          return (await this.getOrCreateClassroomRegistrationsDoc()).registrations.filter((c) => c.registeredAs === "student").map((c) => c.classID);
        } catch (error) {
          logger.warn(
            "Failed to load classroom registrations, continuing without classroom data:",
            error
          );
          return [];
        }
      }
      async scheduleCardReview(review) {
        return scheduleCardReviewLocal(this.writeDB, review);
      }
      async removeScheduledCardReview(reviewId) {
        return removeScheduledCardReviewLocal(this.writeDB, reviewId);
      }
      async registerForClassroom(_classId, _registerAs) {
        return registerUserForClassroom(this._username, _classId, _registerAs);
      }
      async dropFromClassroom(classId) {
        return dropUserFromClassroom(this._username, classId);
      }
      async getUserClassrooms() {
        return getUserClassrooms(this._username);
      }
      async updateUserElo(courseId, elo) {
        return updateUserElo(this._username, courseId, elo);
      }
      async getStrategyState(courseId, strategyKey) {
        const docId = buildStrategyStateId(courseId, strategyKey);
        try {
          const doc = await this.localDB.get(docId);
          return doc.data;
        } catch (e) {
          const err = e;
          if (err.status === 404) {
            return null;
          }
          throw e;
        }
      }
      async putStrategyState(courseId, strategyKey, data) {
        const docId = buildStrategyStateId(courseId, strategyKey);
        let existingRev;
        try {
          const existing = await this.localDB.get(docId);
          existingRev = existing._rev;
        } catch (e) {
          const err = e;
          if (err.status !== 404) {
            throw e;
          }
        }
        const doc = {
          _id: docId,
          _rev: existingRev,
          docType: "STRATEGY_STATE" /* STRATEGY_STATE */,
          courseId,
          strategyKey,
          data,
          updatedAt: (/* @__PURE__ */ new Date()).toISOString()
        };
        await this.localDB.put(doc);
      }
      async putUserOutcome(record) {
        try {
          await this.localDB.put(record);
        } catch (err) {
          if (err.status === 409) {
            const existing = await this.localDB.get(record._id);
            record._rev = existing._rev;
            await this.localDB.put(record);
          } else {
            throw err;
          }
        }
      }
      async deleteStrategyState(courseId, strategyKey) {
        const docId = buildStrategyStateId(courseId, strategyKey);
        try {
          const doc = await this.localDB.get(docId);
          await this.localDB.remove(doc);
        } catch (e) {
          const err = e;
          if (err.status === 404) {
            return;
          }
          throw e;
        }
      }
    };
    userCoursesDoc = "CourseRegistrations";
    userClassroomsDoc = "ClassroomRegistrations";
  }
});

// src/impl/common/index.ts
var init_common = __esm({
  "src/impl/common/index.ts"() {
    "use strict";
    init_SyncStrategy();
    init_BaseUserDB();
    init_userDBHelpers();
  }
});

// src/impl/couch/PouchDataLayerProvider.ts
var PouchDataLayerProvider_exports = {};
__export(PouchDataLayerProvider_exports, {
  CouchDataLayerProvider: () => CouchDataLayerProvider
});
var CouchDataLayerProvider;
var init_PouchDataLayerProvider = __esm({
  "src/impl/couch/PouchDataLayerProvider.ts"() {
    "use strict";
    init_logger();
    init_dataDirectory();
    init_auth();
    init_adminDB2();
    init_classroomDB2();
    init_courseDB();
    init_CourseSyncService();
    init_common();
    init_CouchDBSyncStrategy();
    CouchDataLayerProvider = class {
      initialized = false;
      userDB;
      currentUsername = "";
      // the scoped list of courseIDs for a UI focused on a specific course
      // or group of courses
      _courseIDs = [];
      constructor(coursIDs) {
        if (coursIDs) {
          this._courseIDs = coursIDs;
        }
      }
      async initialize() {
        if (this.initialized) return;
        const isNodeEnvironment = typeof process !== "undefined" && process.versions != null && process.versions.node != null;
        if (isNodeEnvironment) {
          logger.info(
            "CouchDataLayerProvider: Running in Node.js environment, creating guest UserDB for testing."
          );
          await initializeDataDirectory();
          const syncStrategy = new CouchDBSyncStrategy();
          this.userDB = await BaseUser.instance(syncStrategy);
        } else {
          const syncStrategy = new CouchDBSyncStrategy();
          this.userDB = await BaseUser.instance(syncStrategy);
          this.currentUsername = this.userDB.getUsername();
          logger.debug(`Current username: ${this.currentUsername}`);
        }
        this.initialized = true;
      }
      async teardown() {
        this.initialized = false;
      }
      getUserDB() {
        return this.userDB;
      }
      getCourseDB(courseId) {
        const localDB = CourseSyncService.getInstance().getLocalDB(courseId);
        return new CourseDB(courseId, async () => this.getUserDB(), localDB ?? void 0);
      }
      /**
       * Trigger local sync for a course. Call during app initialization or
       * pre-session loading for courses that opt in via CourseConfig.localSync.
       *
       * Safe to call multiple times — concurrent calls coalesce. Returns when
       * sync is complete (or immediately if already synced / disabled).
       *
       * @param courseId - The course to sync locally
       * @param forceEnabled - Skip CourseConfig check and sync regardless.
       *   Use when the caller already knows local sync is desired.
       */
      async ensureCourseSynced(courseId, forceEnabled) {
        return CourseSyncService.getInstance().ensureSynced(courseId, forceEnabled);
      }
      getCoursesDB() {
        return new CoursesDB(this._courseIDs);
      }
      async getClassroomDB(classId, type) {
        if (type === "student") {
          return await StudentClassroomDB.factory(classId, this.getUserDB());
        } else {
          return await TeacherClassroomDB.factory(classId);
        }
      }
      getAdminDB() {
        return new AdminDB();
      }
      async createUserReaderForUser(targetUsername) {
        const requestingUsername = await getLoggedInUsername();
        if (requestingUsername !== "admin") {
          throw new Error("Unauthorized: Only admin users can access other users' data");
        }
        logger.info(`Admin user '${requestingUsername}' requesting UserDBReader for '${targetUsername}'`);
        const syncStrategy = new CouchDBSyncStrategy();
        const targetUserDB = await BaseUser.instance(syncStrategy, targetUsername);
        return targetUserDB;
      }
      isReadOnly() {
        return false;
      }
    };
  }
});

// src/impl/static/StaticDataUnpacker.ts
var pathUtils, nodeFS, StaticDataUnpacker;
var init_StaticDataUnpacker = __esm({
  "src/impl/static/StaticDataUnpacker.ts"() {
    "use strict";
    init_logger();
    init_core();
    pathUtils = {
      isAbsolute: (path2) => {
        if (/^[a-zA-Z]:[\\/]/.test(path2) || /^\\\\/.test(path2)) {
          return true;
        }
        if (path2.startsWith("/")) {
          return true;
        }
        return false;
      }
    };
    nodeFS = null;
    try {
      if (typeof window === "undefined" && typeof process !== "undefined" && process.versions?.node) {
        nodeFS = eval("require")("fs");
      }
    } catch {
    }
    StaticDataUnpacker = class {
      manifest;
      basePath;
      documentCache = /* @__PURE__ */ new Map();
      chunkCache = /* @__PURE__ */ new Map();
      indexCache = /* @__PURE__ */ new Map();
      constructor(manifest, basePath) {
        this.manifest = manifest;
        this.basePath = basePath;
      }
      /**
       * Get a document by ID, loading from appropriate chunk if needed
       */
      async getDocument(id) {
        if (this.documentCache.has(id)) {
          const doc = this.documentCache.get(id);
          return await this.hydrateAttachments(doc);
        }
        const chunk = await this.findChunkForDocument(id);
        if (!chunk) {
          logger.error(
            `Document ${id} not found in any chunk. Available chunks:`,
            this.manifest.chunks.map((c) => `${c.id} (${c.docType}): ${c.startKey} - ${c.endKey}`)
          );
          throw new Error(`Document ${id} not found in any chunk`);
        }
        await this.loadChunk(chunk.id);
        if (this.documentCache.has(id)) {
          const doc = this.documentCache.get(id);
          return await this.hydrateAttachments(doc);
        }
        logger.error(`Document ${id} not found in chunk ${chunk.id}`);
        throw new Error(`Document ${id} not found in chunk ${chunk.id}`);
      }
      /**
       * Get all documents with IDs starting with a specific prefix.
       *
       * This method loads the relevant chunk(s) and returns all matching documents.
       * Useful for querying documents by type (e.g., all NAVIGATION_STRATEGY documents).
       *
       * @param prefix - Document ID prefix to match (e.g., "NAVIGATION_STRATEGY")
       * @returns Array of all documents with IDs starting with the prefix
       */
      async getAllDocumentsByPrefix(prefix) {
        const relevantChunks = this.manifest.chunks.filter((chunk) => {
          const prefixEnd = prefix + "\uFFF0";
          return chunk.startKey <= prefixEnd && chunk.endKey >= prefix;
        });
        if (relevantChunks.length === 0) {
          logger.debug(`[StaticDataUnpacker] No chunks found for prefix: ${prefix}`);
          return [];
        }
        await Promise.all(relevantChunks.map((chunk) => this.loadChunk(chunk.id)));
        const matchingDocs = [];
        for (const [docId, doc] of this.documentCache.entries()) {
          if (docId.startsWith(prefix)) {
            matchingDocs.push(await this.hydrateAttachments(doc));
          }
        }
        logger.debug(
          `[StaticDataUnpacker] Found ${matchingDocs.length} documents with prefix: ${prefix}`
        );
        return matchingDocs;
      }
      /**
       * Query cards by ELO score, returning card IDs sorted by ELO
       */
      async queryByElo(targetElo, limit = 25) {
        const eloIndex = await this.loadIndex("elo");
        if (!eloIndex || !eloIndex.sorted) {
          logger.warn("ELO index not found or malformed, returning empty results");
          return [];
        }
        const sorted = eloIndex.sorted;
        let startIndex = 0;
        let left = 0;
        let right = sorted.length - 1;
        while (left <= right) {
          const mid = Math.floor((left + right) / 2);
          if (sorted[mid].elo < targetElo) {
            left = mid + 1;
          } else {
            right = mid - 1;
          }
        }
        startIndex = left;
        const result = [];
        const halfLimit = Math.floor(limit / 2);
        for (let i = Math.max(0, startIndex - halfLimit); i < startIndex && result.length < limit; i++) {
          result.push(sorted[i].cardId);
        }
        for (let i = startIndex; i < sorted.length && result.length < limit; i++) {
          result.push(sorted[i].cardId);
        }
        return result;
      }
      /**
       * Get all tag names mapped to their card arrays
       */
      async getTagsIndex() {
        try {
          return await this.loadIndex("tags");
        } catch {
          return {
            byCard: {},
            byTag: {}
          };
        }
      }
      getDocTypeFromId(id) {
        for (const docTypeKey in DocTypePrefixes) {
          const prefix = DocTypePrefixes[docTypeKey];
          if (id.startsWith(`${prefix}-`)) {
            return docTypeKey;
          }
        }
        return void 0;
      }
      /**
       * Find which chunk contains a specific document ID
       */
      async findChunkForDocument(docId) {
        const expectedDocType = this.getDocTypeFromId(docId);
        if (expectedDocType) {
          const typeChunks = this.manifest.chunks.filter((c) => c.docType === expectedDocType);
          for (const chunk of typeChunks) {
            if (docId >= chunk.startKey && docId <= chunk.endKey) {
              const exists = await this.verifyDocumentInChunk(docId, chunk);
              if (exists) {
                return chunk;
              }
            }
          }
        } else {
          for (const chunk of this.manifest.chunks) {
            if (docId >= chunk.startKey && docId <= chunk.endKey) {
              const exists = await this.verifyDocumentInChunk(docId, chunk);
              if (exists) {
                return chunk;
              }
            }
          }
          const otherChunks = this.manifest.chunks.filter(
            (c) => c.docType !== "CARD" && c.docType !== "DISPLAYABLE_DATA" && c.docType !== "TAG"
          );
          for (const chunk of otherChunks) {
            if (docId >= chunk.startKey && docId <= chunk.endKey) {
              const exists = await this.verifyDocumentInChunk(docId, chunk);
              if (exists) {
                return chunk;
              }
            }
          }
          return void 0;
        }
        return void 0;
      }
      /**
       * Verify that a document actually exists in a specific chunk by loading and checking it
       */
      async verifyDocumentInChunk(docId, chunk) {
        try {
          await this.loadChunk(chunk.id);
          return this.documentCache.has(docId);
        } catch {
          return false;
        }
      }
      /**
       * Load a chunk file and cache its documents
       */
      async loadChunk(chunkId) {
        if (this.chunkCache.has(chunkId)) {
          return;
        }
        const chunk = this.manifest.chunks.find((c) => c.id === chunkId);
        if (!chunk) {
          throw new Error(`Chunk ${chunkId} not found in manifest`);
        }
        try {
          const chunkPath = `${this.basePath}/${chunk.path}`;
          logger.debug(`Loading chunk from ${chunkPath}`);
          let documents;
          if (this.isLocalPath(chunkPath) && nodeFS) {
            const fileContent = await nodeFS.promises.readFile(chunkPath, "utf8");
            documents = JSON.parse(fileContent);
          } else {
            const response = await fetch(chunkPath);
            if (!response.ok) {
              throw new Error(
                `Failed to fetch chunk ${chunkId}: ${response.status} ${response.statusText}`
              );
            }
            documents = await response.json();
          }
          this.chunkCache.set(chunkId, documents);
          for (const doc of documents) {
            if (doc._id) {
              this.documentCache.set(doc._id, doc);
            }
          }
          logger.debug(`Loaded ${documents.length} documents from chunk ${chunkId}`);
        } catch (error) {
          logger.error(`Failed to load chunk ${chunkId}:`, error);
          throw error;
        }
      }
      /**
       * Load an index file and cache it
       */
      async loadIndex(indexName) {
        if (this.indexCache.has(indexName)) {
          return this.indexCache.get(indexName);
        }
        const indexMeta = this.manifest.indices.find((idx) => idx.name === indexName);
        if (!indexMeta) {
          throw new Error(`Index ${indexName} not found in manifest`);
        }
        try {
          const indexPath = `${this.basePath}/${indexMeta.path}`;
          logger.debug(`Loading index from ${indexPath}`);
          let indexData;
          if (this.isLocalPath(indexPath) && nodeFS) {
            const fileContent = await nodeFS.promises.readFile(indexPath, "utf8");
            indexData = JSON.parse(fileContent);
          } else {
            const response = await fetch(indexPath);
            if (!response.ok) {
              throw new Error(
                `Failed to fetch index ${indexName}: ${response.status} ${response.statusText}`
              );
            }
            indexData = await response.json();
          }
          this.indexCache.set(indexName, indexData);
          logger.debug(`Loaded index ${indexName}`);
          return indexData;
        } catch (error) {
          logger.error(`Failed to load index ${indexName}:`, error);
          throw error;
        }
      }
      /**
       * Get a document by ID without hydration (raw document access)
       * Used internally to avoid recursion during attachment hydration
       */
      async getRawDocument(id) {
        if (this.documentCache.has(id)) {
          return this.documentCache.get(id);
        }
        const chunk = await this.findChunkForDocument(id);
        if (!chunk) {
          logger.error(
            `Document ${id} not found in any chunk. Available chunks:`,
            this.manifest.chunks.map((c) => `${c.id} (${c.docType}): ${c.startKey} - ${c.endKey}`)
          );
          throw new Error(`Document ${id} not found in any chunk`);
        }
        await this.loadChunk(chunk.id);
        if (this.documentCache.has(id)) {
          return this.documentCache.get(id);
        }
        logger.error(`Document ${id} not found in chunk ${chunk.id}`);
        throw new Error(`Document ${id} not found in chunk ${chunk.id}`);
      }
      /**
       * Get attachment URL for a given document and attachment name
       */
      getAttachmentUrl(docId, attachmentName) {
        return `${this.basePath}/attachments/${docId}/${attachmentName}`;
      }
      /**
       * Load attachment data from the document and get the correct file path
       * Uses raw document access to avoid recursion with hydration
       */
      async getAttachmentPath(docId, attachmentName) {
        try {
          const doc = await this.getRawDocument(docId);
          if (doc._attachments && doc._attachments[attachmentName]) {
            const attachment = doc._attachments[attachmentName];
            if (attachment.path) {
              return `${this.basePath}/${attachment.path}`;
            }
          }
          return null;
        } catch {
          return null;
        }
      }
      /**
       * Load attachment as a blob (for browser) or buffer (for Node.js)
       */
      async getAttachmentBlob(docId, attachmentName) {
        const attachmentPath = await this.getAttachmentPath(docId, attachmentName);
        if (!attachmentPath) {
          return null;
        }
        try {
          if (this.isLocalPath(attachmentPath) && nodeFS) {
            const buffer = await nodeFS.promises.readFile(attachmentPath);
            return buffer;
          } else {
            const response = await fetch(attachmentPath);
            if (!response.ok) {
              throw new Error(
                `Failed to fetch attachment ${docId}/${attachmentName}: ${response.status} ${response.statusText}`
              );
            }
            return await response.blob();
          }
        } catch (error) {
          logger.error(`Failed to load attachment ${docId}/${attachmentName}:`, error);
          return null;
        }
      }
      /**
       * Hydrate document attachments by converting file paths to blob URLs
       */
      async hydrateAttachments(doc) {
        const typedDoc = doc;
        if (!typedDoc._attachments) {
          return doc;
        }
        const hydratedDoc = JSON.parse(JSON.stringify(doc));
        for (const [attachmentName, attachment] of Object.entries(typedDoc._attachments)) {
          const attachmentData = attachment;
          if (attachmentData.path) {
            try {
              const blob = await this.getAttachmentBlob(typedDoc._id, attachmentName);
              if (blob) {
                if (typeof window !== "undefined" && window.URL) {
                  hydratedDoc._attachments[attachmentName] = {
                    ...attachmentData,
                    data: blob,
                    stub: false
                    // Indicates this contains actual data, not just metadata
                  };
                } else {
                  hydratedDoc._attachments[attachmentName] = {
                    ...attachmentData,
                    buffer: blob
                    // Attach buffer for Node.js use
                  };
                }
              } else {
                logger.warn(
                  `[hydrateAttachments] getAttachmentBlob returned null for ${typedDoc._id}/${attachmentName}. Skipping hydration for this attachment.`
                );
              }
            } catch (error) {
              logger.warn(
                `[hydrateAttachments] Failed to hydrate attachment ${typedDoc._id}/${attachmentName}:`,
                error
              );
            }
          } else {
            logger.debug(
              `[hydrateAttachments] Attachment ${attachmentName} for doc ${typedDoc._id} has no path. Skipping blob conversion.`
            );
          }
        }
        return hydratedDoc;
      }
      /**
       * Clear all caches (useful for testing or memory management)
       */
      clearCaches() {
        this.documentCache.clear();
        this.chunkCache.clear();
        this.indexCache.clear();
      }
      /**
       * Get cache statistics for debugging
       */
      getCacheStats() {
        return {
          documents: this.documentCache.size,
          chunks: this.chunkCache.size,
          indices: this.indexCache.size
        };
      }
      /**
       * Check if a path is a local file path (vs URL)
       */
      isLocalPath(filePath) {
        return !filePath.startsWith("http://") && !filePath.startsWith("https://") && (pathUtils.isAbsolute(filePath) || filePath.startsWith("./") || filePath.startsWith("../"));
      }
    };
  }
});

// src/impl/static/courseDB.ts
import { Status as Status4 } from "@vue-skuilder/common";
var StaticCourseDB;
var init_courseDB2 = __esm({
  "src/impl/static/courseDB.ts"() {
    "use strict";
    init_types_legacy();
    init_logger();
    init_defaults();
    init_PipelineAssembler();
    StaticCourseDB = class {
      constructor(courseId, unpacker, userDB, manifest) {
        this.courseId = courseId;
        this.unpacker = unpacker;
        this.userDB = userDB;
        this.manifest = manifest;
      }
      getCourseID() {
        return this.courseId;
      }
      async getCourseConfig() {
        if (this.manifest.courseConfig != null) {
          return this.manifest.courseConfig;
        } else {
          throw new Error(`Course config not found for course ${this.courseId}`);
        }
      }
      async updateCourseConfig(_cfg) {
        throw new Error("Cannot update course config in static mode");
      }
      async getCourseInfo() {
        const cardCount = this.manifest.chunks.filter((chunk) => chunk.docType === "CARD" /* CARD */).reduce((total, chunk) => total + chunk.documentCount, 0);
        return {
          cardCount,
          registeredUsers: 0
          // Always 0 in static mode
        };
      }
      async getCourseDoc(id, _options) {
        return this.unpacker.getDocument(id);
      }
      async getCourseDocs(ids, _options) {
        const rows = await Promise.all(
          ids.map(async (id) => {
            try {
              const doc = await this.unpacker.getDocument(id);
              return {
                id,
                key: id,
                value: { rev: "1-static" },
                doc
              };
            } catch {
              return {
                key: id,
                error: "not_found"
              };
            }
          })
        );
        return {
          total_rows: ids.length,
          offset: 0,
          rows
        };
      }
      async getCardsByELO(elo, limit) {
        return (await this.unpacker.queryByElo(elo, limit || 25)).map((card) => {
          const [courseID, cardID, elo2] = card.split("-");
          return { courseID, cardID, elo: elo2 ? parseInt(elo2) : void 0 };
        });
      }
      async getCardEloData(cardIds) {
        const results = await Promise.all(
          cardIds.map(async (id) => {
            try {
              const card = await this.unpacker.getDocument(id);
              return card.elo || { global: { score: 1e3, count: 0 }, tags: {}, misc: {} };
            } catch {
              return { global: { score: 1e3, count: 0 }, tags: {}, misc: {} };
            }
          })
        );
        return results;
      }
      async updateCardElo(cardId, _elo) {
        return { ok: true, id: cardId, rev: "1-static" };
      }
      async getCardsCenteredAtELO(options, filter) {
        let targetElo = typeof options.elo === "number" ? options.elo : 1e3;
        if (options.elo === "user") {
          try {
            const regDoc = await this.userDB.getCourseRegistrationsDoc();
            const courseReg = regDoc.courses.find((c) => c.courseID === this.courseId);
            if (courseReg && typeof courseReg.elo === "object") {
              targetElo = courseReg.elo.global.score;
            }
          } catch {
            targetElo = 1e3;
          }
        } else if (options.elo === "random") {
          targetElo = 800 + Math.random() * 400;
        }
        let cardIds = (await this.unpacker.queryByElo(targetElo, options.limit * 2)).map((c) => {
          return {
            cardID: c,
            courseID: this.courseId
          };
        });
        if (filter) {
          cardIds = cardIds.filter(filter);
        }
        return cardIds.slice(0, options.limit).map((card) => ({
          status: "new",
          // qualifiedID: `${this.courseId}-${cardId}`,
          cardID: card.cardID,
          contentSourceType: "course",
          contentSourceID: this.courseId,
          courseID: this.courseId
        }));
      }
      async getAppliedTags(cardId) {
        try {
          const tagsIndex = await this.unpacker.getTagsIndex();
          const cardTags = tagsIndex.byCard[cardId] || [];
          const rows = await Promise.all(
            cardTags.map(async (tagName) => {
              const tagId = `${"TAG" /* TAG */}-${tagName}`;
              try {
                const tagDoc = await this.unpacker.getDocument(tagId);
                return {
                  id: tagId,
                  key: cardId,
                  value: {
                    name: tagDoc.name,
                    snippet: tagDoc.snippet,
                    count: tagDoc.taggedCards?.length || 0
                  }
                };
              } catch (error) {
                if (error && error.status === 404) {
                  logger.warn(`Tag document not found for ${tagName}, creating stub`);
                } else {
                  logger.error(`Error getting tag document for ${tagName}:`, error);
                  throw error;
                }
                return {
                  id: tagId,
                  key: cardId,
                  value: {
                    name: tagName,
                    snippet: `Tag: ${tagName}`,
                    count: tagsIndex.byTag[tagName]?.length || 0
                  }
                };
              }
            })
          );
          return {
            total_rows: rows.length,
            offset: 0,
            rows
          };
        } catch (error) {
          logger.error(`Error getting applied tags for card ${cardId}:`, error);
          return {
            total_rows: 0,
            offset: 0,
            rows: []
          };
        }
      }
      async getAppliedTagsBatch(cardIds) {
        const tagsIndex = await this.unpacker.getTagsIndex();
        const tagsByCard = /* @__PURE__ */ new Map();
        for (const cardId of cardIds) {
          tagsByCard.set(cardId, tagsIndex.byCard[cardId] || []);
        }
        return tagsByCard;
      }
      async getAllCardIds() {
        const tagsIndex = await this.unpacker.getTagsIndex();
        return Object.keys(tagsIndex.byCard);
      }
      async addTagToCard(_cardId, _tagId) {
        throw new Error("Cannot modify tags in static mode");
      }
      async removeTagFromCard(_cardId, _tagId) {
        throw new Error("Cannot modify tags in static mode");
      }
      async createTag(_tagName) {
        throw new Error("Cannot create tags in static mode");
      }
      async getTag(tagName) {
        return this.unpacker.getDocument(`${"TAG" /* TAG */}-${tagName}`);
      }
      async updateTag(_tag) {
        throw new Error("Cannot update tags in static mode");
      }
      async getCourseTagStubs() {
        try {
          const tagsIndex = await this.unpacker.getTagsIndex();
          if (!tagsIndex || !tagsIndex.byTag) {
            logger.warn("Tags index not found or empty");
            return {
              total_rows: 0,
              offset: 0,
              rows: []
            };
          }
          const tagNames = Object.keys(tagsIndex.byTag);
          const rows = await Promise.all(
            tagNames.map(async (tagName) => {
              const cardIds = tagsIndex.byTag[tagName] || [];
              const tagId = `${"TAG" /* TAG */}-${tagName}`;
              try {
                const tagDoc = await this.unpacker.getDocument(tagId);
                return {
                  id: tagId,
                  key: tagId,
                  value: { rev: "1-static" },
                  doc: tagDoc
                };
              } catch (error) {
                if (error && error.status === 404) {
                  logger.warn(`Tag document not found for ${tagName}, creating stub`);
                  const stubDoc = {
                    _id: tagId,
                    _rev: "1-static",
                    course: this.courseId,
                    docType: "TAG" /* TAG */,
                    name: tagName,
                    snippet: `Tag: ${tagName}`,
                    wiki: "",
                    taggedCards: cardIds,
                    author: "system"
                  };
                  return {
                    id: tagId,
                    key: tagId,
                    value: { rev: "1-static" },
                    doc: stubDoc
                  };
                } else {
                  logger.error(`Error getting tag document for ${tagName}:`, error);
                  throw error;
                }
              }
            })
          );
          return {
            total_rows: rows.length,
            offset: 0,
            rows
          };
        } catch (error) {
          logger.error("Failed to get course tag stubs:", error);
          return {
            total_rows: 0,
            offset: 0,
            rows: []
          };
        }
      }
      async addNote(_codeCourse, _shape, _data, _author, _tags, _uploads, _elo) {
        return {
          status: Status4.error,
          message: "Cannot add notes in static mode"
        };
      }
      async removeCard(_cardId) {
        throw new Error("Cannot remove cards in static mode");
      }
      async getInexperiencedCards() {
        return [];
      }
      // Navigation Strategy Manager implementation
      async getNavigationStrategy(id) {
        try {
          return await this.unpacker.getDocument(id);
        } catch (error) {
          logger.error(`[static/courseDB] Strategy ${id} not found: ${error}`);
          throw error;
        }
      }
      async getAllNavigationStrategies() {
        const prefix = DocTypePrefixes["NAVIGATION_STRATEGY" /* NAVIGATION_STRATEGY */];
        try {
          const docs = await this.unpacker.getAllDocumentsByPrefix(prefix);
          return docs;
        } catch (error) {
          logger.warn(`[static/courseDB] Error loading navigation strategies: ${error}`);
          return [];
        }
      }
      async addNavigationStrategy(_data) {
        throw new Error("Cannot add navigation strategies in static mode");
      }
      async updateNavigationStrategy(_id, _data) {
        throw new Error("Cannot update navigation strategies in static mode");
      }
      /**
       * Create a ContentNavigator for this course.
       *
       * Loads navigation strategy documents from static data and uses PipelineAssembler
       * to build a Pipeline. Falls back to default pipeline if no strategies found.
       */
      async createNavigator(user) {
        try {
          const allStrategies = await this.getAllNavigationStrategies();
          if (allStrategies.length === 0) {
            logger.debug(
              "[static/courseDB] No strategy documents found, using default Pipeline(Composite(ELO, SRS), [eloDistanceFilter])"
            );
            return createDefaultPipeline(user, this);
          }
          const assembler = new PipelineAssembler();
          const { pipeline, generatorStrategies, filterStrategies, warnings } = await assembler.assemble({
            strategies: allStrategies,
            user,
            course: this
          });
          for (const warning of warnings) {
            logger.warn(`[PipelineAssembler] ${warning}`);
          }
          if (!pipeline) {
            logger.debug("[static/courseDB] Pipeline assembly failed, using default pipeline");
            return createDefaultPipeline(user, this);
          }
          logger.debug(
            `[static/courseDB] Using assembled pipeline with ${generatorStrategies.length} generator(s) and ${filterStrategies.length} filter(s)`
          );
          return pipeline;
        } catch (e) {
          logger.error(`[static/courseDB] Error creating navigator: ${e}`);
          throw e;
        }
      }
      // Study Content Source implementation
      _pendingHints = null;
      setEphemeralHints(hints) {
        this._pendingHints = hints;
      }
      async getWeightedCards(limit) {
        try {
          const navigator2 = await this.createNavigator(this.userDB);
          if (this._pendingHints) {
            navigator2.setEphemeralHints(this._pendingHints);
            this._pendingHints = null;
          }
          return navigator2.getWeightedCards(limit);
        } catch (e) {
          logger.error(`[static/courseDB] Error getting weighted cards: ${e}`);
          throw e;
        }
      }
      // Attachment helper methods (internal use, not part of interface)
      /**
       * Get attachment URL for a document and attachment name
       * Internal helper method for static attachment serving
       */
      getAttachmentUrl(docId, attachmentName) {
        return this.unpacker.getAttachmentUrl(docId, attachmentName);
      }
      /**
       * Load attachment as blob/buffer
       * Internal helper method for static attachment serving
       */
      async getAttachmentBlob(docId, attachmentName) {
        return this.unpacker.getAttachmentBlob(docId, attachmentName);
      }
      // Admin search methods
      async searchCards(_query) {
        return [];
      }
      async find(_request) {
        return {
          docs: [],
          warning: "Find operations not supported in static mode"
        };
      }
    };
  }
});

// src/impl/static/coursesDB.ts
var StaticCoursesDB;
var init_coursesDB = __esm({
  "src/impl/static/coursesDB.ts"() {
    "use strict";
    init_logger();
    StaticCoursesDB = class {
      constructor(manifests, dependencyNameToCourseId) {
        this.manifests = manifests;
        this.dependencyNameToCourseId = dependencyNameToCourseId;
      }
      async getCourseConfig(courseId) {
        let manifest = this.manifests[courseId];
        if (!manifest && this.dependencyNameToCourseId) {
          const mappedCourseId = this.dependencyNameToCourseId.get(courseId);
          if (mappedCourseId) {
            manifest = this.manifests[mappedCourseId];
          }
        }
        if (!manifest) {
          logger.warn(`Course manifest for ${courseId} not found`);
          throw new Error(`Course ${courseId} not found`);
        }
        if (manifest.courseConfig) {
          return manifest.courseConfig;
        } else {
          logger.warn(`Course config not found in manifest for course ${courseId}`);
          throw new Error(`Course config not found for course ${courseId}`);
        }
      }
      async getCourseList() {
        return Object.keys(this.manifests).map(
          (courseId) => ({
            courseID: courseId,
            name: this.manifests[courseId].courseName
            // ... other config fields
          })
        );
      }
      async disambiguateCourse(_courseId, _disambiguator) {
        logger.warn("Cannot disambiguate courses in static mode");
      }
    };
  }
});

// src/impl/static/NoOpSyncStrategy.ts
var NoOpSyncStrategy;
var init_NoOpSyncStrategy = __esm({
  "src/impl/static/NoOpSyncStrategy.ts"() {
    "use strict";
    init_common();
    NoOpSyncStrategy = class {
      currentUsername = accomodateGuest().username;
      setupRemoteDB(username) {
        return getLocalUserDB(username);
      }
      getWriteDB(username) {
        return getLocalUserDB(username);
      }
      startSync(_localDB, _remoteDB) {
      }
      stopSync() {
      }
      canCreateAccount() {
        return false;
      }
      canAuthenticate() {
        return false;
      }
      async createAccount(_username, _password) {
        throw new Error(
          "Account creation not supported in static mode. Use local account switching instead."
        );
      }
      async authenticate(_username, _password) {
        throw new Error(
          "Remote authentication not supported in static mode. Use local account switching instead."
        );
      }
      async logout() {
        this.currentUsername = accomodateGuest().username;
        return {
          ok: true
        };
      }
      async getCurrentUsername() {
        return this.currentUsername;
      }
      /**
       * Set the current username (for local account switching)
       * This method is specific to NoOpSyncStrategy and not part of the base interface
       */
      setCurrentUsername(username) {
        this.currentUsername = username;
      }
    };
  }
});

// src/impl/static/StaticDataLayerProvider.ts
var StaticDataLayerProvider_exports = {};
__export(StaticDataLayerProvider_exports, {
  StaticDataLayerProvider: () => StaticDataLayerProvider
});
var StaticDataLayerProvider;
var init_StaticDataLayerProvider = __esm({
  "src/impl/static/StaticDataLayerProvider.ts"() {
    "use strict";
    init_logger();
    init_StaticDataUnpacker();
    init_courseDB2();
    init_coursesDB();
    init_common();
    init_NoOpSyncStrategy();
    StaticDataLayerProvider = class {
      config;
      initialized = false;
      courseUnpackers = /* @__PURE__ */ new Map();
      manifests = {};
      // Mapping from dependency name to actual courseId for backwards compatibility
      dependencyNameToCourseId = /* @__PURE__ */ new Map();
      constructor(config) {
        this.config = {
          localStoragePrefix: config.localStoragePrefix || "skuilder-static",
          rootManifest: config.rootManifest || { dependencies: {} },
          rootManifestUrl: config.rootManifestUrl || "/"
        };
      }
      async resolveCourseDependencies() {
        logger.info("[StaticDataLayerProvider] Starting course dependency resolution...");
        const rootManifest = this.config.rootManifest;
        for (const [courseName, courseUrl] of Object.entries(rootManifest.dependencies || {})) {
          try {
            logger.debug(`[StaticDataLayerProvider] Resolving dependency: ${courseName} from ${courseUrl}`);
            const courseManifestUrl = new URL(courseUrl, this.config.rootManifestUrl).href;
            const courseJsonResponse = await fetch(courseManifestUrl);
            if (!courseJsonResponse.ok) {
              throw new Error(`Failed to fetch course manifest for ${courseName}`);
            }
            const courseJson = await courseJsonResponse.json();
            if (courseJson.content && courseJson.content.manifest) {
              const baseUrl = new URL(".", courseManifestUrl).href;
              const finalManifestUrl = new URL(courseJson.content.manifest, courseManifestUrl).href;
              const finalManifestResponse = await fetch(finalManifestUrl);
              if (!finalManifestResponse.ok) {
                throw new Error(`Failed to fetch final content manifest for ${courseName} at ${finalManifestUrl}`);
              }
              const finalManifest = await finalManifestResponse.json();
              const courseId = finalManifest.courseId || finalManifest.courseConfig?.courseID;
              if (!courseId) {
                throw new Error(`Course manifest for ${courseName} missing courseId`);
              }
              this.manifests[courseId] = finalManifest;
              const unpacker = new StaticDataUnpacker(finalManifest, baseUrl);
              this.courseUnpackers.set(courseId, unpacker);
              this.dependencyNameToCourseId.set(courseName, courseId);
              logger.info(`[StaticDataLayerProvider] Successfully resolved and prepared course: ${courseName} (courseId: ${courseId})`);
            }
          } catch (e) {
            logger.error(`[StaticDataLayerProvider] Failed to resolve dependency ${courseName}:`, e);
          }
        }
        logger.info("[StaticDataLayerProvider] Course dependency resolution complete.");
      }
      async initialize() {
        if (this.initialized) return;
        logger.info("Initializing static data layer provider");
        await this.resolveCourseDependencies();
        this.initialized = true;
      }
      async teardown() {
        this.courseUnpackers.clear();
        this.initialized = false;
      }
      getUserDB() {
        const syncStrategy = new NoOpSyncStrategy();
        return BaseUser.Dummy(syncStrategy);
      }
      getCourseDB(courseId) {
        let unpacker = this.courseUnpackers.get(courseId);
        let actualCourseId = courseId;
        if (!unpacker) {
          const mappedCourseId = this.dependencyNameToCourseId.get(courseId);
          if (mappedCourseId) {
            unpacker = this.courseUnpackers.get(mappedCourseId);
            actualCourseId = mappedCourseId;
          }
        }
        if (!unpacker) {
          throw new Error(`Course ${courseId} not found or failed to initialize in static data layer.`);
        }
        const manifest = this.manifests[actualCourseId];
        return new StaticCourseDB(actualCourseId, unpacker, this.getUserDB(), manifest);
      }
      getCoursesDB() {
        return new StaticCoursesDB(this.manifests, this.dependencyNameToCourseId);
      }
      async getClassroomDB(_classId, _type) {
        throw new Error("Classrooms not supported in static mode");
      }
      getAdminDB() {
        throw new Error("Admin functions not supported in static mode");
      }
      async createUserReaderForUser(targetUsername) {
        logger.warn(`StaticDataLayerProvider: Multi-user access not supported in static mode`);
        logger.warn(`Request: trying to access data for ${targetUsername}`);
        logger.warn(`Returning current user's data instead`);
        return this.getUserDB();
      }
      isReadOnly() {
        return true;
      }
    };
  }
});

// src/factory.ts
async function initializeDataLayer(config) {
  if (dataLayerInstance) {
    logger.warn("Data layer already initialized. Returning existing instance.");
    return dataLayerInstance;
  }
  await initializeNavigatorRegistry();
  if (config.options.localStoragePrefix) {
    ENV.LOCAL_STORAGE_PREFIX = config.options.localStoragePrefix;
  }
  if (config.type === "couch") {
    if (!config.options.COUCHDB_SERVER_URL || !config.options.COUCHDB_SERVER_PROTOCOL) {
      throw new Error("Missing CouchDB server URL or protocol");
    }
    ENV.COUCHDB_SERVER_PROTOCOL = config.options.COUCHDB_SERVER_PROTOCOL;
    ENV.COUCHDB_SERVER_URL = config.options.COUCHDB_SERVER_URL;
    ENV.COUCHDB_USERNAME = config.options.COUCHDB_USERNAME;
    ENV.COUCHDB_PASSWORD = config.options.COUCHDB_PASSWORD;
    if (config.options.courseSync) {
      const { CourseSyncService: CourseSyncService2 } = await Promise.resolve().then(() => (init_CourseSyncService(), CourseSyncService_exports));
      CourseSyncService2.getInstance().configure(config.options.courseSync);
    }
    if (config.options.COUCHDB_PASSWORD && config.options.COUCHDB_USERNAME && typeof window !== "undefined") {
      const { CouchDBSyncStrategy: CouchDBSyncStrategy2 } = await Promise.resolve().then(() => (init_CouchDBSyncStrategy(), CouchDBSyncStrategy_exports));
      const syncStrategy = new CouchDBSyncStrategy2();
      const user = await BaseUser.instance(syncStrategy, config.options.COUCHDB_USERNAME);
      const authResult = await user.login(
        config.options.COUCHDB_USERNAME,
        config.options.COUCHDB_PASSWORD
      );
      if (authResult.ok) {
        logger.info(`Successfully authenticated as ${config.options.COUCHDB_USERNAME}`);
      } else {
        logger.warn(`Authentication failed: ${authResult.error}`);
      }
    }
    const { CouchDataLayerProvider: CouchDataLayerProvider2 } = await Promise.resolve().then(() => (init_PouchDataLayerProvider(), PouchDataLayerProvider_exports));
    dataLayerInstance = new CouchDataLayerProvider2(config.options.COURSE_IDS);
  } else if (config.type === "static") {
    const { StaticDataLayerProvider: StaticDataLayerProvider2 } = await Promise.resolve().then(() => (init_StaticDataLayerProvider(), StaticDataLayerProvider_exports));
    dataLayerInstance = new StaticDataLayerProvider2(config.options);
  } else {
    throw new Error(`Unknown data layer type: ${config.type}`);
  }
  await dataLayerInstance.initialize();
  return dataLayerInstance;
}
function getDataLayer() {
  if (!dataLayerInstance) {
    throw new Error("Data layer not initialized. Call initializeDataLayer first.");
  }
  return dataLayerInstance;
}
async function _resetDataLayer() {
  if (dataLayerInstance) {
    await dataLayerInstance.teardown();
  }
  dataLayerInstance = null;
}
var NOT_SET, ENV, dataLayerInstance;
var init_factory = __esm({
  "src/factory.ts"() {
    "use strict";
    init_common();
    init_logger();
    init_navigators();
    NOT_SET = "NOT_SET";
    ENV = {
      COUCHDB_SERVER_PROTOCOL: NOT_SET,
      COUCHDB_SERVER_URL: NOT_SET,
      LOCAL_STORAGE_PREFIX: ""
    };
    dataLayerInstance = null;
  }
});

// src/study/TagFilteredContentSource.ts
import { hasActiveFilter } from "@vue-skuilder/common";
var TagFilteredContentSource;
var init_TagFilteredContentSource = __esm({
  "src/study/TagFilteredContentSource.ts"() {
    "use strict";
    init_courseDB();
    init_logger();
    TagFilteredContentSource = class {
      courseId;
      filter;
      user;
      // Cache resolved card IDs to avoid repeated lookups within a session
      resolvedCardIds = null;
      constructor(courseId, filter, user) {
        this.courseId = courseId;
        this.filter = filter;
        this.user = user;
        logger.info(
          `[TagFilteredContentSource] Created for course "${courseId}" with filter:`,
          JSON.stringify(filter)
        );
      }
      /**
       * Resolves the TagFilter to a set of eligible card IDs.
       *
       * - Cards in `include` tags are OR'd together (card needs at least one)
       * - Cards in `exclude` tags are removed from the result
       */
      async resolveFilteredCardIds() {
        if (this.resolvedCardIds !== null) {
          return this.resolvedCardIds;
        }
        const includedCardIds = /* @__PURE__ */ new Set();
        if (this.filter.include.length > 0) {
          for (const tagName of this.filter.include) {
            try {
              const tagDoc = await getTag(this.courseId, tagName);
              tagDoc.taggedCards.forEach((cardId) => includedCardIds.add(cardId));
            } catch (error) {
              logger.warn(
                `[TagFilteredContentSource] Could not resolve tag "${tagName}" for inclusion:`,
                error
              );
            }
          }
        }
        if (includedCardIds.size === 0 && this.filter.include.length > 0) {
          logger.warn(
            `[TagFilteredContentSource] No cards found for include tags: ${this.filter.include.join(", ")}`
          );
          this.resolvedCardIds = /* @__PURE__ */ new Set();
          return this.resolvedCardIds;
        }
        const excludedCardIds = /* @__PURE__ */ new Set();
        if (this.filter.exclude.length > 0) {
          for (const tagName of this.filter.exclude) {
            try {
              const tagDoc = await getTag(this.courseId, tagName);
              tagDoc.taggedCards.forEach((cardId) => excludedCardIds.add(cardId));
            } catch (error) {
              logger.warn(
                `[TagFilteredContentSource] Could not resolve tag "${tagName}" for exclusion:`,
                error
              );
            }
          }
        }
        const finalCardIds = /* @__PURE__ */ new Set();
        for (const cardId of includedCardIds) {
          if (!excludedCardIds.has(cardId)) {
            finalCardIds.add(cardId);
          }
        }
        logger.info(
          `[TagFilteredContentSource] Resolved ${finalCardIds.size} cards (included: ${includedCardIds.size}, excluded: ${excludedCardIds.size})`
        );
        this.resolvedCardIds = finalCardIds;
        return finalCardIds;
      }
      /**
       * Get cards with suitability scores for presentation.
       *
       * Filters cards by tag inclusion/exclusion and assigns score=1.0 to all.
       * TagFilteredContentSource does not currently support pluggable navigation
       * strategies - it returns flat-scored candidates.
       *
       * @param limit - Maximum number of cards to return
       * @returns Cards sorted by score descending (all scores = 1.0)
       */
      async getWeightedCards(limit) {
        if (!hasActiveFilter(this.filter)) {
          logger.warn("[TagFilteredContentSource] getWeightedCards called with no active filter");
          return { cards: [] };
        }
        const eligibleCardIds = await this.resolveFilteredCardIds();
        const activeCards = await this.user.getActiveCards();
        const activeCardIds = new Set(activeCards.map((c) => c.cardID));
        const newCardWeighted = [];
        for (const cardId of eligibleCardIds) {
          if (!activeCardIds.has(cardId)) {
            newCardWeighted.push({
              cardId,
              courseId: this.courseId,
              score: 1,
              provenance: [
                {
                  strategy: "tagFilter",
                  strategyName: "Tag Filter",
                  strategyId: "TAG_FILTER",
                  action: "generated",
                  score: 1,
                  reason: `Tag-filtered new card (tags: ${this.filter.include.join(", ")})`
                }
              ]
            });
          }
          if (newCardWeighted.length >= limit) {
            break;
          }
        }
        logger.info(
          `[TagFilteredContentSource] Found ${newCardWeighted.length} new cards matching filter`
        );
        const allReviews = await this.user.getPendingReviews(this.courseId);
        const filteredReviews = allReviews.filter((review) => eligibleCardIds.has(review.cardId));
        logger.info(
          `[TagFilteredContentSource] Found ${filteredReviews.length} pending reviews matching filter (of ${allReviews.length} total)`
        );
        const reviewWeighted = filteredReviews.map((r) => ({
          cardId: r.cardId,
          courseId: r.courseId,
          score: 1,
          reviewID: r._id,
          provenance: [
            {
              strategy: "tagFilter",
              strategyName: "Tag Filter",
              strategyId: "TAG_FILTER",
              action: "generated",
              score: 1,
              reason: `Tag-filtered review (tags: ${this.filter.include.join(", ")})`
            }
          ]
        }));
        return { cards: [...reviewWeighted, ...newCardWeighted].slice(0, limit) };
      }
      /**
       * Clears the cached resolved card IDs.
       * Call this if the underlying tag data may have changed during a session.
       */
      clearCache() {
        this.resolvedCardIds = null;
      }
      /**
       * Returns the course ID this source is filtering.
       */
      getCourseId() {
        return this.courseId;
      }
      /**
       * Returns the active tag filter.
       */
      getFilter() {
        return this.filter;
      }
    };
  }
});

// src/core/interfaces/contentSource.ts
import { hasActiveFilter as hasActiveFilter2 } from "@vue-skuilder/common";
function isReview(item) {
  const ret = item.status === "review" || item.status === "failed-review" || "reviewID" in item;
  return ret;
}
async function getStudySource(source, user) {
  if (source.type === "classroom") {
    return await StudentClassroomDB.factory(source.id, user);
  } else {
    if (hasActiveFilter2(source.tagFilter)) {
      return new TagFilteredContentSource(source.id, source.tagFilter, user);
    }
    return getDataLayer().getCourseDB(source.id);
  }
}
var init_contentSource = __esm({
  "src/core/interfaces/contentSource.ts"() {
    "use strict";
    init_factory();
    init_classroomDB2();
    init_TagFilteredContentSource();
  }
});

// src/core/interfaces/courseDB.ts
var init_courseDB3 = __esm({
  "src/core/interfaces/courseDB.ts"() {
    "use strict";
  }
});

// src/core/interfaces/dataLayerProvider.ts
var init_dataLayerProvider = __esm({
  "src/core/interfaces/dataLayerProvider.ts"() {
    "use strict";
  }
});

// src/core/interfaces/userDB.ts
var init_userDB = __esm({
  "src/core/interfaces/userDB.ts"() {
    "use strict";
  }
});

// src/core/interfaces/index.ts
var init_interfaces = __esm({
  "src/core/interfaces/index.ts"() {
    "use strict";
    init_adminDB();
    init_classroomDB();
    init_contentSource();
    init_courseDB3();
    init_dataLayerProvider();
    init_userDB();
  }
});

// src/core/types/user.ts
var init_user = __esm({
  "src/core/types/user.ts"() {
    "use strict";
  }
});

// src/core/types/strategyState.ts
function buildStrategyStateId(courseId, strategyKey) {
  return `STRATEGY_STATE::${courseId}::${strategyKey}`;
}
var init_strategyState = __esm({
  "src/core/types/strategyState.ts"() {
    "use strict";
  }
});

// src/core/types/userOutcome.ts
var init_userOutcome = __esm({
  "src/core/types/userOutcome.ts"() {
    "use strict";
  }
});

// src/core/bulkImport/cardProcessor.ts
import { Status as Status5 } from "@vue-skuilder/common";
async function importParsedCards(parsedCards, courseDB, config) {
  const results = [];
  for (const parsedCard of parsedCards) {
    try {
      const result = await processCard(parsedCard, courseDB, config);
      results.push(result);
    } catch (error) {
      logger.error("Error processing card:", error);
      let errorOriginalText = parsedCard.markdown;
      if (parsedCard.tags && parsedCard.tags.length > 0) {
        errorOriginalText += `
tags: ${parsedCard.tags.join(", ")}`;
      }
      if (parsedCard.elo !== void 0) {
        errorOriginalText += `
elo: ${parsedCard.elo}`;
      }
      results.push({
        originalText: errorOriginalText,
        status: "error",
        message: `Error processing card: ${error instanceof Error ? error.message : "Unknown error"}`
      });
    }
  }
  return results;
}
async function processCard(parsedCard, courseDB, config) {
  const { markdown, tags, elo } = parsedCard;
  let originalText = markdown;
  if (tags.length > 0) {
    originalText += `
tags: ${tags.join(", ")}`;
  }
  if (elo !== void 0) {
    originalText += `
elo: ${elo}`;
  }
  const cardData = {
    Input: markdown,
    Uploads: []
    // No uploads for bulk import
  };
  const tagsElo = {};
  for (const tag of tags) {
    tagsElo[tag] = {
      score: elo || 0,
      count: 1
    };
  }
  try {
    const result = await courseDB.addNote(
      config.courseCode,
      config.dataShape,
      cardData,
      config.userName,
      tags,
      void 0,
      // attachments
      elo ? {
        global: {
          score: elo,
          count: 1
        },
        tags: tagsElo,
        misc: {}
      } : void 0
    );
    if (result.status === Status5.ok) {
      return {
        originalText,
        status: "success",
        message: "Card added successfully.",
        cardId: result.id ? result.id : "(unknown)"
      };
    } else {
      return {
        originalText,
        status: "error",
        message: result.message || "Failed to add card to database. Unknown error."
      };
    }
  } catch (error) {
    logger.error("Error adding note:", error);
    return {
      originalText,
      status: "error",
      message: `Error adding card: ${error instanceof Error ? error.message : "Unknown error"}`
    };
  }
}
function validateProcessorConfig(config) {
  if (!config.dataShape) {
    return {
      isValid: false,
      errorMessage: "No data shape provided for card processing"
    };
  }
  if (!config.courseCode) {
    return {
      isValid: false,
      errorMessage: "No course code provided for card processing"
    };
  }
  if (!config.userName) {
    return {
      isValid: false,
      errorMessage: "No user name provided for card processing"
    };
  }
  return { isValid: true };
}
var init_cardProcessor = __esm({
  "src/core/bulkImport/cardProcessor.ts"() {
    "use strict";
    init_logger();
  }
});

// src/core/bulkImport/types.ts
var init_types3 = __esm({
  "src/core/bulkImport/types.ts"() {
    "use strict";
  }
});

// src/core/bulkImport/index.ts
var init_bulkImport = __esm({
  "src/core/bulkImport/index.ts"() {
    "use strict";
    init_cardProcessor();
    init_types3();
  }
});

// src/core/UserDBDebugger.ts
function getUserDB() {
  try {
    const provider = getDataLayer();
    return provider.getUserDB();
  } catch {
    logger.info("[UserDB Debug] Data layer not initialized yet.");
    return null;
  }
}
function getRawDB() {
  const userDB = getUserDB();
  if (!userDB) return null;
  const rawDB = userDB.localDB;
  if (!rawDB) {
    logger.info("[UserDB Debug] Unable to access raw database instance.");
    return null;
  }
  return rawDB;
}
function formatTimestamp(isoString) {
  const date = new Date(isoString);
  return date.toLocaleString();
}
function mountUserDBDebugger() {
  if (typeof window === "undefined") return;
  const win = window;
  win.skuilder = win.skuilder || {};
  win.skuilder.userdb = userDBDebugAPI;
}
var userDBDebugAPI;
var init_UserDBDebugger = __esm({
  "src/core/UserDBDebugger.ts"() {
    "use strict";
    init_logger();
    init_factory();
    init_types_legacy();
    init_userDBHelpers();
    userDBDebugAPI = {
      /**
       * Show current user information
       */
      showUser() {
        const userDB = getUserDB();
        if (!userDB) return;
        console.group("\u{1F464} User Information");
        logger.info(`Username: ${userDB.getUsername()}`);
        logger.info(`Logged in: ${userDB.isLoggedIn() ? "Yes \u2705" : "No (Guest) \u274C"}`);
        userDB.getConfig().then((config) => {
          logger.info("Configuration:");
          logger.info(JSON.stringify(config, null, 2));
        }).catch((err) => {
          logger.info(`Error loading config: ${err.message}`);
        }).finally(() => {
          console.groupEnd();
        });
      },
      /**
       * Show scheduled reviews
       */
      async showScheduledReviews(courseId) {
        const userDB = getUserDB();
        if (!userDB) {
          logger.info("[UserDB Debug] Data layer not available");
          return;
        }
        logger.info(`[UserDB Debug] Fetching pending reviews${courseId ? ` for course: ${courseId}` : ""}...`);
        try {
          const reviews = await userDB.getPendingReviews(courseId);
          logger.info(`[UserDB Debug] Got ${reviews.length} reviews`);
          console.group(`\u{1F4C5} Scheduled Reviews${courseId ? ` (${courseId})` : ""}`);
          logger.info(`Total: ${reviews.length}`);
          if (reviews.length > 0) {
            const byCourse = /* @__PURE__ */ new Map();
            for (const review of reviews) {
              if (!byCourse.has(review.courseId)) {
                byCourse.set(review.courseId, []);
              }
              byCourse.get(review.courseId).push(review);
            }
            for (const [course, courseReviews] of byCourse) {
              console.group(`Course: ${course} (${courseReviews.length} reviews)`);
              const sorted = courseReviews.sort((a, b) => {
                const timeA = typeof a.reviewTime === "string" ? a.reviewTime : a.reviewTime.toISOString();
                const timeB = typeof b.reviewTime === "string" ? b.reviewTime : b.reviewTime.toISOString();
                return new Date(timeA).getTime() - new Date(timeB).getTime();
              });
              for (const review of sorted.slice(0, 10)) {
                const reviewTimeStr = typeof review.reviewTime === "string" ? review.reviewTime : review.reviewTime.toISOString();
                logger.info(
                  `  ${review.cardId.slice(0, 12)}... @ ${formatTimestamp(reviewTimeStr)} [${review.scheduledFor}/${review.schedulingAgentId}]`
                );
              }
              if (sorted.length > 10) {
                logger.info(`  ... and ${sorted.length - 10} more`);
              }
              console.groupEnd();
            }
          }
          console.groupEnd();
        } catch (err) {
          logger.info(`Error loading scheduled reviews: ${err.message}`);
        }
      },
      /**
       * Show course registrations
       */
      async showCourseRegistrations() {
        const userDB = getUserDB();
        if (!userDB) return;
        try {
          const registrations = await userDB.getActiveCourses();
          console.group("\u{1F4DA} Course Registrations");
          logger.info(`Total: ${registrations.length}`);
          if (registrations.length > 0) {
            console.table(
              registrations.map((reg) => ({
                courseId: reg.courseID,
                status: reg.status || "active",
                elo: typeof reg.elo === "number" ? reg.elo.toFixed(0) : reg.elo?.global?.score?.toFixed(0) || "N/A"
              }))
            );
          }
          console.groupEnd();
        } catch (err) {
          logger.info(`Error loading course registrations: ${err.message}`);
        }
      },
      /**
       * Show card history for a specific card
       */
      async showCardHistory(cardId) {
        const rawDB = getRawDB();
        if (!rawDB) return;
        try {
          const result = await filterAllDocsByPrefix(rawDB, DocTypePrefixes["CARDRECORD" /* CARDRECORD */]);
          const cardHistories = result.rows.filter((row) => row.doc && row.doc.cardID === cardId).map((row) => row.doc);
          console.group(`\u{1F3B4} Card History: ${cardId}`);
          logger.info(`Total interactions: ${cardHistories.length}`);
          if (cardHistories.length > 0) {
            const sorted = cardHistories.sort(
              (a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
            );
            console.table(
              sorted.slice(0, 20).map((doc) => ({
                time: formatTimestamp(doc.timestamp),
                outcome: doc.outcome || "N/A",
                duration: doc.duration ? `${(doc.duration / 1e3).toFixed(1)}s` : "N/A",
                courseId: doc.courseId
              }))
            );
            if (sorted.length > 20) {
              logger.info(`... and ${sorted.length - 20} more interactions`);
            }
          }
          console.groupEnd();
        } catch (err) {
          logger.info(`Error loading card history: ${err.message}`);
        }
      },
      /**
       * Query documents by type
       */
      async queryByType(docType, limit = 50) {
        const rawDB = getRawDB();
        if (!rawDB) return;
        try {
          const prefix = DocTypePrefixes[DocType[docType]];
          if (!prefix) {
            logger.info(`Unknown document type: ${docType}`);
            return;
          }
          const result = await filterAllDocsByPrefix(rawDB, prefix);
          console.group(`\u{1F4C4} Documents: ${docType}`);
          logger.info(`Total: ${result.rows.length}`);
          logger.info(`Prefix: ${prefix}`);
          if (result.rows.length > 0) {
            logger.info("Sample documents:");
            const samples = result.rows.slice(0, Math.min(limit, result.rows.length));
            for (const row of samples) {
              logger.info(`
${row.id}:`);
              logger.info(JSON.stringify(row.doc, null, 2));
            }
            if (result.rows.length > limit) {
              logger.info(`
... and ${result.rows.length - limit} more documents`);
            }
          }
          console.groupEnd();
        } catch (err) {
          logger.info(`Error querying documents: ${err.message}`);
        }
      },
      /**
       * Show database info and statistics
       */
      async dbInfo() {
        const rawDB = getRawDB();
        if (!rawDB) return;
        try {
          const info = await rawDB.info();
          console.group("\u2139\uFE0F Database Information");
          logger.info(`Database name: ${info.db_name}`);
          logger.info(`Total documents: ${info.doc_count}`);
          logger.info(`Update sequence: ${info.update_seq}`);
          if ("disk_size" in info) {
            logger.info(`Disk size: ${(info.disk_size || 0) / 1024 / 1024} MB`);
          }
          logger.info("\nDocument counts by type:");
          const allDocs = await rawDB.allDocs({ include_docs: false });
          const typeCounts = /* @__PURE__ */ new Map();
          for (const row of allDocs.rows) {
            let prefix = "other";
            for (const [type, typePrefix] of Object.entries(DocTypePrefixes)) {
              if (row.id.startsWith(typePrefix)) {
                prefix = type;
                break;
              }
            }
            typeCounts.set(prefix, (typeCounts.get(prefix) || 0) + 1);
          }
          console.table(
            Array.from(typeCounts.entries()).sort((a, b) => b[1] - a[1]).map(([type, count]) => ({ type, count }))
          );
          console.groupEnd();
        } catch (err) {
          logger.info(`Error getting database info: ${err.message}`);
        }
      },
      /**
       * List all document types
       */
      listDocTypes() {
        console.group("\u{1F4CB} Available Document Types");
        logger.info("Use with queryByType(type):");
        for (const [type, prefix] of Object.entries(DocTypePrefixes)) {
          logger.info(`  ${type.padEnd(30)} \u2192 prefix: "${prefix}"`);
        }
        console.groupEnd();
      },
      /**
       * Export database contents (limited, for debugging)
       */
      async export(includeContent = false) {
        const rawDB = getRawDB();
        const userDB = getUserDB();
        if (!rawDB || !userDB) return "{}";
        try {
          const data = {
            username: userDB.getUsername(),
            loggedIn: userDB.isLoggedIn(),
            timestamp: (/* @__PURE__ */ new Date()).toISOString()
          };
          if (includeContent) {
            const allDocs = await rawDB.allDocs({ include_docs: true });
            data.documents = allDocs.rows.map((row) => ({
              id: row.id,
              doc: row.doc
            }));
            data.totalDocs = allDocs.rows.length;
          } else {
            const allDocs = await rawDB.allDocs({ include_docs: false });
            data.totalDocs = allDocs.rows.length;
            const typeCounts = /* @__PURE__ */ new Map();
            for (const row of allDocs.rows) {
              let prefix = "other";
              for (const [type, typePrefix] of Object.entries(DocTypePrefixes)) {
                if (row.id.startsWith(typePrefix)) {
                  prefix = type;
                  break;
                }
              }
              typeCounts.set(prefix, (typeCounts.get(prefix) || 0) + 1);
            }
            data.docCounts = Object.fromEntries(typeCounts);
          }
          const json = JSON.stringify(data, null, 2);
          logger.info("[UserDB Debug] Database info exported. Copy the returned string or use:");
          logger.info("  copy(window.skuilder.userdb.export())");
          if (!includeContent) {
            logger.info("  For full content export: window.skuilder.userdb.export(true)");
          }
          return json;
        } catch (err) {
          logger.info(`Error exporting database: ${err.message}`);
          return "{}";
        }
      },
      /**
       * Execute raw PouchDB query
       */
      async raw(queryFn) {
        const rawDB = getRawDB();
        if (!rawDB) return;
        try {
          const result = await queryFn(rawDB);
          logger.info("[UserDB Debug] Query result:");
          logger.info(result);
        } catch (err) {
          logger.info(`[UserDB Debug] Query error: ${err.message}`);
        }
      },
      /**
       * Show help
       */
      help() {
        logger.info(`
\u{1F527} UserDB Debug API

Commands:
  .showUser()                           Show current user info and config
  .showScheduledReviews(courseId?)      Show scheduled reviews (optionally filter by course)
  .showCourseRegistrations()            Show all course registrations
  .showCardHistory(cardId)              Show interaction history for a card
  .queryByType(docType, limit?)         Query documents by type (e.g., 'SCHEDULED_CARD')
  .listDocTypes()                       List all available document types
  .dbInfo()                             Show database info and statistics
  .export(includeContent?)              Export database info (true = include all docs)
  .raw(queryFn)                         Execute raw PouchDB query
  .help()                               Show this help message

Examples:
  window.skuilder.userdb.showUser()
  window.skuilder.userdb.showScheduledReviews('course123')
  window.skuilder.userdb.queryByType('SCHEDULED_CARD', 10)
  window.skuilder.userdb.raw(db => db.allDocs({ limit: 5 }))
`);
      }
    };
    mountUserDBDebugger();
  }
});

// src/core/index.ts
var init_core = __esm({
  "src/core/index.ts"() {
    "use strict";
    init_interfaces();
    init_types_legacy();
    init_user();
    init_strategyState();
    init_userOutcome();
    init_Loggable();
    init_util();
    init_navigators();
    init_bulkImport();
    init_orchestration();
    init_UserDBDebugger();
  }
});

// src/index.ts
init_core();
init_courseLookupDB();

// src/courseConfigRegistration.ts
init_logger();
import { NameSpacer as NameSpacer2, toZodJSON } from "@vue-skuilder/common";
function isDataShapeRegistered(dataShape, courseConfig) {
  const namespacedName = NameSpacer2.getDataShapeString({
    dataShape: dataShape.name,
    course: dataShape.course
  });
  const existingDataShape = courseConfig.dataShapes.find((ds) => ds.name === namespacedName);
  return existingDataShape !== void 0;
}
function isDataShapeSchemaAvailable(dataShape, courseConfig) {
  const namespacedName = NameSpacer2.getDataShapeString({
    dataShape: dataShape.name,
    course: dataShape.course
  });
  const existingDataShape = courseConfig.dataShapes.find((ds) => ds.name === namespacedName);
  return existingDataShape !== void 0 && existingDataShape.serializedZodSchema !== void 0;
}
function isQuestionTypeRegistered(question, courseConfig) {
  const namespacedName = NameSpacer2.getQuestionString({
    course: question.course,
    questionType: question.name
  });
  return courseConfig.questionTypes.some((qt) => qt.name === namespacedName);
}
function processCustomQuestionsData(customQuestions) {
  const processedDataShapes = [];
  const processedQuestions = [];
  const courseNames = customQuestions.courses.map((course) => course.name);
  customQuestions.questionClasses.forEach((questionClass) => {
    const courseName = courseNames.length > 0 ? courseNames[0] : customQuestions.meta.packageName;
    if (questionClass.dataShapes && Array.isArray(questionClass.dataShapes)) {
      questionClass.dataShapes.forEach((dataShape) => {
        processedDataShapes.push({
          name: dataShape.name,
          course: courseName,
          dataShape
        });
      });
    }
    processedQuestions.push({
      name: questionClass.name,
      course: courseName,
      questionClass,
      dataShapes: questionClass.dataShapes || [],
      views: questionClass.views || []
    });
  });
  return { dataShapes: processedDataShapes, questions: processedQuestions };
}
function registerDataShape(dataShape, courseConfig) {
  const namespacedName = NameSpacer2.getDataShapeString({
    dataShape: dataShape.name,
    course: dataShape.course
  });
  let serializedZodSchema;
  try {
    serializedZodSchema = toZodJSON(dataShape.dataShape);
  } catch (error) {
    logger.warn(`Failed to generate schema for ${namespacedName}:`, error);
    serializedZodSchema = void 0;
  }
  const existingIndex = courseConfig.dataShapes.findIndex((ds) => ds.name === namespacedName);
  if (existingIndex !== -1) {
    const existingDataShape = courseConfig.dataShapes[existingIndex];
    if (existingDataShape.serializedZodSchema === serializedZodSchema) {
      logger.info(
        `DataShape '${dataShape.name}' from '${dataShape.course}' already registered with identical schema`
      );
      return false;
    }
    if (existingDataShape.serializedZodSchema) {
      logger.info(
        `DataShape '${dataShape.name}' from '${dataShape.course}' schema has changed, updating...`
      );
    } else {
      logger.info(
        `DataShape '${dataShape.name}' from '${dataShape.course}' already registered, but with no schema. Adding schema to existing entry`
      );
    }
    courseConfig.dataShapes[existingIndex] = {
      name: namespacedName,
      questionTypes: existingDataShape.questionTypes,
      // Preserve existing question type associations
      serializedZodSchema
    };
    logger.info(`Updated DataShape: ${namespacedName}`);
    return true;
  }
  courseConfig.dataShapes.push({
    name: namespacedName,
    questionTypes: [],
    serializedZodSchema
  });
  logger.info(`Registered DataShape: ${namespacedName}`);
  return true;
}
function registerQuestionType(question, courseConfig) {
  if (isQuestionTypeRegistered(question, courseConfig)) {
    logger.info(`QuestionType '${question.name}' from '${question.course}' already registered`);
    return false;
  }
  const namespacedQuestionName = NameSpacer2.getQuestionString({
    course: question.course,
    questionType: question.name
  });
  const viewList = question.views.map((view) => {
    if (view.name) {
      return view.name;
    } else {
      return "unnamedComponent";
    }
  });
  const dataShapeList = question.dataShapes.map(
    (dataShape) => NameSpacer2.getDataShapeString({
      course: question.course,
      dataShape: dataShape.name
    })
  );
  courseConfig.questionTypes.push({
    name: namespacedQuestionName,
    viewList,
    dataShapeList
  });
  question.dataShapes.forEach((dataShape) => {
    const namespacedDataShapeName = NameSpacer2.getDataShapeString({
      course: question.course,
      dataShape: dataShape.name
    });
    for (const ds of courseConfig.dataShapes) {
      if (ds.name === namespacedDataShapeName) {
        ds.questionTypes.push(namespacedQuestionName);
      }
    }
  });
  logger.info(`Registered QuestionType: ${namespacedQuestionName}`);
  return true;
}
function removeDataShape(dataShapeName, courseConfig) {
  const index = courseConfig.dataShapes.findIndex((ds) => ds.name === dataShapeName);
  if (index === -1) {
    logger.info(`DataShape '${dataShapeName}' not found in course config`);
    return false;
  }
  courseConfig.dataShapes.splice(index, 1);
  courseConfig.questionTypes.forEach((qt) => {
    const dsIndex = qt.dataShapeList.indexOf(dataShapeName);
    if (dsIndex !== -1) {
      qt.dataShapeList.splice(dsIndex, 1);
    }
  });
  logger.info(`Removed DataShape: ${dataShapeName}`);
  return true;
}
function removeQuestionType(questionTypeName, courseConfig) {
  const index = courseConfig.questionTypes.findIndex((qt) => qt.name === questionTypeName);
  if (index === -1) {
    logger.info(`QuestionType '${questionTypeName}' not found in course config`);
    return false;
  }
  courseConfig.questionTypes.splice(index, 1);
  courseConfig.dataShapes.forEach((ds) => {
    const qtIndex = ds.questionTypes.indexOf(questionTypeName);
    if (qtIndex !== -1) {
      ds.questionTypes.splice(qtIndex, 1);
    }
  });
  logger.info(`Removed QuestionType: ${questionTypeName}`);
  return true;
}
async function removeCustomQuestionTypes(dataShapeNames, questionTypeNames, courseConfig, courseDB) {
  try {
    logger.info("Beginning custom question removal");
    logger.info(`Removing ${dataShapeNames.length} data shapes and ${questionTypeNames.length} question types`);
    let removedCount = 0;
    for (const qtName of questionTypeNames) {
      if (removeQuestionType(qtName, courseConfig)) {
        removedCount++;
      }
    }
    for (const dsName of dataShapeNames) {
      if (removeDataShape(dsName, courseConfig)) {
        removedCount++;
      }
    }
    logger.info("Updating course configuration...");
    const updateResult = await courseDB.updateCourseConfig(courseConfig);
    if (!updateResult.ok) {
      throw new Error(`Failed to update course config: ${JSON.stringify(updateResult)}`);
    }
    logger.info(`Custom question removal complete: ${removedCount} items removed`);
    return { success: true, removedCount };
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    logger.error(`Custom question removal failed: ${errorMessage}`);
    return { success: false, removedCount: 0, errorMessage };
  }
}
async function registerSeedData(question, courseDB, username) {
  if (question.questionClass.seedData && Array.isArray(question.questionClass.seedData)) {
    logger.info(`Registering seed data for question: ${question.name}`);
    try {
      const seedDataPromises = question.questionClass.seedData.filter(() => question.dataShapes.length > 0).map(
        (seedDataItem) => courseDB.addNote(
          question.course,
          question.dataShapes[0],
          seedDataItem,
          username,
          []
        )
      );
      await Promise.all(seedDataPromises);
      logger.info(`Seed data registered for question: ${question.name}`);
    } catch (error) {
      logger.warn(
        `Failed to register seed data for question '${question.name}': ${error instanceof Error ? error.message : String(error)}`
      );
    }
  }
}
async function registerBlanksCard(BlanksCard, BlanksCardDataShapes, courseConfig, courseDB, username) {
  try {
    logger.info("Registering BlanksCard data shapes and question type...");
    let registeredCount = 0;
    const courseName = "default";
    for (const dataShapeClass of BlanksCardDataShapes) {
      const processedDataShape = {
        name: dataShapeClass.name,
        course: courseName,
        dataShape: dataShapeClass
      };
      if (registerDataShape(processedDataShape, courseConfig)) {
        registeredCount++;
      }
    }
    const processedQuestion = {
      name: BlanksCard.name,
      course: courseName,
      questionClass: {
        name: BlanksCard.name,
        dataShapes: BlanksCardDataShapes,
        views: BlanksCard.views || []
      },
      dataShapes: BlanksCardDataShapes,
      views: BlanksCard.views || []
    };
    if (registerQuestionType(processedQuestion, courseConfig)) {
      registeredCount++;
    }
    logger.info("Updating course configuration with BlanksCard...");
    const updateResult = await courseDB.updateCourseConfig(courseConfig);
    if (!updateResult.ok) {
      throw new Error(`Failed to update course config: ${JSON.stringify(updateResult)}`);
    }
    if (username) {
      await registerSeedData(processedQuestion, courseDB, username);
    }
    logger.info(`BlanksCard registration complete: ${registeredCount} items registered`);
    return { success: true };
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    logger.error(`BlanksCard registration failed: ${errorMessage}`);
    return { success: false, errorMessage };
  }
}
async function registerCustomQuestionTypes(customQuestions, courseConfig, courseDB, username) {
  try {
    logger.info("Beginning custom question registration");
    logger.info(`Processing ${customQuestions.questionClasses.length} question classes`);
    const { dataShapes, questions } = processCustomQuestionsData(customQuestions);
    logger.info(`Found ${dataShapes.length} data shapes and ${questions.length} questions`);
    let registeredCount = 0;
    logger.info("Registering data shapes...");
    for (const dataShape of dataShapes) {
      if (registerDataShape(dataShape, courseConfig)) {
        registeredCount++;
      }
    }
    logger.info("Registering question types...");
    for (const question of questions) {
      if (registerQuestionType(question, courseConfig)) {
        registeredCount++;
      }
    }
    logger.info("Updating course configuration...");
    const updateResult = await courseDB.updateCourseConfig(courseConfig);
    if (!updateResult.ok) {
      throw new Error(`Failed to update course config: ${JSON.stringify(updateResult)}`);
    }
    if (username) {
      logger.info("Registering seed data...");
      for (const question of questions) {
        await registerSeedData(question, courseDB, username);
      }
    }
    logger.info(`Custom question registration complete: ${registeredCount} items registered`);
    return { success: true, registeredCount };
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    logger.error(`Custom question registration failed: ${errorMessage}`);
    return { success: false, registeredCount: 0, errorMessage };
  }
}

// src/study/services/SrsService.ts
init_couch();
import moment8 from "moment";

// src/study/SpacedRepetition.ts
init_util();
init_logger();
import moment7 from "moment";
import { isTaggedPerformance } from "@vue-skuilder/common";
var duration = moment7.duration;
function newInterval(user, cardHistory) {
  if (areQuestionRecords(cardHistory)) {
    return newQuestionInterval(user, cardHistory);
  } else {
    return 1e5;
  }
}
function newQuestionInterval(user, cardHistory) {
  const records = cardHistory.records;
  const currentAttempt = records[records.length - 1];
  const lastInterval = lastSuccessfulInterval(records);
  if (lastInterval > cardHistory.bestInterval) {
    cardHistory.bestInterval = lastInterval;
    user.update(cardHistory._id, {
      bestInterval: lastInterval
    }).catch((e) => {
      logger.warn(`[SpacedRepetition] Failed to update bestInterval for ${cardHistory._id}: ${e?.message ?? e}`);
    });
  }
  if (currentAttempt.isCorrect) {
    const rawPerf = currentAttempt.performance;
    const numericPerf = isTaggedPerformance(rawPerf) ? rawPerf._global : rawPerf;
    const skill = Math.min(1, Math.max(0, numericPerf));
    logger.debug(`Demontrated skill: 	${skill}`);
    const interval = lastInterval * (0.75 + skill);
    cardHistory.lapses = getLapses(cardHistory.records);
    cardHistory.streak = getStreak(cardHistory.records);
    if (cardHistory.lapses && cardHistory.streak && cardHistory.bestInterval && (cardHistory.lapses >= 0 || cardHistory.streak >= 0)) {
      const ret = (cardHistory.lapses * interval + cardHistory.streak * cardHistory.bestInterval) / (cardHistory.lapses + cardHistory.streak);
      logger.debug(`Weighted average interval calculation:
	(${cardHistory.lapses} * ${interval} + ${cardHistory.streak} * ${cardHistory.bestInterval}) / (${cardHistory.lapses} + ${cardHistory.streak}) = ${ret}`);
      return ret;
    } else {
      return interval;
    }
  } else {
    return 0;
  }
}
function lastSuccessfulInterval(cardHistory) {
  for (let i = cardHistory.length - 1; i >= 1; i--) {
    if (cardHistory[i].priorAttemps === 0 && cardHistory[i].isCorrect) {
      const lastInterval = secondsBetween(cardHistory[i - 1].timeStamp, cardHistory[i].timeStamp);
      const ret = Math.max(lastInterval, 20 * 60 * 60);
      logger.debug(`Last interval w/ this card was: ${lastInterval}s, returning ${ret}s`);
      return ret;
    }
  }
  return getInitialInterval(cardHistory);
}
function getStreak(records) {
  let streak = 0;
  let index = records.length - 1;
  while (index >= 0 && records[index].isCorrect) {
    index--;
    streak++;
  }
  return streak;
}
function getLapses(records) {
  return records.filter((r) => r.isCorrect === false).length;
}
function getInitialInterval(cardHistory) {
  logger.warn(`history of length: ${cardHistory.length} ignored!`);
  return 60 * 60 * 24 * 3;
}
function secondsBetween(start, end) {
  start = moment7(start);
  end = moment7(end);
  const ret = duration(end.diff(start)).asSeconds();
  return ret;
}

// src/study/services/SrsService.ts
init_logger();
var SrsService = class {
  user;
  constructor(user) {
    this.user = user;
  }
  /**
   * Remove a scheduled review from the user's database.
   * Used to clean up orphaned reviews (e.g., card deleted from course DB).
   */
  removeReview(reviewID) {
    logger.info(`[SrsService] Removing orphaned scheduled review: ${reviewID}`);
    void this.user.removeScheduledCardReview(reviewID);
  }
  /**
   * Calculates the next review time for a card based on its history and
   * schedules it in the user's database.
   * @param history The full history of the card.
   * @param item The study session item, used to determine if a previous review needs to be cleared.
   */
  async scheduleReview(history, item) {
    const nextInterval = newInterval(this.user, history);
    const nextReviewTime = moment8.utc().add(nextInterval, "seconds");
    if (isReview(item)) {
      logger.info(`[SrsService] Removing previously scheduled review for: ${item.cardID}`);
      void this.user.removeScheduledCardReview(item.reviewID);
    }
    void this.user.scheduleCardReview({
      user: this.user.getUsername(),
      course_id: history.courseID,
      card_id: history.cardID,
      time: nextReviewTime,
      scheduledFor: item.contentSourceType,
      schedulingAgentId: item.contentSourceID
    });
  }
};

// src/study/services/EloService.ts
init_logger();
import {
  adjustCourseScores,
  adjustCourseScoresPerTag,
  toCourseElo as toCourseElo7
} from "@vue-skuilder/common";
var EloService = class {
  dataLayer;
  user;
  constructor(dataLayer, user) {
    this.dataLayer = dataLayer;
    this.user = user;
  }
  /**
   * Updates both user and card ELO ratings based on user performance.
   * @param userScore Score between 0-1 representing user performance
   * @param course_id Course identifier
   * @param card_id Card identifier
   * @param userCourseRegDoc User's course registration document (will be mutated)
   * @param currentCard Current card session record
   * @param k Optional K-factor for ELO calculation
   */
  async updateUserAndCardElo(userScore, course_id, card_id, userCourseRegDoc, currentCard, k) {
    if (k) {
      logger.warn(`k value interpretation not currently implemented`);
    }
    const courseDB = this.dataLayer.getCourseDB(currentCard.card.course_id);
    const userElo = toCourseElo7(
      userCourseRegDoc.courses.find((c) => c.courseID === course_id).elo
    );
    const cardElo = (await courseDB.getCardEloData([currentCard.card.card_id]))[0];
    if (cardElo && userElo) {
      const eloUpdate = adjustCourseScores(userElo, cardElo, userScore);
      userCourseRegDoc.courses.find((c) => c.courseID === course_id).elo = eloUpdate.userElo;
      const results = await Promise.allSettled([
        this.user.updateUserElo(course_id, eloUpdate.userElo),
        courseDB.updateCardElo(card_id, eloUpdate.cardElo)
      ]);
      const userEloStatus = results[0].status === "fulfilled";
      const cardEloStatus = results[1].status === "fulfilled";
      if (userEloStatus && cardEloStatus) {
        const user = results[0].value;
        const card = results[1].value;
        if (user.ok && card && card.ok) {
          logger.info(
            `[EloService] Updated ELOS:
            	User: ${JSON.stringify(eloUpdate.userElo)})
            	Card: ${JSON.stringify(eloUpdate.cardElo)})
            `
          );
        }
      } else {
        logger.warn(
          `[EloService] Partial ELO update:
          	User ELO update: ${userEloStatus ? "SUCCESS" : "FAILED"}
          	Card ELO update: ${cardEloStatus ? "SUCCESS" : "FAILED"}`
        );
        if (!userEloStatus && results[0].status === "rejected") {
          logger.error("[EloService] User ELO update error:", results[0].reason);
        }
        if (!cardEloStatus && results[1].status === "rejected") {
          logger.error("[EloService] Card ELO update error:", results[1].reason);
        }
      }
    }
  }
  /**
   * Updates both user and card ELO ratings with per-tag granularity.
   * Tags in taggedPerformance but not on card will be created dynamically.
   *
   * @param taggedPerformance Performance object with _global and per-tag scores
   * @param course_id Course identifier
   * @param card_id Card identifier
   * @param userCourseRegDoc User's course registration document (will be mutated)
   * @param currentCard Current card session record
   */
  async updateUserAndCardEloPerTag(taggedPerformance, course_id, card_id, userCourseRegDoc, currentCard) {
    const courseDB = this.dataLayer.getCourseDB(currentCard.card.course_id);
    const userElo = toCourseElo7(
      userCourseRegDoc.courses.find((c) => c.courseID === course_id).elo
    );
    const [cardEloResults, cardTagsMap] = await Promise.all([
      courseDB.getCardEloData([currentCard.card.card_id]),
      courseDB.getAppliedTagsBatch([card_id])
    ]);
    const cardElo = cardEloResults[0];
    const cardTags = cardTagsMap.get(card_id) ?? [];
    const enriched = { ...taggedPerformance };
    const globalScore = taggedPerformance._global;
    for (const tag of cardTags) {
      if (!(tag in enriched)) {
        enriched[tag] = globalScore;
      }
    }
    if (cardElo && userElo) {
      const eloUpdate = adjustCourseScoresPerTag(userElo, cardElo, enriched);
      userCourseRegDoc.courses.find((c) => c.courseID === course_id).elo = eloUpdate.userElo;
      const results = await Promise.allSettled([
        this.user.updateUserElo(course_id, eloUpdate.userElo),
        courseDB.updateCardElo(card_id, eloUpdate.cardElo)
      ]);
      const userEloStatus = results[0].status === "fulfilled";
      const cardEloStatus = results[1].status === "fulfilled";
      if (userEloStatus && cardEloStatus) {
        const user = results[0].value;
        const card = results[1].value;
        if (user.ok && card && card.ok) {
          const tagCount = Object.keys(enriched).length - 1;
          logger.info(
            `[EloService] Updated ELOS (per-tag, ${tagCount} tags):
            	User: ${JSON.stringify(eloUpdate.userElo)})
            	Card: ${JSON.stringify(eloUpdate.cardElo)})
            `
          );
        }
      } else {
        logger.warn(
          `[EloService] Partial ELO update (per-tag):
          	User ELO update: ${userEloStatus ? "SUCCESS" : "FAILED"}
          	Card ELO update: ${cardEloStatus ? "SUCCESS" : "FAILED"}`
        );
        if (!userEloStatus && results[0].status === "rejected") {
          logger.error("[EloService] User ELO update error:", results[0].reason);
        }
        if (!cardEloStatus && results[1].status === "rejected") {
          logger.error("[EloService] Card ELO update error:", results[1].reason);
        }
      }
    }
  }
};

// src/study/services/ResponseProcessor.ts
init_core();
init_logger();
import { isTaggedPerformance as isTaggedPerformance2 } from "@vue-skuilder/common";
var ResponseProcessor = class {
  srsService;
  eloService;
  constructor(srsService, eloService) {
    this.srsService = srsService;
    this.eloService = eloService;
  }
  /**
   * Parses performance data into global score and optional per-tag scores.
   *
   * @param performance - Numeric or structured performance from QuestionRecord
   * @returns Parsed performance with global score and optional tag scores
   */
  parsePerformance(performance2) {
    if (typeof performance2 === "number") {
      return {
        globalScore: performance2,
        taggedPerformance: null
      };
    }
    if (isTaggedPerformance2(performance2)) {
      return {
        globalScore: performance2._global,
        taggedPerformance: performance2
      };
    }
    logger.warn("[ResponseProcessor] Unexpected performance structure, using neutral score", {
      performance: performance2
    });
    return {
      globalScore: 0.5,
      taggedPerformance: null
    };
  }
  /**
   * Processes a user's response to a card, handling SRS scheduling and ELO updates.
   * @param cardRecord User's response record
   * @param cardHistory Promise resolving to the card's history
   * @param studySessionItem Current study session item
   * @param courseRegistrationDoc User's course registration (for ELO updates)
   * @param currentCard Current study session record
   * @param courseId Course identifier
   * @param cardId Card identifier
   * @param maxAttemptsPerView Maximum attempts allowed per view
   * @param maxSessionViews Maximum session views for this card
   * @param sessionViews Current number of session views
   * @returns ResponseResult with navigation and UI instructions
   */
  async processResponse(cardRecord, cardHistory, studySessionItem, courseRegistrationDoc, currentCard, courseId, cardId, maxAttemptsPerView, maxSessionViews, sessionViews) {
    if (!isQuestionRecord(cardRecord)) {
      return {
        nextCardAction: "dismiss-success",
        shouldLoadNextCard: true,
        isCorrect: true,
        // non-question records are considered "correct"
        shouldClearFeedbackShadow: true
      };
    }
    try {
      const history = await cardHistory;
      let result;
      if (cardRecord.isCorrect) {
        result = this.processCorrectResponse(
          cardRecord,
          history,
          studySessionItem,
          courseRegistrationDoc,
          currentCard,
          courseId,
          cardId
        );
      } else {
        result = this.processIncorrectResponse(
          cardRecord,
          history,
          courseRegistrationDoc,
          currentCard,
          courseId,
          cardId,
          maxAttemptsPerView,
          maxSessionViews,
          sessionViews
        );
      }
      if (cardRecord.deferAdvance && result.shouldLoadNextCard) {
        logger.info(
          "[ResponseProcessor] deferAdvance requested \u2014 suppressing navigation, action stashed:",
          { nextCardAction: result.nextCardAction }
        );
        result = {
          ...result,
          shouldLoadNextCard: false,
          deferred: true
        };
      }
      return result;
    } catch (e) {
      logger.error("[ResponseProcessor] Failed to load card history", { e, cardId });
      throw e;
    }
  }
  /**
   * Handles processing for correct responses: SRS scheduling and ELO updates.
   */
  processCorrectResponse(cardRecord, history, studySessionItem, courseRegistrationDoc, currentCard, courseId, cardId) {
    if (cardRecord.priorAttemps === 0) {
      const skipSrs = currentCard.card.tags.includes("srs:skip");
      if (!skipSrs) {
        void this.srsService.scheduleReview(history, studySessionItem);
      }
      const { globalScore, taggedPerformance } = this.parsePerformance(cardRecord.performance);
      if (taggedPerformance) {
        const tagKeys = Object.keys(taggedPerformance).filter((k) => k !== "_global");
        const nullTags = tagKeys.filter((k) => taggedPerformance[k] === null);
        const scoredTags = tagKeys.filter((k) => taggedPerformance[k] !== null);
        logger.info(
          `[FirstContactElo] correct first-attempt per-tag ELO update for ${cardId} (historyLen=${history.records.length}, priorAttemps=${cardRecord.priorAttemps}): scored=[${scoredTags.join(", ")}] count-only=[${nullTags.join(", ")}]`
        );
        void this.eloService.updateUserAndCardEloPerTag(
          taggedPerformance,
          courseId,
          cardId,
          courseRegistrationDoc,
          currentCard
        );
      } else {
        const userScore = 0.5 + globalScore / 2;
        if (history.records.length === 1) {
          void this.eloService.updateUserAndCardElo(
            userScore,
            courseId,
            cardId,
            courseRegistrationDoc,
            currentCard
          );
        } else {
          const k = Math.ceil(32 / history.records.length);
          void this.eloService.updateUserAndCardElo(
            userScore,
            courseId,
            cardId,
            courseRegistrationDoc,
            currentCard,
            k
          );
        }
        logger.info(
          `[FirstContactElo] correct first-attempt ELO update (score=${userScore.toFixed(3)}) for ${cardId} (historyLen=${history.records.length}, priorAttemps=${cardRecord.priorAttemps})`
        );
      }
      return {
        nextCardAction: "dismiss-success",
        shouldLoadNextCard: true,
        isCorrect: true,
        performanceScore: globalScore,
        shouldClearFeedbackShadow: true
      };
    } else {
      logger.info(
        "[ResponseProcessor] Processed correct response (retry attempt - no scheduling/ELO)"
      );
      const { globalScore } = this.parsePerformance(cardRecord.performance);
      return {
        nextCardAction: "marked-failed",
        shouldLoadNextCard: true,
        isCorrect: true,
        performanceScore: globalScore,
        shouldClearFeedbackShadow: true
      };
    }
  }
  /**
   * Handles processing for incorrect responses: ELO updates only.
   */
  processIncorrectResponse(cardRecord, history, courseRegistrationDoc, currentCard, courseId, cardId, maxAttemptsPerView, maxSessionViews, sessionViews) {
    const { taggedPerformance } = this.parsePerformance(cardRecord.performance);
    let eloUpdated = false;
    if (cardRecord.priorAttemps === 0) {
      if (taggedPerformance) {
        void this.eloService.updateUserAndCardEloPerTag(
          taggedPerformance,
          courseId,
          cardId,
          courseRegistrationDoc,
          currentCard
        );
        logger.info(
          `[FirstContactElo] incorrect first-attempt per-tag ELO update for ${cardId} (historyLen=${history.records.length}, priorAttemps=${cardRecord.priorAttemps}, tags=${Object.keys(taggedPerformance).length - 1})`
        );
      } else {
        void this.eloService.updateUserAndCardElo(
          0,
          // Failed response = 0 score
          courseId,
          cardId,
          courseRegistrationDoc,
          currentCard
        );
        logger.info(
          `[FirstContactElo] incorrect first-attempt ELO update (score=0) for ${cardId} (historyLen=${history.records.length}, priorAttemps=${cardRecord.priorAttemps})`
        );
      }
      eloUpdated = true;
    } else {
      logger.info(
        `[FirstContactElo] incorrect retry \u2014 no ELO update for ${cardId} (historyLen=${history.records.length}, priorAttemps=${cardRecord.priorAttemps})`
      );
    }
    if (currentCard.records.length >= maxAttemptsPerView) {
      if (sessionViews >= maxSessionViews) {
        if (!eloUpdated) {
          if (taggedPerformance) {
            void this.eloService.updateUserAndCardEloPerTag(
              taggedPerformance,
              courseId,
              cardId,
              courseRegistrationDoc,
              currentCard
            );
          } else {
            void this.eloService.updateUserAndCardElo(
              0,
              courseId,
              cardId,
              courseRegistrationDoc,
              currentCard
            );
          }
          logger.info(
            `[FirstContactElo] dismiss-failed final ELO penalty for ${cardId} (historyLen=${history.records.length}, sessionViews=${sessionViews})`
          );
        } else {
          logger.info(
            `[FirstContactElo] dismiss-failed \u2014 ELO already updated this response, skipping double penalty for ${cardId}`
          );
        }
        return {
          nextCardAction: "dismiss-failed",
          shouldLoadNextCard: true,
          isCorrect: false,
          shouldClearFeedbackShadow: true
        };
      } else {
        return {
          nextCardAction: "marked-failed",
          shouldLoadNextCard: true,
          isCorrect: false,
          shouldClearFeedbackShadow: true
        };
      }
    } else {
      return {
        nextCardAction: "none",
        shouldLoadNextCard: false,
        isCorrect: false,
        shouldClearFeedbackShadow: true
      };
    }
  }
};

// src/study/services/CardHydrationService.ts
init_logger();
import {
  displayableDataToViewData,
  isCourseElo,
  toCourseElo as toCourseElo8
} from "@vue-skuilder/common";
function parseAudioURIs(data) {
  if (typeof data !== "string") return [];
  const audioPattern = /https?:\/\/[^\s"'<>]+\.(wav|mp3|ogg|m4a|aac|webm)/gi;
  return data.match(audioPattern) ?? [];
}
function prefetchAudio(url) {
  return new Promise((resolve) => {
    const audio = new Audio();
    audio.preload = "auto";
    const cleanup = () => {
      audio.oncanplaythrough = null;
      audio.onerror = null;
    };
    audio.oncanplaythrough = () => {
      cleanup();
      resolve();
    };
    audio.onerror = () => {
      cleanup();
      logger.warn(`[CardHydrationService] Failed to prefetch audio: ${url}`);
      resolve();
    };
    audio.src = url;
  });
}
var CardHydrationService = class {
  constructor(getViewComponent, getCourseDB3, getItemsToHydrate) {
    this.getViewComponent = getViewComponent;
    this.getCourseDB = getCourseDB3;
    this.getItemsToHydrate = getItemsToHydrate;
  }
  hydratedCards = /* @__PURE__ */ new Map();
  hydrationInFlight = /* @__PURE__ */ new Set();
  hydrationInProgress = false;
  /**
   * Get a hydrated card by ID.
   * @returns Hydrated card or null if not in cache
   */
  getHydratedCard(cardId) {
    return this.hydratedCards.get(cardId) ?? null;
  }
  /**
   * Check if a card is hydrated.
   */
  hasHydratedCard(cardId) {
    return this.hydratedCards.has(cardId);
  }
  /**
   * Remove a card from the cache (call on successful dismiss to free memory).
   */
  removeCard(cardId) {
    this.hydratedCards.delete(cardId);
  }
  /**
   * Check if hydration should be triggered and start background hydration if needed.
   */
  async ensureHydratedCards() {
    void this.fillHydratedCards();
  }
  /**
   * Wait for a specific card to become hydrated.
   * @returns Promise that resolves to a hydrated card or null
   */
  async waitForCard(cardId) {
    if (this.hydratedCards.has(cardId)) {
      return this.hydratedCards.get(cardId);
    }
    if (!this.hydrationInProgress) {
      void this.fillHydratedCards();
    }
    const maxWaitMs = 1e4;
    const pollIntervalMs = 25;
    let elapsed = 0;
    while (elapsed < maxWaitMs) {
      if (this.hydratedCards.has(cardId)) {
        return this.hydratedCards.get(cardId);
      }
      if (!this.hydrationInFlight.has(cardId) && !this.hydrationInProgress) {
        break;
      }
      await new Promise((resolve) => setTimeout(resolve, pollIntervalMs));
      elapsed += pollIntervalMs;
    }
    return this.hydratedCards.get(cardId) ?? null;
  }
  /**
   * Get current hydrated cache size.
   */
  get hydratedCount() {
    return this.hydratedCards.size;
  }
  /**
   * Get list of currently hydrated card IDs (for debugging).
   */
  getHydratedCardIds() {
    return Array.from(this.hydratedCards.keys());
  }
  /**
   * Fill the hydrated cache by hydrating items from getItemsToHydrate().
   * This is a pure cache-warming operation - no queue mutation.
   */
  async fillHydratedCards() {
    if (this.hydrationInProgress) {
      return;
    }
    this.hydrationInProgress = true;
    try {
      const itemsToHydrate = this.getItemsToHydrate();
      for (const item of itemsToHydrate) {
        if (this.hydratedCards.has(item.cardID) || this.hydrationInFlight.has(item.cardID)) {
          continue;
        }
        try {
          await this.hydrateCard(item);
        } catch (e) {
          logger.error(`[CardHydrationService] Error hydrating card ${item.cardID}:`, e);
        }
      }
    } finally {
      this.hydrationInProgress = false;
    }
  }
  /**
   * Hydrate a single card and add to cache.
   */
  async hydrateCard(item) {
    if (this.hydratedCards.has(item.cardID) || this.hydrationInFlight.has(item.cardID)) {
      return;
    }
    this.hydrationInFlight.add(item.cardID);
    try {
      const courseDB = this.getCourseDB(item.courseID);
      const [cardData, tagsByCard] = await Promise.all([
        courseDB.getCourseDoc(item.cardID),
        courseDB.getAppliedTagsBatch([item.cardID])
      ]);
      if (!isCourseElo(cardData.elo)) {
        cardData.elo = toCourseElo8(cardData.elo);
      }
      const view = this.getViewComponent(cardData.id_view);
      const dataDocs = await Promise.all(
        cardData.id_displayable_data.map(
          (id) => courseDB.getCourseDoc(id, {
            attachments: true,
            binary: true
          })
        )
      );
      const audioToPrefetch = [];
      dataDocs.forEach((dd) => {
        dd.data.forEach((f) => {
          audioToPrefetch.push(...parseAudioURIs(f.data));
        });
      });
      const uniqueAudioUrls = [...new Set(audioToPrefetch)];
      if (uniqueAudioUrls.length > 0) {
        logger.debug(
          `[CardHydrationService] Prefetching ${uniqueAudioUrls.length} audio files for card ${item.cardID}`
        );
        await Promise.allSettled(uniqueAudioUrls.map(prefetchAudio));
      }
      const data = dataDocs.map(displayableDataToViewData).reverse();
      this.hydratedCards.set(item.cardID, {
        item,
        view,
        data,
        tags: tagsByCard.get(item.cardID) ?? []
      });
      logger.debug(`[CardHydrationService] Hydrated card ${item.cardID}`);
    } finally {
      this.hydrationInFlight.delete(item.cardID);
    }
  }
};

// src/study/ItemQueue.ts
var ItemQueue = class {
  q = [];
  seenCardIds = [];
  _dequeueCount = 0;
  get dequeueCount() {
    return this._dequeueCount;
  }
  add(item, cardId) {
    if (this.seenCardIds.find((d) => d === cardId)) {
      return;
    }
    this.seenCardIds.push(cardId);
    this.q.push(item);
  }
  addAll(items, cardIdExtractor) {
    items.forEach((i) => this.add(i, cardIdExtractor(i)));
  }
  get length() {
    return this.q.length;
  }
  peek(index) {
    return this.q[index];
  }
  dequeue(cardIdExtractor) {
    if (this.q.length !== 0) {
      this._dequeueCount++;
      const item = this.q.splice(0, 1)[0];
      if (cardIdExtractor) {
        const cardId = cardIdExtractor(item);
        const index = this.seenCardIds.indexOf(cardId);
        if (index > -1) {
          this.seenCardIds.splice(index, 1);
        }
      }
      return item;
    } else {
      return null;
    }
  }
  /**
   * Atomically replace all queue contents with new items.
   *
   * Used by mid-session replanning to swap the queue without a window where
   * it's empty (avoiding dead-air if nextCard() is called concurrently).
   *
   * Preserves dequeueCount (cumulative across the session).
   * Resets seenCardIds to match the new contents — cards from the old queue
   * that don't appear in the new set can be re-added in future replans.
   */
  replaceAll(items, cardIdExtractor) {
    this.q = [];
    this.seenCardIds = [];
    for (const item of items) {
      const cardId = cardIdExtractor(item);
      if (!this.seenCardIds.includes(cardId)) {
        this.seenCardIds.push(cardId);
        this.q.push(item);
      }
    }
  }
  /**
   * Merge new items into the front of the queue, skipping duplicates.
   * Used by additive replans to inject high-quality candidates without
   * discarding the existing queue contents.
   *
   * `forceFrontIds` carries the mandatory (`+INF`) cards in this batch — a
   * durable `requireCard`/`requireTag` re-asserted by every replan. An ordinary
   * duplicate is left in place (skip), but a mandatory one that's *already*
   * queued is pulled out of its current slot so it rejoins at the front in batch
   * order. Without this, an additive merge unshifts fresh non-required cards
   * ahead of an already-present required card, steadily burying it until it never
   * gets drawn — defeating the "must appear" guarantee. Returns the count of
   * genuinely new cards added (re-fronted duplicates are not counted).
   */
  mergeToFront(items, cardIdExtractor, forceFrontIds) {
    let added = 0;
    const toInsert = [];
    for (const item of items) {
      const cardId = cardIdExtractor(item);
      if (!this.seenCardIds.includes(cardId)) {
        this.seenCardIds.push(cardId);
        toInsert.push(item);
        added++;
      } else if (forceFrontIds?.has(cardId)) {
        const idx = this.q.findIndex((qi) => cardIdExtractor(qi) === cardId);
        if (idx >= 0) {
          toInsert.push(...this.q.splice(idx, 1));
        }
      }
    }
    this.q.unshift(...toInsert);
    return added;
  }
  get toString() {
    return `${typeof this.q[0]}:
` + this.q.map((i) => `	${i.courseID}+${i.cardID}: ${i.status}`).join("\n");
  }
};

// src/study/SessionController.ts
init_couch();
init_core();
init_recording();

// src/util/index.ts
init_Loggable();

// src/util/packer/CouchDBToStaticPacker.ts
init_types_legacy();
init_logger();
var CouchDBToStaticPacker = class {
  config;
  sourceDB = null;
  constructor(config = {}) {
    this.config = {
      chunkSize: 1e3,
      includeAttachments: true,
      ...config
    };
  }
  /**
   * Pack a CouchDB course database into static data structures
   */
  async packCourse(sourceDB, courseId) {
    logger.info(`Starting static pack for course: ${courseId}`);
    this.sourceDB = sourceDB;
    const manifest = {
      version: "1.0.0",
      courseId,
      courseName: "",
      courseConfig: null,
      lastUpdated: (/* @__PURE__ */ new Date()).toISOString(),
      documentCount: 0,
      chunks: [],
      indices: [],
      designDocs: []
    };
    const courseConfig = await this.extractCourseConfig(sourceDB);
    manifest.courseName = courseConfig.name;
    manifest.courseConfig = courseConfig;
    manifest.designDocs = await this.extractDesignDocs(sourceDB);
    const docsByType = await this.extractDocumentsByType(sourceDB);
    const attachments = /* @__PURE__ */ new Map();
    if (this.config.includeAttachments) {
      await this.extractAllAttachments(docsByType, attachments);
    }
    const chunks = /* @__PURE__ */ new Map();
    for (const [docType, docs] of Object.entries(docsByType)) {
      const chunkMetadata = this.createChunks(docs, docType);
      manifest.chunks.push(...chunkMetadata);
      manifest.documentCount += docs.length;
      this.prepareChunkData(chunkMetadata, docs, chunks);
    }
    const indices = /* @__PURE__ */ new Map();
    manifest.indices = await this.buildIndices(docsByType, manifest.designDocs, indices);
    return {
      manifest,
      chunks,
      indices,
      attachments
    };
  }
  /**
   * Pack a CouchDB course database and write the static files to disk
   */
  async packCourseToFiles(sourceDB, courseId, outputDir, fsAdapter) {
    logger.info(`Packing course ${courseId} to files in ${outputDir}`);
    const packedData = await this.packCourse(sourceDB, courseId);
    const filesWritten = await this.writePackedDataToFiles(packedData, outputDir, fsAdapter);
    return {
      manifest: packedData.manifest,
      filesWritten,
      attachmentsFound: packedData.attachments ? packedData.attachments.size : 0
    };
  }
  /**
   * Write packed course data to files using FileSystemAdapter
   */
  async writePackedDataToFiles(packedData, outputDir, fsAdapter) {
    let totalFiles = 0;
    await fsAdapter.ensureDir(outputDir);
    const manifestPath = fsAdapter.joinPath(outputDir, "manifest.json");
    await fsAdapter.writeJson(manifestPath, packedData.manifest, { spaces: 2 });
    totalFiles++;
    logger.info(`Wrote manifest: ${manifestPath}`);
    const chunksDir = fsAdapter.joinPath(outputDir, "chunks");
    const indicesDir = fsAdapter.joinPath(outputDir, "indices");
    await fsAdapter.ensureDir(chunksDir);
    await fsAdapter.ensureDir(indicesDir);
    for (const [chunkId, chunkData] of packedData.chunks) {
      const chunkPath = fsAdapter.joinPath(chunksDir, `${chunkId}.json`);
      await fsAdapter.writeJson(chunkPath, chunkData);
      totalFiles++;
    }
    logger.info(`Wrote ${packedData.chunks.size} chunk files`);
    for (const [indexName, indexData] of packedData.indices) {
      const indexPath = fsAdapter.joinPath(indicesDir, `${indexName}.json`);
      await fsAdapter.writeJson(indexPath, indexData, { spaces: 2 });
      totalFiles++;
    }
    logger.info(`Wrote ${packedData.indices.size} index files`);
    if (packedData.attachments && packedData.attachments.size > 0) {
      for (const [attachmentPath, attachmentData] of packedData.attachments) {
        const fullAttachmentPath = fsAdapter.joinPath(outputDir, attachmentPath);
        const attachmentDir = fsAdapter.dirname(fullAttachmentPath);
        await fsAdapter.ensureDir(attachmentDir);
        await fsAdapter.writeFile(fullAttachmentPath, attachmentData.buffer);
        totalFiles++;
      }
      logger.info(`Wrote ${packedData.attachments.size} attachment files`);
    }
    return totalFiles;
  }
  async extractCourseConfig(db) {
    try {
      return await db.get("CourseConfig");
    } catch (error) {
      logger.error("Failed to extract course config:", error);
      throw new Error("Course config not found");
    }
  }
  async extractDesignDocs(db) {
    const result = await db.allDocs({
      startkey: "_design/",
      endkey: "_design/\uFFF0",
      include_docs: true
    });
    return result.rows.map((row) => ({
      _id: row.id,
      views: row.doc.views || {}
    }));
  }
  async extractDocumentsByType(db) {
    const allDocs = await db.allDocs({ include_docs: true });
    const docsByType = {};
    for (const row of allDocs.rows) {
      if (row.id.startsWith("_")) continue;
      const doc = row.doc;
      if (doc.docType) {
        if (!docsByType[doc.docType]) {
          docsByType[doc.docType] = [];
        }
        docsByType[doc.docType].push(doc);
      }
    }
    return docsByType;
  }
  createChunks(docs, docType) {
    const chunks = [];
    const sortedDocs = docs.sort((a, b) => a._id.localeCompare(b._id));
    for (let i = 0; i < sortedDocs.length; i += this.config.chunkSize) {
      const chunk = sortedDocs.slice(i, i + this.config.chunkSize);
      const chunkId = `${docType}-${String(Math.floor(i / this.config.chunkSize)).padStart(4, "0")}`;
      chunks.push({
        id: chunkId,
        docType,
        startKey: chunk[0]._id,
        endKey: chunk[chunk.length - 1]._id,
        documentCount: chunk.length,
        path: `chunks/${chunkId}.json`
      });
    }
    return chunks;
  }
  prepareChunkData(chunkMetadata, docs, chunks) {
    const sortedDocs = docs.sort((a, b) => a._id.localeCompare(b._id));
    for (const chunk of chunkMetadata) {
      const chunkDocs = sortedDocs.filter(
        (doc) => doc._id >= chunk.startKey && doc._id <= chunk.endKey
      );
      const cleanedDocs = chunkDocs.map((doc) => {
        const cleaned = { ...doc };
        delete cleaned._rev;
        if (this.config.includeAttachments && cleaned._attachments) {
          cleaned._attachments = this.transformAttachmentStubs(cleaned._attachments, cleaned._id);
        } else if (!this.config.includeAttachments) {
          delete cleaned._attachments;
        }
        return cleaned;
      });
      chunks.set(chunk.id, cleanedDocs);
    }
  }
  async buildIndices(docsByType, designDocs, indices) {
    const indexMetadata = [];
    if (docsByType["CARD" /* CARD */]) {
      const eloIndexMeta = await this.buildEloIndex(
        docsByType["CARD" /* CARD */],
        indices
      );
      indexMetadata.push(eloIndexMeta);
    }
    if (docsByType["TAG" /* TAG */]) {
      const tagIndexMeta = await this.buildTagIndex(docsByType["TAG" /* TAG */], indices);
      indexMetadata.push(tagIndexMeta);
    }
    for (const designDoc of designDocs) {
      for (const [viewName, viewDef] of Object.entries(designDoc.views)) {
        if (viewDef.map) {
          logger.info(`Processing view: ${designDoc._id}/${viewName}`);
          const indexMeta = await this.buildViewIndex(viewName, designDoc, indices);
          if (indexMeta) {
            indexMetadata.push(indexMeta);
            logger.info(`Successfully built index: ${indexMeta.name}`);
          } else {
            logger.warn(`Skipped view index: ${designDoc._id}/${viewName}`);
          }
        }
      }
    }
    return indexMetadata;
  }
  async buildEloIndex(cards, indices) {
    const eloIndex = [];
    for (const card of cards) {
      if (card.elo?.global?.score) {
        eloIndex.push({
          elo: card.elo.global.score,
          cardId: card._id
        });
      }
    }
    eloIndex.sort((a, b) => a.elo - b.elo);
    const buckets = {};
    const bucketSize = 50;
    for (const entry of eloIndex) {
      const bucket = Math.floor(entry.elo / bucketSize) * bucketSize;
      if (!buckets[bucket]) buckets[bucket] = [];
      buckets[bucket].push(entry.cardId);
    }
    indices.set("elo", {
      sorted: eloIndex,
      buckets,
      stats: {
        min: eloIndex[0]?.elo || 0,
        max: eloIndex[eloIndex.length - 1]?.elo || 0,
        count: eloIndex.length
      }
    });
    return {
      name: "elo",
      type: "btree",
      path: "indices/elo.json"
    };
  }
  async buildTagIndex(tags, indices) {
    const tagIndex = {};
    for (const tag of tags) {
      tagIndex[tag.name] = {
        cardIds: tag.taggedCards,
        snippet: tag.snippet,
        count: tag.taggedCards.length
      };
    }
    const cardToTags = {};
    for (const tag of tags) {
      for (const cardId of tag.taggedCards) {
        if (!cardToTags[cardId]) cardToTags[cardId] = [];
        cardToTags[cardId].push(tag.name);
      }
    }
    indices.set("tags", {
      byTag: tagIndex,
      byCard: cardToTags
    });
    return {
      name: "tags",
      type: "hash",
      path: "indices/tags.json"
    };
  }
  /**
   * Build view index by querying CouchDB views directly instead of parsing map functions
   */
  async buildViewIndex(viewName, designDoc, indices) {
    if (!this.sourceDB) {
      logger.error("Source database not available for view querying");
      return null;
    }
    try {
      const designDocId = designDoc._id;
      const designDocName = designDocId.replace("_design/", "");
      const viewPath = `${designDocName}/${viewName}`;
      logger.info(`Querying CouchDB view: ${viewPath}`);
      const viewResults = await this.sourceDB.query(viewPath, {
        include_docs: false
      });
      if (!viewResults.rows || viewResults.rows.length === 0) {
        logger.warn(`View ${viewPath} returned no results`);
        return null;
      }
      logger.info(`Successfully queried view ${viewPath}: ${viewResults.rows.length} results`);
      const formattedResults = this.formatViewResults(viewName, viewResults.rows, designDoc);
      const indexName = `view-${designDoc._id.replace("_design/", "")}-${viewName}`;
      indices.set(indexName, formattedResults);
      return {
        name: indexName,
        type: "view",
        path: `indices/${indexName}.json`
      };
    } catch (error) {
      logger.error(`Failed to query view ${designDoc._id}/${viewName}:`, error);
      return null;
    }
  }
  /**
   * Format CouchDB view results for static consumption
   */
  formatViewResults(viewName, viewRows, designDoc) {
    const baseResult = {
      type: "couchdb-view",
      viewName,
      designDoc: designDoc._id,
      results: viewRows,
      metadata: {
        resultCount: viewRows.length,
        generatedAt: (/* @__PURE__ */ new Date()).toISOString()
      }
    };
    switch (viewName) {
      case "elo":
        return this.formatEloViewIndex(viewRows, baseResult);
      case "getTags":
        return this.formatTagsViewIndex(viewRows, baseResult);
      case "cardsByInexperience":
        return this.formatInexperienceViewIndex(viewRows, baseResult);
      default:
        return this.formatGenericViewIndex(viewRows, baseResult);
    }
  }
  /**
   * Format ELO view results - convert to sorted array format
   */
  formatEloViewIndex(viewRows, baseResult) {
    const sortedResults = viewRows.sort((a, b) => {
      if (typeof a.key === "number" && typeof b.key === "number") {
        return a.key - b.key;
      }
      return 0;
    });
    return {
      ...baseResult,
      sorted: sortedResults,
      stats: {
        min: sortedResults[0]?.key || 0,
        max: sortedResults[sortedResults.length - 1]?.key || 0,
        count: sortedResults.length
      }
    };
  }
  /**
   * Format tags view results - convert to tag mapping format
   */
  formatTagsViewIndex(viewRows, baseResult) {
    const tagMap = {};
    for (const row of viewRows) {
      const tagName = row.key;
      if (typeof tagName === "string") {
        if (!tagMap[tagName]) {
          tagMap[tagName] = [];
        }
        tagMap[tagName].push(row.id);
      }
    }
    return {
      ...baseResult,
      byTag: tagMap,
      tagCount: Object.keys(tagMap).length
    };
  }
  /**
   * Format inexperience view results - convert to experience-based format
   */
  formatInexperienceViewIndex(viewRows, baseResult) {
    const sortedResults = viewRows.sort((a, b) => {
      if (typeof a.key === "number" && typeof b.key === "number") {
        return a.key - b.key;
      }
      return 0;
    });
    return {
      ...baseResult,
      sorted: sortedResults,
      stats: {
        minInexperience: sortedResults[0]?.key || 0,
        maxInexperience: sortedResults[sortedResults.length - 1]?.key || 0,
        count: sortedResults.length
      }
    };
  }
  /**
   * Format generic view results - fallback for unknown views
   */
  formatGenericViewIndex(_viewRows, baseResult) {
    return {
      ...baseResult
      // Keep results as-is for unknown view types
    };
  }
  /**
   * Extract all attachments from documents and download binary data
   */
  async extractAllAttachments(docsByType, attachments) {
    logger.info("Extracting attachments...");
    const allDocs = [];
    for (const docs of Object.values(docsByType)) {
      allDocs.push(...docs);
    }
    const docsWithAttachments = allDocs.filter((doc) => doc._attachments && Object.keys(doc._attachments).length > 0);
    if (docsWithAttachments.length === 0) {
      logger.info("No attachments found");
      return;
    }
    logger.info(`Found ${docsWithAttachments.length} documents with attachments`);
    const extractionPromises = docsWithAttachments.map(
      (doc) => this.extractDocumentAttachments(doc, attachments)
    );
    await Promise.all(extractionPromises);
    logger.info(`Extracted ${attachments.size} attachment files`);
  }
  /**
   * Extract attachments for a single document
   */
  async extractDocumentAttachments(doc, attachments) {
    if (!doc._attachments || !this.sourceDB) {
      return;
    }
    const docId = doc._id;
    for (const [attachmentName, metadata] of Object.entries(doc._attachments)) {
      try {
        const attachmentResponse = await this.sourceDB.getAttachment(docId, attachmentName);
        let buffer;
        if (attachmentResponse instanceof ArrayBuffer) {
          buffer = Buffer.from(attachmentResponse);
        } else if (Buffer.isBuffer(attachmentResponse)) {
          buffer = attachmentResponse;
        } else {
          const blob = attachmentResponse;
          buffer = Buffer.from(await blob.arrayBuffer());
        }
        const extension = this.getFileExtension(metadata.content_type);
        const filename = `${attachmentName}${extension}`;
        const attachmentPath = `attachments/${docId}/${filename}`;
        attachments.set(attachmentPath, {
          docId,
          attachmentName,
          filename,
          path: attachmentPath,
          contentType: metadata.content_type,
          length: metadata.length || buffer.length,
          digest: metadata.digest,
          buffer
        });
        logger.debug(`Extracted attachment: ${attachmentPath}`);
      } catch (error) {
        logger.error(`Failed to extract attachment ${docId}/${attachmentName}:`, error);
        throw new Error(`Failed to extract attachment ${docId}/${attachmentName}: ${error}`);
      }
    }
  }
  /**
   * Transform attachment stubs to include file paths
   */
  transformAttachmentStubs(attachments, docId) {
    const transformed = {};
    for (const [attachmentName, metadata] of Object.entries(attachments)) {
      const extension = this.getFileExtension(metadata.content_type);
      const filename = `${attachmentName}${extension}`;
      const attachmentPath = `attachments/${docId}/${filename}`;
      transformed[attachmentName] = {
        path: attachmentPath,
        content_type: metadata.content_type,
        length: metadata.length,
        digest: metadata.digest,
        stub: false
        // No longer a stub - we have the actual file
      };
    }
    return transformed;
  }
  /**
   * Get file extension from content type
   */
  getFileExtension(contentType) {
    const extensionMap = {
      "image/jpeg": ".jpg",
      "image/jpg": ".jpg",
      "image/png": ".png",
      "image/gif": ".gif",
      "image/webp": ".webp",
      "audio/mpeg": ".mp3",
      "audio/mp3": ".mp3",
      "audio/wav": ".wav",
      "audio/ogg": ".ogg",
      "video/mp4": ".mp4",
      "video/webm": ".webm",
      "application/pdf": ".pdf",
      "text/plain": ".txt",
      "application/json": ".json"
    };
    return extensionMap[contentType] || "";
  }
};

// src/util/migrator/StaticToCouchDBMigrator.ts
init_logger();

// src/util/migrator/types.ts
var DEFAULT_MIGRATION_OPTIONS = {
  chunkBatchSize: 100,
  validateRoundTrip: false,
  cleanupOnFailure: true,
  timeout: 3e5
  // 5 minutes
};

// src/util/migrator/validation.ts
init_logger();

// src/util/migrator/FileSystemAdapter.ts
var FileSystemError = class extends Error {
  constructor(message, operation, filePath, cause) {
    super(message);
    this.operation = operation;
    this.filePath = filePath;
    this.cause = cause;
    this.name = "FileSystemError";
  }
};

// src/util/migrator/validation.ts
var nodeFS2 = null;
try {
  if (typeof window === "undefined" && typeof process !== "undefined" && process.versions?.node) {
    nodeFS2 = eval("require")("fs");
    nodeFS2.promises = nodeFS2.promises || eval("require")("fs").promises;
  }
} catch {
}
async function validateStaticCourse(staticPath, fs2) {
  const validation = {
    valid: true,
    manifestExists: false,
    chunksExist: false,
    attachmentsExist: false,
    errors: [],
    warnings: []
  };
  try {
    if (fs2) {
      const stats = await fs2.stat(staticPath);
      if (!stats.isDirectory()) {
        validation.errors.push(`Path is not a directory: ${staticPath}`);
        validation.valid = false;
        return validation;
      }
    } else if (!nodeFS2) {
      validation.errors.push("File system access not available - validation skipped");
      validation.valid = false;
      return validation;
    } else {
      const stats = await nodeFS2.promises.stat(staticPath);
      if (!stats.isDirectory()) {
        validation.errors.push(`Path is not a directory: ${staticPath}`);
        validation.valid = false;
        return validation;
      }
    }
    let manifestPath = `${staticPath}/manifest.json`;
    try {
      if (fs2) {
        manifestPath = fs2.joinPath(staticPath, "manifest.json");
        if (await fs2.exists(manifestPath)) {
          validation.manifestExists = true;
          const manifestContent = await fs2.readFile(manifestPath);
          const manifest = JSON.parse(manifestContent);
          validation.courseId = manifest.courseId;
          validation.courseName = manifest.courseName;
          if (!manifest.version || !manifest.courseId || !manifest.chunks || !Array.isArray(manifest.chunks)) {
            validation.errors.push("Invalid manifest structure");
            validation.valid = false;
          }
        } else {
          validation.errors.push(`Manifest not found: ${manifestPath}`);
          validation.valid = false;
        }
      } else {
        manifestPath = `${staticPath}/manifest.json`;
        await nodeFS2.promises.access(manifestPath);
        validation.manifestExists = true;
        const manifestContent = await nodeFS2.promises.readFile(manifestPath, "utf8");
        const manifest = JSON.parse(manifestContent);
        validation.courseId = manifest.courseId;
        validation.courseName = manifest.courseName;
        if (!manifest.version || !manifest.courseId || !manifest.chunks || !Array.isArray(manifest.chunks)) {
          validation.errors.push("Invalid manifest structure");
          validation.valid = false;
        }
      }
    } catch (error) {
      const errorMessage = error instanceof FileSystemError ? error.message : `Manifest not found or invalid: ${manifestPath}`;
      validation.errors.push(errorMessage);
      validation.valid = false;
    }
    let chunksPath = `${staticPath}/chunks`;
    try {
      if (fs2) {
        chunksPath = fs2.joinPath(staticPath, "chunks");
        if (await fs2.exists(chunksPath)) {
          const chunksStats = await fs2.stat(chunksPath);
          if (chunksStats.isDirectory()) {
            validation.chunksExist = true;
          } else {
            validation.errors.push(`Chunks path is not a directory: ${chunksPath}`);
            validation.valid = false;
          }
        } else {
          validation.errors.push(`Chunks directory not found: ${chunksPath}`);
          validation.valid = false;
        }
      } else {
        chunksPath = `${staticPath}/chunks`;
        const chunksStats = await nodeFS2.promises.stat(chunksPath);
        if (chunksStats.isDirectory()) {
          validation.chunksExist = true;
        } else {
          validation.errors.push(`Chunks path is not a directory: ${chunksPath}`);
          validation.valid = false;
        }
      }
    } catch (error) {
      const errorMessage = error instanceof FileSystemError ? error.message : `Chunks directory not found: ${chunksPath}`;
      validation.errors.push(errorMessage);
      validation.valid = false;
    }
    let attachmentsPath;
    try {
      if (fs2) {
        attachmentsPath = fs2.joinPath(staticPath, "attachments");
        if (await fs2.exists(attachmentsPath)) {
          const attachmentsStats = await fs2.stat(attachmentsPath);
          if (attachmentsStats.isDirectory()) {
            validation.attachmentsExist = true;
          }
        } else {
          validation.warnings.push(
            `Attachments directory not found: ${attachmentsPath} (this is OK if course has no attachments)`
          );
        }
      } else {
        attachmentsPath = `${staticPath}/attachments`;
        const attachmentsStats = await nodeFS2.promises.stat(attachmentsPath);
        if (attachmentsStats.isDirectory()) {
          validation.attachmentsExist = true;
        }
      }
    } catch (error) {
      attachmentsPath = attachmentsPath || `${staticPath}/attachments`;
      const warningMessage = error instanceof FileSystemError ? error.message : `Attachments directory not found: ${attachmentsPath} (this is OK if course has no attachments)`;
      validation.warnings.push(warningMessage);
    }
  } catch (error) {
    validation.errors.push(
      `Failed to validate static course: ${error instanceof Error ? error.message : String(error)}`
    );
    validation.valid = false;
  }
  return validation;
}
async function validateMigration(targetDB, expectedCounts, manifest) {
  const validation = {
    valid: true,
    documentCountMatch: false,
    attachmentIntegrity: false,
    viewFunctionality: false,
    issues: []
  };
  try {
    logger.info("Starting migration validation...");
    const actualCounts = await getActualDocumentCounts(targetDB);
    validation.documentCountMatch = compareDocumentCounts(
      expectedCounts,
      actualCounts,
      validation.issues
    );
    await validateCourseConfig(targetDB, manifest, validation.issues);
    validation.viewFunctionality = await validateViews(targetDB, manifest, validation.issues);
    validation.attachmentIntegrity = await validateAttachmentIntegrity(targetDB, validation.issues);
    validation.valid = validation.documentCountMatch && validation.viewFunctionality && validation.attachmentIntegrity;
    logger.info(`Migration validation completed. Valid: ${validation.valid}`);
    if (validation.issues.length > 0) {
      logger.info(`Validation issues: ${validation.issues.length}`);
      validation.issues.forEach((issue) => {
        if (issue.type === "error") {
          logger.error(`${issue.category}: ${issue.message}`);
        } else {
          logger.warn(`${issue.category}: ${issue.message}`);
        }
      });
    }
  } catch (error) {
    validation.valid = false;
    validation.issues.push({
      type: "error",
      category: "metadata",
      message: `Validation failed: ${error instanceof Error ? error.message : String(error)}`
    });
  }
  return validation;
}
async function getActualDocumentCounts(db) {
  const counts = {};
  try {
    const allDocs = await db.allDocs({ include_docs: true });
    for (const row of allDocs.rows) {
      if (row.id.startsWith("_design/")) {
        counts["_design"] = (counts["_design"] || 0) + 1;
        continue;
      }
      const doc = row.doc;
      if (doc && doc.docType) {
        counts[doc.docType] = (counts[doc.docType] || 0) + 1;
      } else {
        counts["unknown"] = (counts["unknown"] || 0) + 1;
      }
    }
  } catch (error) {
    logger.error("Failed to get actual document counts:", error);
  }
  return counts;
}
function compareDocumentCounts(expected, actual, issues) {
  let countsMatch = true;
  for (const [docType, expectedCount] of Object.entries(expected)) {
    const actualCount = actual[docType] || 0;
    if (actualCount !== expectedCount) {
      countsMatch = false;
      issues.push({
        type: "error",
        category: "documents",
        message: `Document count mismatch for ${docType}: expected ${expectedCount}, got ${actualCount}`
      });
    }
  }
  for (const [docType, actualCount] of Object.entries(actual)) {
    if (!expected[docType] && docType !== "_design") {
      issues.push({
        type: "warning",
        category: "documents",
        message: `Unexpected document type found: ${docType} (${actualCount} documents)`
      });
    }
  }
  return countsMatch;
}
async function validateCourseConfig(db, manifest, issues) {
  try {
    const courseConfig = await db.get("CourseConfig");
    if (!courseConfig) {
      issues.push({
        type: "error",
        category: "course_config",
        message: "CourseConfig document not found after migration"
      });
      return;
    }
    if (!courseConfig.courseID) {
      issues.push({
        type: "warning",
        category: "course_config",
        message: "CourseConfig document missing courseID field"
      });
    }
    if (courseConfig.courseID !== manifest.courseId) {
      issues.push({
        type: "warning",
        category: "course_config",
        message: `CourseConfig courseID mismatch: expected ${manifest.courseId}, got ${courseConfig.courseID}`
      });
    }
    logger.debug("CourseConfig document validation passed");
  } catch (error) {
    if (error.status === 404) {
      issues.push({
        type: "error",
        category: "course_config",
        message: "CourseConfig document not found in database"
      });
    } else {
      issues.push({
        type: "error",
        category: "course_config",
        message: `Failed to validate CourseConfig document: ${error instanceof Error ? error.message : String(error)}`
      });
    }
  }
}
async function validateViews(db, manifest, issues) {
  let viewsValid = true;
  try {
    for (const designDoc of manifest.designDocs) {
      try {
        const doc = await db.get(designDoc._id);
        if (!doc) {
          viewsValid = false;
          issues.push({
            type: "error",
            category: "views",
            message: `Design document not found: ${designDoc._id}`
          });
          continue;
        }
        for (const viewName of Object.keys(designDoc.views)) {
          try {
            const viewPath = `${designDoc._id}/${viewName}`;
            await db.query(viewPath, { limit: 1 });
          } catch (viewError) {
            viewsValid = false;
            issues.push({
              type: "error",
              category: "views",
              message: `View not accessible: ${designDoc._id}/${viewName} - ${viewError}`
            });
          }
        }
      } catch (error) {
        viewsValid = false;
        issues.push({
          type: "error",
          category: "views",
          message: `Failed to validate design document ${designDoc._id}: ${error}`
        });
      }
    }
  } catch (error) {
    viewsValid = false;
    issues.push({
      type: "error",
      category: "views",
      message: `View validation failed: ${error instanceof Error ? error.message : String(error)}`
    });
  }
  return viewsValid;
}
async function validateAttachmentIntegrity(db, issues) {
  let attachmentsValid = true;
  try {
    const allDocs = await db.allDocs({
      include_docs: true,
      limit: 10
      // Sample first 10 documents for performance
    });
    let attachmentCount = 0;
    let validAttachments = 0;
    for (const row of allDocs.rows) {
      const doc = row.doc;
      if (doc && doc._attachments) {
        for (const [attachmentName, _attachmentMeta] of Object.entries(doc._attachments)) {
          attachmentCount++;
          try {
            const attachment = await db.getAttachment(doc._id, attachmentName);
            if (attachment) {
              validAttachments++;
            }
          } catch (attachmentError) {
            attachmentsValid = false;
            issues.push({
              type: "error",
              category: "attachments",
              message: `Attachment not accessible: ${doc._id}/${attachmentName} - ${attachmentError}`
            });
          }
        }
      }
    }
    if (attachmentCount === 0) {
      issues.push({
        type: "warning",
        category: "attachments",
        message: "No attachments found in sampled documents"
      });
    } else {
      logger.info(`Validated ${validAttachments}/${attachmentCount} sampled attachments`);
    }
  } catch (error) {
    attachmentsValid = false;
    issues.push({
      type: "error",
      category: "attachments",
      message: `Attachment validation failed: ${error instanceof Error ? error.message : String(error)}`
    });
  }
  return attachmentsValid;
}

// src/util/migrator/StaticToCouchDBMigrator.ts
var nodeFS3 = null;
var nodePath = null;
try {
  if (typeof window === "undefined" && typeof process !== "undefined" && process.versions?.node) {
    nodeFS3 = eval("require")("fs");
    nodePath = eval("require")("path");
    nodeFS3.promises = nodeFS3.promises || eval("require")("fs").promises;
  }
} catch {
}
var StaticToCouchDBMigrator = class {
  options;
  progressCallback;
  fs;
  constructor(options = {}, fileSystemAdapter) {
    this.options = {
      ...DEFAULT_MIGRATION_OPTIONS,
      ...options
    };
    this.fs = fileSystemAdapter;
  }
  /**
   * Set a progress callback to receive updates during migration
   */
  setProgressCallback(callback) {
    this.progressCallback = callback;
  }
  /**
   * Migrate a static course to CouchDB
   */
  async migrateCourse(staticPath, targetDB) {
    const startTime = Date.now();
    const result = {
      success: false,
      documentsRestored: 0,
      attachmentsRestored: 0,
      designDocsRestored: 0,
      courseConfigRestored: 0,
      errors: [],
      warnings: [],
      migrationTime: 0
    };
    try {
      logger.info(`Starting migration from ${staticPath} to CouchDB`);
      this.reportProgress("manifest", 0, 1, "Validating static course...");
      const validation = await validateStaticCourse(staticPath, this.fs);
      if (!validation.valid) {
        result.errors.push(...validation.errors);
        throw new Error(`Static course validation failed: ${validation.errors.join(", ")}`);
      }
      result.warnings.push(...validation.warnings);
      this.reportProgress("manifest", 1, 1, "Loading course manifest...");
      const manifest = await this.loadManifest(staticPath);
      logger.info(`Loaded manifest for course: ${manifest.courseId} (${manifest.courseName})`);
      this.reportProgress(
        "design_docs",
        0,
        manifest.designDocs.length,
        "Restoring design documents..."
      );
      const designDocResults = await this.restoreDesignDocuments(manifest.designDocs, targetDB);
      result.designDocsRestored = designDocResults.restored;
      result.errors.push(...designDocResults.errors);
      result.warnings.push(...designDocResults.warnings);
      this.reportProgress("course_config", 0, 1, "Restoring CourseConfig document...");
      const courseConfigResults = await this.restoreCourseConfig(manifest, targetDB);
      result.courseConfigRestored = courseConfigResults.restored;
      result.errors.push(...courseConfigResults.errors);
      result.warnings.push(...courseConfigResults.warnings);
      this.reportProgress("course_config", 1, 1, "CourseConfig document restored");
      const expectedCounts = this.calculateExpectedCounts(manifest);
      this.reportProgress(
        "documents",
        0,
        manifest.documentCount,
        "Aggregating documents from chunks..."
      );
      const documents = await this.aggregateDocuments(staticPath, manifest);
      const filteredDocuments = documents.filter((doc) => doc._id !== "CourseConfig");
      if (documents.length !== filteredDocuments.length) {
        result.warnings.push(
          `Filtered out ${documents.length - filteredDocuments.length} CourseConfig document(s) from chunks to prevent conflicts`
        );
      }
      this.reportProgress(
        "documents",
        filteredDocuments.length,
        manifest.documentCount,
        "Uploading documents to CouchDB..."
      );
      const docResults = await this.uploadDocuments(filteredDocuments, targetDB);
      result.documentsRestored = docResults.restored;
      result.errors.push(...docResults.errors);
      result.warnings.push(...docResults.warnings);
      const docsWithAttachments = documents.filter(
        (doc) => doc._attachments && Object.keys(doc._attachments).length > 0
      );
      this.reportProgress("attachments", 0, docsWithAttachments.length, "Uploading attachments...");
      const attachmentResults = await this.uploadAttachments(
        staticPath,
        docsWithAttachments,
        targetDB
      );
      result.attachmentsRestored = attachmentResults.restored;
      result.errors.push(...attachmentResults.errors);
      result.warnings.push(...attachmentResults.warnings);
      if (this.options.validateRoundTrip) {
        this.reportProgress("validation", 0, 1, "Validating migration...");
        const validationResult = await validateMigration(targetDB, expectedCounts, manifest);
        if (!validationResult.valid) {
          result.warnings.push("Migration validation found issues");
          validationResult.issues.forEach((issue) => {
            if (issue.type === "error") {
              result.errors.push(`Validation: ${issue.message}`);
            } else {
              result.warnings.push(`Validation: ${issue.message}`);
            }
          });
        }
        this.reportProgress("validation", 1, 1, "Migration validation completed");
      }
      result.success = result.errors.length === 0;
      result.migrationTime = Date.now() - startTime;
      logger.info(`Migration completed in ${result.migrationTime}ms`);
      logger.info(`Documents restored: ${result.documentsRestored}`);
      logger.info(`Attachments restored: ${result.attachmentsRestored}`);
      logger.info(`Design docs restored: ${result.designDocsRestored}`);
      logger.info(`CourseConfig restored: ${result.courseConfigRestored}`);
      if (result.errors.length > 0) {
        logger.error(`Migration completed with ${result.errors.length} errors`);
      }
      if (result.warnings.length > 0) {
        logger.warn(`Migration completed with ${result.warnings.length} warnings`);
      }
    } catch (error) {
      result.success = false;
      result.migrationTime = Date.now() - startTime;
      const errorMessage = error instanceof Error ? error.message : String(error);
      result.errors.push(`Migration failed: ${errorMessage}`);
      logger.error("Migration failed:", error);
      if (this.options.cleanupOnFailure) {
        try {
          await this.cleanupFailedMigration(targetDB);
        } catch (cleanupError) {
          logger.error("Failed to cleanup after migration failure:", cleanupError);
          result.warnings.push("Failed to cleanup after migration failure");
        }
      }
    }
    return result;
  }
  /**
   * Load and parse the manifest file
   */
  async loadManifest(staticPath) {
    try {
      let manifestContent;
      let manifestPath;
      if (this.fs) {
        manifestPath = this.fs.joinPath(staticPath, "manifest.json");
        manifestContent = await this.fs.readFile(manifestPath);
      } else {
        manifestPath = nodeFS3 && nodePath ? nodePath.join(staticPath, "manifest.json") : `${staticPath}/manifest.json`;
        if (nodeFS3 && this.isLocalPath(staticPath)) {
          manifestContent = await nodeFS3.promises.readFile(manifestPath, "utf8");
        } else {
          const response = await fetch(manifestPath);
          if (!response.ok) {
            throw new Error(`Failed to fetch manifest: ${response.status} ${response.statusText}`);
          }
          manifestContent = await response.text();
        }
      }
      const manifest = JSON.parse(manifestContent);
      if (!manifest.version || !manifest.courseId || !manifest.chunks) {
        throw new Error("Invalid manifest structure");
      }
      return manifest;
    } catch (error) {
      const errorMessage = error instanceof FileSystemError ? error.message : `Failed to load manifest: ${error instanceof Error ? error.message : String(error)}`;
      throw new Error(errorMessage);
    }
  }
  /**
   * Restore design documents to CouchDB
   */
  async restoreDesignDocuments(designDocs, db) {
    const result = { restored: 0, errors: [], warnings: [] };
    for (let i = 0; i < designDocs.length; i++) {
      const designDoc = designDocs[i];
      this.reportProgress("design_docs", i, designDocs.length, `Restoring ${designDoc._id}...`);
      try {
        let existingDoc;
        try {
          existingDoc = await db.get(designDoc._id);
        } catch {
        }
        const docToInsert = {
          _id: designDoc._id,
          views: designDoc.views
        };
        if (existingDoc) {
          docToInsert._rev = existingDoc._rev;
          logger.debug(`Updating existing design document: ${designDoc._id}`);
        } else {
          logger.debug(`Creating new design document: ${designDoc._id}`);
        }
        await db.put(docToInsert);
        result.restored++;
      } catch (error) {
        const errorMessage = `Failed to restore design document ${designDoc._id}: ${error instanceof Error ? error.message : String(error)}`;
        result.errors.push(errorMessage);
        logger.error(errorMessage);
      }
    }
    this.reportProgress(
      "design_docs",
      designDocs.length,
      designDocs.length,
      `Restored ${result.restored} design documents`
    );
    return result;
  }
  /**
   * Aggregate documents from all chunks
   */
  async aggregateDocuments(staticPath, manifest) {
    const allDocuments = [];
    const documentMap = /* @__PURE__ */ new Map();
    for (let i = 0; i < manifest.chunks.length; i++) {
      const chunk = manifest.chunks[i];
      this.reportProgress(
        "documents",
        allDocuments.length,
        manifest.documentCount,
        `Loading chunk ${chunk.id}...`
      );
      try {
        const documents = await this.loadChunk(staticPath, chunk);
        for (const doc of documents) {
          if (!doc._id) {
            logger.warn(`Document without _id found in chunk ${chunk.id}, skipping`);
            continue;
          }
          if (documentMap.has(doc._id)) {
            logger.warn(`Duplicate document ID found: ${doc._id}, using latest version`);
          }
          documentMap.set(doc._id, doc);
        }
      } catch (error) {
        throw new Error(
          `Failed to load chunk ${chunk.id}: ${error instanceof Error ? error.message : String(error)}`
        );
      }
    }
    allDocuments.push(...documentMap.values());
    logger.info(
      `Aggregated ${allDocuments.length} unique documents from ${manifest.chunks.length} chunks`
    );
    return allDocuments;
  }
  /**
   * Load documents from a single chunk file
   */
  async loadChunk(staticPath, chunk) {
    try {
      let chunkContent;
      let chunkPath;
      if (this.fs) {
        chunkPath = this.fs.joinPath(staticPath, chunk.path);
        chunkContent = await this.fs.readFile(chunkPath);
      } else {
        chunkPath = nodeFS3 && nodePath ? nodePath.join(staticPath, chunk.path) : `${staticPath}/${chunk.path}`;
        if (nodeFS3 && this.isLocalPath(staticPath)) {
          chunkContent = await nodeFS3.promises.readFile(chunkPath, "utf8");
        } else {
          const response = await fetch(chunkPath);
          if (!response.ok) {
            throw new Error(`Failed to fetch chunk: ${response.status} ${response.statusText}`);
          }
          chunkContent = await response.text();
        }
      }
      const documents = JSON.parse(chunkContent);
      if (!Array.isArray(documents)) {
        throw new Error("Chunk file does not contain an array of documents");
      }
      return documents;
    } catch (error) {
      const errorMessage = error instanceof FileSystemError ? error.message : `Failed to load chunk: ${error instanceof Error ? error.message : String(error)}`;
      throw new Error(errorMessage);
    }
  }
  /**
   * Upload documents to CouchDB in batches
   */
  async uploadDocuments(documents, db) {
    const result = { restored: 0, errors: [], warnings: [] };
    const batchSize = this.options.chunkBatchSize;
    for (let i = 0; i < documents.length; i += batchSize) {
      const batch = documents.slice(i, i + batchSize);
      this.reportProgress(
        "documents",
        i,
        documents.length,
        `Uploading batch ${Math.floor(i / batchSize) + 1}...`
      );
      try {
        const docsToInsert = batch.map((doc) => {
          const cleanDoc = { ...doc };
          delete cleanDoc._rev;
          delete cleanDoc._attachments;
          return cleanDoc;
        });
        const bulkResult = await db.bulkDocs(docsToInsert);
        for (let j = 0; j < bulkResult.length; j++) {
          const docResult = bulkResult[j];
          const originalDoc = batch[j];
          if ("error" in docResult) {
            const errorMessage = `Failed to upload document ${originalDoc._id}: ${docResult.error} - ${docResult.reason}`;
            result.errors.push(errorMessage);
            logger.error(errorMessage);
          } else {
            result.restored++;
          }
        }
      } catch (error) {
        let errorMessage;
        if (error instanceof Error) {
          errorMessage = `Failed to upload document batch starting at index ${i}: ${error.message}`;
        } else if (error && typeof error === "object" && "message" in error) {
          errorMessage = `Failed to upload document batch starting at index ${i}: ${error.message}`;
        } else {
          errorMessage = `Failed to upload document batch starting at index ${i}: ${JSON.stringify(error)}`;
        }
        result.errors.push(errorMessage);
        logger.error(errorMessage);
      }
    }
    this.reportProgress(
      "documents",
      documents.length,
      documents.length,
      `Uploaded ${result.restored} documents`
    );
    return result;
  }
  /**
   * Upload attachments from filesystem to CouchDB
   */
  async uploadAttachments(staticPath, documents, db) {
    const result = { restored: 0, errors: [], warnings: [] };
    let processedDocs = 0;
    for (const doc of documents) {
      this.reportProgress(
        "attachments",
        processedDocs,
        documents.length,
        `Processing attachments for ${doc._id}...`
      );
      processedDocs++;
      if (!doc._attachments) {
        continue;
      }
      for (const [attachmentName, attachmentMeta] of Object.entries(doc._attachments)) {
        try {
          const uploadResult = await this.uploadSingleAttachment(
            staticPath,
            doc._id,
            attachmentName,
            attachmentMeta,
            db
          );
          if (uploadResult.success) {
            result.restored++;
          } else {
            result.errors.push(uploadResult.error || "Unknown attachment upload error");
          }
        } catch (error) {
          const errorMessage = `Failed to upload attachment ${doc._id}/${attachmentName}: ${error instanceof Error ? error.message : String(error)}`;
          result.errors.push(errorMessage);
          logger.error(errorMessage);
        }
      }
    }
    this.reportProgress(
      "attachments",
      documents.length,
      documents.length,
      `Uploaded ${result.restored} attachments`
    );
    return result;
  }
  /**
   * Upload a single attachment file
   */
  async uploadSingleAttachment(staticPath, docId, attachmentName, attachmentMeta, db) {
    const result = {
      success: false,
      attachmentName,
      docId
    };
    try {
      if (!attachmentMeta.path) {
        result.error = "Attachment metadata missing file path";
        return result;
      }
      let attachmentData;
      let attachmentPath;
      if (this.fs) {
        attachmentPath = this.fs.joinPath(staticPath, attachmentMeta.path);
        attachmentData = await this.fs.readBinary(attachmentPath);
      } else {
        attachmentPath = nodeFS3 && nodePath ? nodePath.join(staticPath, attachmentMeta.path) : `${staticPath}/${attachmentMeta.path}`;
        if (nodeFS3 && this.isLocalPath(staticPath)) {
          attachmentData = await nodeFS3.promises.readFile(attachmentPath);
        } else {
          const response = await fetch(attachmentPath);
          if (!response.ok) {
            result.error = `Failed to fetch attachment: ${response.status} ${response.statusText}`;
            return result;
          }
          attachmentData = await response.arrayBuffer();
        }
      }
      const doc = await db.get(docId);
      await db.putAttachment(
        docId,
        attachmentName,
        doc._rev,
        attachmentData,
        // PouchDB accepts both ArrayBuffer and Buffer
        attachmentMeta.content_type
      );
      result.success = true;
    } catch (error) {
      result.error = error instanceof Error ? error.message : String(error);
    }
    return result;
  }
  /**
   * Restore CourseConfig document from manifest
   */
  async restoreCourseConfig(manifest, targetDB) {
    const results = {
      restored: 0,
      errors: [],
      warnings: []
    };
    try {
      if (!manifest.courseConfig) {
        results.warnings.push(
          "No courseConfig found in manifest, skipping CourseConfig document creation"
        );
        return results;
      }
      const courseConfigDoc = {
        _id: "CourseConfig",
        ...manifest.courseConfig,
        courseID: manifest.courseId
      };
      delete courseConfigDoc._rev;
      await targetDB.put(courseConfigDoc);
      results.restored = 1;
      logger.info(`CourseConfig document created for course: ${manifest.courseId}`);
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : JSON.stringify(error);
      results.errors.push(`Failed to restore CourseConfig: ${errorMessage}`);
      logger.error("CourseConfig restoration failed:", error);
    }
    return results;
  }
  /**
   * Calculate expected document counts from manifest
   */
  calculateExpectedCounts(manifest) {
    const counts = {};
    for (const chunk of manifest.chunks) {
      counts[chunk.docType] = (counts[chunk.docType] || 0) + chunk.documentCount;
    }
    if (manifest.designDocs.length > 0) {
      counts["_design"] = manifest.designDocs.length;
    }
    return counts;
  }
  /**
   * Clean up database after failed migration
   */
  async cleanupFailedMigration(db) {
    logger.info("Cleaning up failed migration...");
    try {
      const allDocs = await db.allDocs();
      const docsToDelete = allDocs.rows.map((row) => ({
        _id: row.id,
        _rev: row.value.rev,
        _deleted: true
      }));
      if (docsToDelete.length > 0) {
        await db.bulkDocs(docsToDelete);
        logger.info(`Cleaned up ${docsToDelete.length} documents from failed migration`);
      }
    } catch (error) {
      logger.error("Failed to cleanup documents:", error);
      throw error;
    }
  }
  /**
   * Report progress to callback if available
   */
  reportProgress(phase, current, total, message) {
    if (this.progressCallback) {
      this.progressCallback({
        phase,
        current,
        total,
        message
      });
    }
  }
  /**
   * Check if a path is a local file path (vs URL)
   */
  isLocalPath(path2) {
    return !path2.startsWith("http://") && !path2.startsWith("https://");
  }
};

// src/util/index.ts
init_dataDirectory();

// src/study/SessionController.ts
init_navigators();
init_Pipeline();

// src/study/SourceMixer.ts
var QuotaRoundRobinMixer = class {
  mix(batches, limit) {
    if (batches.length === 0) {
      return [];
    }
    const quotaPerSource = Math.ceil(limit / batches.length);
    const sourceStacks = batches.map((batch) => {
      return [...batch.weighted].sort((a, b) => b.score - a.score).slice(0, quotaPerSource);
    });
    for (let i = sourceStacks.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [sourceStacks[i], sourceStacks[j]] = [sourceStacks[j], sourceStacks[i]];
    }
    const result = [];
    let exhausted = 0;
    const cursors = new Array(sourceStacks.length).fill(0);
    while (result.length < limit && exhausted < sourceStacks.length) {
      exhausted = 0;
      for (let s = 0; s < sourceStacks.length; s++) {
        if (result.length >= limit) break;
        if (cursors[s] < sourceStacks[s].length) {
          result.push(sourceStacks[s][cursors[s]]);
          cursors[s]++;
        } else {
          exhausted++;
        }
      }
    }
    return result;
  }
};

// src/study/MixerDebugger.ts
init_logger();
init_navigators();
var MAX_RUNS2 = 10;
var runHistory2 = [];
function buildSourceSummary(batch, sourceId, sourceName) {
  const scores = batch.weighted.map((c) => c.score);
  const reviewCount = batch.weighted.filter((c) => getCardOrigin(c) === "review").length;
  const newCount = batch.weighted.filter((c) => getCardOrigin(c) === "new").length;
  return {
    sourceIndex: batch.sourceIndex,
    sourceId,
    sourceName,
    totalCards: batch.weighted.length,
    reviewCount,
    newCount,
    topScore: scores.length > 0 ? Math.max(...scores) : 0,
    bottomScore: scores.length > 0 ? Math.min(...scores) : 0,
    scoreRange: scores.length > 0 ? [Math.min(...scores), Math.max(...scores)] : [0, 0],
    avgScore: scores.length > 0 ? scores.reduce((a, b) => a + b, 0) / scores.length : 0
  };
}
function buildSourceBreakdown(sourceId, sourceName, allCards) {
  const sourceCards = allCards.filter((c) => c.courseId === sourceId);
  const selectedCards = sourceCards.filter((c) => c.selected);
  const reviewsProvided = sourceCards.filter((c) => c.origin === "review").length;
  const newProvided = sourceCards.filter((c) => c.origin === "new").length;
  const reviewsSelected = selectedCards.filter((c) => c.origin === "review").length;
  const newSelected = selectedCards.filter((c) => c.origin === "new").length;
  return {
    sourceId,
    sourceName,
    reviewsProvided,
    newProvided,
    reviewsSelected,
    newSelected,
    totalSelected: selectedCards.length,
    selectionRate: sourceCards.length > 0 ? selectedCards.length / sourceCards.length * 100 : 0
  };
}
function captureMixerRun(mixerType, batches, sourceIds, sourceNames, requestedLimit, quotaPerSource, mixedResult) {
  const sourceSummaries = batches.map(
    (batch, idx) => buildSourceSummary(batch, sourceIds[idx] || `source-${idx}`, sourceNames[idx])
  );
  const selectedIds = new Set(mixedResult.map((c) => c.cardId));
  const sourceRankings = /* @__PURE__ */ new Map();
  batches.forEach((batch) => {
    const sorted = [...batch.weighted].sort((a, b) => b.score - a.score);
    const rankings = /* @__PURE__ */ new Map();
    sorted.forEach((card, idx) => {
      rankings.set(card.cardId, idx + 1);
    });
    sourceRankings.set(sourceIds[batch.sourceIndex] || `source-${batch.sourceIndex}`, rankings);
  });
  const mixRankings = /* @__PURE__ */ new Map();
  mixedResult.forEach((card, idx) => {
    mixRankings.set(card.cardId, idx + 1);
  });
  const allCardsMap = /* @__PURE__ */ new Map();
  batches.forEach((batch) => {
    batch.weighted.forEach((card) => {
      allCardsMap.set(card.cardId, card);
    });
  });
  const cards = Array.from(allCardsMap.values()).map((card) => ({
    cardId: card.cardId,
    courseId: card.courseId,
    origin: getCardOrigin(card),
    score: card.score,
    sourceIndex: batches.findIndex((b) => b.weighted.some((c) => c.cardId === card.cardId)),
    selected: selectedIds.has(card.cardId),
    rankInSource: sourceRankings.get(card.courseId)?.get(card.cardId),
    rankInMix: mixRankings.get(card.cardId)
  }));
  const uniqueSourceIds = Array.from(new Set(sourceIds.filter((id) => id)));
  const sourceBreakdowns = uniqueSourceIds.map(
    (sourceId, idx) => buildSourceBreakdown(sourceId, sourceNames[idx], cards)
  );
  const report = {
    runId: `mix-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    timestamp: /* @__PURE__ */ new Date(),
    mixerType,
    requestedLimit,
    quotaPerSource,
    sourceSummaries,
    cards,
    finalCount: mixedResult.length,
    reviewsSelected: mixedResult.filter((c) => getCardOrigin(c) === "review").length,
    newSelected: mixedResult.filter((c) => getCardOrigin(c) === "new").length,
    sourceBreakdowns
  };
  runHistory2.unshift(report);
  if (runHistory2.length > MAX_RUNS2) {
    runHistory2.pop();
  }
}
function printMixerSummary(run) {
  console.group(`\u{1F3A8} Mixer Run: ${run.mixerType}`);
  logger.info(`Run ID: ${run.runId}`);
  logger.info(`Time: ${run.timestamp.toISOString()}`);
  logger.info(
    `Config: limit=${run.requestedLimit}${run.quotaPerSource ? `, quota/source=${run.quotaPerSource}` : ""}`
  );
  console.group(`\u{1F4E5} Input: ${run.sourceSummaries.length} sources`);
  for (const src of run.sourceSummaries) {
    logger.info(
      `  ${src.sourceName || src.sourceId}: ${src.totalCards} cards (${src.reviewCount} reviews, ${src.newCount} new)`
    );
    logger.info(`    Score range: [${src.scoreRange[0].toFixed(2)}, ${src.scoreRange[1].toFixed(2)}], avg: ${src.avgScore.toFixed(2)}`);
  }
  console.groupEnd();
  console.group(`\u{1F4E4} Output: ${run.finalCount} cards selected (${run.reviewsSelected} reviews, ${run.newSelected} new)`);
  for (const breakdown of run.sourceBreakdowns) {
    const name = breakdown.sourceName || breakdown.sourceId;
    logger.info(
      `  ${name}: ${breakdown.totalSelected} selected (${breakdown.reviewsSelected} reviews, ${breakdown.newSelected} new) - ${breakdown.selectionRate.toFixed(1)}% selection rate`
    );
  }
  console.groupEnd();
  console.groupEnd();
}
var mixerDebugAPI = {
  /**
   * Get raw run history for programmatic access.
   */
  get runs() {
    return [...runHistory2];
  },
  /**
   * Show summary of a specific mixer run.
   */
  showRun(idOrIndex = 0) {
    if (runHistory2.length === 0) {
      logger.info("[Mixer Debug] No runs captured yet.");
      return;
    }
    let run;
    if (typeof idOrIndex === "number") {
      run = runHistory2[idOrIndex];
      if (!run) {
        logger.info(`[Mixer Debug] No run found at index ${idOrIndex}. History length: ${runHistory2.length}`);
        return;
      }
    } else {
      run = runHistory2.find((r) => r.runId.endsWith(idOrIndex));
      if (!run) {
        logger.info(`[Mixer Debug] No run found matching ID '${idOrIndex}'.`);
        return;
      }
    }
    printMixerSummary(run);
  },
  /**
   * Show summary of the last mixer run.
   */
  showLastMix() {
    this.showRun(0);
  },
  /**
   * Explain source balance in the last run.
   */
  explainSourceBalance() {
    if (runHistory2.length === 0) {
      logger.info("[Mixer Debug] No runs captured yet.");
      return;
    }
    const run = runHistory2[0];
    console.group("\u2696\uFE0F Source Balance Analysis");
    logger.info(`Mixer: ${run.mixerType}`);
    logger.info(`Requested limit: ${run.requestedLimit}`);
    if (run.quotaPerSource) {
      logger.info(`Quota per source: ${run.quotaPerSource}`);
    }
    console.group("Input Distribution:");
    for (const src of run.sourceSummaries) {
      const name = src.sourceName || src.sourceId;
      logger.info(`${name}:`);
      logger.info(`  Provided: ${src.totalCards} cards (${src.reviewCount} reviews, ${src.newCount} new)`);
      logger.info(`  Score range: [${src.scoreRange[0].toFixed(2)}, ${src.scoreRange[1].toFixed(2)}]`);
    }
    console.groupEnd();
    console.group("Selection Results:");
    for (const breakdown of run.sourceBreakdowns) {
      const name = breakdown.sourceName || breakdown.sourceId;
      logger.info(`${name}:`);
      logger.info(
        `  Selected: ${breakdown.totalSelected}/${breakdown.reviewsProvided + breakdown.newProvided} (${breakdown.selectionRate.toFixed(1)}%)`
      );
      logger.info(`  Reviews: ${breakdown.reviewsSelected}/${breakdown.reviewsProvided}`);
      logger.info(`  New: ${breakdown.newSelected}/${breakdown.newProvided}`);
      if (breakdown.reviewsProvided > 0 && breakdown.reviewsSelected === 0) {
        logger.info(`  \u26A0\uFE0F Had reviews but none selected!`);
      }
      if (breakdown.totalSelected === 0 && breakdown.reviewsProvided + breakdown.newProvided > 0) {
        logger.info(`  \u26A0\uFE0F Had cards but none selected!`);
      }
    }
    console.groupEnd();
    const selectionRates = run.sourceBreakdowns.map((b) => b.selectionRate);
    const avgRate = selectionRates.reduce((a, b) => a + b, 0) / selectionRates.length;
    const maxDeviation = Math.max(...selectionRates.map((r) => Math.abs(r - avgRate)));
    if (maxDeviation > 20) {
      logger.info(`
\u26A0\uFE0F Significant imbalance detected (max deviation: ${maxDeviation.toFixed(1)}%)`);
      logger.info("Possible causes:");
      logger.info("  - Score range differences between sources");
      logger.info("  - One source has much better quality cards");
      logger.info("  - Different card availability (reviews vs new)");
    }
    console.groupEnd();
  },
  /**
   * Compare score distributions across sources.
   */
  compareScores() {
    if (runHistory2.length === 0) {
      logger.info("[Mixer Debug] No runs captured yet.");
      return;
    }
    const run = runHistory2[0];
    console.group("\u{1F4CA} Score Distribution Comparison");
    console.table(
      run.sourceSummaries.map((src) => ({
        source: src.sourceName || src.sourceId,
        cards: src.totalCards,
        min: src.bottomScore.toFixed(3),
        max: src.topScore.toFixed(3),
        avg: src.avgScore.toFixed(3),
        range: (src.topScore - src.bottomScore).toFixed(3)
      }))
    );
    const ranges = run.sourceSummaries.map((s) => s.topScore - s.bottomScore);
    const avgScores = run.sourceSummaries.map((s) => s.avgScore);
    const rangeDiff = Math.max(...ranges) - Math.min(...ranges);
    const avgDiff = Math.max(...avgScores) - Math.min(...avgScores);
    if (rangeDiff > 0.3 || avgDiff > 0.2) {
      logger.info("\n\u26A0\uFE0F Significant score distribution differences detected");
      logger.info(
        "This may cause one source to dominate selection if using global sorting (not quota-based)"
      );
    }
    console.groupEnd();
  },
  /**
   * Show detailed information for a specific card.
   */
  showCard(cardId) {
    for (const run of runHistory2) {
      const card = run.cards.find((c) => c.cardId === cardId);
      if (card) {
        const source = run.sourceSummaries.find((s) => s.sourceIndex === card.sourceIndex);
        console.group(`\u{1F3B4} Card: ${cardId}`);
        logger.info(`Course: ${card.courseId}`);
        logger.info(`Source: ${source?.sourceName || source?.sourceId || "unknown"}`);
        logger.info(`Origin: ${card.origin}`);
        logger.info(`Score: ${card.score.toFixed(3)}`);
        if (card.rankInSource) {
          logger.info(`Rank in source: #${card.rankInSource}`);
        }
        if (card.rankInMix) {
          logger.info(`Rank in mixed results: #${card.rankInMix}`);
        }
        logger.info(`Selected: ${card.selected ? "Yes \u2705" : "No \u274C"}`);
        if (!card.selected && card.rankInSource) {
          logger.info("\nWhy not selected:");
          if (run.quotaPerSource && card.rankInSource > run.quotaPerSource) {
            logger.info(`  - Ranked #${card.rankInSource} in source, but quota was ${run.quotaPerSource}`);
          }
          logger.info("  - Check score compared to selected cards using .showRun()");
        }
        console.groupEnd();
        return;
      }
    }
    logger.info(`[Mixer Debug] Card '${cardId}' not found in recent runs.`);
  },
  /**
   * Show all runs in compact format.
   */
  listRuns() {
    if (runHistory2.length === 0) {
      logger.info("[Mixer Debug] No runs captured yet.");
      return;
    }
    console.table(
      runHistory2.map((r) => ({
        id: r.runId.slice(-8),
        time: r.timestamp.toLocaleTimeString(),
        mixer: r.mixerType,
        sources: r.sourceSummaries.length,
        selected: r.finalCount,
        reviews: r.reviewsSelected,
        new: r.newSelected
      }))
    );
  },
  /**
   * Export run history as JSON for bug reports.
   */
  export() {
    const json = JSON.stringify(runHistory2, null, 2);
    logger.info("[Mixer Debug] Run history exported. Copy the returned string or use:");
    logger.info("  copy(window.skuilder.mixer.export())");
    return json;
  },
  /**
   * Clear run history.
   */
  clear() {
    runHistory2.length = 0;
    logger.info("[Mixer Debug] Run history cleared.");
  },
  /**
   * Show help.
   */
  help() {
    logger.info(`
\u{1F3A8} Mixer Debug API

Commands:
  .showLastMix()           Show summary of most recent mixer run
  .showRun(id|index)       Show summary of a specific run (by index or ID suffix)
  .explainSourceBalance()  Analyze source balance and selection patterns
  .compareScores()         Compare score distributions across sources
  .showCard(cardId)        Show mixer decisions for a specific card
  .listRuns()              List all captured runs in table format
  .export()                Export run history as JSON for bug reports
  .clear()                 Clear run history
  .runs                    Access raw run history array
  .help()                  Show this help message

Example:
  window.skuilder.mixer.showLastMix()
  window.skuilder.mixer.explainSourceBalance()
  window.skuilder.mixer.compareScores()
`);
  }
};
function mountMixerDebugger() {
  if (typeof window === "undefined") return;
  const win = window;
  win.skuilder = win.skuilder || {};
  win.skuilder.mixer = mixerDebugAPI;
}
mountMixerDebugger();

// src/study/SessionDebugger.ts
init_logger();
init_PipelineDebugger();
init_SrsDebugger();

// src/study/SessionOverlay.ts
init_logger();
var activeController = null;
function registerActiveController(controller) {
  activeController = controller;
}
function getActiveController() {
  return activeController;
}
var OVERLAY_ID = "skuilder-session-overlay";
var POLL_MS = 300;
var INLINE_THRESHOLD = 5;
var SPINNER_FRAMES = ["\u280B", "\u2819", "\u2839", "\u2838", "\u283C", "\u2834", "\u2826", "\u2827", "\u2807", "\u280F"];
var spinnerFrame = 0;
var overlayEl = null;
var pollHandle = null;
var lastSnapshot = null;
var copyFlashUntil = 0;
var minified = false;
var expanded = {
  supplyQ: false,
  failedQ: false,
  drawn: false
};
function toggleSessionOverlay() {
  if (typeof document === "undefined") {
    logger.info("[Session Overlay] No DOM available (non-browser host); overlay unavailable.");
    return;
  }
  if (overlayEl) {
    teardown();
    logger.info("[Session Overlay] Hidden.");
  } else {
    mount();
    logger.info("[Session Overlay] Shown. Toggle off with window.skuilder.session.dbgOverlay().");
  }
}
function mount() {
  minified = false;
  overlayEl = document.createElement("div");
  overlayEl.id = OVERLAY_ID;
  Object.assign(overlayEl.style, {
    position: "fixed",
    top: "8px",
    left: "8px",
    zIndex: "2147483647",
    maxWidth: "320px",
    maxHeight: "90vh",
    overflowY: "auto",
    padding: "8px 10px",
    background: "rgba(17, 24, 39, 0.92)",
    color: "#e5e7eb",
    font: "11px/1.4 ui-monospace, SFMono-Regular, Menlo, monospace",
    borderRadius: "6px",
    boxShadow: "0 4px 16px rgba(0,0,0,0.4)",
    pointerEvents: "auto",
    userSelect: "none"
  });
  document.body.appendChild(overlayEl);
  render();
  pollHandle = setInterval(render, POLL_MS);
}
function teardown() {
  if (pollHandle !== null) {
    clearInterval(pollHandle);
    pollHandle = null;
  }
  if (overlayEl?.parentNode) {
    overlayEl.parentNode.removeChild(overlayEl);
  }
  overlayEl = null;
}
function render() {
  if (!overlayEl) return;
  spinnerFrame++;
  const ctrl = getActiveController();
  if (!ctrl) {
    lastSnapshot = null;
    overlayEl.innerHTML = headerHtml() + (minified ? "" : `<div style="opacity:.65">No active session.</div>`);
    attachHandlers();
    return;
  }
  const s = ctrl.getDebugSnapshot();
  lastSnapshot = s;
  if (minified) {
    overlayEl.innerHTML = headerHtml();
    attachHandlers();
    return;
  }
  overlayEl.innerHTML = headerHtml() + replanHtml(s) + metaHtml(s) + hintsHtml(s.sessionHints) + backlogHtml(s.reviewBacklog) + queueHtml("supplyQ", "supplyQ", s.supplyQ) + queueHtml("failedQ", "failedQ", s.failedQ) + drawnHtml("drawn", s.drawnCards);
  attachHandlers();
}
function attachHandlers() {
  if (!overlayEl) return;
  overlayEl.querySelectorAll("[data-q]").forEach((el) => {
    el.onclick = () => {
      const key = el.dataset.q;
      if (!key) return;
      expanded[key] = !expanded[key];
      render();
    };
  });
  const copyBtn = overlayEl.querySelector("[data-copy]");
  if (copyBtn) {
    copyBtn.onclick = (ev) => {
      ev.stopPropagation();
      copySnapshot();
    };
  }
  const minBtn = overlayEl.querySelector("[data-min]");
  if (minBtn) {
    minBtn.onclick = (ev) => {
      ev.stopPropagation();
      minified = !minified;
      render();
    };
  }
}
function copySnapshot() {
  const text = snapshotToText(lastSnapshot);
  const flash = () => {
    copyFlashUntil = Date.now() + 1200;
    render();
  };
  const clip = typeof navigator !== "undefined" ? navigator.clipboard : void 0;
  if (clip?.writeText) {
    clip.writeText(text).then(flash, (err) => {
      logger.warn(`[Session Overlay] Clipboard write failed: ${String(err)}`);
    });
  } else {
    logger.info(`[Session Overlay] Clipboard unavailable; snapshot follows:
${text}`);
  }
}
function headerHtml() {
  const flashing = Date.now() < copyFlashUntil;
  const btnLabel = flashing ? "\u2713 copied" : "\u2398 copy";
  const btnColor = flashing ? "#86efac" : "#93c5fd";
  const copyBtn = `<span data-copy style="cursor:pointer;float:right;font-weight:400;color:${btnColor};border:1px solid currentColor;border-radius:4px;padding:0 4px;line-height:1.3">${btnLabel}</span>`;
  const minBtn = `<span data-min title="${minified ? "Restore" : "Minify"}" style="cursor:pointer;float:right;font-weight:400;color:#93c5fd;border:1px solid currentColor;border-radius:4px;padding:0 5px;margin-right:4px;line-height:1.3">${minified ? "\u25A2" : "\u2014"}</span>`;
  return `<div style="font-weight:600;color:#93c5fd;margin-bottom:${minified ? 0 : 4}px">${copyBtn}${minBtn}\u2699 SessionController</div>`;
}
function replanHtml(s) {
  if (!s.replanActive) {
    return `<div style="margin-bottom:6px;opacity:.45">\u25CB idle</div>`;
  }
  const frame = SPINNER_FRAMES[spinnerFrame % SPINNER_FRAMES.length];
  const reason = esc(s.replanLabel ?? "(auto)");
  return `<div style="margin-bottom:6px;color:#fde047">${frame} replanning <span style="opacity:.85">[${reason}]</span></div>`;
}
function metaHtml(s) {
  const mmss = formatTime(s.secondsRemaining);
  const guarantee = s.hasCardGuarantee ? ` \xB7 <span style="color:#fbbf24">guarantee ${s.minCardsGuarantee}</span>` : "";
  const rows = [
    `time ${mmss}${guarantee}`,
    `well-indicated left: ${s.wellIndicatedRemaining}`,
    `current: ${s.currentCard ? esc(s.currentCard) : '<span style="opacity:.6">\u2014</span>'}`
  ];
  return `<div style="margin-bottom:6px">${rows.map((r) => `<div>${r}</div>`).join("")}</div>`;
}
function hintsHtml(h) {
  const parts = [];
  if (h) {
    if (h.boostTags && Object.keys(h.boostTags).length) {
      parts.push(
        `boost: ` + Object.entries(h.boostTags).map(([k, v]) => `${esc(k)}<span style="opacity:.6">\xD7${v}</span>`).join(", ")
      );
    }
    if (h.boostCards && Object.keys(h.boostCards).length) {
      parts.push(
        `boostCards: ` + Object.entries(h.boostCards).map(([k, v]) => `${esc(k)}<span style="opacity:.6">\xD7${v}</span>`).join(", ")
      );
    }
    if (h.requireCards?.length) parts.push(`require: ${h.requireCards.map(esc).join(", ")}`);
    if (h.requireTags?.length) parts.push(`requireTags: ${h.requireTags.map(esc).join(", ")}`);
    if (h.excludeTags?.length) parts.push(`exclude: ${h.excludeTags.map(esc).join(", ")}`);
    if (h.excludeCards?.length) parts.push(`excludeCards: ${h.excludeCards.map(esc).join(", ")}`);
  }
  const body = parts.length ? parts.map((p) => `<div style="margin-left:6px">${p}</div>`).join("") : `<div style="margin-left:6px;opacity:.6">none</div>`;
  return `<div style="margin-bottom:6px"><div style="color:#86efac">sessionHints</div>${body}</div>`;
}
function backlogHtml(backlog) {
  if (!backlog.length) return "";
  const rows = backlog.map((b) => {
    const maxed = b.backlogMultiplier >= b.maxBacklogMultiplier - 1e-9;
    const multColor = b.backlogMultiplier <= 1 ? "#86efac" : maxed ? "#fca5a5" : "#fcd34d";
    const headroom = maxed ? "maxed \u2014 boosts decide order until they relax" : b.backlogMultiplier > 1 ? "climbing as backlog grows" : "healthy \u2014 no pressure";
    const top = b.topReviewScore !== null ? b.topReviewScore.toFixed(2) : "\u2014";
    const next = b.nextDueIn ? ` <span style="opacity:.6">\xB7 next due ${esc(b.nextDueIn)}</span>` : "";
    return `<div style="margin-left:6px"><span style="opacity:.7">${esc(b.courseId.slice(0, 8))}</span> due ${b.dueNow}/${b.scheduledTotal} <span style="opacity:.6">(healthy ${b.healthyBacklog})</span>${next}<div style="margin-left:6px">pressure <span style="color:${multColor}">\xD7${b.backlogMultiplier.toFixed(2)}/${b.maxBacklogMultiplier.toFixed(2)}</span> <span style="opacity:.6">${headroom} \xB7 top review ${top}</span></div></div>`;
  }).join("");
  return `<div style="margin-bottom:6px"><div style="color:#93c5fd">review backpressure</div>${rows}</div>`;
}
function fmtScore(score) {
  if (score === void 0) return "";
  if (!Number.isFinite(score)) return "REQ";
  return score.toFixed(2);
}
function queueItemHtml(item) {
  const tagColor = item.origin === "review" ? "#93c5fd" : "#fcd34d";
  const score = fmtScore(item.score);
  const label = `${item.origin === "review" ? "r" : "n"}${score ? " " + score : ""}`;
  return `${esc(item.cardID)}<span style="color:${tagColor};opacity:.85"> [${label}]</span>`;
}
function queueHtml(key, label, q) {
  const collapsible = q.length > INLINE_THRESHOLD;
  const isOpen = collapsible && expanded[key];
  const caret = collapsible ? expanded[key] ? "\u25BE " : "\u25B8 " : "";
  const drawn = q.dequeueCount ? ` <span style="opacity:.5">drawn ${q.dequeueCount}</span>` : "";
  const titleStyle = collapsible ? "cursor:pointer;color:#f9a8d4" : "color:#f9a8d4";
  const titleAttr = collapsible ? ` data-q="${key}"` : "";
  const title = `<div${titleAttr} style="${titleStyle}">${caret}${label}: ${q.length}${drawn}</div>`;
  if (!q.cards.length) {
    return title + `<div style="margin:1px 0 6px 6px;opacity:.5">empty</div>`;
  }
  const shown = isOpen ? q.cards : q.cards.slice(0, INLINE_THRESHOLD);
  const hiddenCount = q.length - shown.length;
  const listMarginBottom = collapsible ? 2 : 6;
  let body = `<ol style="margin:2px 0 ${listMarginBottom}px 0;padding-left:20px">` + shown.map((c) => `<li style="white-space:nowrap">${queueItemHtml(c)}</li>`).join("") + `</ol>`;
  if (collapsible) {
    const footer = isOpen ? "\u25BE show less" : `\u2026 +${hiddenCount} more`;
    body += `<div data-q="${key}" style="cursor:pointer;margin:0 0 6px 20px;opacity:.6">${footer}</div>`;
  }
  return title + body;
}
function outcomeGlyph(correct) {
  if (correct === true) return `<span style="color:#86efac">\u2713</span>`;
  if (correct === false) return `<span style="color:#fca5a5">\u2717</span>`;
  return `<span style="opacity:.5">\xB7</span>`;
}
function drawnHtml(key, drawn) {
  const collapsible = drawn.length > INLINE_THRESHOLD;
  const isOpen = collapsible && expanded[key];
  const caret = collapsible ? expanded[key] ? "\u25BE " : "\u25B8 " : "";
  const titleStyle = collapsible ? "cursor:pointer;color:#c4b5fd" : "color:#c4b5fd";
  const titleAttr = collapsible ? ` data-q="${key}"` : "";
  const title = `<div${titleAttr} style="${titleStyle}">${caret}drawn: ${drawn.length}</div>`;
  if (!drawn.length) {
    return title + `<div style="margin:1px 0 6px 6px;opacity:.5">none yet</div>`;
  }
  const shown = isOpen ? drawn : drawn.slice(0, INLINE_THRESHOLD);
  const hiddenCount = drawn.length - shown.length;
  const listMarginBottom = collapsible ? 2 : 6;
  const rows = shown.map((d) => {
    const retries = d.attempts > 1 ? `<span style="opacity:.5"> \xD7${d.attempts}</span>` : "";
    const time = `<span style="opacity:.45"> ${Math.round(d.timeSpentMs / 100) / 10}s</span>`;
    return `<li style="white-space:nowrap">${outcomeGlyph(d.correct)} ${esc(d.cardID)}<span style="opacity:.5"> [${esc(d.status)}]</span>${retries}${time}</li>`;
  }).join("");
  let body = `<ol style="margin:2px 0 ${listMarginBottom}px 0;padding-left:20px">${rows}</ol>`;
  if (collapsible) {
    const footer = isOpen ? "\u25BE show less" : `\u2026 +${hiddenCount} more`;
    body += `<div data-q="${key}" style="cursor:pointer;margin:0 0 6px 20px;opacity:.6">${footer}</div>`;
  }
  return title + body;
}
function snapshotToText(s) {
  if (!s) return "SessionController \u2014 no active session.";
  const lines = [];
  lines.push("=== SessionController ===");
  lines.push(`time ${formatTime(s.secondsRemaining)}`);
  if (s.hasCardGuarantee) lines.push(`guarantee: ${s.minCardsGuarantee}`);
  lines.push(`well-indicated left: ${s.wellIndicatedRemaining}`);
  lines.push(`current: ${s.currentCard ?? "\u2014"}`);
  lines.push(
    s.replanActive ? `replan: ACTIVE [${s.replanLabel ?? "(auto)"}]` : "replan: idle"
  );
  lines.push("");
  lines.push("sessionHints:");
  const h = s.sessionHints;
  const hintParts = [];
  if (h) {
    if (h.boostTags && Object.keys(h.boostTags).length)
      hintParts.push(`  boost: ${Object.entries(h.boostTags).map(([k, v]) => `${k}\xD7${v}`).join(", ")}`);
    if (h.boostCards && Object.keys(h.boostCards).length)
      hintParts.push(`  boostCards: ${Object.entries(h.boostCards).map(([k, v]) => `${k}\xD7${v}`).join(", ")}`);
    if (h.requireCards?.length) hintParts.push(`  require: ${h.requireCards.join(", ")}`);
    if (h.requireTags?.length) hintParts.push(`  requireTags: ${h.requireTags.join(", ")}`);
    if (h.excludeTags?.length) hintParts.push(`  exclude: ${h.excludeTags.join(", ")}`);
    if (h.excludeCards?.length) hintParts.push(`  excludeCards: ${h.excludeCards.join(", ")}`);
  }
  lines.push(hintParts.length ? hintParts.join("\n") : "  none");
  if (s.reviewBacklog.length) {
    lines.push("");
    lines.push("review backpressure:");
    for (const b of s.reviewBacklog) {
      const maxed = b.backlogMultiplier >= b.maxBacklogMultiplier - 1e-9;
      const headroom = maxed ? "maxed (boosts decide order)" : b.backlogMultiplier > 1 ? "climbing" : "healthy";
      const top = b.topReviewScore !== null ? b.topReviewScore.toFixed(2) : "\u2014";
      const next = b.nextDueIn ? `, next due ${b.nextDueIn}` : "";
      lines.push(
        `  ${b.courseId.slice(0, 8)}: due ${b.dueNow}/${b.scheduledTotal} (healthy ${b.healthyBacklog})${next}; pressure \xD7${b.backlogMultiplier.toFixed(2)}/${b.maxBacklogMultiplier.toFixed(2)} ${headroom}; top review ${top}`
      );
    }
  }
  const queueText = (label, q) => {
    lines.push("");
    lines.push(`${label}: ${q.length} (drawn ${q.dequeueCount})`);
    q.cards.forEach((c, i) => {
      const score = fmtScore(c.score);
      const tag = `${c.origin === "review" ? "r" : "n"}${score ? " " + score : ""}`;
      lines.push(`  ${i + 1}. ${c.cardID} [${tag}]`);
    });
  };
  queueText("supplyQ", s.supplyQ);
  queueText("failedQ", s.failedQ);
  lines.push("");
  lines.push(`drawn: ${s.drawnCards.length}`);
  s.drawnCards.forEach((d, i) => {
    const mark = d.correct === true ? "\u2713" : d.correct === false ? "\u2717" : "\xB7";
    const time = `${Math.round(d.timeSpentMs / 100) / 10}s`;
    lines.push(`  ${i + 1}. ${mark} ${d.cardID} [${d.status}] \xD7${d.attempts} ${time}`);
  });
  return lines.join("\n");
}
function formatTime(totalSeconds) {
  const s = Math.max(0, Math.round(totalSeconds));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${r.toString().padStart(2, "0")}`;
}
function esc(value) {
  return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

// src/study/SessionDebugger.ts
var activeSession = null;
var sessionHistory = [];
var MAX_HISTORY = 5;
function startSessionTracking(supplyQLength, failedQLength) {
  clearRunHistory();
  clearSrsBacklogDebug();
  const sessionId = `session-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  activeSession = {
    sessionId,
    startTime: /* @__PURE__ */ new Date(),
    initialQueues: {
      timestamp: /* @__PURE__ */ new Date(),
      supplyQLength,
      failedQLength
    },
    presentations: [],
    queueSnapshots: []
  };
  logger.debug(`[SessionDebugger] Started tracking session: ${sessionId}`);
}
function recordCardPresentation(cardId, courseId, courseName, origin, queueSource, score) {
  if (!activeSession) {
    logger.warn("[SessionDebugger] No active session to record presentation");
    return;
  }
  activeSession.presentations.push({
    timestamp: /* @__PURE__ */ new Date(),
    sequenceNumber: activeSession.presentations.length + 1,
    cardId,
    courseId,
    courseName,
    origin,
    queueSource,
    score
  });
}
function snapshotQueues(supplyQLength, failedQLength, supplyQNext3) {
  if (!activeSession) {
    return;
  }
  activeSession.queueSnapshots.push({
    timestamp: /* @__PURE__ */ new Date(),
    supplyQLength,
    failedQLength,
    supplyQNext3
  });
}
function endSessionTracking() {
  if (!activeSession) {
    return;
  }
  activeSession.endTime = /* @__PURE__ */ new Date();
  sessionHistory.unshift(activeSession);
  if (sessionHistory.length > MAX_HISTORY) {
    sessionHistory.pop();
  }
  logger.debug(`[SessionDebugger] Ended session: ${activeSession.sessionId}`);
  activeSession = null;
}
function showCurrentQueue() {
  if (!activeSession) {
    logger.info("[Session Debug] No active session.");
    return;
  }
  const latest = activeSession.queueSnapshots[activeSession.queueSnapshots.length - 1] || activeSession.initialQueues;
  console.group("\u{1F4CA} Current Queue State");
  logger.info(`Supply Queue: ${latest.supplyQLength} cards`);
  if (latest.supplyQNext3 && latest.supplyQNext3.length > 0) {
    logger.info(`  Next: ${latest.supplyQNext3.join(", ")}`);
  }
  logger.info(`Failed Queue: ${latest.failedQLength} cards`);
  console.groupEnd();
}
function showPresentationHistory(sessionIndex = 0) {
  const session = sessionIndex === 0 && activeSession ? activeSession : sessionHistory[sessionIndex];
  if (!session) {
    logger.info(`[Session Debug] No session found at index ${sessionIndex}`);
    return;
  }
  console.group(`\u{1F4DC} Session History: ${session.sessionId}`);
  logger.info(`Started: ${session.startTime.toLocaleTimeString()}`);
  if (session.endTime) {
    logger.info(`Ended: ${session.endTime.toLocaleTimeString()}`);
  }
  logger.info(`Cards presented: ${session.presentations.length}`);
  if (session.presentations.length > 0) {
    console.table(
      session.presentations.map((p) => ({
        "#": p.sequenceNumber,
        course: p.courseName || p.courseId.slice(0, 8),
        origin: p.origin,
        queue: p.queueSource,
        score: p.score?.toFixed(3) || "-",
        time: p.timestamp.toLocaleTimeString()
      }))
    );
  }
  console.groupEnd();
}
function showInterleaving(sessionIndex = 0) {
  const session = sessionIndex === 0 && activeSession ? activeSession : sessionHistory[sessionIndex];
  if (!session) {
    logger.info(`[Session Debug] No session found at index ${sessionIndex}`);
    return;
  }
  console.group("\u{1F500} Interleaving Analysis");
  const courseCounts = /* @__PURE__ */ new Map();
  const courseOrigins = /* @__PURE__ */ new Map();
  session.presentations.forEach((p) => {
    const name = p.courseName || p.courseId;
    courseCounts.set(name, (courseCounts.get(name) || 0) + 1);
    if (!courseOrigins.has(name)) {
      courseOrigins.set(name, { review: 0, new: 0, failed: 0 });
    }
    const origins = courseOrigins.get(name);
    origins[p.origin]++;
  });
  logger.info("Course distribution:");
  console.table(
    Array.from(courseCounts.entries()).map(([course, count]) => {
      const origins = courseOrigins.get(course);
      return {
        course,
        total: count,
        reviews: origins.review,
        new: origins.new,
        failed: origins.failed,
        percentage: (count / session.presentations.length * 100).toFixed(1) + "%"
      };
    })
  );
  if (session.presentations.length > 0) {
    logger.info("\nPresentation sequence (first 20):");
    const sequence = session.presentations.slice(0, 20).map((p, idx) => `${idx + 1}. ${p.courseName || p.courseId.slice(0, 8)} (${p.origin})`).join("\n");
    logger.info(sequence);
  }
  let maxCluster = 0;
  let currentCluster = 1;
  let currentCourse = session.presentations[0]?.courseId;
  for (let i = 1; i < session.presentations.length; i++) {
    if (session.presentations[i].courseId === currentCourse) {
      currentCluster++;
      maxCluster = Math.max(maxCluster, currentCluster);
    } else {
      currentCourse = session.presentations[i].courseId;
      currentCluster = 1;
    }
  }
  if (maxCluster > 3) {
    logger.info(`
\u26A0\uFE0F Detected clustering: max ${maxCluster} cards from same course in a row`);
    logger.info("This suggests cards are sorted by score rather than round-robin by course.");
  }
  console.groupEnd();
}
var sessionDebugAPI = {
  /**
   * Get raw session history for programmatic access.
   */
  get sessions() {
    return [...sessionHistory];
  },
  /**
   * Get active session if any.
   */
  get active() {
    return activeSession;
  },
  /**
   * Show current queue state.
   */
  showQueue() {
    showCurrentQueue();
  },
  /**
   * Toggle the pinned, live-updating DOM overlay for the active controller
   * (queues, session hints, timer). No-ops in non-browser hosts.
   */
  dbgOverlay() {
    toggleSessionOverlay();
  },
  /**
   * Show presentation history for current or past session.
   */
  showHistory(sessionIndex = 0) {
    showPresentationHistory(sessionIndex);
  },
  /**
   * Analyze course interleaving pattern.
   */
  showInterleaving(sessionIndex = 0) {
    showInterleaving(sessionIndex);
  },
  /**
   * List all tracked sessions.
   */
  listSessions() {
    if (activeSession) {
      logger.info(`Active session: ${activeSession.sessionId} (${activeSession.presentations.length} cards presented)`);
    }
    if (sessionHistory.length === 0) {
      logger.info("[Session Debug] No completed sessions in history.");
      return;
    }
    console.table(
      sessionHistory.map((s, idx) => ({
        index: idx,
        id: s.sessionId.slice(-8),
        started: s.startTime.toLocaleTimeString(),
        ended: s.endTime?.toLocaleTimeString() || "incomplete",
        cards: s.presentations.length
      }))
    );
  },
  /**
   * Export session history as JSON for bug reports.
   */
  export() {
    const data = {
      active: activeSession,
      history: sessionHistory
    };
    const json = JSON.stringify(data, null, 2);
    logger.info("[Session Debug] Session data exported. Copy the returned string or use:");
    logger.info("  copy(window.skuilder.session.export())");
    return json;
  },
  /**
   * Clear session history.
   */
  clear() {
    sessionHistory.length = 0;
    logger.info("[Session Debug] Session history cleared.");
  },
  /**
   * Show help.
   */
  help() {
    logger.info(`
\u{1F3AF} Session Debug API

Commands:
  .dbgOverlay()             Toggle the pinned live overlay (queues, hints, timer)
  .showQueue()              Show current queue state (active session only)
  .showHistory(index?)      Show presentation history (0=current/last, 1=previous, etc)
  .showInterleaving(index?) Analyze course interleaving pattern
  .listSessions()           List all tracked sessions
  .export()                 Export session data as JSON for bug reports
  .clear()                  Clear session history
  .sessions                 Access raw session history array
  .active                   Access active session (if any)
  .help()                   Show this help message

Example:
  window.skuilder.session.showHistory()
  window.skuilder.session.showInterleaving()
  window.skuilder.session.showQueue()
`);
  }
};
function mountSessionDebugger() {
  if (typeof window === "undefined") return;
  const win = window;
  win.skuilder = win.skuilder || {};
  win.skuilder.session = sessionDebugAPI;
}
mountSessionDebugger();

// src/study/SessionController.ts
init_logger();
var SessionController = class _SessionController extends Loggable {
  _className = "SessionController";
  services;
  srsService;
  eloService;
  hydrationService;
  mixer;
  dataLayer;
  courseNameCache = /* @__PURE__ */ new Map();
  /**
   * Default pipeline batch size for new-card planning.
   * Set via constructor options; falls back to 20 when not specified.
   * Individual replans can override via `ReplanOptions.limit`.
   */
  _defaultBatchLimit = 20;
  sources;
  // dataLayer and getViewComponent now injected into CardHydrationService
  _sessionRecord = [];
  set sessionRecord(r) {
    this._sessionRecord = r;
  }
  // Session card stores
  _currentCard = null;
  /**
   * The single supply queue: `new` + `review` items interleaved in pipeline
   * rank order (the mixer's score-ordered, source-interleaved output, with
   * `+INF` required cards floated to the front). Drawn front-to-back; reviews
   * and new compete on one cross-comparable scale rather than being re-mixed
   * by a probability gate. Replaced/re-ranked wholesale on replan. See
   * `docs/decision-single-supply-queue.md`.
   */
  supplyQ = new ItemQueue();
  failedQ = new ItemQueue();
  // END   Session card stores
  /**
   * Supply draws since the last failed-queue *event* (a failed draw, or a card
   * entering failedQ on failure). Drives the light steady failed-interleave
   * (§7): after this many consecutive supply draws, a pending failed card is
   * drawn so remediation doesn't starve mid-session. Incremented on each supply
   * draw; reset to 0 both when a failed card is drawn AND when one is added to
   * failedQ — the latter gives a just-failed card spacing instead of an instant
   * retry (the counter would otherwise already be ≥ threshold from the preceding
   * supply run).
   */
  _supplyDrawsSinceFailed = 0;
  /**
   * Promise tracking a currently in-progress replan, or null if idle.
   * Used by nextCard() to await completion before drawing from queues.
   */
  _replanPromise = null;
  /**
   * Reason for the replan currently executing in `_runReplan`, surfaced by the
   * debug overlay's spinner. The caller's `opts.label` when present, else
   * `'(auto)'`. Only meaningful while `_replanPromise` is non-null; cleared
   * when the in-flight chain settles.
   */
  _activeReplanLabel = null;
  /**
   * Number of well-indicated supply cards remaining before the queue
   * degrades to poorly-indicated content. Decremented on each supplyQ
   * draw; when it hits 0, a replan is triggered automatically
   * (user state has changed from completing good cards).
   */
  _wellIndicatedRemaining = 0;
  /**
   * When true, suppresses the quality-based auto-replan trigger in
   * nextCard(). Set after a burst replan (small limit) to prevent the
   * auto-replan from clobbering the burst cards before they're consumed.
   * Cleared when the depletion-triggered replan fires (supplyQ exhausted).
   */
  _suppressQualityReplan = false;
  /**
   * When > 0, the session timer cannot end the session. Decremented on
   * each nextCard() draw. Set by replans that include `minFollowUpCards`.
   */
  _minCardsGuarantee = 0;
  /**
   * Session-durable scoring hints. Re-merged into every pipeline run for
   * the rest of the session (initial plan + every replan, including bare
   * auto-replans and the wedge-breaker), via `_applyHintsToSources`.
   *
   * Set by `setSessionHints()` (e.g. session-start post-lesson boost) or by
   * any replan carrying `ReplanOptions.sessionHints` (e.g. a just-failed
   * concept boost). Replace semantics, no decay — lives until overwritten
   * or session end. See `ReplanOptions.sessionHints` for rationale.
   *
   * Note: the controller-managed auto-excludes (current card, session
   * record, imminent draw) are intentionally NOT folded in here — those are
   * recomputed per-run in `_runReplan` and would otherwise go stale.
   */
  _sessionHints = null;
  /**
   * Card IDs that have been *served* (drawn/consumed) this session. Populated
   * at the single consumption choke-point (removeItemFromQueue), so it reflects
   * a draw the instant it happens — earlier than `_sessionRecord`, which only
   * lands once the card is *responded to*.
   *
   * Used to keep already-served cards out of supplyQ on every (re)plan, across
   * ALL origins: a `new` card shown once must never re-enter, and once replans
   * re-pull reviews, an answered/in-flight review must not re-enter the supply
   * before its SRS reschedule clears the due-window (the review-loop guard,
   * decision doc §4). This is the general guard against re-presentation —
   * including the case where a replan in flight captured a now-drawn card (e.g.
   * a +INF require-injected follow-up the depletion prefetch grabbed just before
   * it was drawn). failedQ is separate and controller-owned, so failed cards
   * legitimately recur there without being gated here.
   */
  _servedCardIds = /* @__PURE__ */ new Set();
  /**
   * Consumer-supplied hooks invoked after each question response is processed.
   * Seeded from constructor options (threaded from
   * `StudySessionConfig.outcomeObservers`). See {@link OutcomeObserver}.
   */
  _outcomeObservers = [];
  /**
   * Lazily-built, stable capability object handed to observers. Bound to
   * `this`; constructed once so observers can rely on referential identity.
   */
  _sessionControls = null;
  startTime;
  endTime;
  _secondsRemaining;
  get secondsRemaining() {
    return this._secondsRemaining;
  }
  /** True when a card guarantee is active, preventing timer-based session end. */
  get hasCardGuarantee() {
    return this._minCardsGuarantee > 0;
  }
  get report() {
    const supplyCount = this.supplyQ.dequeueCount;
    const supplyWord = supplyCount === 1 ? "card" : "cards";
    return `${supplyCount} supply ${supplyWord} drawn`;
  }
  get detailedReport() {
    return this.supplyQ.toString + "\n" + this.failedQ.toString;
  }
  // @ts-expect-error NodeJS.Timeout type not available in browser context
  _intervalHandle;
  /**
   * @param sources - Array of content sources to mix for the session
   * @param time - Session duration in seconds
   * @param dataLayer - Data layer provider
   * @param getViewComponent - Function to resolve view components
   * @param mixer - Optional source mixer strategy (defaults to QuotaRoundRobinMixer)
   * @param options - Optional session-level configuration
   * @param options.defaultBatchLimit - Default supply working-set size (default: 20).
   *   Smaller values for newer users cause more frequent replans, keeping plans
   *   aligned with rapidly-changing user state.
   */
  constructor(sources, time, dataLayer, getViewComponent, mixer, options) {
    super();
    this.dataLayer = dataLayer;
    this.mixer = mixer || new QuotaRoundRobinMixer();
    this.srsService = new SrsService(dataLayer.getUserDB());
    this.eloService = new EloService(dataLayer, dataLayer.getUserDB());
    this.hydrationService = new CardHydrationService(
      getViewComponent,
      (courseId) => dataLayer.getCourseDB(courseId),
      () => this._getItemsToHydrate()
    );
    this.services = {
      response: new ResponseProcessor(this.srsService, this.eloService)
    };
    this.sources = sources;
    this.startTime = /* @__PURE__ */ new Date();
    this._secondsRemaining = time;
    this.endTime = new Date(this.startTime.valueOf() + 1e3 * this._secondsRemaining);
    if (options?.defaultBatchLimit !== void 0) {
      this._defaultBatchLimit = options.defaultBatchLimit;
    }
    if (options?.outcomeObservers?.length) {
      this._outcomeObservers = [...options.outcomeObservers];
    }
    this.log(`Session constructed:
    startTime: ${this.startTime}
    endTime: ${this.endTime}
    defaultBatchLimit: ${this._defaultBatchLimit}`);
    registerActiveController(this);
  }
  tick() {
    this._secondsRemaining = Math.floor((this.endTime.valueOf() - Date.now()) / 1e3);
    if (this._secondsRemaining <= 0) {
      clearInterval(this._intervalHandle);
    }
  }
  /**
   * Returns a rough, erring toward conservative, guess at
   * the amount of time the failed cards queue will require
   * to clean up.
   *
   * (seconds)
   */
  estimateCleanupTime() {
    let time = 0;
    for (let i = 0; i < this.failedQ.length; i++) {
      const c = this.failedQ.peek(i);
      const record = this._sessionRecord.find((r) => r.item.cardID === c.cardID);
      let cardTime = 0;
      if (record) {
        for (let j = 0; j < record.records.length; j++) {
          cardTime += record.records[j].timeSpent;
        }
        cardTime = cardTime / record.records.length;
        time += cardTime;
      }
    }
    const ret = time / 1e3;
    this.log(`Failed card cleanup estimate: ${Math.round(ret)}`);
    return ret;
  }
  async prepareSession() {
    if (this.sources.some((s) => typeof s.getWeightedCards !== "function")) {
      throw new Error(
        "[SessionController] All content sources must implement getWeightedCards()."
      );
    }
    const wellIndicated = await this.getWeightedContent();
    this._wellIndicatedRemaining = wellIndicated;
    if (wellIndicated >= 0 && wellIndicated < _SessionController.MIN_WELL_INDICATED) {
      this.log(
        `[Init] Only ${wellIndicated}/${_SessionController.MIN_WELL_INDICATED} well-indicated cards in initial load`
      );
    }
    await this.hydrationService.ensureHydratedCards();
    startSessionTracking(this.supplyQ.length, this.failedQ.length);
    this._intervalHandle = setInterval(() => {
      this.tick();
    }, 1e3);
  }
  /**
   * Request a mid-session replan. Re-runs the pipeline with current user state
   * and atomically replaces (or merges into) the supplyQ contents. Safe to call
   * at any time during a session.
   *
   * Concurrency policy:
   * - Two unhinted auto-replans never run in parallel; the second coalesces
   *   into the first (returns the same promise).
   * - A hint-bearing replan that arrives while another replan is in flight
   *   is queued to run **after** the in-flight one rather than dropped.
   *   This preserves caller intent (label, requireCards, excludeTags,
   *   limit, minFollowUpCards) instead of silently discarding it. Without
   *   queueing, a background auto-replan that started just before a
   *   completion-triggered replan would clobber the queue with unhinted
   *   results (e.g. surfacing another gpc-intro card right after one
   *   completed, skipping the prescribed `c-wst-*` follow-up).
   *
   * Re-pulls and re-ranks the whole supply (including reviews); does NOT affect
   * failedQ (controller-owned remediation).
   *
   * If nextCard() is called while a replan is in flight, it will automatically
   * await the replan before drawing from queues, ensuring the user always sees
   * cards scored against their latest state.
   *
   * Typical trigger: application-level code (e.g. after a GPC intro completion)
   * calls this to ensure newly-unlocked content appears in the session.
   */
  async requestReplan(options) {
    const opts = this.normalizeReplanOptions(options);
    const hasIntent = this._replanHasIntent(opts);
    if (this._replanPromise) {
      if (!hasIntent) {
        this.log("Replan already in progress, coalescing unhinted auto-replan");
        return this._replanPromise;
      }
      const labelTag = opts.label ? ` [${opts.label}]` : "";
      this.log(
        `Replan in progress; queueing hint-bearing replan${labelTag} behind in-flight run`
      );
      const inflight = this._replanPromise;
      const queued = inflight.catch(() => void 0).then(() => this._runReplan(opts));
      const tracked2 = queued.finally(() => {
        if (this._replanPromise === tracked2) {
          this._replanPromise = null;
          this._activeReplanLabel = null;
        }
      });
      this._replanPromise = tracked2;
      return queued;
    }
    const run = this._runReplan(opts);
    const tracked = run.finally(() => {
      if (this._replanPromise === tracked) {
        this._replanPromise = null;
        this._activeReplanLabel = null;
      }
    });
    this._replanPromise = tracked;
    await run;
  }
  /**
   * True when a requestReplan call carries caller intent that must not be
   * silently dropped. Bare unhinted auto-replans (depletion / quality
   * triggers in nextCard) return false and may coalesce.
   */
  _replanHasIntent(opts) {
    if (opts.limit !== void 0) return true;
    if (opts.minFollowUpCards !== void 0) return true;
    if (opts.mode && opts.mode !== "replace") return true;
    if (opts.hints && Object.keys(opts.hints).length > 0) return true;
    if (opts.sessionHints !== void 0) return true;
    if (opts.mergeSessionHints !== void 0) return true;
    return false;
  }
  /**
   * Body of a single replan: populate auto-excludes, stash hints on
   * sources, log, then run the pipeline. Extracted so it can be invoked
   * either immediately (no in-flight replan) or queued (chained after
   * the in-flight one resolves).
   *
   * IMPORTANT: hint stash and the queue-state snapshot used to build
   * excludeCards happen at *invocation* time, not at *queue* time. For a
   * queued replan that means excludes reflect the state after the prior
   * replan landed — which is what we want, since the prior replan's
   * supplyQ.peek(0) is the imminent draw we need to exclude.
   */
  async _runReplan(opts) {
    this._activeReplanLabel = opts.label ?? "(auto)";
    if (!opts.hints) opts.hints = {};
    const hints = opts.hints;
    const excludeSet = new Set(hints.excludeCards ?? []);
    if (this._currentCard?.item.cardID) {
      excludeSet.add(this._currentCard.item.cardID);
    }
    for (const rec of this._sessionRecord) {
      excludeSet.add(rec.card.card_id);
    }
    if (this.supplyQ.length > 0) {
      excludeSet.add(this.supplyQ.peek(0).cardID);
    }
    hints.excludeCards = [...excludeSet];
    if (opts.sessionHints !== void 0) {
      this._sessionHints = opts.sessionHints;
      this.log(
        `[Replan] Session hints ${opts.sessionHints ? "set" : "cleared"}: ${JSON.stringify(opts.sessionHints)}`
      );
    }
    if (opts.mergeSessionHints !== void 0) {
      this._sessionHints = mergeHints2([this._sessionHints, opts.mergeSessionHints]) ?? null;
      this.log(`[Replan] Session hints merged: ${JSON.stringify(this._sessionHints)}`);
    }
    this._applyHintsToSources(opts.hints, opts.label);
    const labelTag = opts.label ? ` [${opts.label}]` : "";
    this.log(
      `Mid-session replan requested${labelTag} (limit: ${opts.limit ?? "default"}, mode: ${opts.mode ?? "replace"}${opts.hints ? ", with hints" : ""})`
    );
    if (opts.minFollowUpCards !== void 0 && opts.minFollowUpCards > 0) {
      this._minCardsGuarantee = Math.max(this._minCardsGuarantee, opts.minFollowUpCards);
      this.log(`[Replan] Card guarantee set to ${this._minCardsGuarantee}`);
    }
    await this._executeReplan(opts);
  }
  /**
   * Set the session-durable scoring hints (replace semantics, no decay).
   *
   * Unlike a one-shot replan hint, these are re-merged into every pipeline
   * run for the rest of the session — including the initial plan when set
   * before `prepareSession()`, every replan, the bare auto-replans, and the
   * wedge-breaker. Pass `null` to clear.
   *
   * Typical callers:
   * - `StudySession` at session start, threading `StudySessionConfig.initHints`
   *   (e.g. a post-lesson concept boost) — so the boost outlives the first
   *   queue rebuild instead of being clobbered by the first auto-replan.
   * - A consumer view on a failure, boosting the just-failed concept tag.
   *
   * Does not itself trigger a replan; the next plan/replan picks it up.
   */
  setSessionHints(hints) {
    this._sessionHints = hints;
    this.log(`Session hints ${hints ? "set" : "cleared"}: ${JSON.stringify(hints)}`);
  }
  /**
   * Read the current session-durable hints (for read-modify-write callers,
   * e.g. an outcome observer that clamps a compounding boost).
   */
  getSessionHints() {
    return this._sessionHints;
  }
  /**
   * Live state snapshot for the debug overlay (window.skuilder.session
   * .dbgOverlay()). Reads directly from the private queues and hints, so it
   * always reflects the current moment — unlike the passive SessionDebugger
   * snapshots, which only capture what was explicitly pushed to them.
   */
  getDebugSnapshot() {
    const describe = (q) => {
      const cards = [];
      for (let i = 0; i < q.length; i++) {
        const item = q.peek(i);
        cards.push({
          cardID: item.cardID,
          status: item.status,
          origin: isReview(item) ? "review" : "new",
          score: item.score
        });
      }
      return { length: q.length, dequeueCount: q.dequeueCount, cards };
    };
    const drawnCards = this._sessionRecord.map((r) => {
      const last = r.records[r.records.length - 1];
      return {
        cardID: r.item.cardID,
        status: r.item.status,
        attempts: r.records.length,
        correct: last && isQuestionRecord(last) ? last.isCorrect : null,
        timeSpentMs: r.records.reduce((sum, rec) => sum + rec.timeSpent, 0)
      };
    });
    return {
      secondsRemaining: this.secondsRemaining,
      hasCardGuarantee: this.hasCardGuarantee,
      minCardsGuarantee: this._minCardsGuarantee,
      wellIndicatedRemaining: this._wellIndicatedRemaining,
      currentCard: this._currentCard?.item.cardID ?? null,
      sessionHints: this._sessionHints,
      replanActive: this._replanPromise !== null,
      replanLabel: this._activeReplanLabel,
      supplyQ: describe(this.supplyQ),
      failedQ: describe(this.failedQ),
      reviewBacklog: getSrsBacklogDebug(),
      drawnCards
    };
  }
  /**
   * Merge `hints` into the durable session hints via the pipeline's
   * `mergeHints` (boosts multiply, require/exclude lists concat-dedup).
   * Convenience over get-then-set for the common additive case. Note the
   * multiplicative, no-decay semantics — clamp boost factors at the call
   * site if a repeatedly-emphasised tag could compound unboundedly.
   */
  mergeSessionHints(hints) {
    this._sessionHints = mergeHints2([this._sessionHints, hints]) ?? null;
    this.log(`Session hints merged: ${JSON.stringify(this._sessionHints)}`);
  }
  /**
   * Merge the durable `_sessionHints` with this run's one-shot hints and
   * push the result to every source for consumption on the next pipeline
   * run. Centralised so the initial plan and all replan paths apply session
   * emphasis identically. No-op when there are no hints of either kind.
   */
  _applyHintsToSources(oneShot, label) {
    const oneShotWithLabel = oneShot && label ? { ...oneShot, _label: label } : oneShot;
    const merged = mergeHints2([this._sessionHints, oneShotWithLabel]);
    if (!merged) return;
    for (const source of this.sources) {
      source.setEphemeralHints?.(merged);
    }
  }
  /**
   * Build (once) the stable capability object handed to outcome observers.
   * Methods are bound to `this`; the object identity is stable across calls
   * so observers may key off it.
   */
  _getSessionControls() {
    if (!this._sessionControls) {
      this._sessionControls = {
        getSessionHints: () => this.getSessionHints(),
        setSessionHints: (h) => this.setSessionHints(h),
        mergeSessionHints: (h) => this.mergeSessionHints(h),
        requestReplan: (opts) => this.requestReplan(opts)
      };
    }
    return this._sessionControls;
  }
  /**
   * Notify registered outcome observers about a processed response.
   *
   * Only question records are surfaced (non-question dismisses are skipped).
   * Observers run after ELO/SRS are recorded and before navigation. Each is
   * awaited but isolated in try/catch — a throwing observer is logged and
   * skipped, never wedging the session. Keep observers cheap and `void` any
   * long work (e.g. a triggered replan) to avoid stalling the draw.
   */
  async _notifyOutcomeObservers(record, currentCard, result) {
    if (this._outcomeObservers.length === 0) return;
    if (!isQuestionRecord(record)) return;
    const outcome = {
      record,
      card: currentCard.card,
      result
    };
    const controls = this._getSessionControls();
    for (const observer of this._outcomeObservers) {
      try {
        await observer(outcome, controls);
      } catch (e) {
        this.error("[OutcomeObserver] observer threw; ignoring", e);
      }
    }
  }
  /**
   * Run a replan, bypassing requestReplan()'s coalesce logic.
   *
   * Use this when correctness depends on a *fresh* pipeline run, not on
   * the existence of *some* in-flight replan. Specifically: the
   * wedge-breaker path in nextCard(), where coalescing into a previous
   * run that we now know produced insufficient content would re-create
   * the bug we're trying to prevent.
   *
   * Still tracks _replanPromise like requestReplan() does so concurrent
   * observers (auto-trigger guards in nextCard()) see consistent state.
   */
  async _replanUncoalesced(opts) {
    const run = this._runReplan(opts);
    const tracked = run.finally(() => {
      if (this._replanPromise === tracked) {
        this._replanPromise = null;
        this._activeReplanLabel = null;
      }
    });
    this._replanPromise = tracked;
    await run;
  }
  /**
   * Normalise the requestReplan argument. Accepts either a ReplanOptions
   * object (new API) or a plain Record<string, unknown> (legacy callers
   * that passed hints directly). Distinguishes the two by checking for
   * the presence of ReplanOptions-specific keys.
   */
  normalizeReplanOptions(input) {
    if (!input) return {};
    const replanKeys = ["hints", "sessionHints", "limit", "mode", "label", "minFollowUpCards"];
    const inputKeys = Object.keys(input);
    if (inputKeys.some((k) => replanKeys.includes(k))) {
      return input;
    }
    return { hints: input };
  }
  /** Minimum well-indicated cards before an additive retry is attempted */
  static MIN_WELL_INDICATED = 5;
  /**
   * Score threshold for considering a card "well-indicated."
   * Cards below this score are treated as fallback filler — present only
   * because no strategy hard-removed them, but likely penalized by one
   * or more filters. Strategy-agnostic: the SessionController doesn't
   * know or care which strategy assigned the score.
   */
  static WELL_INDICATED_SCORE = 0.1;
  /**
   * supplyQ length at or below which the opportunistic depletion-prefetch
   * fires. Sets the lead time available for the background replan to land
   * before the user actually empties the queue and falls into the
   * (synchronous) wedge-breaker path.
   *
   * Set to a small absolute value (not a fraction of batch limit) because
   * pipeline latency is roughly fixed regardless of batch size — what
   * matters is "how many cards of user-pace do we have left." 3 cards
   * × ~3-5s/card = ~10-15s of lead time, comfortably exceeding typical
   * pipeline latency.
   */
  static DEPLETION_PREFETCH_THRESHOLD = 3;
  /**
   * Internal replan execution. Runs the pipeline, rebuilds the supplyQ,
   * atomically swaps it in, and triggers hydration for the new contents.
   *
   * If the initial replan produces fewer than MIN_WELL_INDICATED cards that
   * pass all hierarchy filters, one additive retry is attempted — merging
   * any new high-quality candidates into the front of the queue.
   */
  async _executeReplan(opts = {}) {
    const limit = opts.limit;
    const mode = opts.mode ?? "replace";
    const wellIndicated = await this.getWeightedContent({
      replan: true,
      additive: mode === "merge",
      limit
    });
    this._wellIndicatedRemaining = wellIndicated;
    if (limit !== void 0 && limit < this._defaultBatchLimit) {
      this._suppressQualityReplan = true;
      this.log(`[Replan] Burst mode (limit=${limit}): suppressing quality-based auto-replan`);
    } else {
      this._suppressQualityReplan = false;
    }
    if (wellIndicated >= 0 && wellIndicated < _SessionController.MIN_WELL_INDICATED) {
      this.log(
        `[Replan] Only ${wellIndicated}/${_SessionController.MIN_WELL_INDICATED} well-indicated cards after replan`
      );
    }
    await this.hydrationService.ensureHydratedCards();
    const labelTag = opts.label ? ` [${opts.label}]` : "";
    this.log(`Replan complete${labelTag}: supplyQ now has ${this.supplyQ.length} cards (mode=${mode})`);
    snapshotQueues(this.supplyQ.length, this.failedQ.length);
  }
  addTime(seconds) {
    this.endTime = new Date(this.endTime.valueOf() + 1e3 * seconds);
  }
  get failedCount() {
    return this.failedQ.length;
  }
  toString() {
    return `Session: ${this.supplyQ.length} supply, ${this.failedQ.length} failed`;
  }
  reportString() {
    return `${this.supplyQ.dequeueCount} supply, ${this.failedQ.dequeueCount} failed`;
  }
  /**
   * Returns debug information about the current session state.
   * Used by SessionControllerDebug component for runtime inspection.
   */
  getDebugInfo() {
    const supportsWeightedCards = this.sources.some(
      (s) => typeof s.getWeightedCards === "function"
    );
    const extractQueueItems = (queue, limit = 10) => {
      const items = [];
      for (let i = 0; i < Math.min(queue.length, limit); i++) {
        const item = queue.peek(i);
        items.push({
          courseID: item.courseID || "unknown",
          cardID: item.cardID || "unknown",
          status: item.status || "unknown",
          score: item.score
        });
      }
      return items;
    };
    return {
      api: {
        mode: supportsWeightedCards ? "weighted" : "legacy",
        description: supportsWeightedCards ? "Using getWeightedCards() API with scored candidates" : "ERROR: getWeightedCards() not a function."
      },
      supplyQueue: {
        length: this.supplyQ.length,
        dequeueCount: this.supplyQ.dequeueCount,
        items: extractQueueItems(this.supplyQ)
      },
      failedQueue: {
        length: this.failedQ.length,
        dequeueCount: this.failedQ.dequeueCount,
        items: extractQueueItems(this.failedQ)
      },
      hydratedCache: {
        count: this.hydrationService.hydratedCount,
        cardIds: this.hydrationService.getHydratedCardIds()
      },
      replan: {
        inProgress: this._replanPromise !== null,
        suppressQualityReplan: this._suppressQualityReplan,
        defaultBatchLimit: this._defaultBatchLimit,
        minCardsGuarantee: this._minCardsGuarantee
      }
    };
  }
  /**
   * Fetch weighted content from all sources, mix across sources, and populate
   * the single supply queue in pipeline rank order.
   *
   * Reviews and new cards compete on one cross-comparable scale (SRS 0.5–1.0
   * w/ backlog pressure vs ELO 0.0–1.0) — there is no origin split and no
   * second mixer. The working set is `supplyLimit` cards (the top of the mixed
   * ranking, plus any `+INF` required cards floated to the front); replans
   * re-pull and re-rank the whole supply, so a heavy review backlog surfaces as
   * a refreshed top-ranked working set rather than a frozen 200-card snapshot.
   *
   * @param options.replan - If true, this is a mid-session replan rather than
   *   initial session setup. Atomically replaces supplyQ contents and treats
   *   empty results as non-fatal.
   * @param options.additive - If true (replan only), merge high-quality
   *   candidates into the front of the existing supplyQ instead of replacing it.
   * @returns Number of "well-indicated" cards (passed all hierarchy filters)
   *   in the new content. Returns -1 if no content was loaded.
   */
  async getWeightedContent(options) {
    const replan = options?.replan ?? false;
    const additive = options?.additive ?? false;
    const supplyLimit = options?.limit ?? this._defaultBatchLimit;
    const fetchLimit = supplyLimit;
    if (!replan) {
      this._applyHintsToSources();
    }
    const batches = [];
    for (let i = 0; i < this.sources.length; i++) {
      const source = this.sources[i];
      try {
        const weighted = (await source.getWeightedCards(fetchLimit)).cards;
        batches.push({
          sourceIndex: i,
          weighted
        });
      } catch (error) {
        this.error(`Failed to get content from source ${i}:`, error);
        if (this.sources.length === 1) {
          throw new Error(`Cannot start session: failed to load content from source ${i}`);
        }
      }
    }
    if (batches.length === 0) {
      if (replan) {
        this.log("Replan: no content from any source, keeping existing supplyQ");
        return -1;
      }
      throw new Error(
        `Cannot start session: failed to load content from all ${this.sources.length} source(s). Check logs for details.`
      );
    }
    const mixedWeighted = this.mixer.mix(batches, fetchLimit * this.sources.length);
    const sourceIds = batches.map((b) => {
      const firstCard = b.weighted[0];
      return firstCard?.courseId || `source-${b.sourceIndex}`;
    });
    await Promise.all(
      sourceIds.map(async (id) => {
        if (!this.courseNameCache.has(id)) {
          try {
            const config = await this.dataLayer.getCoursesDB().getCourseConfig(id);
            this.courseNameCache.set(id, config.name);
          } catch {
          }
        }
      })
    );
    const sourceNames = sourceIds.map((id) => this.courseNameCache.get(id));
    const quotaPerSource = this.mixer instanceof QuotaRoundRobinMixer ? Math.ceil(fetchLimit * this.sources.length / batches.length) : void 0;
    captureMixerRun(
      this.mixer.constructor.name,
      batches,
      sourceIds,
      sourceNames,
      fetchLimit * this.sources.length,
      quotaPerSource,
      mixedWeighted
    );
    const candidates = mixedWeighted.filter((w) => !this._servedCardIds.has(w.cardId));
    const mandatoryWeighted = candidates.filter((w) => w.score === Number.POSITIVE_INFINITY);
    const optionalWeighted = candidates.filter((w) => w.score !== Number.POSITIVE_INFINITY);
    const supplyWeighted = [
      ...mandatoryWeighted,
      ...optionalWeighted.slice(0, Math.max(0, supplyLimit - mandatoryWeighted.length))
    ];
    const mandatoryIds = new Set(mandatoryWeighted.map((w) => w.cardId));
    const wellIndicated = supplyWeighted.filter(
      (w) => w.score >= _SessionController.WELL_INDICATED_SCORE
    ).length;
    let report = replan ? "Replan content:\n" : "Mixed content session created with:\n";
    const supplyItems = supplyWeighted.map((w) => {
      const origin = getCardOrigin(w);
      const scoreStr = Number.isFinite(w.score) ? w.score.toFixed(2) : "+INF";
      report += `${origin === "review" ? "Review" : "New"}: ${w.courseId}::${w.cardId} (score: ${scoreStr})
`;
      return this._buildSupplyItem(w, origin);
    });
    if (additive) {
      const added = this.supplyQ.mergeToFront(supplyItems, (item) => item.cardID, mandatoryIds);
      report += `Additive merge: ${added} cards added to front of supplyQ
`;
    } else if (replan) {
      this.supplyQ.replaceAll(supplyItems, (item) => item.cardID);
    } else {
      for (const item of supplyItems) {
        this.supplyQ.add(item, item.cardID);
      }
    }
    this.log(report);
    return wellIndicated;
  }
  /**
   * Build a supply item from a weighted candidate. Review-origin cards carry
   * their `reviewID` so SRS outcome tracking and re-presentation work; new
   * cards do not. `score` is carried on both for the debug overlay.
   */
  _buildSupplyItem(w, origin = getCardOrigin(w)) {
    const base = {
      cardID: w.cardId,
      courseID: w.courseId,
      contentSourceType: "course",
      contentSourceID: w.courseId,
      score: w.score
    };
    if (origin === "review") {
      const reviewItem = { ...base, status: "review", reviewID: w.reviewID };
      return reviewItem;
    }
    const newItem = { ...base, status: "new" };
    return newItem;
  }
  /**
   * Returns items that should be pre-hydrated.
   * Deterministic: top N items from each queue to ensure coverage.
   * Failed queue items will typically already be hydrated (from initial render).
   */
  _getItemsToHydrate() {
    const items = [];
    const SUPPLY_PREFETCH = 3;
    const FAILED_PREFETCH = 2;
    for (let i = 0; i < Math.min(SUPPLY_PREFETCH, this.supplyQ.length); i++) {
      items.push(this.supplyQ.peek(i));
    }
    for (let i = 0; i < Math.min(FAILED_PREFETCH, this.failedQ.length); i++) {
      items.push(this.failedQ.peek(i));
    }
    return items;
  }
  /**
   * Selects the next item to present to the user.
   *
   * The supplyQ is already rank-ordered (the pipeline + mixer did the mixing,
   * with `+INF` required cards floated to the front), so the primary path is a
   * deterministic front-to-back draw — no second new-vs-review mixer. The only
   * remaining decisions are (a) when the session ends and (b) when to interleave
   * a remediation card from failedQ. See decision doc §2/§3/§7.
   */
  _selectNextItemToHydrate() {
    if (this.supplyQ.length === 0 && this.failedQ.length === 0) {
      return null;
    }
    if (this._secondsRemaining < 2 && this.failedQ.length === 0 && this._minCardsGuarantee <= 0) {
      return null;
    }
    if (this._secondsRemaining <= 0 && this._minCardsGuarantee <= 0) {
      return this.failedQ.length > 0 ? this.failedQ.peek(0) : null;
    }
    const supplyTop = this.supplyQ.length > 0 ? this.supplyQ.peek(0) : null;
    if (this._minCardsGuarantee > 0 && supplyTop) {
      return supplyTop;
    }
    if (this.failedQ.length > 0 && this._shouldInterleaveFailed(supplyTop !== null)) {
      return this.failedQ.peek(0);
    }
    if (supplyTop) {
      return supplyTop;
    }
    if (this.failedQ.length > 0) {
      return this.failedQ.peek(0);
    }
    this.log(`No more cards available for the session!`);
    return null;
  }
  /** Supply draws between forced failed-queue interleaves (light steady cadence). */
  static FAILED_INTERLEAVE_EVERY = 4;
  /**
   * Slack (seconds) below which the endgame failed-pressure kicks in: when the
   * time left after clearing remediation drops under this, bias hard to failed
   * so the session doesn't end with un-cleared remediation. Mirrors the old
   * `availableTime > 20` ladder thresholds.
   */
  static FAILED_ENDGAME_SLACK_SECONDS = 20;
  /**
   * Whether to interleave a failed (remediation) card now instead of drawing
   * the supply head. Replaces the old `newBound`/`reviewBound` probability
   * ladder's failed path (decision doc §7).
   *
   * @param supplyAvailable - whether supplyQ has a card to draw instead.
   */
  _shouldInterleaveFailed(supplyAvailable) {
    if (this.failedQ.length === 0) return false;
    if (!supplyAvailable) return true;
    const availableTime = this._secondsRemaining - this.estimateCleanupTime();
    if (availableTime <= _SessionController.FAILED_ENDGAME_SLACK_SECONDS) return true;
    return this._supplyDrawsSinceFailed >= _SessionController.FAILED_INTERLEAVE_EVERY;
  }
  async nextCard(action = "dismiss-success") {
    this.dismissCurrentCard(action);
    if (this._minCardsGuarantee > 0) {
      this._minCardsGuarantee--;
      this.log(`[CardGuarantee] ${this._minCardsGuarantee} guaranteed cards remaining`);
    }
    if (this._replanPromise && this.supplyQ.length === 0 && this.failedQ.length === 0) {
      this.log("nextCard: queues empty, awaiting in-flight replan before drawing");
      await this._replanPromise;
    }
    if (this.supplyQ.length <= _SessionController.DEPLETION_PREFETCH_THRESHOLD && this._secondsRemaining > 0 && !this._replanPromise) {
      this._suppressQualityReplan = false;
      this.log(
        `[AutoReplan:depletion] supplyQ has ${this.supplyQ.length} card(s) (${this.failedQ.length} failed pending) with ${this._secondsRemaining}s remaining. Triggering background replan.`
      );
      void this.requestReplan({ label: "auto:depletion", mode: "merge" });
    }
    const REPLAN_BUFFER = 3;
    if (!this._suppressQualityReplan && this._wellIndicatedRemaining <= REPLAN_BUFFER && this.supplyQ.length > 0 && !this._replanPromise) {
      this.log(
        `[AutoReplan:quality] ${this._wellIndicatedRemaining} well-indicated cards remaining (supplyQ: ${this.supplyQ.length}). Triggering background replan.`
      );
      void this.requestReplan({ label: "auto:quality" });
    }
    if (this._secondsRemaining <= 0 && this.failedQ.length === 0 && this._minCardsGuarantee <= 0) {
      this._currentCard = null;
      endSessionTracking();
      return null;
    }
    const WEDGE_MAX_EMPTY_STREAK = 3;
    const WEDGE_BACKOFF_MS = 250;
    let wedgeEmptyStreak = 0;
    while (this._secondsRemaining > 0 && this.supplyQ.length === 0 && this.failedQ.length === 0) {
      this.log(
        `[WedgeBreaker] All queues empty with ${this._secondsRemaining}s remaining. Running pipeline (attempt ${wedgeEmptyStreak + 1}/${WEDGE_MAX_EMPTY_STREAK}).`
      );
      await this._replanUncoalesced({ label: "wedge-breaker" });
      if (this.supplyQ.length === 0 && this.failedQ.length === 0) {
        wedgeEmptyStreak++;
        if (wedgeEmptyStreak >= WEDGE_MAX_EMPTY_STREAK) {
          this.log(
            `[WedgeBreaker] Pipeline returned no content ${WEDGE_MAX_EMPTY_STREAK} consecutive times. Giving up; session will end.`
          );
          break;
        }
        await new Promise((resolve) => setTimeout(resolve, WEDGE_BACKOFF_MS));
      } else {
        wedgeEmptyStreak = 0;
      }
    }
    const MAX_SKIP = 20;
    for (let attempt = 0; attempt < MAX_SKIP; attempt++) {
      const nextItem = this._selectNextItemToHydrate();
      if (!nextItem) {
        this._currentCard = null;
        endSessionTracking();
        return null;
      }
      let card = this.hydrationService.getHydratedCard(nextItem.cardID);
      if (!card) {
        card = await this.hydrationService.waitForCard(nextItem.cardID);
      }
      this.removeItemFromQueue(nextItem);
      if (card) {
        await this.hydrationService.ensureHydratedCards();
        this._currentCard = card;
        const origin = nextItem.status === "review" || nextItem.status === "failed-review" ? "review" : nextItem.status === "new" || nextItem.status === "failed-new" ? "new" : "failed";
        const queueSource = nextItem.status.startsWith("failed") ? "failedQ" : "supplyQ";
        recordCardPresentation(
          nextItem.cardID,
          nextItem.courseID,
          this.courseNameCache.get(nextItem.courseID),
          origin,
          queueSource,
          nextItem.score
        );
        snapshotQueues(this.supplyQ.length, this.failedQ.length);
        return card;
      }
      this.log(`Skipping card ${nextItem.cardID}: hydration failed, trying next`);
      if (isReview(nextItem)) {
        this.srsService.removeReview(nextItem.reviewID);
      }
    }
    this.log(`Exhausted ${MAX_SKIP} skip attempts finding a hydratable card`);
    this._currentCard = null;
    endSessionTracking();
    return null;
  }
  /**
   * Public API for processing user responses to cards.
   * @param cardRecord User's response record
   * @param cardHistory Promise resolving to the card's history
   * @param courseRegistrationDoc User's course registration document
   * @param currentCard Current study session record
   * @param courseId Course identifier
   * @param cardId Card identifier
   * @param maxAttemptsPerView Maximum attempts allowed per view
   * @param maxSessionViews Maximum session views for this card
   * @param sessionViews Current number of session views
   * @returns ResponseResult with navigation and UI instructions
   */
  async submitResponse(cardRecord, cardHistory, courseRegistrationDoc, currentCard, courseId, cardId, maxAttemptsPerView, maxSessionViews, sessionViews) {
    const studySessionItem = {
      ...currentCard.item
    };
    const result = await this.services.response.processResponse(
      cardRecord,
      cardHistory,
      studySessionItem,
      courseRegistrationDoc,
      currentCard,
      courseId,
      cardId,
      maxAttemptsPerView,
      maxSessionViews,
      sessionViews
    );
    await this._notifyOutcomeObservers(cardRecord, currentCard, result);
    return result;
  }
  dismissCurrentCard(action = "dismiss-success") {
    if (this._currentCard) {
      if (action === "dismiss-success") {
        this.hydrationService.removeCard(this._currentCard.item.cardID);
      } else if (action === "marked-failed") {
        let failedItem;
        if (isReview(this._currentCard.item)) {
          failedItem = {
            cardID: this._currentCard.item.cardID,
            courseID: this._currentCard.item.courseID,
            contentSourceID: this._currentCard.item.contentSourceID,
            contentSourceType: this._currentCard.item.contentSourceType,
            status: "failed-review",
            reviewID: this._currentCard.item.reviewID
          };
        } else {
          failedItem = {
            cardID: this._currentCard.item.cardID,
            courseID: this._currentCard.item.courseID,
            contentSourceID: this._currentCard.item.contentSourceID,
            contentSourceType: this._currentCard.item.contentSourceType,
            status: "failed-new"
          };
        }
        this.failedQ.add(failedItem, failedItem.cardID);
        this._supplyDrawsSinceFailed = 0;
      } else if (action === "dismiss-error") {
        this.hydrationService.removeCard(this._currentCard.item.cardID);
      } else if (action === "dismiss-failed") {
        this.hydrationService.removeCard(this._currentCard.item.cardID);
      }
    }
  }
  /**
   * Remove an item from its source queue after consumption by nextCard().
   */
  removeItemFromQueue(item) {
    this._clearDurableRequirement(item.cardID);
    this._servedCardIds.add(item.cardID);
    if (this.failedQ.peek(0)?.cardID === item.cardID) {
      this.failedQ.dequeue((queueItem) => queueItem.cardID);
      this._supplyDrawsSinceFailed = 0;
    } else if (this.supplyQ.peek(0)?.cardID === item.cardID) {
      this.supplyQ.dequeue((queueItem) => queueItem.cardID);
      this._supplyDrawsSinceFailed++;
      if (this._wellIndicatedRemaining > 0) {
        this._wellIndicatedRemaining--;
      }
    }
  }
  /**
   * Remove a satisfied card ID from the durable session-hint `requireCards`
   * list. Called when a card is consumed (see removeItemFromQueue). No-op if
   * the card was not a durable requirement.
   *
   * Matches literal IDs only: a glob/pattern requirement (which may stand for
   * several cards) is NOT considered satisfied by a single draw and is left in
   * place — durable patterns are the caller's responsibility, one-shot `hints`
   * remain the right tool for them.
   */
  _clearDurableRequirement(cardID) {
    const req = this._sessionHints?.requireCards;
    if (!req || req.length === 0) return;
    const next = req.filter((id) => id !== cardID);
    if (next.length === req.length) return;
    this._sessionHints = {
      ...this._sessionHints,
      requireCards: next.length > 0 ? next : void 0
    };
    this.log(`[Replan] Durable requirement satisfied & cleared on draw: ${cardID}`);
  }
  /**
   * End the session and record learning outcomes.
   *
   * This method aggregates all responses from the session and records a
   * UserOutcomeRecord if evolutionary orchestration is enabled.
   */
  async endSession() {
    if (!this._sessionRecord || this._sessionRecord.length === 0) {
      return;
    }
    const questionRecords = this._sessionRecord.flatMap((r) => r.records).filter((r) => r.userAnswer !== void 0);
    if (questionRecords.length === 0) {
      return;
    }
    let orchestrationContext = null;
    const strategies = [];
    for (const source of this.sources) {
      if (source.getOrchestrationContext) {
        try {
          orchestrationContext = await source.getOrchestrationContext();
          if (source.getStrategyIds) {
            strategies.push(...source.getStrategyIds());
          }
        } catch (e) {
          logger.warn(`[SessionController] Failed to get orchestration context: ${e}`);
        }
        if (orchestrationContext) break;
      }
    }
    if (!orchestrationContext) {
      logger.debug("[SessionController] No orchestration context available, skipping outcome recording");
      return;
    }
    const periodEnd = (/* @__PURE__ */ new Date()).toISOString();
    const periodStart = new Date(this.startTime).toISOString();
    await recordUserOutcome(
      orchestrationContext,
      periodStart,
      periodEnd,
      questionRecords,
      strategies
    );
  }
};

// src/study/index.ts
init_TagFilteredContentSource();

// src/index.ts
init_factory();
export {
  ContentNavigator,
  CouchDBToStaticPacker,
  CourseLookup,
  DIVERSITY_FLOOR,
  DIVERSITY_STRENGTH,
  DocType,
  DocTypePrefixes,
  ENV,
  FileSystemError,
  GuestUsername,
  Loggable,
  NOT_SET,
  NavigatorRole,
  NavigatorRoles,
  Navigators,
  QuotaRoundRobinMixer,
  SessionController,
  StaticToCouchDBMigrator,
  TagFilteredContentSource,
  _resetDataLayer,
  aggregateOutcomesForGradient,
  areQuestionRecords,
  buildStrategyStateId,
  captureMixerRun,
  clearSrsBacklogDebug,
  computeDeviation,
  computeEffectiveWeight,
  computeOutcomeSignal,
  computeSpread,
  computeStrategyGradient,
  createOrchestrationContext,
  diversityRerank,
  docIsDeleted,
  endSessionTracking,
  ensureAppDataDirectory,
  getActivePipeline,
  getAppDataDirectory,
  getCardHistoryID,
  getCardOrigin,
  getDataLayer,
  getDbPath,
  getDefaultLearnableWeight,
  getRegisteredNavigator,
  getRegisteredNavigatorNames,
  getRegisteredNavigatorRole,
  getSrsBacklogDebug,
  getStudySource,
  hasRegisteredNavigator,
  importParsedCards,
  initializeDataDirectory,
  initializeDataLayer,
  initializeNavigatorRegistry,
  isDataShapeRegistered,
  isDataShapeSchemaAvailable,
  isFilter,
  isGenerator,
  isQuestionRecord,
  isQuestionTypeRegistered,
  isReview,
  log,
  mixerDebugAPI,
  mountMixerDebugger,
  mountPipelineDebugger,
  mountSessionDebugger,
  mountUserDBDebugger,
  newInterval,
  parseCardHistoryID,
  pipelineDebugAPI,
  processCustomQuestionsData,
  recordCardPresentation,
  recordUserOutcome,
  registerBlanksCard,
  registerCustomQuestionTypes,
  registerDataShape,
  registerNavigator,
  registerQuestionType,
  registerSeedData,
  removeCustomQuestionTypes,
  removeDataShape,
  removeQuestionType,
  runPeriodUpdate,
  scoreAccuracyInZone,
  sessionDebugAPI,
  snapshotQueues,
  startSessionTracking,
  updateLearningState,
  updateStrategyWeight,
  userDBDebugAPI,
  validateMigration,
  validateProcessorConfig,
  validateStaticCourse
};
//# sourceMappingURL=index.mjs.map